/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// @ts-expect-error Explicitly disable long.js support
$protobuf.util.Long = undefined;
$protobuf.configure();

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.motionmaster = (() => {

    /**
     * Namespace motionmaster.
     * @exports motionmaster
     * @namespace
     */
    const motionmaster = {};

    motionmaster.MotionMasterMessage = (function() {

        /**
         * Properties of a MotionMasterMessage.
         * @memberof motionmaster
         * @interface IMotionMasterMessage
         * @property {string|null} [id] MotionMasterMessage id
         * @property {motionmaster.MotionMasterMessage.IRequest|null} [request] MotionMasterMessage request
         * @property {motionmaster.MotionMasterMessage.IStatus|null} [status] MotionMasterMessage status
         */

        /**
         * Constructs a new MotionMasterMessage.
         * @memberof motionmaster
         * @classdesc Represents a MotionMasterMessage.
         * @implements IMotionMasterMessage
         * @constructor
         * @param {motionmaster.IMotionMasterMessage=} [properties] Properties to set
         */
        function MotionMasterMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MotionMasterMessage id.
         * @member {string} id
         * @memberof motionmaster.MotionMasterMessage
         * @instance
         */
        MotionMasterMessage.prototype.id = "";

        /**
         * MotionMasterMessage request.
         * @member {motionmaster.MotionMasterMessage.IRequest|null|undefined} request
         * @memberof motionmaster.MotionMasterMessage
         * @instance
         */
        MotionMasterMessage.prototype.request = null;

        /**
         * MotionMasterMessage status.
         * @member {motionmaster.MotionMasterMessage.IStatus|null|undefined} status
         * @memberof motionmaster.MotionMasterMessage
         * @instance
         */
        MotionMasterMessage.prototype.status = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * MotionMasterMessage type.
         * @member {"request"|"status"|undefined} type
         * @memberof motionmaster.MotionMasterMessage
         * @instance
         */
        Object.defineProperty(MotionMasterMessage.prototype, "type", {
            get: $util.oneOfGetter($oneOfFields = ["request", "status"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MotionMasterMessage instance using the specified properties.
         * @function create
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {motionmaster.IMotionMasterMessage=} [properties] Properties to set
         * @returns {motionmaster.MotionMasterMessage} MotionMasterMessage instance
         */
        MotionMasterMessage.create = function create(properties) {
            return new MotionMasterMessage(properties);
        };

        /**
         * Encodes the specified MotionMasterMessage message. Does not implicitly {@link motionmaster.MotionMasterMessage.verify|verify} messages.
         * @function encode
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {motionmaster.IMotionMasterMessage} message MotionMasterMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotionMasterMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.request != null && Object.hasOwnProperty.call(message, "request"))
                $root.motionmaster.MotionMasterMessage.Request.encode(message.request, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                $root.motionmaster.MotionMasterMessage.Status.encode(message.status, writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MotionMasterMessage message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {motionmaster.IMotionMasterMessage} message MotionMasterMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MotionMasterMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MotionMasterMessage message from the specified reader or buffer.
         * @function decode
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {motionmaster.MotionMasterMessage} MotionMasterMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotionMasterMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 101: {
                        message.request = $root.motionmaster.MotionMasterMessage.Request.decode(reader, reader.uint32());
                        break;
                    }
                case 102: {
                        message.status = $root.motionmaster.MotionMasterMessage.Status.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MotionMasterMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {motionmaster.MotionMasterMessage} MotionMasterMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MotionMasterMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MotionMasterMessage message.
         * @function verify
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MotionMasterMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.request != null && message.hasOwnProperty("request")) {
                properties.type = 1;
                {
                    let error = $root.motionmaster.MotionMasterMessage.Request.verify(message.request);
                    if (error)
                        return "request." + error;
                }
            }
            if (message.status != null && message.hasOwnProperty("status")) {
                if (properties.type === 1)
                    return "type: multiple values";
                properties.type = 1;
                {
                    let error = $root.motionmaster.MotionMasterMessage.Status.verify(message.status);
                    if (error)
                        return "status." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MotionMasterMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {motionmaster.MotionMasterMessage} MotionMasterMessage
         */
        MotionMasterMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.motionmaster.MotionMasterMessage)
                return object;
            let message = new $root.motionmaster.MotionMasterMessage();
            if (object.id != null)
                message.id = String(object.id);
            if (object.request != null) {
                if (typeof object.request !== "object")
                    throw TypeError(".motionmaster.MotionMasterMessage.request: object expected");
                message.request = $root.motionmaster.MotionMasterMessage.Request.fromObject(object.request);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".motionmaster.MotionMasterMessage.status: object expected");
                message.status = $root.motionmaster.MotionMasterMessage.Status.fromObject(object.status);
            }
            return message;
        };

        /**
         * Creates a plain object from a MotionMasterMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {motionmaster.MotionMasterMessage} message MotionMasterMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MotionMasterMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.request != null && message.hasOwnProperty("request")) {
                object.request = $root.motionmaster.MotionMasterMessage.Request.toObject(message.request, options);
                if (options.oneofs)
                    object.type = "request";
            }
            if (message.status != null && message.hasOwnProperty("status")) {
                object.status = $root.motionmaster.MotionMasterMessage.Status.toObject(message.status, options);
                if (options.oneofs)
                    object.type = "status";
            }
            return object;
        };

        /**
         * Converts this MotionMasterMessage to JSON.
         * @function toJSON
         * @memberof motionmaster.MotionMasterMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MotionMasterMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MotionMasterMessage
         * @function getTypeUrl
         * @memberof motionmaster.MotionMasterMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MotionMasterMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/motionmaster.MotionMasterMessage";
        };

        MotionMasterMessage.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof motionmaster.MotionMasterMessage
             * @interface IRequest
             * @property {string|null} [topic] Request topic
             * @property {motionmaster.MotionMasterMessage.Request.IPingSystem|null} [pingSystem] Request pingSystem
             * @property {motionmaster.MotionMasterMessage.Request.IGetSystemVersion|null} [getSystemVersion] Request getSystemVersion
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo|null} [getDeviceInfo] Request getDeviceInfo
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo|null} [getDeviceParameterInfo] Request getDeviceParameterInfo
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues|null} [getDeviceParameterValues] Request getDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues|null} [getMultiDeviceParameterValues] Request getMultiDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues|null} [setDeviceParameterValues] Request setDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues|null} [setMultiDeviceParameterValues] Request setMultiDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList|null} [getDeviceFileList] Request getDeviceFileList
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceFile|null} [getDeviceFile] Request getDeviceFile
             * @property {motionmaster.MotionMasterMessage.Request.ISetDeviceFile|null} [setDeviceFile] Request setDeviceFile
             * @property {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile|null} [deleteDeviceFile] Request deleteDeviceFile
             * @property {motionmaster.MotionMasterMessage.Request.IResetDeviceFault|null} [resetDeviceFault] Request resetDeviceFault
             * @property {motionmaster.MotionMasterMessage.Request.IStopDevice|null} [stopDevice] Request stopDevice
             * @property {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation|null} [startDeviceFirmwareInstallation] Request startDeviceFirmwareInstallation
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceLog|null} [getDeviceLog] Request getDeviceLog
             * @property {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording|null} [startCoggingTorqueRecording] Request startCoggingTorqueRecording
             * @property {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData|null} [getCoggingTorqueData] Request getCoggingTorqueData
             * @property {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection|null} [startOffsetDetection] Request startOffsetDetection
             * @property {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification|null} [startPlantIdentification] Request startPlantIdentification
             * @property {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains|null} [computeAutoTuningGains] Request computeAutoTuningGains
             * @property {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters|null} [setMotionControllerParameters] Request setMotionControllerParameters
             * @property {motionmaster.MotionMasterMessage.Request.IEnableMotionController|null} [enableMotionController] Request enableMotionController
             * @property {motionmaster.MotionMasterMessage.Request.IDisableMotionController|null} [disableMotionController] Request disableMotionController
             * @property {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters|null} [setSignalGeneratorParameters] Request setSignalGeneratorParameters
             * @property {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator|null} [startSignalGenerator] Request startSignalGenerator
             * @property {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator|null} [stopSignalGenerator] Request stopSignalGenerator
             * @property {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues|null} [startMonitoringDeviceParameterValues] Request startMonitoringDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues|null} [stopMonitoringDeviceParameterValues] Request stopMonitoringDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState|null} [getEthercatNetworkState] Request getEthercatNetworkState
             * @property {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState|null} [setEthercatNetworkState] Request setEthercatNetworkState
             * @property {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration|null} [startNarrowAngleCalibration] Request startNarrowAngleCalibration
             * @property {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout|null} [setSystemClientTimeout] Request setSystemClientTimeout
             * @property {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification|null} [startSystemIdentification] Request startSystemIdentification
             * @property {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance|null} [getCirculoEncoderMagnetDistance] Request getCirculoEncoderMagnetDistance
             * @property {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure|null} [startCirculoEncoderNarrowAngleCalibrationProcedure] Request startCirculoEncoderNarrowAngleCalibrationProcedure
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State|null} [getDeviceCia402State] Request getDeviceCia402State
             * @property {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State|null} [setDeviceCia402State] Request setDeviceCia402State
             * @property {motionmaster.MotionMasterMessage.Request.IGetSystemLog|null} [getSystemLog] Request getSystemLog
             * @property {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore|null} [startDeviceSiiRestore] Request startDeviceSiiRestore
             * @property {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl|null} [startOpenLoopFieldControl] Request startOpenLoopFieldControl
             * @property {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains|null} [computeFullAutoTuningGains] Request computeFullAutoTuningGains
             * @property {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning|null} [startFullAutoTuning] Request startFullAutoTuning
             * @property {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning|null} [stopFullAutoTuning] Request stopFullAutoTuning
             * @property {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration|null} [startCirculoEncoderConfiguration] Request startCirculoEncoderConfiguration
             * @property {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure|null} [stopCirculoEncoderNarrowAngleCalibrationProcedure] Request stopCirculoEncoderNarrowAngleCalibrationProcedure
             * @property {motionmaster.MotionMasterMessage.Request.IStartOsCommand|null} [startOsCommand] Request startOsCommand
             * @property {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall|null} [executeForwardCall] Request executeForwardCall
             * @property {motionmaster.MotionMasterMessage.Request.IGetSystemInformation|null} [getSystemInformation] Request getSystemInformation
             * @property {motionmaster.MotionMasterMessage.Request.ISetPdoMode|null} [setPdoMode] Request setPdoMode
             * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceSii|null} [getDeviceSii] Request getDeviceSii
             */

            /**
             * Constructs a new Request.
             * @memberof motionmaster.MotionMasterMessage
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {motionmaster.MotionMasterMessage.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request topic.
             * @member {string} topic
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.topic = "";

            /**
             * Request pingSystem.
             * @member {motionmaster.MotionMasterMessage.Request.IPingSystem|null|undefined} pingSystem
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.pingSystem = null;

            /**
             * Request getSystemVersion.
             * @member {motionmaster.MotionMasterMessage.Request.IGetSystemVersion|null|undefined} getSystemVersion
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getSystemVersion = null;

            /**
             * Request getDeviceInfo.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo|null|undefined} getDeviceInfo
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceInfo = null;

            /**
             * Request getDeviceParameterInfo.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo|null|undefined} getDeviceParameterInfo
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceParameterInfo = null;

            /**
             * Request getDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues|null|undefined} getDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceParameterValues = null;

            /**
             * Request getMultiDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues|null|undefined} getMultiDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getMultiDeviceParameterValues = null;

            /**
             * Request setDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues|null|undefined} setDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setDeviceParameterValues = null;

            /**
             * Request setMultiDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues|null|undefined} setMultiDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setMultiDeviceParameterValues = null;

            /**
             * Request getDeviceFileList.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList|null|undefined} getDeviceFileList
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceFileList = null;

            /**
             * Request getDeviceFile.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceFile|null|undefined} getDeviceFile
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceFile = null;

            /**
             * Request setDeviceFile.
             * @member {motionmaster.MotionMasterMessage.Request.ISetDeviceFile|null|undefined} setDeviceFile
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setDeviceFile = null;

            /**
             * Request deleteDeviceFile.
             * @member {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile|null|undefined} deleteDeviceFile
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.deleteDeviceFile = null;

            /**
             * Request resetDeviceFault.
             * @member {motionmaster.MotionMasterMessage.Request.IResetDeviceFault|null|undefined} resetDeviceFault
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.resetDeviceFault = null;

            /**
             * Request stopDevice.
             * @member {motionmaster.MotionMasterMessage.Request.IStopDevice|null|undefined} stopDevice
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.stopDevice = null;

            /**
             * Request startDeviceFirmwareInstallation.
             * @member {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation|null|undefined} startDeviceFirmwareInstallation
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startDeviceFirmwareInstallation = null;

            /**
             * Request getDeviceLog.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceLog|null|undefined} getDeviceLog
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceLog = null;

            /**
             * Request startCoggingTorqueRecording.
             * @member {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording|null|undefined} startCoggingTorqueRecording
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startCoggingTorqueRecording = null;

            /**
             * Request getCoggingTorqueData.
             * @member {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData|null|undefined} getCoggingTorqueData
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getCoggingTorqueData = null;

            /**
             * Request startOffsetDetection.
             * @member {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection|null|undefined} startOffsetDetection
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startOffsetDetection = null;

            /**
             * Request startPlantIdentification.
             * @member {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification|null|undefined} startPlantIdentification
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startPlantIdentification = null;

            /**
             * Request computeAutoTuningGains.
             * @member {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains|null|undefined} computeAutoTuningGains
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.computeAutoTuningGains = null;

            /**
             * Request setMotionControllerParameters.
             * @member {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters|null|undefined} setMotionControllerParameters
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setMotionControllerParameters = null;

            /**
             * Request enableMotionController.
             * @member {motionmaster.MotionMasterMessage.Request.IEnableMotionController|null|undefined} enableMotionController
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.enableMotionController = null;

            /**
             * Request disableMotionController.
             * @member {motionmaster.MotionMasterMessage.Request.IDisableMotionController|null|undefined} disableMotionController
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.disableMotionController = null;

            /**
             * Request setSignalGeneratorParameters.
             * @member {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters|null|undefined} setSignalGeneratorParameters
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setSignalGeneratorParameters = null;

            /**
             * Request startSignalGenerator.
             * @member {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator|null|undefined} startSignalGenerator
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startSignalGenerator = null;

            /**
             * Request stopSignalGenerator.
             * @member {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator|null|undefined} stopSignalGenerator
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.stopSignalGenerator = null;

            /**
             * Request startMonitoringDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues|null|undefined} startMonitoringDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startMonitoringDeviceParameterValues = null;

            /**
             * Request stopMonitoringDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues|null|undefined} stopMonitoringDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.stopMonitoringDeviceParameterValues = null;

            /**
             * Request getEthercatNetworkState.
             * @member {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState|null|undefined} getEthercatNetworkState
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getEthercatNetworkState = null;

            /**
             * Request setEthercatNetworkState.
             * @member {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState|null|undefined} setEthercatNetworkState
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setEthercatNetworkState = null;

            /**
             * Request startNarrowAngleCalibration.
             * @member {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration|null|undefined} startNarrowAngleCalibration
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startNarrowAngleCalibration = null;

            /**
             * Request setSystemClientTimeout.
             * @member {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout|null|undefined} setSystemClientTimeout
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setSystemClientTimeout = null;

            /**
             * Request startSystemIdentification.
             * @member {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification|null|undefined} startSystemIdentification
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startSystemIdentification = null;

            /**
             * Request getCirculoEncoderMagnetDistance.
             * @member {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance|null|undefined} getCirculoEncoderMagnetDistance
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getCirculoEncoderMagnetDistance = null;

            /**
             * Request startCirculoEncoderNarrowAngleCalibrationProcedure.
             * @member {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure|null|undefined} startCirculoEncoderNarrowAngleCalibrationProcedure
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startCirculoEncoderNarrowAngleCalibrationProcedure = null;

            /**
             * Request getDeviceCia402State.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State|null|undefined} getDeviceCia402State
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceCia402State = null;

            /**
             * Request setDeviceCia402State.
             * @member {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State|null|undefined} setDeviceCia402State
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setDeviceCia402State = null;

            /**
             * Request getSystemLog.
             * @member {motionmaster.MotionMasterMessage.Request.IGetSystemLog|null|undefined} getSystemLog
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getSystemLog = null;

            /**
             * Request startDeviceSiiRestore.
             * @member {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore|null|undefined} startDeviceSiiRestore
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startDeviceSiiRestore = null;

            /**
             * Request startOpenLoopFieldControl.
             * @member {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl|null|undefined} startOpenLoopFieldControl
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startOpenLoopFieldControl = null;

            /**
             * Request computeFullAutoTuningGains.
             * @member {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains|null|undefined} computeFullAutoTuningGains
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.computeFullAutoTuningGains = null;

            /**
             * Request startFullAutoTuning.
             * @member {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning|null|undefined} startFullAutoTuning
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startFullAutoTuning = null;

            /**
             * Request stopFullAutoTuning.
             * @member {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning|null|undefined} stopFullAutoTuning
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.stopFullAutoTuning = null;

            /**
             * Request startCirculoEncoderConfiguration.
             * @member {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration|null|undefined} startCirculoEncoderConfiguration
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startCirculoEncoderConfiguration = null;

            /**
             * Request stopCirculoEncoderNarrowAngleCalibrationProcedure.
             * @member {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure|null|undefined} stopCirculoEncoderNarrowAngleCalibrationProcedure
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.stopCirculoEncoderNarrowAngleCalibrationProcedure = null;

            /**
             * Request startOsCommand.
             * @member {motionmaster.MotionMasterMessage.Request.IStartOsCommand|null|undefined} startOsCommand
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.startOsCommand = null;

            /**
             * Request executeForwardCall.
             * @member {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall|null|undefined} executeForwardCall
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.executeForwardCall = null;

            /**
             * Request getSystemInformation.
             * @member {motionmaster.MotionMasterMessage.Request.IGetSystemInformation|null|undefined} getSystemInformation
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getSystemInformation = null;

            /**
             * Request setPdoMode.
             * @member {motionmaster.MotionMasterMessage.Request.ISetPdoMode|null|undefined} setPdoMode
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.setPdoMode = null;

            /**
             * Request getDeviceSii.
             * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceSii|null|undefined} getDeviceSii
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Request.prototype.getDeviceSii = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Request type.
             * @member {"pingSystem"|"getSystemVersion"|"getDeviceInfo"|"getDeviceParameterInfo"|"getDeviceParameterValues"|"getMultiDeviceParameterValues"|"setDeviceParameterValues"|"setMultiDeviceParameterValues"|"getDeviceFileList"|"getDeviceFile"|"setDeviceFile"|"deleteDeviceFile"|"resetDeviceFault"|"stopDevice"|"startDeviceFirmwareInstallation"|"getDeviceLog"|"startCoggingTorqueRecording"|"getCoggingTorqueData"|"startOffsetDetection"|"startPlantIdentification"|"computeAutoTuningGains"|"setMotionControllerParameters"|"enableMotionController"|"disableMotionController"|"setSignalGeneratorParameters"|"startSignalGenerator"|"stopSignalGenerator"|"startMonitoringDeviceParameterValues"|"stopMonitoringDeviceParameterValues"|"getEthercatNetworkState"|"setEthercatNetworkState"|"startNarrowAngleCalibration"|"setSystemClientTimeout"|"startSystemIdentification"|"getCirculoEncoderMagnetDistance"|"startCirculoEncoderNarrowAngleCalibrationProcedure"|"getDeviceCia402State"|"setDeviceCia402State"|"getSystemLog"|"startDeviceSiiRestore"|"startOpenLoopFieldControl"|"computeFullAutoTuningGains"|"startFullAutoTuning"|"stopFullAutoTuning"|"startCirculoEncoderConfiguration"|"stopCirculoEncoderNarrowAngleCalibrationProcedure"|"startOsCommand"|"executeForwardCall"|"getSystemInformation"|"setPdoMode"|"getDeviceSii"|undefined} type
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             */
            Object.defineProperty(Request.prototype, "type", {
                get: $util.oneOfGetter($oneOfFields = ["pingSystem", "getSystemVersion", "getDeviceInfo", "getDeviceParameterInfo", "getDeviceParameterValues", "getMultiDeviceParameterValues", "setDeviceParameterValues", "setMultiDeviceParameterValues", "getDeviceFileList", "getDeviceFile", "setDeviceFile", "deleteDeviceFile", "resetDeviceFault", "stopDevice", "startDeviceFirmwareInstallation", "getDeviceLog", "startCoggingTorqueRecording", "getCoggingTorqueData", "startOffsetDetection", "startPlantIdentification", "computeAutoTuningGains", "setMotionControllerParameters", "enableMotionController", "disableMotionController", "setSignalGeneratorParameters", "startSignalGenerator", "stopSignalGenerator", "startMonitoringDeviceParameterValues", "stopMonitoringDeviceParameterValues", "getEthercatNetworkState", "setEthercatNetworkState", "startNarrowAngleCalibration", "setSystemClientTimeout", "startSystemIdentification", "getCirculoEncoderMagnetDistance", "startCirculoEncoderNarrowAngleCalibrationProcedure", "getDeviceCia402State", "setDeviceCia402State", "getSystemLog", "startDeviceSiiRestore", "startOpenLoopFieldControl", "computeFullAutoTuningGains", "startFullAutoTuning", "stopFullAutoTuning", "startCirculoEncoderConfiguration", "stopCirculoEncoderNarrowAngleCalibrationProcedure", "startOsCommand", "executeForwardCall", "getSystemInformation", "setPdoMode", "getDeviceSii"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {motionmaster.MotionMasterMessage.IRequest=} [properties] Properties to set
             * @returns {motionmaster.MotionMasterMessage.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.verify|verify} messages.
             * @function encode
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {motionmaster.MotionMasterMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.topic);
                if (message.pingSystem != null && Object.hasOwnProperty.call(message, "pingSystem"))
                    $root.motionmaster.MotionMasterMessage.Request.PingSystem.encode(message.pingSystem, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
                if (message.getSystemVersion != null && Object.hasOwnProperty.call(message, "getSystemVersion"))
                    $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion.encode(message.getSystemVersion, writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
                if (message.getDeviceInfo != null && Object.hasOwnProperty.call(message, "getDeviceInfo"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo.encode(message.getDeviceInfo, writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
                if (message.getDeviceParameterInfo != null && Object.hasOwnProperty.call(message, "getDeviceParameterInfo"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.encode(message.getDeviceParameterInfo, writer.uint32(/* id 104, wireType 2 =*/834).fork()).ldelim();
                if (message.getDeviceParameterValues != null && Object.hasOwnProperty.call(message, "getDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.encode(message.getDeviceParameterValues, writer.uint32(/* id 105, wireType 2 =*/842).fork()).ldelim();
                if (message.getMultiDeviceParameterValues != null && Object.hasOwnProperty.call(message, "getMultiDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.encode(message.getMultiDeviceParameterValues, writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
                if (message.setDeviceParameterValues != null && Object.hasOwnProperty.call(message, "setDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.encode(message.setDeviceParameterValues, writer.uint32(/* id 107, wireType 2 =*/858).fork()).ldelim();
                if (message.setMultiDeviceParameterValues != null && Object.hasOwnProperty.call(message, "setMultiDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.encode(message.setMultiDeviceParameterValues, writer.uint32(/* id 108, wireType 2 =*/866).fork()).ldelim();
                if (message.getDeviceFileList != null && Object.hasOwnProperty.call(message, "getDeviceFileList"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList.encode(message.getDeviceFileList, writer.uint32(/* id 109, wireType 2 =*/874).fork()).ldelim();
                if (message.getDeviceFile != null && Object.hasOwnProperty.call(message, "getDeviceFile"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile.encode(message.getDeviceFile, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
                if (message.setDeviceFile != null && Object.hasOwnProperty.call(message, "setDeviceFile"))
                    $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile.encode(message.setDeviceFile, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
                if (message.deleteDeviceFile != null && Object.hasOwnProperty.call(message, "deleteDeviceFile"))
                    $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.encode(message.deleteDeviceFile, writer.uint32(/* id 112, wireType 2 =*/898).fork()).ldelim();
                if (message.resetDeviceFault != null && Object.hasOwnProperty.call(message, "resetDeviceFault"))
                    $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault.encode(message.resetDeviceFault, writer.uint32(/* id 113, wireType 2 =*/906).fork()).ldelim();
                if (message.stopDevice != null && Object.hasOwnProperty.call(message, "stopDevice"))
                    $root.motionmaster.MotionMasterMessage.Request.StopDevice.encode(message.stopDevice, writer.uint32(/* id 114, wireType 2 =*/914).fork()).ldelim();
                if (message.startDeviceFirmwareInstallation != null && Object.hasOwnProperty.call(message, "startDeviceFirmwareInstallation"))
                    $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.encode(message.startDeviceFirmwareInstallation, writer.uint32(/* id 115, wireType 2 =*/922).fork()).ldelim();
                if (message.getDeviceLog != null && Object.hasOwnProperty.call(message, "getDeviceLog"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog.encode(message.getDeviceLog, writer.uint32(/* id 116, wireType 2 =*/930).fork()).ldelim();
                if (message.startCoggingTorqueRecording != null && Object.hasOwnProperty.call(message, "startCoggingTorqueRecording"))
                    $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.encode(message.startCoggingTorqueRecording, writer.uint32(/* id 117, wireType 2 =*/938).fork()).ldelim();
                if (message.getCoggingTorqueData != null && Object.hasOwnProperty.call(message, "getCoggingTorqueData"))
                    $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.encode(message.getCoggingTorqueData, writer.uint32(/* id 118, wireType 2 =*/946).fork()).ldelim();
                if (message.startOffsetDetection != null && Object.hasOwnProperty.call(message, "startOffsetDetection"))
                    $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection.encode(message.startOffsetDetection, writer.uint32(/* id 119, wireType 2 =*/954).fork()).ldelim();
                if (message.startPlantIdentification != null && Object.hasOwnProperty.call(message, "startPlantIdentification"))
                    $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification.encode(message.startPlantIdentification, writer.uint32(/* id 120, wireType 2 =*/962).fork()).ldelim();
                if (message.computeAutoTuningGains != null && Object.hasOwnProperty.call(message, "computeAutoTuningGains"))
                    $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.encode(message.computeAutoTuningGains, writer.uint32(/* id 121, wireType 2 =*/970).fork()).ldelim();
                if (message.setMotionControllerParameters != null && Object.hasOwnProperty.call(message, "setMotionControllerParameters"))
                    $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.encode(message.setMotionControllerParameters, writer.uint32(/* id 122, wireType 2 =*/978).fork()).ldelim();
                if (message.enableMotionController != null && Object.hasOwnProperty.call(message, "enableMotionController"))
                    $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.encode(message.enableMotionController, writer.uint32(/* id 123, wireType 2 =*/986).fork()).ldelim();
                if (message.disableMotionController != null && Object.hasOwnProperty.call(message, "disableMotionController"))
                    $root.motionmaster.MotionMasterMessage.Request.DisableMotionController.encode(message.disableMotionController, writer.uint32(/* id 124, wireType 2 =*/994).fork()).ldelim();
                if (message.setSignalGeneratorParameters != null && Object.hasOwnProperty.call(message, "setSignalGeneratorParameters"))
                    $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.encode(message.setSignalGeneratorParameters, writer.uint32(/* id 125, wireType 2 =*/1002).fork()).ldelim();
                if (message.startSignalGenerator != null && Object.hasOwnProperty.call(message, "startSignalGenerator"))
                    $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator.encode(message.startSignalGenerator, writer.uint32(/* id 126, wireType 2 =*/1010).fork()).ldelim();
                if (message.stopSignalGenerator != null && Object.hasOwnProperty.call(message, "stopSignalGenerator"))
                    $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator.encode(message.stopSignalGenerator, writer.uint32(/* id 127, wireType 2 =*/1018).fork()).ldelim();
                if (message.startMonitoringDeviceParameterValues != null && Object.hasOwnProperty.call(message, "startMonitoringDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.encode(message.startMonitoringDeviceParameterValues, writer.uint32(/* id 128, wireType 2 =*/1026).fork()).ldelim();
                if (message.stopMonitoringDeviceParameterValues != null && Object.hasOwnProperty.call(message, "stopMonitoringDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.encode(message.stopMonitoringDeviceParameterValues, writer.uint32(/* id 129, wireType 2 =*/1034).fork()).ldelim();
                if (message.getEthercatNetworkState != null && Object.hasOwnProperty.call(message, "getEthercatNetworkState"))
                    $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.encode(message.getEthercatNetworkState, writer.uint32(/* id 130, wireType 2 =*/1042).fork()).ldelim();
                if (message.setEthercatNetworkState != null && Object.hasOwnProperty.call(message, "setEthercatNetworkState"))
                    $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.encode(message.setEthercatNetworkState, writer.uint32(/* id 131, wireType 2 =*/1050).fork()).ldelim();
                if (message.startNarrowAngleCalibration != null && Object.hasOwnProperty.call(message, "startNarrowAngleCalibration"))
                    $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.encode(message.startNarrowAngleCalibration, writer.uint32(/* id 132, wireType 2 =*/1058).fork()).ldelim();
                if (message.setSystemClientTimeout != null && Object.hasOwnProperty.call(message, "setSystemClientTimeout"))
                    $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.encode(message.setSystemClientTimeout, writer.uint32(/* id 133, wireType 2 =*/1066).fork()).ldelim();
                if (message.startSystemIdentification != null && Object.hasOwnProperty.call(message, "startSystemIdentification"))
                    $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification.encode(message.startSystemIdentification, writer.uint32(/* id 134, wireType 2 =*/1074).fork()).ldelim();
                if (message.getCirculoEncoderMagnetDistance != null && Object.hasOwnProperty.call(message, "getCirculoEncoderMagnetDistance"))
                    $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.encode(message.getCirculoEncoderMagnetDistance, writer.uint32(/* id 135, wireType 2 =*/1082).fork()).ldelim();
                if (message.startCirculoEncoderNarrowAngleCalibrationProcedure != null && Object.hasOwnProperty.call(message, "startCirculoEncoderNarrowAngleCalibrationProcedure"))
                    $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.encode(message.startCirculoEncoderNarrowAngleCalibrationProcedure, writer.uint32(/* id 136, wireType 2 =*/1090).fork()).ldelim();
                if (message.getDeviceCia402State != null && Object.hasOwnProperty.call(message, "getDeviceCia402State"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.encode(message.getDeviceCia402State, writer.uint32(/* id 137, wireType 2 =*/1098).fork()).ldelim();
                if (message.setDeviceCia402State != null && Object.hasOwnProperty.call(message, "setDeviceCia402State"))
                    $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.encode(message.setDeviceCia402State, writer.uint32(/* id 138, wireType 2 =*/1106).fork()).ldelim();
                if (message.getSystemLog != null && Object.hasOwnProperty.call(message, "getSystemLog"))
                    $root.motionmaster.MotionMasterMessage.Request.GetSystemLog.encode(message.getSystemLog, writer.uint32(/* id 139, wireType 2 =*/1114).fork()).ldelim();
                if (message.startDeviceSiiRestore != null && Object.hasOwnProperty.call(message, "startDeviceSiiRestore"))
                    $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.encode(message.startDeviceSiiRestore, writer.uint32(/* id 140, wireType 2 =*/1122).fork()).ldelim();
                if (message.startOpenLoopFieldControl != null && Object.hasOwnProperty.call(message, "startOpenLoopFieldControl"))
                    $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.encode(message.startOpenLoopFieldControl, writer.uint32(/* id 141, wireType 2 =*/1130).fork()).ldelim();
                if (message.computeFullAutoTuningGains != null && Object.hasOwnProperty.call(message, "computeFullAutoTuningGains"))
                    $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.encode(message.computeFullAutoTuningGains, writer.uint32(/* id 142, wireType 2 =*/1138).fork()).ldelim();
                if (message.startFullAutoTuning != null && Object.hasOwnProperty.call(message, "startFullAutoTuning"))
                    $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.encode(message.startFullAutoTuning, writer.uint32(/* id 143, wireType 2 =*/1146).fork()).ldelim();
                if (message.stopFullAutoTuning != null && Object.hasOwnProperty.call(message, "stopFullAutoTuning"))
                    $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.encode(message.stopFullAutoTuning, writer.uint32(/* id 144, wireType 2 =*/1154).fork()).ldelim();
                if (message.startCirculoEncoderConfiguration != null && Object.hasOwnProperty.call(message, "startCirculoEncoderConfiguration"))
                    $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.encode(message.startCirculoEncoderConfiguration, writer.uint32(/* id 145, wireType 2 =*/1162).fork()).ldelim();
                if (message.stopCirculoEncoderNarrowAngleCalibrationProcedure != null && Object.hasOwnProperty.call(message, "stopCirculoEncoderNarrowAngleCalibrationProcedure"))
                    $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.encode(message.stopCirculoEncoderNarrowAngleCalibrationProcedure, writer.uint32(/* id 146, wireType 2 =*/1170).fork()).ldelim();
                if (message.startOsCommand != null && Object.hasOwnProperty.call(message, "startOsCommand"))
                    $root.motionmaster.MotionMasterMessage.Request.StartOsCommand.encode(message.startOsCommand, writer.uint32(/* id 147, wireType 2 =*/1178).fork()).ldelim();
                if (message.executeForwardCall != null && Object.hasOwnProperty.call(message, "executeForwardCall"))
                    $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.encode(message.executeForwardCall, writer.uint32(/* id 148, wireType 2 =*/1186).fork()).ldelim();
                if (message.getSystemInformation != null && Object.hasOwnProperty.call(message, "getSystemInformation"))
                    $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation.encode(message.getSystemInformation, writer.uint32(/* id 149, wireType 2 =*/1194).fork()).ldelim();
                if (message.setPdoMode != null && Object.hasOwnProperty.call(message, "setPdoMode"))
                    $root.motionmaster.MotionMasterMessage.Request.SetPdoMode.encode(message.setPdoMode, writer.uint32(/* id 150, wireType 2 =*/1202).fork()).ldelim();
                if (message.getDeviceSii != null && Object.hasOwnProperty.call(message, "getDeviceSii"))
                    $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii.encode(message.getDeviceSii, writer.uint32(/* id 151, wireType 2 =*/1210).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {motionmaster.MotionMasterMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {motionmaster.MotionMasterMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1: {
                            message.topic = reader.string();
                            break;
                        }
                    case 101: {
                            message.pingSystem = $root.motionmaster.MotionMasterMessage.Request.PingSystem.decode(reader, reader.uint32());
                            break;
                        }
                    case 102: {
                            message.getSystemVersion = $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion.decode(reader, reader.uint32());
                            break;
                        }
                    case 103: {
                            message.getDeviceInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo.decode(reader, reader.uint32());
                            break;
                        }
                    case 104: {
                            message.getDeviceParameterInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.decode(reader, reader.uint32());
                            break;
                        }
                    case 105: {
                            message.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 106: {
                            message.getMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 107: {
                            message.setDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 108: {
                            message.setMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 109: {
                            message.getDeviceFileList = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList.decode(reader, reader.uint32());
                            break;
                        }
                    case 110: {
                            message.getDeviceFile = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile.decode(reader, reader.uint32());
                            break;
                        }
                    case 111: {
                            message.setDeviceFile = $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile.decode(reader, reader.uint32());
                            break;
                        }
                    case 112: {
                            message.deleteDeviceFile = $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.decode(reader, reader.uint32());
                            break;
                        }
                    case 113: {
                            message.resetDeviceFault = $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault.decode(reader, reader.uint32());
                            break;
                        }
                    case 114: {
                            message.stopDevice = $root.motionmaster.MotionMasterMessage.Request.StopDevice.decode(reader, reader.uint32());
                            break;
                        }
                    case 115: {
                            message.startDeviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.decode(reader, reader.uint32());
                            break;
                        }
                    case 116: {
                            message.getDeviceLog = $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog.decode(reader, reader.uint32());
                            break;
                        }
                    case 117: {
                            message.startCoggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.decode(reader, reader.uint32());
                            break;
                        }
                    case 118: {
                            message.getCoggingTorqueData = $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.decode(reader, reader.uint32());
                            break;
                        }
                    case 119: {
                            message.startOffsetDetection = $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection.decode(reader, reader.uint32());
                            break;
                        }
                    case 120: {
                            message.startPlantIdentification = $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification.decode(reader, reader.uint32());
                            break;
                        }
                    case 121: {
                            message.computeAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.decode(reader, reader.uint32());
                            break;
                        }
                    case 122: {
                            message.setMotionControllerParameters = $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.decode(reader, reader.uint32());
                            break;
                        }
                    case 123: {
                            message.enableMotionController = $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.decode(reader, reader.uint32());
                            break;
                        }
                    case 124: {
                            message.disableMotionController = $root.motionmaster.MotionMasterMessage.Request.DisableMotionController.decode(reader, reader.uint32());
                            break;
                        }
                    case 125: {
                            message.setSignalGeneratorParameters = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.decode(reader, reader.uint32());
                            break;
                        }
                    case 126: {
                            message.startSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator.decode(reader, reader.uint32());
                            break;
                        }
                    case 127: {
                            message.stopSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator.decode(reader, reader.uint32());
                            break;
                        }
                    case 128: {
                            message.startMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 129: {
                            message.stopMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 130: {
                            message.getEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.decode(reader, reader.uint32());
                            break;
                        }
                    case 131: {
                            message.setEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.decode(reader, reader.uint32());
                            break;
                        }
                    case 132: {
                            message.startNarrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.decode(reader, reader.uint32());
                            break;
                        }
                    case 133: {
                            message.setSystemClientTimeout = $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.decode(reader, reader.uint32());
                            break;
                        }
                    case 134: {
                            message.startSystemIdentification = $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification.decode(reader, reader.uint32());
                            break;
                        }
                    case 135: {
                            message.getCirculoEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.decode(reader, reader.uint32());
                            break;
                        }
                    case 136: {
                            message.startCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.decode(reader, reader.uint32());
                            break;
                        }
                    case 137: {
                            message.getDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.decode(reader, reader.uint32());
                            break;
                        }
                    case 138: {
                            message.setDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.decode(reader, reader.uint32());
                            break;
                        }
                    case 139: {
                            message.getSystemLog = $root.motionmaster.MotionMasterMessage.Request.GetSystemLog.decode(reader, reader.uint32());
                            break;
                        }
                    case 140: {
                            message.startDeviceSiiRestore = $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.decode(reader, reader.uint32());
                            break;
                        }
                    case 141: {
                            message.startOpenLoopFieldControl = $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.decode(reader, reader.uint32());
                            break;
                        }
                    case 142: {
                            message.computeFullAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.decode(reader, reader.uint32());
                            break;
                        }
                    case 143: {
                            message.startFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.decode(reader, reader.uint32());
                            break;
                        }
                    case 144: {
                            message.stopFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.decode(reader, reader.uint32());
                            break;
                        }
                    case 145: {
                            message.startCirculoEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.decode(reader, reader.uint32());
                            break;
                        }
                    case 146: {
                            message.stopCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.decode(reader, reader.uint32());
                            break;
                        }
                    case 147: {
                            message.startOsCommand = $root.motionmaster.MotionMasterMessage.Request.StartOsCommand.decode(reader, reader.uint32());
                            break;
                        }
                    case 148: {
                            message.executeForwardCall = $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.decode(reader, reader.uint32());
                            break;
                        }
                    case 149: {
                            message.getSystemInformation = $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation.decode(reader, reader.uint32());
                            break;
                        }
                    case 150: {
                            message.setPdoMode = $root.motionmaster.MotionMasterMessage.Request.SetPdoMode.decode(reader, reader.uint32());
                            break;
                        }
                    case 151: {
                            message.getDeviceSii = $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {motionmaster.MotionMasterMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.topic != null && message.hasOwnProperty("topic"))
                    if (!$util.isString(message.topic))
                        return "topic: string expected";
                if (message.pingSystem != null && message.hasOwnProperty("pingSystem")) {
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.PingSystem.verify(message.pingSystem);
                        if (error)
                            return "pingSystem." + error;
                    }
                }
                if (message.getSystemVersion != null && message.hasOwnProperty("getSystemVersion")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion.verify(message.getSystemVersion);
                        if (error)
                            return "getSystemVersion." + error;
                    }
                }
                if (message.getDeviceInfo != null && message.hasOwnProperty("getDeviceInfo")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo.verify(message.getDeviceInfo);
                        if (error)
                            return "getDeviceInfo." + error;
                    }
                }
                if (message.getDeviceParameterInfo != null && message.hasOwnProperty("getDeviceParameterInfo")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.verify(message.getDeviceParameterInfo);
                        if (error)
                            return "getDeviceParameterInfo." + error;
                    }
                }
                if (message.getDeviceParameterValues != null && message.hasOwnProperty("getDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.verify(message.getDeviceParameterValues);
                        if (error)
                            return "getDeviceParameterValues." + error;
                    }
                }
                if (message.getMultiDeviceParameterValues != null && message.hasOwnProperty("getMultiDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.verify(message.getMultiDeviceParameterValues);
                        if (error)
                            return "getMultiDeviceParameterValues." + error;
                    }
                }
                if (message.setDeviceParameterValues != null && message.hasOwnProperty("setDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.verify(message.setDeviceParameterValues);
                        if (error)
                            return "setDeviceParameterValues." + error;
                    }
                }
                if (message.setMultiDeviceParameterValues != null && message.hasOwnProperty("setMultiDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.verify(message.setMultiDeviceParameterValues);
                        if (error)
                            return "setMultiDeviceParameterValues." + error;
                    }
                }
                if (message.getDeviceFileList != null && message.hasOwnProperty("getDeviceFileList")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList.verify(message.getDeviceFileList);
                        if (error)
                            return "getDeviceFileList." + error;
                    }
                }
                if (message.getDeviceFile != null && message.hasOwnProperty("getDeviceFile")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile.verify(message.getDeviceFile);
                        if (error)
                            return "getDeviceFile." + error;
                    }
                }
                if (message.setDeviceFile != null && message.hasOwnProperty("setDeviceFile")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile.verify(message.setDeviceFile);
                        if (error)
                            return "setDeviceFile." + error;
                    }
                }
                if (message.deleteDeviceFile != null && message.hasOwnProperty("deleteDeviceFile")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.verify(message.deleteDeviceFile);
                        if (error)
                            return "deleteDeviceFile." + error;
                    }
                }
                if (message.resetDeviceFault != null && message.hasOwnProperty("resetDeviceFault")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault.verify(message.resetDeviceFault);
                        if (error)
                            return "resetDeviceFault." + error;
                    }
                }
                if (message.stopDevice != null && message.hasOwnProperty("stopDevice")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StopDevice.verify(message.stopDevice);
                        if (error)
                            return "stopDevice." + error;
                    }
                }
                if (message.startDeviceFirmwareInstallation != null && message.hasOwnProperty("startDeviceFirmwareInstallation")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.verify(message.startDeviceFirmwareInstallation);
                        if (error)
                            return "startDeviceFirmwareInstallation." + error;
                    }
                }
                if (message.getDeviceLog != null && message.hasOwnProperty("getDeviceLog")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog.verify(message.getDeviceLog);
                        if (error)
                            return "getDeviceLog." + error;
                    }
                }
                if (message.startCoggingTorqueRecording != null && message.hasOwnProperty("startCoggingTorqueRecording")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.verify(message.startCoggingTorqueRecording);
                        if (error)
                            return "startCoggingTorqueRecording." + error;
                    }
                }
                if (message.getCoggingTorqueData != null && message.hasOwnProperty("getCoggingTorqueData")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.verify(message.getCoggingTorqueData);
                        if (error)
                            return "getCoggingTorqueData." + error;
                    }
                }
                if (message.startOffsetDetection != null && message.hasOwnProperty("startOffsetDetection")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection.verify(message.startOffsetDetection);
                        if (error)
                            return "startOffsetDetection." + error;
                    }
                }
                if (message.startPlantIdentification != null && message.hasOwnProperty("startPlantIdentification")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification.verify(message.startPlantIdentification);
                        if (error)
                            return "startPlantIdentification." + error;
                    }
                }
                if (message.computeAutoTuningGains != null && message.hasOwnProperty("computeAutoTuningGains")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.verify(message.computeAutoTuningGains);
                        if (error)
                            return "computeAutoTuningGains." + error;
                    }
                }
                if (message.setMotionControllerParameters != null && message.hasOwnProperty("setMotionControllerParameters")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.verify(message.setMotionControllerParameters);
                        if (error)
                            return "setMotionControllerParameters." + error;
                    }
                }
                if (message.enableMotionController != null && message.hasOwnProperty("enableMotionController")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.verify(message.enableMotionController);
                        if (error)
                            return "enableMotionController." + error;
                    }
                }
                if (message.disableMotionController != null && message.hasOwnProperty("disableMotionController")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.DisableMotionController.verify(message.disableMotionController);
                        if (error)
                            return "disableMotionController." + error;
                    }
                }
                if (message.setSignalGeneratorParameters != null && message.hasOwnProperty("setSignalGeneratorParameters")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.verify(message.setSignalGeneratorParameters);
                        if (error)
                            return "setSignalGeneratorParameters." + error;
                    }
                }
                if (message.startSignalGenerator != null && message.hasOwnProperty("startSignalGenerator")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator.verify(message.startSignalGenerator);
                        if (error)
                            return "startSignalGenerator." + error;
                    }
                }
                if (message.stopSignalGenerator != null && message.hasOwnProperty("stopSignalGenerator")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator.verify(message.stopSignalGenerator);
                        if (error)
                            return "stopSignalGenerator." + error;
                    }
                }
                if (message.startMonitoringDeviceParameterValues != null && message.hasOwnProperty("startMonitoringDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.verify(message.startMonitoringDeviceParameterValues);
                        if (error)
                            return "startMonitoringDeviceParameterValues." + error;
                    }
                }
                if (message.stopMonitoringDeviceParameterValues != null && message.hasOwnProperty("stopMonitoringDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.verify(message.stopMonitoringDeviceParameterValues);
                        if (error)
                            return "stopMonitoringDeviceParameterValues." + error;
                    }
                }
                if (message.getEthercatNetworkState != null && message.hasOwnProperty("getEthercatNetworkState")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.verify(message.getEthercatNetworkState);
                        if (error)
                            return "getEthercatNetworkState." + error;
                    }
                }
                if (message.setEthercatNetworkState != null && message.hasOwnProperty("setEthercatNetworkState")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.verify(message.setEthercatNetworkState);
                        if (error)
                            return "setEthercatNetworkState." + error;
                    }
                }
                if (message.startNarrowAngleCalibration != null && message.hasOwnProperty("startNarrowAngleCalibration")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.verify(message.startNarrowAngleCalibration);
                        if (error)
                            return "startNarrowAngleCalibration." + error;
                    }
                }
                if (message.setSystemClientTimeout != null && message.hasOwnProperty("setSystemClientTimeout")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.verify(message.setSystemClientTimeout);
                        if (error)
                            return "setSystemClientTimeout." + error;
                    }
                }
                if (message.startSystemIdentification != null && message.hasOwnProperty("startSystemIdentification")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification.verify(message.startSystemIdentification);
                        if (error)
                            return "startSystemIdentification." + error;
                    }
                }
                if (message.getCirculoEncoderMagnetDistance != null && message.hasOwnProperty("getCirculoEncoderMagnetDistance")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.verify(message.getCirculoEncoderMagnetDistance);
                        if (error)
                            return "getCirculoEncoderMagnetDistance." + error;
                    }
                }
                if (message.startCirculoEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("startCirculoEncoderNarrowAngleCalibrationProcedure")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.verify(message.startCirculoEncoderNarrowAngleCalibrationProcedure);
                        if (error)
                            return "startCirculoEncoderNarrowAngleCalibrationProcedure." + error;
                    }
                }
                if (message.getDeviceCia402State != null && message.hasOwnProperty("getDeviceCia402State")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.verify(message.getDeviceCia402State);
                        if (error)
                            return "getDeviceCia402State." + error;
                    }
                }
                if (message.setDeviceCia402State != null && message.hasOwnProperty("setDeviceCia402State")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.verify(message.setDeviceCia402State);
                        if (error)
                            return "setDeviceCia402State." + error;
                    }
                }
                if (message.getSystemLog != null && message.hasOwnProperty("getSystemLog")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetSystemLog.verify(message.getSystemLog);
                        if (error)
                            return "getSystemLog." + error;
                    }
                }
                if (message.startDeviceSiiRestore != null && message.hasOwnProperty("startDeviceSiiRestore")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.verify(message.startDeviceSiiRestore);
                        if (error)
                            return "startDeviceSiiRestore." + error;
                    }
                }
                if (message.startOpenLoopFieldControl != null && message.hasOwnProperty("startOpenLoopFieldControl")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.verify(message.startOpenLoopFieldControl);
                        if (error)
                            return "startOpenLoopFieldControl." + error;
                    }
                }
                if (message.computeFullAutoTuningGains != null && message.hasOwnProperty("computeFullAutoTuningGains")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.verify(message.computeFullAutoTuningGains);
                        if (error)
                            return "computeFullAutoTuningGains." + error;
                    }
                }
                if (message.startFullAutoTuning != null && message.hasOwnProperty("startFullAutoTuning")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.verify(message.startFullAutoTuning);
                        if (error)
                            return "startFullAutoTuning." + error;
                    }
                }
                if (message.stopFullAutoTuning != null && message.hasOwnProperty("stopFullAutoTuning")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.verify(message.stopFullAutoTuning);
                        if (error)
                            return "stopFullAutoTuning." + error;
                    }
                }
                if (message.startCirculoEncoderConfiguration != null && message.hasOwnProperty("startCirculoEncoderConfiguration")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.verify(message.startCirculoEncoderConfiguration);
                        if (error)
                            return "startCirculoEncoderConfiguration." + error;
                    }
                }
                if (message.stopCirculoEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("stopCirculoEncoderNarrowAngleCalibrationProcedure")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.verify(message.stopCirculoEncoderNarrowAngleCalibrationProcedure);
                        if (error)
                            return "stopCirculoEncoderNarrowAngleCalibrationProcedure." + error;
                    }
                }
                if (message.startOsCommand != null && message.hasOwnProperty("startOsCommand")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.StartOsCommand.verify(message.startOsCommand);
                        if (error)
                            return "startOsCommand." + error;
                    }
                }
                if (message.executeForwardCall != null && message.hasOwnProperty("executeForwardCall")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.verify(message.executeForwardCall);
                        if (error)
                            return "executeForwardCall." + error;
                    }
                }
                if (message.getSystemInformation != null && message.hasOwnProperty("getSystemInformation")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation.verify(message.getSystemInformation);
                        if (error)
                            return "getSystemInformation." + error;
                    }
                }
                if (message.setPdoMode != null && message.hasOwnProperty("setPdoMode")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.SetPdoMode.verify(message.setPdoMode);
                        if (error)
                            return "setPdoMode." + error;
                    }
                }
                if (message.getDeviceSii != null && message.hasOwnProperty("getDeviceSii")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii.verify(message.getDeviceSii);
                        if (error)
                            return "getDeviceSii." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {motionmaster.MotionMasterMessage.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.motionmaster.MotionMasterMessage.Request)
                    return object;
                let message = new $root.motionmaster.MotionMasterMessage.Request();
                if (object.topic != null)
                    message.topic = String(object.topic);
                if (object.pingSystem != null) {
                    if (typeof object.pingSystem !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.pingSystem: object expected");
                    message.pingSystem = $root.motionmaster.MotionMasterMessage.Request.PingSystem.fromObject(object.pingSystem);
                }
                if (object.getSystemVersion != null) {
                    if (typeof object.getSystemVersion !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getSystemVersion: object expected");
                    message.getSystemVersion = $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion.fromObject(object.getSystemVersion);
                }
                if (object.getDeviceInfo != null) {
                    if (typeof object.getDeviceInfo !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceInfo: object expected");
                    message.getDeviceInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo.fromObject(object.getDeviceInfo);
                }
                if (object.getDeviceParameterInfo != null) {
                    if (typeof object.getDeviceParameterInfo !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceParameterInfo: object expected");
                    message.getDeviceParameterInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.fromObject(object.getDeviceParameterInfo);
                }
                if (object.getDeviceParameterValues != null) {
                    if (typeof object.getDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceParameterValues: object expected");
                    message.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.fromObject(object.getDeviceParameterValues);
                }
                if (object.getMultiDeviceParameterValues != null) {
                    if (typeof object.getMultiDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getMultiDeviceParameterValues: object expected");
                    message.getMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.fromObject(object.getMultiDeviceParameterValues);
                }
                if (object.setDeviceParameterValues != null) {
                    if (typeof object.setDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setDeviceParameterValues: object expected");
                    message.setDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.fromObject(object.setDeviceParameterValues);
                }
                if (object.setMultiDeviceParameterValues != null) {
                    if (typeof object.setMultiDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setMultiDeviceParameterValues: object expected");
                    message.setMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.fromObject(object.setMultiDeviceParameterValues);
                }
                if (object.getDeviceFileList != null) {
                    if (typeof object.getDeviceFileList !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceFileList: object expected");
                    message.getDeviceFileList = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList.fromObject(object.getDeviceFileList);
                }
                if (object.getDeviceFile != null) {
                    if (typeof object.getDeviceFile !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceFile: object expected");
                    message.getDeviceFile = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile.fromObject(object.getDeviceFile);
                }
                if (object.setDeviceFile != null) {
                    if (typeof object.setDeviceFile !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setDeviceFile: object expected");
                    message.setDeviceFile = $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile.fromObject(object.setDeviceFile);
                }
                if (object.deleteDeviceFile != null) {
                    if (typeof object.deleteDeviceFile !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.deleteDeviceFile: object expected");
                    message.deleteDeviceFile = $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.fromObject(object.deleteDeviceFile);
                }
                if (object.resetDeviceFault != null) {
                    if (typeof object.resetDeviceFault !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.resetDeviceFault: object expected");
                    message.resetDeviceFault = $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault.fromObject(object.resetDeviceFault);
                }
                if (object.stopDevice != null) {
                    if (typeof object.stopDevice !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.stopDevice: object expected");
                    message.stopDevice = $root.motionmaster.MotionMasterMessage.Request.StopDevice.fromObject(object.stopDevice);
                }
                if (object.startDeviceFirmwareInstallation != null) {
                    if (typeof object.startDeviceFirmwareInstallation !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startDeviceFirmwareInstallation: object expected");
                    message.startDeviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.fromObject(object.startDeviceFirmwareInstallation);
                }
                if (object.getDeviceLog != null) {
                    if (typeof object.getDeviceLog !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceLog: object expected");
                    message.getDeviceLog = $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog.fromObject(object.getDeviceLog);
                }
                if (object.startCoggingTorqueRecording != null) {
                    if (typeof object.startCoggingTorqueRecording !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startCoggingTorqueRecording: object expected");
                    message.startCoggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.fromObject(object.startCoggingTorqueRecording);
                }
                if (object.getCoggingTorqueData != null) {
                    if (typeof object.getCoggingTorqueData !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getCoggingTorqueData: object expected");
                    message.getCoggingTorqueData = $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.fromObject(object.getCoggingTorqueData);
                }
                if (object.startOffsetDetection != null) {
                    if (typeof object.startOffsetDetection !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startOffsetDetection: object expected");
                    message.startOffsetDetection = $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection.fromObject(object.startOffsetDetection);
                }
                if (object.startPlantIdentification != null) {
                    if (typeof object.startPlantIdentification !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startPlantIdentification: object expected");
                    message.startPlantIdentification = $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification.fromObject(object.startPlantIdentification);
                }
                if (object.computeAutoTuningGains != null) {
                    if (typeof object.computeAutoTuningGains !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.computeAutoTuningGains: object expected");
                    message.computeAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.fromObject(object.computeAutoTuningGains);
                }
                if (object.setMotionControllerParameters != null) {
                    if (typeof object.setMotionControllerParameters !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setMotionControllerParameters: object expected");
                    message.setMotionControllerParameters = $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.fromObject(object.setMotionControllerParameters);
                }
                if (object.enableMotionController != null) {
                    if (typeof object.enableMotionController !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.enableMotionController: object expected");
                    message.enableMotionController = $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.fromObject(object.enableMotionController);
                }
                if (object.disableMotionController != null) {
                    if (typeof object.disableMotionController !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.disableMotionController: object expected");
                    message.disableMotionController = $root.motionmaster.MotionMasterMessage.Request.DisableMotionController.fromObject(object.disableMotionController);
                }
                if (object.setSignalGeneratorParameters != null) {
                    if (typeof object.setSignalGeneratorParameters !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setSignalGeneratorParameters: object expected");
                    message.setSignalGeneratorParameters = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.fromObject(object.setSignalGeneratorParameters);
                }
                if (object.startSignalGenerator != null) {
                    if (typeof object.startSignalGenerator !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startSignalGenerator: object expected");
                    message.startSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator.fromObject(object.startSignalGenerator);
                }
                if (object.stopSignalGenerator != null) {
                    if (typeof object.stopSignalGenerator !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.stopSignalGenerator: object expected");
                    message.stopSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator.fromObject(object.stopSignalGenerator);
                }
                if (object.startMonitoringDeviceParameterValues != null) {
                    if (typeof object.startMonitoringDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startMonitoringDeviceParameterValues: object expected");
                    message.startMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.fromObject(object.startMonitoringDeviceParameterValues);
                }
                if (object.stopMonitoringDeviceParameterValues != null) {
                    if (typeof object.stopMonitoringDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.stopMonitoringDeviceParameterValues: object expected");
                    message.stopMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.fromObject(object.stopMonitoringDeviceParameterValues);
                }
                if (object.getEthercatNetworkState != null) {
                    if (typeof object.getEthercatNetworkState !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getEthercatNetworkState: object expected");
                    message.getEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.fromObject(object.getEthercatNetworkState);
                }
                if (object.setEthercatNetworkState != null) {
                    if (typeof object.setEthercatNetworkState !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setEthercatNetworkState: object expected");
                    message.setEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.fromObject(object.setEthercatNetworkState);
                }
                if (object.startNarrowAngleCalibration != null) {
                    if (typeof object.startNarrowAngleCalibration !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startNarrowAngleCalibration: object expected");
                    message.startNarrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.fromObject(object.startNarrowAngleCalibration);
                }
                if (object.setSystemClientTimeout != null) {
                    if (typeof object.setSystemClientTimeout !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setSystemClientTimeout: object expected");
                    message.setSystemClientTimeout = $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.fromObject(object.setSystemClientTimeout);
                }
                if (object.startSystemIdentification != null) {
                    if (typeof object.startSystemIdentification !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startSystemIdentification: object expected");
                    message.startSystemIdentification = $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification.fromObject(object.startSystemIdentification);
                }
                if (object.getCirculoEncoderMagnetDistance != null) {
                    if (typeof object.getCirculoEncoderMagnetDistance !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getCirculoEncoderMagnetDistance: object expected");
                    message.getCirculoEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.fromObject(object.getCirculoEncoderMagnetDistance);
                }
                if (object.startCirculoEncoderNarrowAngleCalibrationProcedure != null) {
                    if (typeof object.startCirculoEncoderNarrowAngleCalibrationProcedure !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startCirculoEncoderNarrowAngleCalibrationProcedure: object expected");
                    message.startCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.fromObject(object.startCirculoEncoderNarrowAngleCalibrationProcedure);
                }
                if (object.getDeviceCia402State != null) {
                    if (typeof object.getDeviceCia402State !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceCia402State: object expected");
                    message.getDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.fromObject(object.getDeviceCia402State);
                }
                if (object.setDeviceCia402State != null) {
                    if (typeof object.setDeviceCia402State !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setDeviceCia402State: object expected");
                    message.setDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.fromObject(object.setDeviceCia402State);
                }
                if (object.getSystemLog != null) {
                    if (typeof object.getSystemLog !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getSystemLog: object expected");
                    message.getSystemLog = $root.motionmaster.MotionMasterMessage.Request.GetSystemLog.fromObject(object.getSystemLog);
                }
                if (object.startDeviceSiiRestore != null) {
                    if (typeof object.startDeviceSiiRestore !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startDeviceSiiRestore: object expected");
                    message.startDeviceSiiRestore = $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.fromObject(object.startDeviceSiiRestore);
                }
                if (object.startOpenLoopFieldControl != null) {
                    if (typeof object.startOpenLoopFieldControl !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startOpenLoopFieldControl: object expected");
                    message.startOpenLoopFieldControl = $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.fromObject(object.startOpenLoopFieldControl);
                }
                if (object.computeFullAutoTuningGains != null) {
                    if (typeof object.computeFullAutoTuningGains !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.computeFullAutoTuningGains: object expected");
                    message.computeFullAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.fromObject(object.computeFullAutoTuningGains);
                }
                if (object.startFullAutoTuning != null) {
                    if (typeof object.startFullAutoTuning !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startFullAutoTuning: object expected");
                    message.startFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.fromObject(object.startFullAutoTuning);
                }
                if (object.stopFullAutoTuning != null) {
                    if (typeof object.stopFullAutoTuning !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.stopFullAutoTuning: object expected");
                    message.stopFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.fromObject(object.stopFullAutoTuning);
                }
                if (object.startCirculoEncoderConfiguration != null) {
                    if (typeof object.startCirculoEncoderConfiguration !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startCirculoEncoderConfiguration: object expected");
                    message.startCirculoEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.fromObject(object.startCirculoEncoderConfiguration);
                }
                if (object.stopCirculoEncoderNarrowAngleCalibrationProcedure != null) {
                    if (typeof object.stopCirculoEncoderNarrowAngleCalibrationProcedure !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.stopCirculoEncoderNarrowAngleCalibrationProcedure: object expected");
                    message.stopCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.fromObject(object.stopCirculoEncoderNarrowAngleCalibrationProcedure);
                }
                if (object.startOsCommand != null) {
                    if (typeof object.startOsCommand !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.startOsCommand: object expected");
                    message.startOsCommand = $root.motionmaster.MotionMasterMessage.Request.StartOsCommand.fromObject(object.startOsCommand);
                }
                if (object.executeForwardCall != null) {
                    if (typeof object.executeForwardCall !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.executeForwardCall: object expected");
                    message.executeForwardCall = $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.fromObject(object.executeForwardCall);
                }
                if (object.getSystemInformation != null) {
                    if (typeof object.getSystemInformation !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getSystemInformation: object expected");
                    message.getSystemInformation = $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation.fromObject(object.getSystemInformation);
                }
                if (object.setPdoMode != null) {
                    if (typeof object.setPdoMode !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.setPdoMode: object expected");
                    message.setPdoMode = $root.motionmaster.MotionMasterMessage.Request.SetPdoMode.fromObject(object.setPdoMode);
                }
                if (object.getDeviceSii != null) {
                    if (typeof object.getDeviceSii !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Request.getDeviceSii: object expected");
                    message.getDeviceSii = $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii.fromObject(object.getDeviceSii);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {motionmaster.MotionMasterMessage.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.topic = "";
                if (message.topic != null && message.hasOwnProperty("topic"))
                    object.topic = message.topic;
                if (message.pingSystem != null && message.hasOwnProperty("pingSystem")) {
                    object.pingSystem = $root.motionmaster.MotionMasterMessage.Request.PingSystem.toObject(message.pingSystem, options);
                    if (options.oneofs)
                        object.type = "pingSystem";
                }
                if (message.getSystemVersion != null && message.hasOwnProperty("getSystemVersion")) {
                    object.getSystemVersion = $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion.toObject(message.getSystemVersion, options);
                    if (options.oneofs)
                        object.type = "getSystemVersion";
                }
                if (message.getDeviceInfo != null && message.hasOwnProperty("getDeviceInfo")) {
                    object.getDeviceInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo.toObject(message.getDeviceInfo, options);
                    if (options.oneofs)
                        object.type = "getDeviceInfo";
                }
                if (message.getDeviceParameterInfo != null && message.hasOwnProperty("getDeviceParameterInfo")) {
                    object.getDeviceParameterInfo = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.toObject(message.getDeviceParameterInfo, options);
                    if (options.oneofs)
                        object.type = "getDeviceParameterInfo";
                }
                if (message.getDeviceParameterValues != null && message.hasOwnProperty("getDeviceParameterValues")) {
                    object.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.toObject(message.getDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "getDeviceParameterValues";
                }
                if (message.getMultiDeviceParameterValues != null && message.hasOwnProperty("getMultiDeviceParameterValues")) {
                    object.getMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.toObject(message.getMultiDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "getMultiDeviceParameterValues";
                }
                if (message.setDeviceParameterValues != null && message.hasOwnProperty("setDeviceParameterValues")) {
                    object.setDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.toObject(message.setDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "setDeviceParameterValues";
                }
                if (message.setMultiDeviceParameterValues != null && message.hasOwnProperty("setMultiDeviceParameterValues")) {
                    object.setMultiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.toObject(message.setMultiDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "setMultiDeviceParameterValues";
                }
                if (message.getDeviceFileList != null && message.hasOwnProperty("getDeviceFileList")) {
                    object.getDeviceFileList = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList.toObject(message.getDeviceFileList, options);
                    if (options.oneofs)
                        object.type = "getDeviceFileList";
                }
                if (message.getDeviceFile != null && message.hasOwnProperty("getDeviceFile")) {
                    object.getDeviceFile = $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile.toObject(message.getDeviceFile, options);
                    if (options.oneofs)
                        object.type = "getDeviceFile";
                }
                if (message.setDeviceFile != null && message.hasOwnProperty("setDeviceFile")) {
                    object.setDeviceFile = $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile.toObject(message.setDeviceFile, options);
                    if (options.oneofs)
                        object.type = "setDeviceFile";
                }
                if (message.deleteDeviceFile != null && message.hasOwnProperty("deleteDeviceFile")) {
                    object.deleteDeviceFile = $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.toObject(message.deleteDeviceFile, options);
                    if (options.oneofs)
                        object.type = "deleteDeviceFile";
                }
                if (message.resetDeviceFault != null && message.hasOwnProperty("resetDeviceFault")) {
                    object.resetDeviceFault = $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault.toObject(message.resetDeviceFault, options);
                    if (options.oneofs)
                        object.type = "resetDeviceFault";
                }
                if (message.stopDevice != null && message.hasOwnProperty("stopDevice")) {
                    object.stopDevice = $root.motionmaster.MotionMasterMessage.Request.StopDevice.toObject(message.stopDevice, options);
                    if (options.oneofs)
                        object.type = "stopDevice";
                }
                if (message.startDeviceFirmwareInstallation != null && message.hasOwnProperty("startDeviceFirmwareInstallation")) {
                    object.startDeviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.toObject(message.startDeviceFirmwareInstallation, options);
                    if (options.oneofs)
                        object.type = "startDeviceFirmwareInstallation";
                }
                if (message.getDeviceLog != null && message.hasOwnProperty("getDeviceLog")) {
                    object.getDeviceLog = $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog.toObject(message.getDeviceLog, options);
                    if (options.oneofs)
                        object.type = "getDeviceLog";
                }
                if (message.startCoggingTorqueRecording != null && message.hasOwnProperty("startCoggingTorqueRecording")) {
                    object.startCoggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.toObject(message.startCoggingTorqueRecording, options);
                    if (options.oneofs)
                        object.type = "startCoggingTorqueRecording";
                }
                if (message.getCoggingTorqueData != null && message.hasOwnProperty("getCoggingTorqueData")) {
                    object.getCoggingTorqueData = $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.toObject(message.getCoggingTorqueData, options);
                    if (options.oneofs)
                        object.type = "getCoggingTorqueData";
                }
                if (message.startOffsetDetection != null && message.hasOwnProperty("startOffsetDetection")) {
                    object.startOffsetDetection = $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection.toObject(message.startOffsetDetection, options);
                    if (options.oneofs)
                        object.type = "startOffsetDetection";
                }
                if (message.startPlantIdentification != null && message.hasOwnProperty("startPlantIdentification")) {
                    object.startPlantIdentification = $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification.toObject(message.startPlantIdentification, options);
                    if (options.oneofs)
                        object.type = "startPlantIdentification";
                }
                if (message.computeAutoTuningGains != null && message.hasOwnProperty("computeAutoTuningGains")) {
                    object.computeAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.toObject(message.computeAutoTuningGains, options);
                    if (options.oneofs)
                        object.type = "computeAutoTuningGains";
                }
                if (message.setMotionControllerParameters != null && message.hasOwnProperty("setMotionControllerParameters")) {
                    object.setMotionControllerParameters = $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.toObject(message.setMotionControllerParameters, options);
                    if (options.oneofs)
                        object.type = "setMotionControllerParameters";
                }
                if (message.enableMotionController != null && message.hasOwnProperty("enableMotionController")) {
                    object.enableMotionController = $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.toObject(message.enableMotionController, options);
                    if (options.oneofs)
                        object.type = "enableMotionController";
                }
                if (message.disableMotionController != null && message.hasOwnProperty("disableMotionController")) {
                    object.disableMotionController = $root.motionmaster.MotionMasterMessage.Request.DisableMotionController.toObject(message.disableMotionController, options);
                    if (options.oneofs)
                        object.type = "disableMotionController";
                }
                if (message.setSignalGeneratorParameters != null && message.hasOwnProperty("setSignalGeneratorParameters")) {
                    object.setSignalGeneratorParameters = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.toObject(message.setSignalGeneratorParameters, options);
                    if (options.oneofs)
                        object.type = "setSignalGeneratorParameters";
                }
                if (message.startSignalGenerator != null && message.hasOwnProperty("startSignalGenerator")) {
                    object.startSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator.toObject(message.startSignalGenerator, options);
                    if (options.oneofs)
                        object.type = "startSignalGenerator";
                }
                if (message.stopSignalGenerator != null && message.hasOwnProperty("stopSignalGenerator")) {
                    object.stopSignalGenerator = $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator.toObject(message.stopSignalGenerator, options);
                    if (options.oneofs)
                        object.type = "stopSignalGenerator";
                }
                if (message.startMonitoringDeviceParameterValues != null && message.hasOwnProperty("startMonitoringDeviceParameterValues")) {
                    object.startMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.toObject(message.startMonitoringDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "startMonitoringDeviceParameterValues";
                }
                if (message.stopMonitoringDeviceParameterValues != null && message.hasOwnProperty("stopMonitoringDeviceParameterValues")) {
                    object.stopMonitoringDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.toObject(message.stopMonitoringDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "stopMonitoringDeviceParameterValues";
                }
                if (message.getEthercatNetworkState != null && message.hasOwnProperty("getEthercatNetworkState")) {
                    object.getEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.toObject(message.getEthercatNetworkState, options);
                    if (options.oneofs)
                        object.type = "getEthercatNetworkState";
                }
                if (message.setEthercatNetworkState != null && message.hasOwnProperty("setEthercatNetworkState")) {
                    object.setEthercatNetworkState = $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.toObject(message.setEthercatNetworkState, options);
                    if (options.oneofs)
                        object.type = "setEthercatNetworkState";
                }
                if (message.startNarrowAngleCalibration != null && message.hasOwnProperty("startNarrowAngleCalibration")) {
                    object.startNarrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.toObject(message.startNarrowAngleCalibration, options);
                    if (options.oneofs)
                        object.type = "startNarrowAngleCalibration";
                }
                if (message.setSystemClientTimeout != null && message.hasOwnProperty("setSystemClientTimeout")) {
                    object.setSystemClientTimeout = $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.toObject(message.setSystemClientTimeout, options);
                    if (options.oneofs)
                        object.type = "setSystemClientTimeout";
                }
                if (message.startSystemIdentification != null && message.hasOwnProperty("startSystemIdentification")) {
                    object.startSystemIdentification = $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification.toObject(message.startSystemIdentification, options);
                    if (options.oneofs)
                        object.type = "startSystemIdentification";
                }
                if (message.getCirculoEncoderMagnetDistance != null && message.hasOwnProperty("getCirculoEncoderMagnetDistance")) {
                    object.getCirculoEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.toObject(message.getCirculoEncoderMagnetDistance, options);
                    if (options.oneofs)
                        object.type = "getCirculoEncoderMagnetDistance";
                }
                if (message.startCirculoEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("startCirculoEncoderNarrowAngleCalibrationProcedure")) {
                    object.startCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.toObject(message.startCirculoEncoderNarrowAngleCalibrationProcedure, options);
                    if (options.oneofs)
                        object.type = "startCirculoEncoderNarrowAngleCalibrationProcedure";
                }
                if (message.getDeviceCia402State != null && message.hasOwnProperty("getDeviceCia402State")) {
                    object.getDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.toObject(message.getDeviceCia402State, options);
                    if (options.oneofs)
                        object.type = "getDeviceCia402State";
                }
                if (message.setDeviceCia402State != null && message.hasOwnProperty("setDeviceCia402State")) {
                    object.setDeviceCia402State = $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.toObject(message.setDeviceCia402State, options);
                    if (options.oneofs)
                        object.type = "setDeviceCia402State";
                }
                if (message.getSystemLog != null && message.hasOwnProperty("getSystemLog")) {
                    object.getSystemLog = $root.motionmaster.MotionMasterMessage.Request.GetSystemLog.toObject(message.getSystemLog, options);
                    if (options.oneofs)
                        object.type = "getSystemLog";
                }
                if (message.startDeviceSiiRestore != null && message.hasOwnProperty("startDeviceSiiRestore")) {
                    object.startDeviceSiiRestore = $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.toObject(message.startDeviceSiiRestore, options);
                    if (options.oneofs)
                        object.type = "startDeviceSiiRestore";
                }
                if (message.startOpenLoopFieldControl != null && message.hasOwnProperty("startOpenLoopFieldControl")) {
                    object.startOpenLoopFieldControl = $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.toObject(message.startOpenLoopFieldControl, options);
                    if (options.oneofs)
                        object.type = "startOpenLoopFieldControl";
                }
                if (message.computeFullAutoTuningGains != null && message.hasOwnProperty("computeFullAutoTuningGains")) {
                    object.computeFullAutoTuningGains = $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.toObject(message.computeFullAutoTuningGains, options);
                    if (options.oneofs)
                        object.type = "computeFullAutoTuningGains";
                }
                if (message.startFullAutoTuning != null && message.hasOwnProperty("startFullAutoTuning")) {
                    object.startFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.toObject(message.startFullAutoTuning, options);
                    if (options.oneofs)
                        object.type = "startFullAutoTuning";
                }
                if (message.stopFullAutoTuning != null && message.hasOwnProperty("stopFullAutoTuning")) {
                    object.stopFullAutoTuning = $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.toObject(message.stopFullAutoTuning, options);
                    if (options.oneofs)
                        object.type = "stopFullAutoTuning";
                }
                if (message.startCirculoEncoderConfiguration != null && message.hasOwnProperty("startCirculoEncoderConfiguration")) {
                    object.startCirculoEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.toObject(message.startCirculoEncoderConfiguration, options);
                    if (options.oneofs)
                        object.type = "startCirculoEncoderConfiguration";
                }
                if (message.stopCirculoEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("stopCirculoEncoderNarrowAngleCalibrationProcedure")) {
                    object.stopCirculoEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.toObject(message.stopCirculoEncoderNarrowAngleCalibrationProcedure, options);
                    if (options.oneofs)
                        object.type = "stopCirculoEncoderNarrowAngleCalibrationProcedure";
                }
                if (message.startOsCommand != null && message.hasOwnProperty("startOsCommand")) {
                    object.startOsCommand = $root.motionmaster.MotionMasterMessage.Request.StartOsCommand.toObject(message.startOsCommand, options);
                    if (options.oneofs)
                        object.type = "startOsCommand";
                }
                if (message.executeForwardCall != null && message.hasOwnProperty("executeForwardCall")) {
                    object.executeForwardCall = $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.toObject(message.executeForwardCall, options);
                    if (options.oneofs)
                        object.type = "executeForwardCall";
                }
                if (message.getSystemInformation != null && message.hasOwnProperty("getSystemInformation")) {
                    object.getSystemInformation = $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation.toObject(message.getSystemInformation, options);
                    if (options.oneofs)
                        object.type = "getSystemInformation";
                }
                if (message.setPdoMode != null && message.hasOwnProperty("setPdoMode")) {
                    object.setPdoMode = $root.motionmaster.MotionMasterMessage.Request.SetPdoMode.toObject(message.setPdoMode, options);
                    if (options.oneofs)
                        object.type = "setPdoMode";
                }
                if (message.getDeviceSii != null && message.hasOwnProperty("getDeviceSii")) {
                    object.getDeviceSii = $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii.toObject(message.getDeviceSii, options);
                    if (options.oneofs)
                        object.type = "getDeviceSii";
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof motionmaster.MotionMasterMessage.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Request
             * @function getTypeUrl
             * @memberof motionmaster.MotionMasterMessage.Request
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request";
            };

            Request.PingSystem = (function() {

                /**
                 * Properties of a PingSystem.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IPingSystem
                 */

                /**
                 * Constructs a new PingSystem.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a PingSystem.
                 * @implements IPingSystem
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IPingSystem=} [properties] Properties to set
                 */
                function PingSystem(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new PingSystem instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IPingSystem=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.PingSystem} PingSystem instance
                 */
                PingSystem.create = function create(properties) {
                    return new PingSystem(properties);
                };

                /**
                 * Encodes the specified PingSystem message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.PingSystem.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IPingSystem} message PingSystem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PingSystem.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified PingSystem message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.PingSystem.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IPingSystem} message PingSystem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PingSystem.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PingSystem message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.PingSystem} PingSystem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PingSystem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.PingSystem();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PingSystem message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.PingSystem} PingSystem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PingSystem.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PingSystem message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PingSystem.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a PingSystem message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.PingSystem} PingSystem
                 */
                PingSystem.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.PingSystem)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Request.PingSystem();
                };

                /**
                 * Creates a plain object from a PingSystem message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.PingSystem} message PingSystem
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PingSystem.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this PingSystem to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PingSystem.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PingSystem
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.PingSystem
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PingSystem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.PingSystem";
                };

                return PingSystem;
            })();

            Request.GetSystemVersion = (function() {

                /**
                 * Properties of a GetSystemVersion.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetSystemVersion
                 */

                /**
                 * Constructs a new GetSystemVersion.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetSystemVersion.
                 * @implements IGetSystemVersion
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemVersion=} [properties] Properties to set
                 */
                function GetSystemVersion(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new GetSystemVersion instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemVersion=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemVersion} GetSystemVersion instance
                 */
                GetSystemVersion.create = function create(properties) {
                    return new GetSystemVersion(properties);
                };

                /**
                 * Encodes the specified GetSystemVersion message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemVersion.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemVersion} message GetSystemVersion message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemVersion.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified GetSystemVersion message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemVersion.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemVersion} message GetSystemVersion message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemVersion.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetSystemVersion message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemVersion} GetSystemVersion
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemVersion.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetSystemVersion message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemVersion} GetSystemVersion
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemVersion.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetSystemVersion message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetSystemVersion.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a GetSystemVersion message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemVersion} GetSystemVersion
                 */
                GetSystemVersion.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Request.GetSystemVersion();
                };

                /**
                 * Creates a plain object from a GetSystemVersion message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetSystemVersion} message GetSystemVersion
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetSystemVersion.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this GetSystemVersion to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetSystemVersion.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetSystemVersion
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemVersion
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetSystemVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetSystemVersion";
                };

                return GetSystemVersion;
            })();

            Request.GetDeviceInfo = (function() {

                /**
                 * Properties of a GetDeviceInfo.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceInfo
                 */

                /**
                 * Constructs a new GetDeviceInfo.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceInfo.
                 * @implements IGetDeviceInfo
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo=} [properties] Properties to set
                 */
                function GetDeviceInfo(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new GetDeviceInfo instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceInfo} GetDeviceInfo instance
                 */
                GetDeviceInfo.create = function create(properties) {
                    return new GetDeviceInfo(properties);
                };

                /**
                 * Encodes the specified GetDeviceInfo message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceInfo.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo} message GetDeviceInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceInfo message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceInfo} message GetDeviceInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceInfo} GetDeviceInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceInfo} GetDeviceInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceInfo message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceInfo} GetDeviceInfo
                 */
                GetDeviceInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Request.GetDeviceInfo();
                };

                /**
                 * Creates a plain object from a GetDeviceInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceInfo} message GetDeviceInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceInfo.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this GetDeviceInfo to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceInfo
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceInfo";
                };

                return GetDeviceInfo;
            })();

            Request.GetDeviceParameterInfo = (function() {

                /**
                 * Properties of a GetDeviceParameterInfo.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceParameterInfo
                 * @property {number|null} [deviceAddress] GetDeviceParameterInfo deviceAddress
                 */

                /**
                 * Constructs a new GetDeviceParameterInfo.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceParameterInfo.
                 * @implements IGetDeviceParameterInfo
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo=} [properties] Properties to set
                 */
                function GetDeviceParameterInfo(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceParameterInfo deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @instance
                 */
                GetDeviceParameterInfo.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetDeviceParameterInfo instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo} GetDeviceParameterInfo instance
                 */
                GetDeviceParameterInfo.create = function create(properties) {
                    return new GetDeviceParameterInfo(properties);
                };

                /**
                 * Encodes the specified GetDeviceParameterInfo message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo} message GetDeviceParameterInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceParameterInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceParameterInfo message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterInfo} message GetDeviceParameterInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceParameterInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceParameterInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo} GetDeviceParameterInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceParameterInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceParameterInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo} GetDeviceParameterInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceParameterInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceParameterInfo message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceParameterInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceParameterInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo} GetDeviceParameterInfo
                 */
                GetDeviceParameterInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceParameterInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo} message GetDeviceParameterInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceParameterInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetDeviceParameterInfo to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceParameterInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceParameterInfo
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceParameterInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceParameterInfo";
                };

                return GetDeviceParameterInfo;
            })();

            Request.GetDeviceParameterValues = (function() {

                /**
                 * Properties of a GetDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceParameterValues
                 * @property {number|null} [deviceAddress] GetDeviceParameterValues deviceAddress
                 * @property {Array.<motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter>|null} [parameters] GetDeviceParameterValues parameters
                 * @property {boolean|null} [sendProgress] GetDeviceParameterValues sendProgress
                 */

                /**
                 * Constructs a new GetDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceParameterValues.
                 * @implements IGetDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues=} [properties] Properties to set
                 */
                function GetDeviceParameterValues(properties) {
                    this.parameters = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceParameterValues deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @instance
                 */
                GetDeviceParameterValues.prototype.deviceAddress = 0;

                /**
                 * GetDeviceParameterValues parameters.
                 * @member {Array.<motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter>} parameters
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @instance
                 */
                GetDeviceParameterValues.prototype.parameters = $util.emptyArray;

                /**
                 * GetDeviceParameterValues sendProgress.
                 * @member {boolean} sendProgress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @instance
                 */
                GetDeviceParameterValues.prototype.sendProgress = false;

                /**
                 * Creates a new GetDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues} GetDeviceParameterValues instance
                 */
                GetDeviceParameterValues.create = function create(properties) {
                    return new GetDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified GetDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues} message GetDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.parameters != null && message.parameters.length)
                        for (let i = 0; i < message.parameters.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.encode(message.parameters[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.sendProgress != null && Object.hasOwnProperty.call(message, "sendProgress"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.sendProgress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues} message GetDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues} GetDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                if (!(message.parameters && message.parameters.length))
                                    message.parameters = [];
                                message.parameters.push($root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                message.sendProgress = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues} GetDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.parameters != null && message.hasOwnProperty("parameters")) {
                        if (!Array.isArray(message.parameters))
                            return "parameters: array expected";
                        for (let i = 0; i < message.parameters.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.verify(message.parameters[i]);
                            if (error)
                                return "parameters." + error;
                        }
                    }
                    if (message.sendProgress != null && message.hasOwnProperty("sendProgress"))
                        if (typeof message.sendProgress !== "boolean")
                            return "sendProgress: boolean expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues} GetDeviceParameterValues
                 */
                GetDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.parameters) {
                        if (!Array.isArray(object.parameters))
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.parameters: array expected");
                        message.parameters = [];
                        for (let i = 0; i < object.parameters.length; ++i) {
                            if (typeof object.parameters[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.parameters: object expected");
                            message.parameters[i] = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.fromObject(object.parameters[i]);
                        }
                    }
                    if (object.sendProgress != null)
                        message.sendProgress = Boolean(object.sendProgress);
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues} message GetDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.parameters = [];
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.sendProgress = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.parameters && message.parameters.length) {
                        object.parameters = [];
                        for (let j = 0; j < message.parameters.length; ++j)
                            object.parameters[j] = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.toObject(message.parameters[j], options);
                    }
                    if (message.sendProgress != null && message.hasOwnProperty("sendProgress"))
                        object.sendProgress = message.sendProgress;
                    return object;
                };

                /**
                 * Converts this GetDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues";
                };

                GetDeviceParameterValues.Parameter = (function() {

                    /**
                     * Properties of a Parameter.
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                     * @interface IParameter
                     * @property {number|null} [index] Parameter index
                     * @property {number|null} [subindex] Parameter subindex
                     * @property {boolean|null} [loadFromCache] Parameter loadFromCache
                     */

                    /**
                     * Constructs a new Parameter.
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues
                     * @classdesc Represents a Parameter.
                     * @implements IParameter
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter=} [properties] Properties to set
                     */
                    function Parameter(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Parameter index.
                     * @member {number} index
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @instance
                     */
                    Parameter.prototype.index = 0;

                    /**
                     * Parameter subindex.
                     * @member {number} subindex
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @instance
                     */
                    Parameter.prototype.subindex = 0;

                    /**
                     * Parameter loadFromCache.
                     * @member {boolean} loadFromCache
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @instance
                     */
                    Parameter.prototype.loadFromCache = false;

                    /**
                     * Creates a new Parameter instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter} Parameter instance
                     */
                    Parameter.create = function create(properties) {
                        return new Parameter(properties);
                    };

                    /**
                     * Encodes the specified Parameter message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                        if (message.subindex != null && Object.hasOwnProperty.call(message, "subindex"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.subindex);
                        if (message.loadFromCache != null && Object.hasOwnProperty.call(message, "loadFromCache"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.loadFromCache);
                        return writer;
                    };

                    /**
                     * Encodes the specified Parameter message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Parameter message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.index = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.subindex = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.loadFromCache = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Parameter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Parameter message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Parameter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.index != null && message.hasOwnProperty("index"))
                            if (!$util.isInteger(message.index))
                                return "index: integer expected";
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            if (!$util.isInteger(message.subindex))
                                return "subindex: integer expected";
                        if (message.loadFromCache != null && message.hasOwnProperty("loadFromCache"))
                            if (typeof message.loadFromCache !== "boolean")
                                return "loadFromCache: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a Parameter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter} Parameter
                     */
                    Parameter.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter();
                        if (object.index != null)
                            message.index = object.index >>> 0;
                        if (object.subindex != null)
                            message.subindex = object.subindex >>> 0;
                        if (object.loadFromCache != null)
                            message.loadFromCache = Boolean(object.loadFromCache);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Parameter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter} message Parameter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Parameter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.index = 0;
                            object.subindex = 0;
                            object.loadFromCache = false;
                        }
                        if (message.index != null && message.hasOwnProperty("index"))
                            object.index = message.index;
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            object.subindex = message.subindex;
                        if (message.loadFromCache != null && message.hasOwnProperty("loadFromCache"))
                            object.loadFromCache = message.loadFromCache;
                        return object;
                    };

                    /**
                     * Converts this Parameter to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Parameter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Parameter
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Parameter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.Parameter";
                    };

                    return Parameter;
                })();

                return GetDeviceParameterValues;
            })();

            Request.GetMultiDeviceParameterValues = (function() {

                /**
                 * Properties of a GetMultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetMultiDeviceParameterValues
                 * @property {Array.<motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues>|null} [collection] GetMultiDeviceParameterValues collection
                 */

                /**
                 * Constructs a new GetMultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetMultiDeviceParameterValues.
                 * @implements IGetMultiDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues=} [properties] Properties to set
                 */
                function GetMultiDeviceParameterValues(properties) {
                    this.collection = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetMultiDeviceParameterValues collection.
                 * @member {Array.<motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues>} collection
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @instance
                 */
                GetMultiDeviceParameterValues.prototype.collection = $util.emptyArray;

                /**
                 * Creates a new GetMultiDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues} GetMultiDeviceParameterValues instance
                 */
                GetMultiDeviceParameterValues.create = function create(properties) {
                    return new GetMultiDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified GetMultiDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues} message GetMultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMultiDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.collection != null && message.collection.length)
                        for (let i = 0; i < message.collection.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.encode(message.collection[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GetMultiDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetMultiDeviceParameterValues} message GetMultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMultiDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetMultiDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues} GetMultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMultiDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.collection && message.collection.length))
                                    message.collection = [];
                                message.collection.push($root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetMultiDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues} GetMultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMultiDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetMultiDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetMultiDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.collection != null && message.hasOwnProperty("collection")) {
                        if (!Array.isArray(message.collection))
                            return "collection: array expected";
                        for (let i = 0; i < message.collection.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.verify(message.collection[i]);
                            if (error)
                                return "collection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a GetMultiDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues} GetMultiDeviceParameterValues
                 */
                GetMultiDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues();
                    if (object.collection) {
                        if (!Array.isArray(object.collection))
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.collection: array expected");
                        message.collection = [];
                        for (let i = 0; i < object.collection.length; ++i) {
                            if (typeof object.collection[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues.collection: object expected");
                            message.collection[i] = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.fromObject(object.collection[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetMultiDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues} message GetMultiDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetMultiDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.collection = [];
                    if (message.collection && message.collection.length) {
                        object.collection = [];
                        for (let j = 0; j < message.collection.length; ++j)
                            object.collection[j] = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.toObject(message.collection[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this GetMultiDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetMultiDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetMultiDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetMultiDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetMultiDeviceParameterValues";
                };

                return GetMultiDeviceParameterValues;
            })();

            Request.SetDeviceParameterValues = (function() {

                /**
                 * Properties of a SetDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetDeviceParameterValues
                 * @property {number|null} [deviceAddress] SetDeviceParameterValues deviceAddress
                 * @property {Array.<motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue>|null} [parameterValues] SetDeviceParameterValues parameterValues
                 */

                /**
                 * Constructs a new SetDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetDeviceParameterValues.
                 * @implements ISetDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues=} [properties] Properties to set
                 */
                function SetDeviceParameterValues(properties) {
                    this.parameterValues = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetDeviceParameterValues deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @instance
                 */
                SetDeviceParameterValues.prototype.deviceAddress = 0;

                /**
                 * SetDeviceParameterValues parameterValues.
                 * @member {Array.<motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue>} parameterValues
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @instance
                 */
                SetDeviceParameterValues.prototype.parameterValues = $util.emptyArray;

                /**
                 * Creates a new SetDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues} SetDeviceParameterValues instance
                 */
                SetDeviceParameterValues.create = function create(properties) {
                    return new SetDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified SetDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues} message SetDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.parameterValues != null && message.parameterValues.length)
                        for (let i = 0; i < message.parameterValues.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.encode(message.parameterValues[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SetDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues} message SetDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues} SetDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 3: {
                                if (!(message.parameterValues && message.parameterValues.length))
                                    message.parameterValues = [];
                                message.parameterValues.push($root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues} SetDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.parameterValues != null && message.hasOwnProperty("parameterValues")) {
                        if (!Array.isArray(message.parameterValues))
                            return "parameterValues: array expected";
                        for (let i = 0; i < message.parameterValues.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.verify(message.parameterValues[i]);
                            if (error)
                                return "parameterValues." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SetDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues} SetDeviceParameterValues
                 */
                SetDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.parameterValues) {
                        if (!Array.isArray(object.parameterValues))
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.parameterValues: array expected");
                        message.parameterValues = [];
                        for (let i = 0; i < object.parameterValues.length; ++i) {
                            if (typeof object.parameterValues[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.parameterValues: object expected");
                            message.parameterValues[i] = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.fromObject(object.parameterValues[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues} message SetDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.parameterValues = [];
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.parameterValues && message.parameterValues.length) {
                        object.parameterValues = [];
                        for (let j = 0; j < message.parameterValues.length; ++j)
                            object.parameterValues[j] = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.toObject(message.parameterValues[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SetDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues";
                };

                SetDeviceParameterValues.ParameterValue = (function() {

                    /**
                     * Properties of a ParameterValue.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                     * @interface IParameterValue
                     * @property {number|null} [index] ParameterValue index
                     * @property {number|null} [subindex] ParameterValue subindex
                     * @property {number|null} [intValue] ParameterValue intValue
                     * @property {number|null} [uintValue] ParameterValue uintValue
                     * @property {number|null} [floatValue] ParameterValue floatValue
                     * @property {string|null} [stringValue] ParameterValue stringValue
                     * @property {Uint8Array|null} [rawValue] ParameterValue rawValue
                     */

                    /**
                     * Constructs a new ParameterValue.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues
                     * @classdesc Represents a ParameterValue.
                     * @implements IParameterValue
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue=} [properties] Properties to set
                     */
                    function ParameterValue(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ParameterValue index.
                     * @member {number} index
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.index = 0;

                    /**
                     * ParameterValue subindex.
                     * @member {number} subindex
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.subindex = 0;

                    /**
                     * ParameterValue intValue.
                     * @member {number|null|undefined} intValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.intValue = null;

                    /**
                     * ParameterValue uintValue.
                     * @member {number|null|undefined} uintValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.uintValue = null;

                    /**
                     * ParameterValue floatValue.
                     * @member {number|null|undefined} floatValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.floatValue = null;

                    /**
                     * ParameterValue stringValue.
                     * @member {string|null|undefined} stringValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.stringValue = null;

                    /**
                     * ParameterValue rawValue.
                     * @member {Uint8Array|null|undefined} rawValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.rawValue = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * ParameterValue typeValue.
                     * @member {"intValue"|"uintValue"|"floatValue"|"stringValue"|"rawValue"|undefined} typeValue
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     */
                    Object.defineProperty(ParameterValue.prototype, "typeValue", {
                        get: $util.oneOfGetter($oneOfFields = ["intValue", "uintValue", "floatValue", "stringValue", "rawValue"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new ParameterValue instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue} ParameterValue instance
                     */
                    ParameterValue.create = function create(properties) {
                        return new ParameterValue(properties);
                    };

                    /**
                     * Encodes the specified ParameterValue message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue} message ParameterValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                        if (message.subindex != null && Object.hasOwnProperty.call(message, "subindex"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.subindex);
                        if (message.intValue != null && Object.hasOwnProperty.call(message, "intValue"))
                            writer.uint32(/* id 3, wireType 0 =*/24).sint64(message.intValue);
                        if (message.uintValue != null && Object.hasOwnProperty.call(message, "uintValue"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.uintValue);
                        if (message.floatValue != null && Object.hasOwnProperty.call(message, "floatValue"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.floatValue);
                        if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.stringValue);
                        if (message.rawValue != null && Object.hasOwnProperty.call(message, "rawValue"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.rawValue);
                        return writer;
                    };

                    /**
                     * Encodes the specified ParameterValue message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.IParameterValue} message ParameterValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ParameterValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue} ParameterValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.index = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.subindex = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.intValue = reader.sint64();
                                    break;
                                }
                            case 4: {
                                    message.uintValue = reader.uint64();
                                    break;
                                }
                            case 5: {
                                    message.floatValue = reader.float();
                                    break;
                                }
                            case 6: {
                                    message.stringValue = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.rawValue = reader.bytes();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ParameterValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue} ParameterValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ParameterValue message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ParameterValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        let properties = {};
                        if (message.index != null && message.hasOwnProperty("index"))
                            if (!$util.isInteger(message.index))
                                return "index: integer expected";
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            if (!$util.isInteger(message.subindex))
                                return "subindex: integer expected";
                        if (message.intValue != null && message.hasOwnProperty("intValue")) {
                            properties.typeValue = 1;
                            if (!$util.isInteger(message.intValue) && !(message.intValue && $util.isInteger(message.intValue.low) && $util.isInteger(message.intValue.high)))
                                return "intValue: integer|Long expected";
                        }
                        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!$util.isInteger(message.uintValue) && !(message.uintValue && $util.isInteger(message.uintValue.low) && $util.isInteger(message.uintValue.high)))
                                return "uintValue: integer|Long expected";
                        }
                        if (message.floatValue != null && message.hasOwnProperty("floatValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (typeof message.floatValue !== "number")
                                return "floatValue: number expected";
                        }
                        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!$util.isString(message.stringValue))
                                return "stringValue: string expected";
                        }
                        if (message.rawValue != null && message.hasOwnProperty("rawValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!(message.rawValue && typeof message.rawValue.length === "number" || $util.isString(message.rawValue)))
                                return "rawValue: buffer expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a ParameterValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue} ParameterValue
                     */
                    ParameterValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue();
                        if (object.index != null)
                            message.index = object.index >>> 0;
                        if (object.subindex != null)
                            message.subindex = object.subindex >>> 0;
                        if (object.intValue != null)
                            if ($util.Long)
                                (message.intValue = $util.Long.fromValue(object.intValue)).unsigned = false;
                            else if (typeof object.intValue === "string")
                                message.intValue = parseInt(object.intValue, 10);
                            else if (typeof object.intValue === "number")
                                message.intValue = object.intValue;
                            else if (typeof object.intValue === "object")
                                message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
                        if (object.uintValue != null)
                            if ($util.Long)
                                (message.uintValue = $util.Long.fromValue(object.uintValue)).unsigned = true;
                            else if (typeof object.uintValue === "string")
                                message.uintValue = parseInt(object.uintValue, 10);
                            else if (typeof object.uintValue === "number")
                                message.uintValue = object.uintValue;
                            else if (typeof object.uintValue === "object")
                                message.uintValue = new $util.LongBits(object.uintValue.low >>> 0, object.uintValue.high >>> 0).toNumber(true);
                        if (object.floatValue != null)
                            message.floatValue = Number(object.floatValue);
                        if (object.stringValue != null)
                            message.stringValue = String(object.stringValue);
                        if (object.rawValue != null)
                            if (typeof object.rawValue === "string")
                                $util.base64.decode(object.rawValue, message.rawValue = $util.newBuffer($util.base64.length(object.rawValue)), 0);
                            else if (object.rawValue.length >= 0)
                                message.rawValue = object.rawValue;
                        return message;
                    };

                    /**
                     * Creates a plain object from a ParameterValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue} message ParameterValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ParameterValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.index = 0;
                            object.subindex = 0;
                        }
                        if (message.index != null && message.hasOwnProperty("index"))
                            object.index = message.index;
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            object.subindex = message.subindex;
                        if (message.intValue != null && message.hasOwnProperty("intValue")) {
                            if (typeof message.intValue === "number")
                                object.intValue = options.longs === String ? String(message.intValue) : message.intValue;
                            else
                                object.intValue = options.longs === String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                            if (options.oneofs)
                                object.typeValue = "intValue";
                        }
                        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
                            if (typeof message.uintValue === "number")
                                object.uintValue = options.longs === String ? String(message.uintValue) : message.uintValue;
                            else
                                object.uintValue = options.longs === String ? $util.Long.prototype.toString.call(message.uintValue) : options.longs === Number ? new $util.LongBits(message.uintValue.low >>> 0, message.uintValue.high >>> 0).toNumber(true) : message.uintValue;
                            if (options.oneofs)
                                object.typeValue = "uintValue";
                        }
                        if (message.floatValue != null && message.hasOwnProperty("floatValue")) {
                            object.floatValue = options.json && !isFinite(message.floatValue) ? String(message.floatValue) : message.floatValue;
                            if (options.oneofs)
                                object.typeValue = "floatValue";
                        }
                        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                            object.stringValue = message.stringValue;
                            if (options.oneofs)
                                object.typeValue = "stringValue";
                        }
                        if (message.rawValue != null && message.hasOwnProperty("rawValue")) {
                            object.rawValue = options.bytes === String ? $util.base64.encode(message.rawValue, 0, message.rawValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.rawValue) : message.rawValue;
                            if (options.oneofs)
                                object.typeValue = "rawValue";
                        }
                        return object;
                    };

                    /**
                     * Converts this ParameterValue to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ParameterValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ParameterValue
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ParameterValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.ParameterValue";
                    };

                    return ParameterValue;
                })();

                return SetDeviceParameterValues;
            })();

            Request.SetMultiDeviceParameterValues = (function() {

                /**
                 * Properties of a SetMultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetMultiDeviceParameterValues
                 * @property {Array.<motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues>|null} [collection] SetMultiDeviceParameterValues collection
                 */

                /**
                 * Constructs a new SetMultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetMultiDeviceParameterValues.
                 * @implements ISetMultiDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues=} [properties] Properties to set
                 */
                function SetMultiDeviceParameterValues(properties) {
                    this.collection = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetMultiDeviceParameterValues collection.
                 * @member {Array.<motionmaster.MotionMasterMessage.Request.ISetDeviceParameterValues>} collection
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @instance
                 */
                SetMultiDeviceParameterValues.prototype.collection = $util.emptyArray;

                /**
                 * Creates a new SetMultiDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues} SetMultiDeviceParameterValues instance
                 */
                SetMultiDeviceParameterValues.create = function create(properties) {
                    return new SetMultiDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified SetMultiDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues} message SetMultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetMultiDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.collection != null && message.collection.length)
                        for (let i = 0; i < message.collection.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.encode(message.collection[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SetMultiDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMultiDeviceParameterValues} message SetMultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetMultiDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetMultiDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues} SetMultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetMultiDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.collection && message.collection.length))
                                    message.collection = [];
                                message.collection.push($root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetMultiDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues} SetMultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetMultiDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetMultiDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetMultiDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.collection != null && message.hasOwnProperty("collection")) {
                        if (!Array.isArray(message.collection))
                            return "collection: array expected";
                        for (let i = 0; i < message.collection.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.verify(message.collection[i]);
                            if (error)
                                return "collection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SetMultiDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues} SetMultiDeviceParameterValues
                 */
                SetMultiDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues();
                    if (object.collection) {
                        if (!Array.isArray(object.collection))
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.collection: array expected");
                        message.collection = [];
                        for (let i = 0; i < object.collection.length; ++i) {
                            if (typeof object.collection[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues.collection: object expected");
                            message.collection[i] = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.fromObject(object.collection[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetMultiDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues} message SetMultiDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetMultiDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.collection = [];
                    if (message.collection && message.collection.length) {
                        object.collection = [];
                        for (let j = 0; j < message.collection.length; ++j)
                            object.collection[j] = $root.motionmaster.MotionMasterMessage.Request.SetDeviceParameterValues.toObject(message.collection[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SetMultiDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetMultiDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetMultiDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetMultiDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetMultiDeviceParameterValues";
                };

                return SetMultiDeviceParameterValues;
            })();

            Request.GetDeviceFileList = (function() {

                /**
                 * Properties of a GetDeviceFileList.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceFileList
                 * @property {number|null} [deviceAddress] GetDeviceFileList deviceAddress
                 */

                /**
                 * Constructs a new GetDeviceFileList.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceFileList.
                 * @implements IGetDeviceFileList
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList=} [properties] Properties to set
                 */
                function GetDeviceFileList(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceFileList deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @instance
                 */
                GetDeviceFileList.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetDeviceFileList instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFileList} GetDeviceFileList instance
                 */
                GetDeviceFileList.create = function create(properties) {
                    return new GetDeviceFileList(properties);
                };

                /**
                 * Encodes the specified GetDeviceFileList message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceFileList.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList} message GetDeviceFileList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceFileList.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceFileList message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceFileList.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFileList} message GetDeviceFileList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceFileList.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceFileList message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFileList} GetDeviceFileList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceFileList.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceFileList message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFileList} GetDeviceFileList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceFileList.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceFileList message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceFileList.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceFileList message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFileList} GetDeviceFileList
                 */
                GetDeviceFileList.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceFileList();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceFileList message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceFileList} message GetDeviceFileList
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceFileList.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetDeviceFileList to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceFileList.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceFileList
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFileList
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceFileList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceFileList";
                };

                return GetDeviceFileList;
            })();

            Request.GetDeviceFile = (function() {

                /**
                 * Properties of a GetDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceFile
                 * @property {number|null} [deviceAddress] GetDeviceFile deviceAddress
                 * @property {string|null} [name] GetDeviceFile name
                 */

                /**
                 * Constructs a new GetDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceFile.
                 * @implements IGetDeviceFile
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFile=} [properties] Properties to set
                 */
                function GetDeviceFile(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceFile deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @instance
                 */
                GetDeviceFile.prototype.deviceAddress = 0;

                /**
                 * GetDeviceFile name.
                 * @member {string} name
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @instance
                 */
                GetDeviceFile.prototype.name = "";

                /**
                 * Creates a new GetDeviceFile instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFile=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFile} GetDeviceFile instance
                 */
                GetDeviceFile.create = function create(properties) {
                    return new GetDeviceFile(properties);
                };

                /**
                 * Encodes the specified GetDeviceFile message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceFile.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFile} message GetDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceFile.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceFile message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceFile.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceFile} message GetDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceFile.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceFile message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFile} GetDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceFile.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceFile message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFile} GetDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceFile.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceFile message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceFile.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceFile message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceFile} GetDeviceFile
                 */
                GetDeviceFile.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceFile();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.name != null)
                        message.name = String(object.name);
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceFile message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceFile} message GetDeviceFile
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceFile.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.name = "";
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };

                /**
                 * Converts this GetDeviceFile to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceFile.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceFile
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceFile
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceFile";
                };

                return GetDeviceFile;
            })();

            Request.SetDeviceFile = (function() {

                /**
                 * Properties of a SetDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetDeviceFile
                 * @property {number|null} [deviceAddress] SetDeviceFile deviceAddress
                 * @property {string|null} [name] SetDeviceFile name
                 * @property {Uint8Array|null} [content] SetDeviceFile content
                 * @property {boolean|null} [overwrite] SetDeviceFile overwrite
                 */

                /**
                 * Constructs a new SetDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetDeviceFile.
                 * @implements ISetDeviceFile
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceFile=} [properties] Properties to set
                 */
                function SetDeviceFile(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetDeviceFile deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @instance
                 */
                SetDeviceFile.prototype.deviceAddress = 0;

                /**
                 * SetDeviceFile name.
                 * @member {string} name
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @instance
                 */
                SetDeviceFile.prototype.name = "";

                /**
                 * SetDeviceFile content.
                 * @member {Uint8Array} content
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @instance
                 */
                SetDeviceFile.prototype.content = $util.newBuffer([]);

                /**
                 * SetDeviceFile overwrite.
                 * @member {boolean} overwrite
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @instance
                 */
                SetDeviceFile.prototype.overwrite = false;

                /**
                 * Creates a new SetDeviceFile instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceFile=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceFile} SetDeviceFile instance
                 */
                SetDeviceFile.create = function create(properties) {
                    return new SetDeviceFile(properties);
                };

                /**
                 * Encodes the specified SetDeviceFile message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceFile.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceFile} message SetDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceFile.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
                    if (message.overwrite != null && Object.hasOwnProperty.call(message, "overwrite"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.overwrite);
                    return writer;
                };

                /**
                 * Encodes the specified SetDeviceFile message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceFile.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceFile} message SetDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceFile.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetDeviceFile message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceFile} SetDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceFile.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.content = reader.bytes();
                                break;
                            }
                        case 4: {
                                message.overwrite = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetDeviceFile message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceFile} SetDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceFile.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetDeviceFile message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetDeviceFile.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.content != null && message.hasOwnProperty("content"))
                        if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                            return "content: buffer expected";
                    if (message.overwrite != null && message.hasOwnProperty("overwrite"))
                        if (typeof message.overwrite !== "boolean")
                            return "overwrite: boolean expected";
                    return null;
                };

                /**
                 * Creates a SetDeviceFile message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceFile} SetDeviceFile
                 */
                SetDeviceFile.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceFile();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.content != null)
                        if (typeof object.content === "string")
                            $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                        else if (object.content.length >= 0)
                            message.content = object.content;
                    if (object.overwrite != null)
                        message.overwrite = Boolean(object.overwrite);
                    return message;
                };

                /**
                 * Creates a plain object from a SetDeviceFile message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetDeviceFile} message SetDeviceFile
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetDeviceFile.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.name = "";
                        if (options.bytes === String)
                            object.content = "";
                        else {
                            object.content = [];
                            if (options.bytes !== Array)
                                object.content = $util.newBuffer(object.content);
                        }
                        object.overwrite = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.content != null && message.hasOwnProperty("content"))
                        object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                    if (message.overwrite != null && message.hasOwnProperty("overwrite"))
                        object.overwrite = message.overwrite;
                    return object;
                };

                /**
                 * Converts this SetDeviceFile to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetDeviceFile.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetDeviceFile
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceFile
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetDeviceFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetDeviceFile";
                };

                return SetDeviceFile;
            })();

            Request.DeleteDeviceFile = (function() {

                /**
                 * Properties of a DeleteDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IDeleteDeviceFile
                 * @property {number|null} [deviceAddress] DeleteDeviceFile deviceAddress
                 * @property {string|null} [name] DeleteDeviceFile name
                 */

                /**
                 * Constructs a new DeleteDeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a DeleteDeviceFile.
                 * @implements IDeleteDeviceFile
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile=} [properties] Properties to set
                 */
                function DeleteDeviceFile(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeleteDeviceFile deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @instance
                 */
                DeleteDeviceFile.prototype.deviceAddress = 0;

                /**
                 * DeleteDeviceFile name.
                 * @member {string} name
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @instance
                 */
                DeleteDeviceFile.prototype.name = "";

                /**
                 * Creates a new DeleteDeviceFile instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.DeleteDeviceFile} DeleteDeviceFile instance
                 */
                DeleteDeviceFile.create = function create(properties) {
                    return new DeleteDeviceFile(properties);
                };

                /**
                 * Encodes the specified DeleteDeviceFile message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile} message DeleteDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeleteDeviceFile.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    return writer;
                };

                /**
                 * Encodes the specified DeleteDeviceFile message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.DeleteDeviceFile.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDeleteDeviceFile} message DeleteDeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeleteDeviceFile.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeleteDeviceFile message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.DeleteDeviceFile} DeleteDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeleteDeviceFile.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeleteDeviceFile message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.DeleteDeviceFile} DeleteDeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeleteDeviceFile.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeleteDeviceFile message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeleteDeviceFile.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    return null;
                };

                /**
                 * Creates a DeleteDeviceFile message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.DeleteDeviceFile} DeleteDeviceFile
                 */
                DeleteDeviceFile.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.DeleteDeviceFile();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.name != null)
                        message.name = String(object.name);
                    return message;
                };

                /**
                 * Creates a plain object from a DeleteDeviceFile message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.DeleteDeviceFile} message DeleteDeviceFile
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeleteDeviceFile.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.name = "";
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    return object;
                };

                /**
                 * Converts this DeleteDeviceFile to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeleteDeviceFile.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeleteDeviceFile
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.DeleteDeviceFile
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeleteDeviceFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.DeleteDeviceFile";
                };

                return DeleteDeviceFile;
            })();

            Request.ResetDeviceFault = (function() {

                /**
                 * Properties of a ResetDeviceFault.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IResetDeviceFault
                 * @property {number|null} [deviceAddress] ResetDeviceFault deviceAddress
                 */

                /**
                 * Constructs a new ResetDeviceFault.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a ResetDeviceFault.
                 * @implements IResetDeviceFault
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IResetDeviceFault=} [properties] Properties to set
                 */
                function ResetDeviceFault(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ResetDeviceFault deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @instance
                 */
                ResetDeviceFault.prototype.deviceAddress = 0;

                /**
                 * Creates a new ResetDeviceFault instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IResetDeviceFault=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.ResetDeviceFault} ResetDeviceFault instance
                 */
                ResetDeviceFault.create = function create(properties) {
                    return new ResetDeviceFault(properties);
                };

                /**
                 * Encodes the specified ResetDeviceFault message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ResetDeviceFault.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IResetDeviceFault} message ResetDeviceFault message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetDeviceFault.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified ResetDeviceFault message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ResetDeviceFault.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IResetDeviceFault} message ResetDeviceFault message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ResetDeviceFault.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ResetDeviceFault message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.ResetDeviceFault} ResetDeviceFault
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetDeviceFault.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ResetDeviceFault message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.ResetDeviceFault} ResetDeviceFault
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ResetDeviceFault.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ResetDeviceFault message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ResetDeviceFault.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a ResetDeviceFault message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.ResetDeviceFault} ResetDeviceFault
                 */
                ResetDeviceFault.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.ResetDeviceFault();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a ResetDeviceFault message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ResetDeviceFault} message ResetDeviceFault
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ResetDeviceFault.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this ResetDeviceFault to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ResetDeviceFault.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ResetDeviceFault
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.ResetDeviceFault
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ResetDeviceFault.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ResetDeviceFault";
                };

                return ResetDeviceFault;
            })();

            Request.StopDevice = (function() {

                /**
                 * Properties of a StopDevice.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStopDevice
                 * @property {number|null} [deviceAddress] StopDevice deviceAddress
                 */

                /**
                 * Constructs a new StopDevice.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StopDevice.
                 * @implements IStopDevice
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStopDevice=} [properties] Properties to set
                 */
                function StopDevice(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StopDevice deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @instance
                 */
                StopDevice.prototype.deviceAddress = 0;

                /**
                 * Creates a new StopDevice instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopDevice=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StopDevice} StopDevice instance
                 */
                StopDevice.create = function create(properties) {
                    return new StopDevice(properties);
                };

                /**
                 * Encodes the specified StopDevice message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopDevice.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopDevice} message StopDevice message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopDevice.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StopDevice message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopDevice.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopDevice} message StopDevice message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopDevice.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StopDevice message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StopDevice} StopDevice
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopDevice.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StopDevice();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StopDevice message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StopDevice} StopDevice
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopDevice.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StopDevice message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StopDevice.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StopDevice message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StopDevice} StopDevice
                 */
                StopDevice.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StopDevice)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StopDevice();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StopDevice message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StopDevice} message StopDevice
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StopDevice.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StopDevice to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StopDevice.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StopDevice
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StopDevice
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StopDevice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StopDevice";
                };

                return StopDevice;
            })();

            Request.StartDeviceFirmwareInstallation = (function() {

                /**
                 * Properties of a StartDeviceFirmwareInstallation.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartDeviceFirmwareInstallation
                 * @property {number|null} [deviceAddress] StartDeviceFirmwareInstallation deviceAddress
                 * @property {Uint8Array|null} [firmwarePackageContent] StartDeviceFirmwareInstallation firmwarePackageContent
                 * @property {boolean|null} [skipSiiInstallation] StartDeviceFirmwareInstallation skipSiiInstallation
                 * @property {Array.<string>|null} [skipFiles] StartDeviceFirmwareInstallation skipFiles
                 */

                /**
                 * Constructs a new StartDeviceFirmwareInstallation.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartDeviceFirmwareInstallation.
                 * @implements IStartDeviceFirmwareInstallation
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation=} [properties] Properties to set
                 */
                function StartDeviceFirmwareInstallation(properties) {
                    this.skipFiles = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartDeviceFirmwareInstallation deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @instance
                 */
                StartDeviceFirmwareInstallation.prototype.deviceAddress = 0;

                /**
                 * StartDeviceFirmwareInstallation firmwarePackageContent.
                 * @member {Uint8Array} firmwarePackageContent
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @instance
                 */
                StartDeviceFirmwareInstallation.prototype.firmwarePackageContent = $util.newBuffer([]);

                /**
                 * StartDeviceFirmwareInstallation skipSiiInstallation.
                 * @member {boolean} skipSiiInstallation
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @instance
                 */
                StartDeviceFirmwareInstallation.prototype.skipSiiInstallation = false;

                /**
                 * StartDeviceFirmwareInstallation skipFiles.
                 * @member {Array.<string>} skipFiles
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @instance
                 */
                StartDeviceFirmwareInstallation.prototype.skipFiles = $util.emptyArray;

                /**
                 * Creates a new StartDeviceFirmwareInstallation instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation} StartDeviceFirmwareInstallation instance
                 */
                StartDeviceFirmwareInstallation.create = function create(properties) {
                    return new StartDeviceFirmwareInstallation(properties);
                };

                /**
                 * Encodes the specified StartDeviceFirmwareInstallation message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation} message StartDeviceFirmwareInstallation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartDeviceFirmwareInstallation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.firmwarePackageContent != null && Object.hasOwnProperty.call(message, "firmwarePackageContent"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.firmwarePackageContent);
                    if (message.skipSiiInstallation != null && Object.hasOwnProperty.call(message, "skipSiiInstallation"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.skipSiiInstallation);
                    if (message.skipFiles != null && message.skipFiles.length)
                        for (let i = 0; i < message.skipFiles.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.skipFiles[i]);
                    return writer;
                };

                /**
                 * Encodes the specified StartDeviceFirmwareInstallation message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceFirmwareInstallation} message StartDeviceFirmwareInstallation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartDeviceFirmwareInstallation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartDeviceFirmwareInstallation message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation} StartDeviceFirmwareInstallation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartDeviceFirmwareInstallation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.firmwarePackageContent = reader.bytes();
                                break;
                            }
                        case 3: {
                                message.skipSiiInstallation = reader.bool();
                                break;
                            }
                        case 4: {
                                if (!(message.skipFiles && message.skipFiles.length))
                                    message.skipFiles = [];
                                message.skipFiles.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartDeviceFirmwareInstallation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation} StartDeviceFirmwareInstallation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartDeviceFirmwareInstallation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartDeviceFirmwareInstallation message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartDeviceFirmwareInstallation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.firmwarePackageContent != null && message.hasOwnProperty("firmwarePackageContent"))
                        if (!(message.firmwarePackageContent && typeof message.firmwarePackageContent.length === "number" || $util.isString(message.firmwarePackageContent)))
                            return "firmwarePackageContent: buffer expected";
                    if (message.skipSiiInstallation != null && message.hasOwnProperty("skipSiiInstallation"))
                        if (typeof message.skipSiiInstallation !== "boolean")
                            return "skipSiiInstallation: boolean expected";
                    if (message.skipFiles != null && message.hasOwnProperty("skipFiles")) {
                        if (!Array.isArray(message.skipFiles))
                            return "skipFiles: array expected";
                        for (let i = 0; i < message.skipFiles.length; ++i)
                            if (!$util.isString(message.skipFiles[i]))
                                return "skipFiles: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a StartDeviceFirmwareInstallation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation} StartDeviceFirmwareInstallation
                 */
                StartDeviceFirmwareInstallation.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.firmwarePackageContent != null)
                        if (typeof object.firmwarePackageContent === "string")
                            $util.base64.decode(object.firmwarePackageContent, message.firmwarePackageContent = $util.newBuffer($util.base64.length(object.firmwarePackageContent)), 0);
                        else if (object.firmwarePackageContent.length >= 0)
                            message.firmwarePackageContent = object.firmwarePackageContent;
                    if (object.skipSiiInstallation != null)
                        message.skipSiiInstallation = Boolean(object.skipSiiInstallation);
                    if (object.skipFiles) {
                        if (!Array.isArray(object.skipFiles))
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation.skipFiles: array expected");
                        message.skipFiles = [];
                        for (let i = 0; i < object.skipFiles.length; ++i)
                            message.skipFiles[i] = String(object.skipFiles[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartDeviceFirmwareInstallation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation} message StartDeviceFirmwareInstallation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartDeviceFirmwareInstallation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.skipFiles = [];
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        if (options.bytes === String)
                            object.firmwarePackageContent = "";
                        else {
                            object.firmwarePackageContent = [];
                            if (options.bytes !== Array)
                                object.firmwarePackageContent = $util.newBuffer(object.firmwarePackageContent);
                        }
                        object.skipSiiInstallation = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.firmwarePackageContent != null && message.hasOwnProperty("firmwarePackageContent"))
                        object.firmwarePackageContent = options.bytes === String ? $util.base64.encode(message.firmwarePackageContent, 0, message.firmwarePackageContent.length) : options.bytes === Array ? Array.prototype.slice.call(message.firmwarePackageContent) : message.firmwarePackageContent;
                    if (message.skipSiiInstallation != null && message.hasOwnProperty("skipSiiInstallation"))
                        object.skipSiiInstallation = message.skipSiiInstallation;
                    if (message.skipFiles && message.skipFiles.length) {
                        object.skipFiles = [];
                        for (let j = 0; j < message.skipFiles.length; ++j)
                            object.skipFiles[j] = message.skipFiles[j];
                    }
                    return object;
                };

                /**
                 * Converts this StartDeviceFirmwareInstallation to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartDeviceFirmwareInstallation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartDeviceFirmwareInstallation
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartDeviceFirmwareInstallation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartDeviceFirmwareInstallation";
                };

                return StartDeviceFirmwareInstallation;
            })();

            Request.GetDeviceLog = (function() {

                /**
                 * Properties of a GetDeviceLog.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceLog
                 * @property {number|null} [deviceAddress] GetDeviceLog deviceAddress
                 */

                /**
                 * Constructs a new GetDeviceLog.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceLog.
                 * @implements IGetDeviceLog
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceLog=} [properties] Properties to set
                 */
                function GetDeviceLog(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceLog deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @instance
                 */
                GetDeviceLog.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetDeviceLog instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceLog=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceLog} GetDeviceLog instance
                 */
                GetDeviceLog.create = function create(properties) {
                    return new GetDeviceLog(properties);
                };

                /**
                 * Encodes the specified GetDeviceLog message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceLog.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceLog} message GetDeviceLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceLog.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceLog message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceLog.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceLog} message GetDeviceLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceLog.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceLog message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceLog} GetDeviceLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceLog.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceLog message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceLog} GetDeviceLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceLog.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceLog message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceLog.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceLog message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceLog} GetDeviceLog
                 */
                GetDeviceLog.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceLog();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceLog message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceLog} message GetDeviceLog
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceLog.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetDeviceLog to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceLog.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceLog
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceLog
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceLog";
                };

                return GetDeviceLog;
            })();

            Request.StartCoggingTorqueRecording = (function() {

                /**
                 * Properties of a StartCoggingTorqueRecording.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartCoggingTorqueRecording
                 * @property {number|null} [deviceAddress] StartCoggingTorqueRecording deviceAddress
                 * @property {boolean|null} [skipAutoTuning] StartCoggingTorqueRecording skipAutoTuning
                 */

                /**
                 * Constructs a new StartCoggingTorqueRecording.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartCoggingTorqueRecording.
                 * @implements IStartCoggingTorqueRecording
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording=} [properties] Properties to set
                 */
                function StartCoggingTorqueRecording(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartCoggingTorqueRecording deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @instance
                 */
                StartCoggingTorqueRecording.prototype.deviceAddress = 0;

                /**
                 * StartCoggingTorqueRecording skipAutoTuning.
                 * @member {boolean} skipAutoTuning
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @instance
                 */
                StartCoggingTorqueRecording.prototype.skipAutoTuning = false;

                /**
                 * Creates a new StartCoggingTorqueRecording instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording} StartCoggingTorqueRecording instance
                 */
                StartCoggingTorqueRecording.create = function create(properties) {
                    return new StartCoggingTorqueRecording(properties);
                };

                /**
                 * Encodes the specified StartCoggingTorqueRecording message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording} message StartCoggingTorqueRecording message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCoggingTorqueRecording.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.skipAutoTuning != null && Object.hasOwnProperty.call(message, "skipAutoTuning"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipAutoTuning);
                    return writer;
                };

                /**
                 * Encodes the specified StartCoggingTorqueRecording message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCoggingTorqueRecording} message StartCoggingTorqueRecording message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCoggingTorqueRecording.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartCoggingTorqueRecording message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording} StartCoggingTorqueRecording
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCoggingTorqueRecording.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.skipAutoTuning = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartCoggingTorqueRecording message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording} StartCoggingTorqueRecording
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCoggingTorqueRecording.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartCoggingTorqueRecording message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartCoggingTorqueRecording.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.skipAutoTuning != null && message.hasOwnProperty("skipAutoTuning"))
                        if (typeof message.skipAutoTuning !== "boolean")
                            return "skipAutoTuning: boolean expected";
                    return null;
                };

                /**
                 * Creates a StartCoggingTorqueRecording message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording} StartCoggingTorqueRecording
                 */
                StartCoggingTorqueRecording.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.skipAutoTuning != null)
                        message.skipAutoTuning = Boolean(object.skipAutoTuning);
                    return message;
                };

                /**
                 * Creates a plain object from a StartCoggingTorqueRecording message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording} message StartCoggingTorqueRecording
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartCoggingTorqueRecording.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.skipAutoTuning = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.skipAutoTuning != null && message.hasOwnProperty("skipAutoTuning"))
                        object.skipAutoTuning = message.skipAutoTuning;
                    return object;
                };

                /**
                 * Converts this StartCoggingTorqueRecording to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartCoggingTorqueRecording.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartCoggingTorqueRecording
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartCoggingTorqueRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartCoggingTorqueRecording";
                };

                return StartCoggingTorqueRecording;
            })();

            Request.GetCoggingTorqueData = (function() {

                /**
                 * Properties of a GetCoggingTorqueData.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetCoggingTorqueData
                 * @property {number|null} [deviceAddress] GetCoggingTorqueData deviceAddress
                 */

                /**
                 * Constructs a new GetCoggingTorqueData.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetCoggingTorqueData.
                 * @implements IGetCoggingTorqueData
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData=} [properties] Properties to set
                 */
                function GetCoggingTorqueData(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetCoggingTorqueData deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @instance
                 */
                GetCoggingTorqueData.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetCoggingTorqueData instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData} GetCoggingTorqueData instance
                 */
                GetCoggingTorqueData.create = function create(properties) {
                    return new GetCoggingTorqueData(properties);
                };

                /**
                 * Encodes the specified GetCoggingTorqueData message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData} message GetCoggingTorqueData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoggingTorqueData.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetCoggingTorqueData message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCoggingTorqueData} message GetCoggingTorqueData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoggingTorqueData.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetCoggingTorqueData message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData} GetCoggingTorqueData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoggingTorqueData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetCoggingTorqueData message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData} GetCoggingTorqueData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoggingTorqueData.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetCoggingTorqueData message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetCoggingTorqueData.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetCoggingTorqueData message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData} GetCoggingTorqueData
                 */
                GetCoggingTorqueData.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetCoggingTorqueData message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData} message GetCoggingTorqueData
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetCoggingTorqueData.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetCoggingTorqueData to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetCoggingTorqueData.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetCoggingTorqueData
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetCoggingTorqueData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetCoggingTorqueData";
                };

                return GetCoggingTorqueData;
            })();

            Request.StartOffsetDetection = (function() {

                /**
                 * Properties of a StartOffsetDetection.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartOffsetDetection
                 * @property {number|null} [deviceAddress] StartOffsetDetection deviceAddress
                 */

                /**
                 * Constructs a new StartOffsetDetection.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartOffsetDetection.
                 * @implements IStartOffsetDetection
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection=} [properties] Properties to set
                 */
                function StartOffsetDetection(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartOffsetDetection deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @instance
                 */
                StartOffsetDetection.prototype.deviceAddress = 0;

                /**
                 * Creates a new StartOffsetDetection instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOffsetDetection} StartOffsetDetection instance
                 */
                StartOffsetDetection.create = function create(properties) {
                    return new StartOffsetDetection(properties);
                };

                /**
                 * Encodes the specified StartOffsetDetection message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOffsetDetection.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection} message StartOffsetDetection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOffsetDetection.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StartOffsetDetection message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOffsetDetection.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOffsetDetection} message StartOffsetDetection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOffsetDetection.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartOffsetDetection message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOffsetDetection} StartOffsetDetection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOffsetDetection.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartOffsetDetection message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOffsetDetection} StartOffsetDetection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOffsetDetection.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartOffsetDetection message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartOffsetDetection.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StartOffsetDetection message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOffsetDetection} StartOffsetDetection
                 */
                StartOffsetDetection.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartOffsetDetection();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartOffsetDetection message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartOffsetDetection} message StartOffsetDetection
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartOffsetDetection.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StartOffsetDetection to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartOffsetDetection.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartOffsetDetection
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOffsetDetection
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartOffsetDetection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartOffsetDetection";
                };

                return StartOffsetDetection;
            })();

            Request.StartPlantIdentification = (function() {

                /**
                 * Properties of a StartPlantIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartPlantIdentification
                 * @property {number|null} [deviceAddress] StartPlantIdentification deviceAddress
                 * @property {number|null} [durationSeconds] StartPlantIdentification durationSeconds
                 * @property {number|null} [torqueAmplitude] StartPlantIdentification torqueAmplitude
                 * @property {number|null} [startFrequency] StartPlantIdentification startFrequency
                 * @property {number|null} [endFrequency] StartPlantIdentification endFrequency
                 * @property {number|null} [cutoffFrequency] StartPlantIdentification cutoffFrequency
                 */

                /**
                 * Constructs a new StartPlantIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartPlantIdentification.
                 * @implements IStartPlantIdentification
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification=} [properties] Properties to set
                 */
                function StartPlantIdentification(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartPlantIdentification deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.deviceAddress = 0;

                /**
                 * StartPlantIdentification durationSeconds.
                 * @member {number} durationSeconds
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.durationSeconds = 0;

                /**
                 * StartPlantIdentification torqueAmplitude.
                 * @member {number} torqueAmplitude
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.torqueAmplitude = 0;

                /**
                 * StartPlantIdentification startFrequency.
                 * @member {number} startFrequency
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.startFrequency = 0;

                /**
                 * StartPlantIdentification endFrequency.
                 * @member {number} endFrequency
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.endFrequency = 0;

                /**
                 * StartPlantIdentification cutoffFrequency.
                 * @member {number} cutoffFrequency
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 */
                StartPlantIdentification.prototype.cutoffFrequency = 0;

                /**
                 * Creates a new StartPlantIdentification instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartPlantIdentification} StartPlantIdentification instance
                 */
                StartPlantIdentification.create = function create(properties) {
                    return new StartPlantIdentification(properties);
                };

                /**
                 * Encodes the specified StartPlantIdentification message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartPlantIdentification.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification} message StartPlantIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartPlantIdentification.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.durationSeconds != null && Object.hasOwnProperty.call(message, "durationSeconds"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.durationSeconds);
                    if (message.torqueAmplitude != null && Object.hasOwnProperty.call(message, "torqueAmplitude"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.torqueAmplitude);
                    if (message.startFrequency != null && Object.hasOwnProperty.call(message, "startFrequency"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.startFrequency);
                    if (message.endFrequency != null && Object.hasOwnProperty.call(message, "endFrequency"))
                        writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.endFrequency);
                    if (message.cutoffFrequency != null && Object.hasOwnProperty.call(message, "cutoffFrequency"))
                        writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.cutoffFrequency);
                    return writer;
                };

                /**
                 * Encodes the specified StartPlantIdentification message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartPlantIdentification.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartPlantIdentification} message StartPlantIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartPlantIdentification.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartPlantIdentification message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartPlantIdentification} StartPlantIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartPlantIdentification.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.durationSeconds = reader.float();
                                break;
                            }
                        case 3: {
                                message.torqueAmplitude = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.startFrequency = reader.uint32();
                                break;
                            }
                        case 5: {
                                message.endFrequency = reader.uint32();
                                break;
                            }
                        case 6: {
                                message.cutoffFrequency = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartPlantIdentification message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartPlantIdentification} StartPlantIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartPlantIdentification.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartPlantIdentification message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartPlantIdentification.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
                        if (typeof message.durationSeconds !== "number")
                            return "durationSeconds: number expected";
                    if (message.torqueAmplitude != null && message.hasOwnProperty("torqueAmplitude"))
                        if (!$util.isInteger(message.torqueAmplitude))
                            return "torqueAmplitude: integer expected";
                    if (message.startFrequency != null && message.hasOwnProperty("startFrequency"))
                        if (!$util.isInteger(message.startFrequency))
                            return "startFrequency: integer expected";
                    if (message.endFrequency != null && message.hasOwnProperty("endFrequency"))
                        if (!$util.isInteger(message.endFrequency))
                            return "endFrequency: integer expected";
                    if (message.cutoffFrequency != null && message.hasOwnProperty("cutoffFrequency"))
                        if (!$util.isInteger(message.cutoffFrequency))
                            return "cutoffFrequency: integer expected";
                    return null;
                };

                /**
                 * Creates a StartPlantIdentification message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartPlantIdentification} StartPlantIdentification
                 */
                StartPlantIdentification.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartPlantIdentification();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.durationSeconds != null)
                        message.durationSeconds = Number(object.durationSeconds);
                    if (object.torqueAmplitude != null)
                        message.torqueAmplitude = object.torqueAmplitude >>> 0;
                    if (object.startFrequency != null)
                        message.startFrequency = object.startFrequency >>> 0;
                    if (object.endFrequency != null)
                        message.endFrequency = object.endFrequency >>> 0;
                    if (object.cutoffFrequency != null)
                        message.cutoffFrequency = object.cutoffFrequency >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartPlantIdentification message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartPlantIdentification} message StartPlantIdentification
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartPlantIdentification.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.durationSeconds = 0;
                        object.torqueAmplitude = 0;
                        object.startFrequency = 0;
                        object.endFrequency = 0;
                        object.cutoffFrequency = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
                        object.durationSeconds = options.json && !isFinite(message.durationSeconds) ? String(message.durationSeconds) : message.durationSeconds;
                    if (message.torqueAmplitude != null && message.hasOwnProperty("torqueAmplitude"))
                        object.torqueAmplitude = message.torqueAmplitude;
                    if (message.startFrequency != null && message.hasOwnProperty("startFrequency"))
                        object.startFrequency = message.startFrequency;
                    if (message.endFrequency != null && message.hasOwnProperty("endFrequency"))
                        object.endFrequency = message.endFrequency;
                    if (message.cutoffFrequency != null && message.hasOwnProperty("cutoffFrequency"))
                        object.cutoffFrequency = message.cutoffFrequency;
                    return object;
                };

                /**
                 * Converts this StartPlantIdentification to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartPlantIdentification.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartPlantIdentification
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartPlantIdentification
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartPlantIdentification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartPlantIdentification";
                };

                return StartPlantIdentification;
            })();

            Request.StartSystemIdentification = (function() {

                /**
                 * Properties of a StartSystemIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartSystemIdentification
                 * @property {number|null} [deviceAddress] StartSystemIdentification deviceAddress
                 * @property {number|null} [durationSeconds] StartSystemIdentification durationSeconds
                 * @property {number|null} [torqueAmplitude] StartSystemIdentification torqueAmplitude
                 * @property {number|null} [startFrequency] StartSystemIdentification startFrequency
                 * @property {number|null} [endFrequency] StartSystemIdentification endFrequency
                 * @property {boolean|null} [nextGenSysId] StartSystemIdentification nextGenSysId
                 * @property {boolean|null} [skipChirpSignal] StartSystemIdentification skipChirpSignal
                 */

                /**
                 * Constructs a new StartSystemIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartSystemIdentification.
                 * @implements IStartSystemIdentification
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification=} [properties] Properties to set
                 */
                function StartSystemIdentification(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartSystemIdentification deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.deviceAddress = 0;

                /**
                 * StartSystemIdentification durationSeconds.
                 * @member {number} durationSeconds
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.durationSeconds = 0;

                /**
                 * StartSystemIdentification torqueAmplitude.
                 * @member {number} torqueAmplitude
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.torqueAmplitude = 0;

                /**
                 * StartSystemIdentification startFrequency.
                 * @member {number} startFrequency
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.startFrequency = 0;

                /**
                 * StartSystemIdentification endFrequency.
                 * @member {number} endFrequency
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.endFrequency = 0;

                /**
                 * StartSystemIdentification nextGenSysId.
                 * @member {boolean} nextGenSysId
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.nextGenSysId = false;

                /**
                 * StartSystemIdentification skipChirpSignal.
                 * @member {boolean} skipChirpSignal
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 */
                StartSystemIdentification.prototype.skipChirpSignal = false;

                /**
                 * Creates a new StartSystemIdentification instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSystemIdentification} StartSystemIdentification instance
                 */
                StartSystemIdentification.create = function create(properties) {
                    return new StartSystemIdentification(properties);
                };

                /**
                 * Encodes the specified StartSystemIdentification message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartSystemIdentification.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification} message StartSystemIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartSystemIdentification.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.durationSeconds != null && Object.hasOwnProperty.call(message, "durationSeconds"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.durationSeconds);
                    if (message.torqueAmplitude != null && Object.hasOwnProperty.call(message, "torqueAmplitude"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.torqueAmplitude);
                    if (message.startFrequency != null && Object.hasOwnProperty.call(message, "startFrequency"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.startFrequency);
                    if (message.endFrequency != null && Object.hasOwnProperty.call(message, "endFrequency"))
                        writer.uint32(/* id 5, wireType 5 =*/45).float(message.endFrequency);
                    if (message.nextGenSysId != null && Object.hasOwnProperty.call(message, "nextGenSysId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.nextGenSysId);
                    if (message.skipChirpSignal != null && Object.hasOwnProperty.call(message, "skipChirpSignal"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.skipChirpSignal);
                    return writer;
                };

                /**
                 * Encodes the specified StartSystemIdentification message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartSystemIdentification.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSystemIdentification} message StartSystemIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartSystemIdentification.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartSystemIdentification message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSystemIdentification} StartSystemIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartSystemIdentification.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.durationSeconds = reader.float();
                                break;
                            }
                        case 3: {
                                message.torqueAmplitude = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.startFrequency = reader.float();
                                break;
                            }
                        case 5: {
                                message.endFrequency = reader.float();
                                break;
                            }
                        case 6: {
                                message.nextGenSysId = reader.bool();
                                break;
                            }
                        case 7: {
                                message.skipChirpSignal = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartSystemIdentification message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSystemIdentification} StartSystemIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartSystemIdentification.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartSystemIdentification message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartSystemIdentification.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
                        if (typeof message.durationSeconds !== "number")
                            return "durationSeconds: number expected";
                    if (message.torqueAmplitude != null && message.hasOwnProperty("torqueAmplitude"))
                        if (!$util.isInteger(message.torqueAmplitude))
                            return "torqueAmplitude: integer expected";
                    if (message.startFrequency != null && message.hasOwnProperty("startFrequency"))
                        if (typeof message.startFrequency !== "number")
                            return "startFrequency: number expected";
                    if (message.endFrequency != null && message.hasOwnProperty("endFrequency"))
                        if (typeof message.endFrequency !== "number")
                            return "endFrequency: number expected";
                    if (message.nextGenSysId != null && message.hasOwnProperty("nextGenSysId"))
                        if (typeof message.nextGenSysId !== "boolean")
                            return "nextGenSysId: boolean expected";
                    if (message.skipChirpSignal != null && message.hasOwnProperty("skipChirpSignal"))
                        if (typeof message.skipChirpSignal !== "boolean")
                            return "skipChirpSignal: boolean expected";
                    return null;
                };

                /**
                 * Creates a StartSystemIdentification message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSystemIdentification} StartSystemIdentification
                 */
                StartSystemIdentification.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartSystemIdentification();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.durationSeconds != null)
                        message.durationSeconds = Number(object.durationSeconds);
                    if (object.torqueAmplitude != null)
                        message.torqueAmplitude = object.torqueAmplitude >>> 0;
                    if (object.startFrequency != null)
                        message.startFrequency = Number(object.startFrequency);
                    if (object.endFrequency != null)
                        message.endFrequency = Number(object.endFrequency);
                    if (object.nextGenSysId != null)
                        message.nextGenSysId = Boolean(object.nextGenSysId);
                    if (object.skipChirpSignal != null)
                        message.skipChirpSignal = Boolean(object.skipChirpSignal);
                    return message;
                };

                /**
                 * Creates a plain object from a StartSystemIdentification message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartSystemIdentification} message StartSystemIdentification
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartSystemIdentification.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.durationSeconds = 0;
                        object.torqueAmplitude = 0;
                        object.startFrequency = 0;
                        object.endFrequency = 0;
                        object.nextGenSysId = false;
                        object.skipChirpSignal = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.durationSeconds != null && message.hasOwnProperty("durationSeconds"))
                        object.durationSeconds = options.json && !isFinite(message.durationSeconds) ? String(message.durationSeconds) : message.durationSeconds;
                    if (message.torqueAmplitude != null && message.hasOwnProperty("torqueAmplitude"))
                        object.torqueAmplitude = message.torqueAmplitude;
                    if (message.startFrequency != null && message.hasOwnProperty("startFrequency"))
                        object.startFrequency = options.json && !isFinite(message.startFrequency) ? String(message.startFrequency) : message.startFrequency;
                    if (message.endFrequency != null && message.hasOwnProperty("endFrequency"))
                        object.endFrequency = options.json && !isFinite(message.endFrequency) ? String(message.endFrequency) : message.endFrequency;
                    if (message.nextGenSysId != null && message.hasOwnProperty("nextGenSysId"))
                        object.nextGenSysId = message.nextGenSysId;
                    if (message.skipChirpSignal != null && message.hasOwnProperty("skipChirpSignal"))
                        object.skipChirpSignal = message.skipChirpSignal;
                    return object;
                };

                /**
                 * Converts this StartSystemIdentification to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartSystemIdentification.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartSystemIdentification
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSystemIdentification
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartSystemIdentification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartSystemIdentification";
                };

                return StartSystemIdentification;
            })();

            Request.ComputeAutoTuningGains = (function() {

                /**
                 * Properties of a ComputeAutoTuningGains.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IComputeAutoTuningGains
                 * @property {number|null} [deviceAddress] ComputeAutoTuningGains deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters|null} [positionParameters] ComputeAutoTuningGains positionParameters
                 * @property {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters|null} [velocityParameters] ComputeAutoTuningGains velocityParameters
                 */

                /**
                 * Constructs a new ComputeAutoTuningGains.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a ComputeAutoTuningGains.
                 * @implements IComputeAutoTuningGains
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains=} [properties] Properties to set
                 */
                function ComputeAutoTuningGains(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ComputeAutoTuningGains deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @instance
                 */
                ComputeAutoTuningGains.prototype.deviceAddress = 0;

                /**
                 * ComputeAutoTuningGains positionParameters.
                 * @member {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters|null|undefined} positionParameters
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @instance
                 */
                ComputeAutoTuningGains.prototype.positionParameters = null;

                /**
                 * ComputeAutoTuningGains velocityParameters.
                 * @member {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters|null|undefined} velocityParameters
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @instance
                 */
                ComputeAutoTuningGains.prototype.velocityParameters = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * ComputeAutoTuningGains type.
                 * @member {"positionParameters"|"velocityParameters"|undefined} type
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @instance
                 */
                Object.defineProperty(ComputeAutoTuningGains.prototype, "type", {
                    get: $util.oneOfGetter($oneOfFields = ["positionParameters", "velocityParameters"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ComputeAutoTuningGains instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains} ComputeAutoTuningGains instance
                 */
                ComputeAutoTuningGains.create = function create(properties) {
                    return new ComputeAutoTuningGains(properties);
                };

                /**
                 * Encodes the specified ComputeAutoTuningGains message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains} message ComputeAutoTuningGains message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComputeAutoTuningGains.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.positionParameters != null && Object.hasOwnProperty.call(message, "positionParameters"))
                        $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.encode(message.positionParameters, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.velocityParameters != null && Object.hasOwnProperty.call(message, "velocityParameters"))
                        $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.encode(message.velocityParameters, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ComputeAutoTuningGains message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeAutoTuningGains} message ComputeAutoTuningGains message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComputeAutoTuningGains.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ComputeAutoTuningGains message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains} ComputeAutoTuningGains
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComputeAutoTuningGains.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.positionParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.velocityParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ComputeAutoTuningGains message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains} ComputeAutoTuningGains
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComputeAutoTuningGains.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ComputeAutoTuningGains message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ComputeAutoTuningGains.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.positionParameters != null && message.hasOwnProperty("positionParameters")) {
                        properties.type = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.verify(message.positionParameters);
                            if (error)
                                return "positionParameters." + error;
                        }
                    }
                    if (message.velocityParameters != null && message.hasOwnProperty("velocityParameters")) {
                        if (properties.type === 1)
                            return "type: multiple values";
                        properties.type = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.verify(message.velocityParameters);
                            if (error)
                                return "velocityParameters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ComputeAutoTuningGains message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains} ComputeAutoTuningGains
                 */
                ComputeAutoTuningGains.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.positionParameters != null) {
                        if (typeof object.positionParameters !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.positionParameters: object expected");
                        message.positionParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.fromObject(object.positionParameters);
                    }
                    if (object.velocityParameters != null) {
                        if (typeof object.velocityParameters !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.velocityParameters: object expected");
                        message.velocityParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.fromObject(object.velocityParameters);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ComputeAutoTuningGains message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains} message ComputeAutoTuningGains
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ComputeAutoTuningGains.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.positionParameters != null && message.hasOwnProperty("positionParameters")) {
                        object.positionParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.toObject(message.positionParameters, options);
                        if (options.oneofs)
                            object.type = "positionParameters";
                    }
                    if (message.velocityParameters != null && message.hasOwnProperty("velocityParameters")) {
                        object.velocityParameters = $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.toObject(message.velocityParameters, options);
                        if (options.oneofs)
                            object.type = "velocityParameters";
                    }
                    return object;
                };

                /**
                 * Converts this ComputeAutoTuningGains to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ComputeAutoTuningGains.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ComputeAutoTuningGains
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ComputeAutoTuningGains.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains";
                };

                ComputeAutoTuningGains.PositionParameters = (function() {

                    /**
                     * Properties of a PositionParameters.
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                     * @interface IPositionParameters
                     * @property {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType|null} [controllerType] PositionParameters controllerType
                     * @property {number|null} [settlingTime] PositionParameters settlingTime
                     * @property {number|null} [positionDamping] PositionParameters positionDamping
                     * @property {number|null} [alphaMult] PositionParameters alphaMult
                     * @property {number|null} [order] PositionParameters order
                     * @property {number|null} [lb] PositionParameters lb
                     * @property {number|null} [ub] PositionParameters ub
                     */

                    /**
                     * Constructs a new PositionParameters.
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                     * @classdesc Represents a PositionParameters.
                     * @implements IPositionParameters
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters=} [properties] Properties to set
                     */
                    function PositionParameters(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionParameters controllerType.
                     * @member {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType} controllerType
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.controllerType = 0;

                    /**
                     * PositionParameters settlingTime.
                     * @member {number} settlingTime
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.settlingTime = 0;

                    /**
                     * PositionParameters positionDamping.
                     * @member {number} positionDamping
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.positionDamping = 0;

                    /**
                     * PositionParameters alphaMult.
                     * @member {number} alphaMult
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.alphaMult = 0;

                    /**
                     * PositionParameters order.
                     * @member {number} order
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.order = 0;

                    /**
                     * PositionParameters lb.
                     * @member {number} lb
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.lb = 0;

                    /**
                     * PositionParameters ub.
                     * @member {number} ub
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     */
                    PositionParameters.prototype.ub = 0;

                    /**
                     * Creates a new PositionParameters instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters} PositionParameters instance
                     */
                    PositionParameters.create = function create(properties) {
                        return new PositionParameters(properties);
                    };

                    /**
                     * Encodes the specified PositionParameters message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters} message PositionParameters message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionParameters.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.controllerType != null && Object.hasOwnProperty.call(message, "controllerType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.controllerType);
                        if (message.settlingTime != null && Object.hasOwnProperty.call(message, "settlingTime"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.settlingTime);
                        if (message.positionDamping != null && Object.hasOwnProperty.call(message, "positionDamping"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.positionDamping);
                        if (message.alphaMult != null && Object.hasOwnProperty.call(message, "alphaMult"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.alphaMult);
                        if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.order);
                        if (message.lb != null && Object.hasOwnProperty.call(message, "lb"))
                            writer.uint32(/* id 6, wireType 5 =*/53).float(message.lb);
                        if (message.ub != null && Object.hasOwnProperty.call(message, "ub"))
                            writer.uint32(/* id 7, wireType 5 =*/61).float(message.ub);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionParameters message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IPositionParameters} message PositionParameters message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionParameters.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionParameters message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters} PositionParameters
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionParameters.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.controllerType = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.settlingTime = reader.float();
                                    break;
                                }
                            case 3: {
                                    message.positionDamping = reader.float();
                                    break;
                                }
                            case 4: {
                                    message.alphaMult = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.order = reader.uint32();
                                    break;
                                }
                            case 6: {
                                    message.lb = reader.float();
                                    break;
                                }
                            case 7: {
                                    message.ub = reader.float();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionParameters message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters} PositionParameters
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionParameters.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionParameters message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionParameters.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                            switch (message.controllerType) {
                            default:
                                return "controllerType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.settlingTime != null && message.hasOwnProperty("settlingTime"))
                            if (typeof message.settlingTime !== "number")
                                return "settlingTime: number expected";
                        if (message.positionDamping != null && message.hasOwnProperty("positionDamping"))
                            if (typeof message.positionDamping !== "number")
                                return "positionDamping: number expected";
                        if (message.alphaMult != null && message.hasOwnProperty("alphaMult"))
                            if (!$util.isInteger(message.alphaMult))
                                return "alphaMult: integer expected";
                        if (message.order != null && message.hasOwnProperty("order"))
                            if (!$util.isInteger(message.order))
                                return "order: integer expected";
                        if (message.lb != null && message.hasOwnProperty("lb"))
                            if (typeof message.lb !== "number")
                                return "lb: number expected";
                        if (message.ub != null && message.hasOwnProperty("ub"))
                            if (typeof message.ub !== "number")
                                return "ub: number expected";
                        return null;
                    };

                    /**
                     * Creates a PositionParameters message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters} PositionParameters
                     */
                    PositionParameters.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters();
                        switch (object.controllerType) {
                        default:
                            if (typeof object.controllerType === "number") {
                                message.controllerType = object.controllerType;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.controllerType = 0;
                            break;
                        case "PI_P":
                        case 1:
                            message.controllerType = 1;
                            break;
                        case "P_PI":
                        case 2:
                            message.controllerType = 2;
                            break;
                        }
                        if (object.settlingTime != null)
                            message.settlingTime = Number(object.settlingTime);
                        if (object.positionDamping != null)
                            message.positionDamping = Number(object.positionDamping);
                        if (object.alphaMult != null)
                            message.alphaMult = object.alphaMult | 0;
                        if (object.order != null)
                            message.order = object.order >>> 0;
                        if (object.lb != null)
                            message.lb = Number(object.lb);
                        if (object.ub != null)
                            message.ub = Number(object.ub);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionParameters message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters} message PositionParameters
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionParameters.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.controllerType = options.enums === String ? "UNSPECIFIED" : 0;
                            object.settlingTime = 0;
                            object.positionDamping = 0;
                            object.alphaMult = 0;
                            object.order = 0;
                            object.lb = 0;
                            object.ub = 0;
                        }
                        if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                            object.controllerType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType[message.controllerType] === undefined ? message.controllerType : $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType[message.controllerType] : message.controllerType;
                        if (message.settlingTime != null && message.hasOwnProperty("settlingTime"))
                            object.settlingTime = options.json && !isFinite(message.settlingTime) ? String(message.settlingTime) : message.settlingTime;
                        if (message.positionDamping != null && message.hasOwnProperty("positionDamping"))
                            object.positionDamping = options.json && !isFinite(message.positionDamping) ? String(message.positionDamping) : message.positionDamping;
                        if (message.alphaMult != null && message.hasOwnProperty("alphaMult"))
                            object.alphaMult = message.alphaMult;
                        if (message.order != null && message.hasOwnProperty("order"))
                            object.order = message.order;
                        if (message.lb != null && message.hasOwnProperty("lb"))
                            object.lb = options.json && !isFinite(message.lb) ? String(message.lb) : message.lb;
                        if (message.ub != null && message.hasOwnProperty("ub"))
                            object.ub = options.json && !isFinite(message.ub) ? String(message.ub) : message.ub;
                        return object;
                    };

                    /**
                     * Converts this PositionParameters to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionParameters.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionParameters
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionParameters.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters";
                    };

                    /**
                     * ControllerType enum.
                     * @name motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} PI_P=1 PI_P value
                     * @property {number} P_PI=2 P_PI value
                     */
                    PositionParameters.ControllerType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PI_P"] = 1;
                        values[valuesById[2] = "P_PI"] = 2;
                        return values;
                    })();

                    return PositionParameters;
                })();

                ComputeAutoTuningGains.VelocityParameters = (function() {

                    /**
                     * Properties of a VelocityParameters.
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                     * @interface IVelocityParameters
                     * @property {number|null} [velocityLoopBandwidth] VelocityParameters velocityLoopBandwidth
                     * @property {number|null} [velocityDamping] VelocityParameters velocityDamping
                     */

                    /**
                     * Constructs a new VelocityParameters.
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains
                     * @classdesc Represents a VelocityParameters.
                     * @implements IVelocityParameters
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters=} [properties] Properties to set
                     */
                    function VelocityParameters(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityParameters velocityLoopBandwidth.
                     * @member {number} velocityLoopBandwidth
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @instance
                     */
                    VelocityParameters.prototype.velocityLoopBandwidth = 0;

                    /**
                     * VelocityParameters velocityDamping.
                     * @member {number} velocityDamping
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @instance
                     */
                    VelocityParameters.prototype.velocityDamping = 0;

                    /**
                     * Creates a new VelocityParameters instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters} VelocityParameters instance
                     */
                    VelocityParameters.create = function create(properties) {
                        return new VelocityParameters(properties);
                    };

                    /**
                     * Encodes the specified VelocityParameters message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters} message VelocityParameters message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityParameters.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.velocityLoopBandwidth != null && Object.hasOwnProperty.call(message, "velocityLoopBandwidth"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.velocityLoopBandwidth);
                        if (message.velocityDamping != null && Object.hasOwnProperty.call(message, "velocityDamping"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.velocityDamping);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityParameters message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.IVelocityParameters} message VelocityParameters message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityParameters.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityParameters message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters} VelocityParameters
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityParameters.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.velocityLoopBandwidth = reader.float();
                                    break;
                                }
                            case 2: {
                                    message.velocityDamping = reader.float();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityParameters message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters} VelocityParameters
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityParameters.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityParameters message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityParameters.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.velocityLoopBandwidth != null && message.hasOwnProperty("velocityLoopBandwidth"))
                            if (typeof message.velocityLoopBandwidth !== "number")
                                return "velocityLoopBandwidth: number expected";
                        if (message.velocityDamping != null && message.hasOwnProperty("velocityDamping"))
                            if (typeof message.velocityDamping !== "number")
                                return "velocityDamping: number expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityParameters message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters} VelocityParameters
                     */
                    VelocityParameters.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters();
                        if (object.velocityLoopBandwidth != null)
                            message.velocityLoopBandwidth = Number(object.velocityLoopBandwidth);
                        if (object.velocityDamping != null)
                            message.velocityDamping = Number(object.velocityDamping);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityParameters message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters} message VelocityParameters
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityParameters.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.velocityLoopBandwidth = 0;
                            object.velocityDamping = 0;
                        }
                        if (message.velocityLoopBandwidth != null && message.hasOwnProperty("velocityLoopBandwidth"))
                            object.velocityLoopBandwidth = options.json && !isFinite(message.velocityLoopBandwidth) ? String(message.velocityLoopBandwidth) : message.velocityLoopBandwidth;
                        if (message.velocityDamping != null && message.hasOwnProperty("velocityDamping"))
                            object.velocityDamping = options.json && !isFinite(message.velocityDamping) ? String(message.velocityDamping) : message.velocityDamping;
                        return object;
                    };

                    /**
                     * Converts this VelocityParameters to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityParameters.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityParameters
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityParameters.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ComputeAutoTuningGains.VelocityParameters";
                    };

                    return VelocityParameters;
                })();

                return ComputeAutoTuningGains;
            })();

            Request.SetMotionControllerParameters = (function() {

                /**
                 * Properties of a SetMotionControllerParameters.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetMotionControllerParameters
                 * @property {number|null} [deviceAddress] SetMotionControllerParameters deviceAddress
                 * @property {number|null} [target] SetMotionControllerParameters target
                 */

                /**
                 * Constructs a new SetMotionControllerParameters.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetMotionControllerParameters.
                 * @implements ISetMotionControllerParameters
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters=} [properties] Properties to set
                 */
                function SetMotionControllerParameters(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetMotionControllerParameters deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @instance
                 */
                SetMotionControllerParameters.prototype.deviceAddress = 0;

                /**
                 * SetMotionControllerParameters target.
                 * @member {number} target
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @instance
                 */
                SetMotionControllerParameters.prototype.target = 0;

                /**
                 * Creates a new SetMotionControllerParameters instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters} SetMotionControllerParameters instance
                 */
                SetMotionControllerParameters.create = function create(properties) {
                    return new SetMotionControllerParameters(properties);
                };

                /**
                 * Encodes the specified SetMotionControllerParameters message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters} message SetMotionControllerParameters message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetMotionControllerParameters.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.target);
                    return writer;
                };

                /**
                 * Encodes the specified SetMotionControllerParameters message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetMotionControllerParameters} message SetMotionControllerParameters message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetMotionControllerParameters.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetMotionControllerParameters message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters} SetMotionControllerParameters
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetMotionControllerParameters.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.target = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetMotionControllerParameters message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters} SetMotionControllerParameters
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetMotionControllerParameters.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetMotionControllerParameters message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetMotionControllerParameters.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.target != null && message.hasOwnProperty("target"))
                        if (!$util.isInteger(message.target))
                            return "target: integer expected";
                    return null;
                };

                /**
                 * Creates a SetMotionControllerParameters message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters} SetMotionControllerParameters
                 */
                SetMotionControllerParameters.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.target != null)
                        message.target = object.target | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SetMotionControllerParameters message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters} message SetMotionControllerParameters
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetMotionControllerParameters.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.target = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.target != null && message.hasOwnProperty("target"))
                        object.target = message.target;
                    return object;
                };

                /**
                 * Converts this SetMotionControllerParameters to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetMotionControllerParameters.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetMotionControllerParameters
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetMotionControllerParameters.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetMotionControllerParameters";
                };

                return SetMotionControllerParameters;
            })();

            Request.EnableMotionController = (function() {

                /**
                 * Properties of an EnableMotionController.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IEnableMotionController
                 * @property {number|null} [deviceAddress] EnableMotionController deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.EnableMotionController.ControllerType|null} [controllerType] EnableMotionController controllerType
                 * @property {boolean|null} [filter] EnableMotionController filter
                 */

                /**
                 * Constructs a new EnableMotionController.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents an EnableMotionController.
                 * @implements IEnableMotionController
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IEnableMotionController=} [properties] Properties to set
                 */
                function EnableMotionController(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EnableMotionController deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @instance
                 */
                EnableMotionController.prototype.deviceAddress = 0;

                /**
                 * EnableMotionController controllerType.
                 * @member {motionmaster.MotionMasterMessage.Request.EnableMotionController.ControllerType} controllerType
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @instance
                 */
                EnableMotionController.prototype.controllerType = 0;

                /**
                 * EnableMotionController filter.
                 * @member {boolean} filter
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @instance
                 */
                EnableMotionController.prototype.filter = false;

                /**
                 * Creates a new EnableMotionController instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IEnableMotionController=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.EnableMotionController} EnableMotionController instance
                 */
                EnableMotionController.create = function create(properties) {
                    return new EnableMotionController(properties);
                };

                /**
                 * Encodes the specified EnableMotionController message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.EnableMotionController.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IEnableMotionController} message EnableMotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnableMotionController.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.controllerType != null && Object.hasOwnProperty.call(message, "controllerType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.controllerType);
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.filter);
                    return writer;
                };

                /**
                 * Encodes the specified EnableMotionController message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.EnableMotionController.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IEnableMotionController} message EnableMotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnableMotionController.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EnableMotionController message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.EnableMotionController} EnableMotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnableMotionController.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.EnableMotionController();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.controllerType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.filter = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EnableMotionController message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.EnableMotionController} EnableMotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnableMotionController.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EnableMotionController message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnableMotionController.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        switch (message.controllerType) {
                        default:
                            return "controllerType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        if (typeof message.filter !== "boolean")
                            return "filter: boolean expected";
                    return null;
                };

                /**
                 * Creates an EnableMotionController message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.EnableMotionController} EnableMotionController
                 */
                EnableMotionController.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.EnableMotionController)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.EnableMotionController();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.controllerType) {
                    default:
                        if (typeof object.controllerType === "number") {
                            message.controllerType = object.controllerType;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.controllerType = 0;
                        break;
                    case "POSITION":
                    case 1:
                        message.controllerType = 1;
                        break;
                    case "VELOCITY":
                    case 2:
                        message.controllerType = 2;
                        break;
                    case "TORQUE":
                    case 3:
                        message.controllerType = 3;
                        break;
                    }
                    if (object.filter != null)
                        message.filter = Boolean(object.filter);
                    return message;
                };

                /**
                 * Creates a plain object from an EnableMotionController message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.EnableMotionController} message EnableMotionController
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnableMotionController.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.controllerType = options.enums === String ? "UNSPECIFIED" : 0;
                        object.filter = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        object.controllerType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.ControllerType[message.controllerType] === undefined ? message.controllerType : $root.motionmaster.MotionMasterMessage.Request.EnableMotionController.ControllerType[message.controllerType] : message.controllerType;
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        object.filter = message.filter;
                    return object;
                };

                /**
                 * Converts this EnableMotionController to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnableMotionController.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EnableMotionController
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.EnableMotionController
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EnableMotionController.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.EnableMotionController";
                };

                /**
                 * ControllerType enum.
                 * @name motionmaster.MotionMasterMessage.Request.EnableMotionController.ControllerType
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} POSITION=1 POSITION value
                 * @property {number} VELOCITY=2 VELOCITY value
                 * @property {number} TORQUE=3 TORQUE value
                 */
                EnableMotionController.ControllerType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "POSITION"] = 1;
                    values[valuesById[2] = "VELOCITY"] = 2;
                    values[valuesById[3] = "TORQUE"] = 3;
                    return values;
                })();

                return EnableMotionController;
            })();

            Request.DisableMotionController = (function() {

                /**
                 * Properties of a DisableMotionController.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IDisableMotionController
                 * @property {number|null} [deviceAddress] DisableMotionController deviceAddress
                 */

                /**
                 * Constructs a new DisableMotionController.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a DisableMotionController.
                 * @implements IDisableMotionController
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IDisableMotionController=} [properties] Properties to set
                 */
                function DisableMotionController(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DisableMotionController deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @instance
                 */
                DisableMotionController.prototype.deviceAddress = 0;

                /**
                 * Creates a new DisableMotionController instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDisableMotionController=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.DisableMotionController} DisableMotionController instance
                 */
                DisableMotionController.create = function create(properties) {
                    return new DisableMotionController(properties);
                };

                /**
                 * Encodes the specified DisableMotionController message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.DisableMotionController.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDisableMotionController} message DisableMotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisableMotionController.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified DisableMotionController message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.DisableMotionController.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IDisableMotionController} message DisableMotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DisableMotionController.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DisableMotionController message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.DisableMotionController} DisableMotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisableMotionController.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.DisableMotionController();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DisableMotionController message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.DisableMotionController} DisableMotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DisableMotionController.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DisableMotionController message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DisableMotionController.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a DisableMotionController message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.DisableMotionController} DisableMotionController
                 */
                DisableMotionController.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.DisableMotionController)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.DisableMotionController();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a DisableMotionController message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.DisableMotionController} message DisableMotionController
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DisableMotionController.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this DisableMotionController to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DisableMotionController.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DisableMotionController
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.DisableMotionController
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DisableMotionController.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.DisableMotionController";
                };

                return DisableMotionController;
            })();

            Request.SetSignalGeneratorParameters = (function() {

                /**
                 * Properties of a SetSignalGeneratorParameters.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetSignalGeneratorParameters
                 * @property {number|null} [deviceAddress] SetSignalGeneratorParameters deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse|null} [positionStepResponse] SetSignalGeneratorParameters positionStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse|null} [positionAdvancedStepResponse] SetSignalGeneratorParameters positionAdvancedStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp|null} [positionRamp] SetSignalGeneratorParameters positionRamp
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal|null} [positionTrapezoidal] SetSignalGeneratorParameters positionTrapezoidal
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional|null} [positionBidirectional] SetSignalGeneratorParameters positionBidirectional
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave|null} [positionSineWave] SetSignalGeneratorParameters positionSineWave
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse|null} [velocityStepResponse] SetSignalGeneratorParameters velocityStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse|null} [velocityAdvancedStepResponse] SetSignalGeneratorParameters velocityAdvancedStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp|null} [velocityRamp] SetSignalGeneratorParameters velocityRamp
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal|null} [velocityTrapezoidal] SetSignalGeneratorParameters velocityTrapezoidal
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional|null} [velocityBidirectional] SetSignalGeneratorParameters velocityBidirectional
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave|null} [velocitySineWave] SetSignalGeneratorParameters velocitySineWave
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse|null} [torqueStepResponse] SetSignalGeneratorParameters torqueStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse|null} [torqueAdvancedStepResponse] SetSignalGeneratorParameters torqueAdvancedStepResponse
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp|null} [torqueRamp] SetSignalGeneratorParameters torqueRamp
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal|null} [torqueTrapezoidal] SetSignalGeneratorParameters torqueTrapezoidal
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional|null} [torqueBidirectional] SetSignalGeneratorParameters torqueBidirectional
                 * @property {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave|null} [torqueSineWave] SetSignalGeneratorParameters torqueSineWave
                 */

                /**
                 * Constructs a new SetSignalGeneratorParameters.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetSignalGeneratorParameters.
                 * @implements ISetSignalGeneratorParameters
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters=} [properties] Properties to set
                 */
                function SetSignalGeneratorParameters(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetSignalGeneratorParameters deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.deviceAddress = 0;

                /**
                 * SetSignalGeneratorParameters positionStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse|null|undefined} positionStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionStepResponse = null;

                /**
                 * SetSignalGeneratorParameters positionAdvancedStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse|null|undefined} positionAdvancedStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionAdvancedStepResponse = null;

                /**
                 * SetSignalGeneratorParameters positionRamp.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp|null|undefined} positionRamp
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionRamp = null;

                /**
                 * SetSignalGeneratorParameters positionTrapezoidal.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal|null|undefined} positionTrapezoidal
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionTrapezoidal = null;

                /**
                 * SetSignalGeneratorParameters positionBidirectional.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional|null|undefined} positionBidirectional
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionBidirectional = null;

                /**
                 * SetSignalGeneratorParameters positionSineWave.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave|null|undefined} positionSineWave
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.positionSineWave = null;

                /**
                 * SetSignalGeneratorParameters velocityStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse|null|undefined} velocityStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocityStepResponse = null;

                /**
                 * SetSignalGeneratorParameters velocityAdvancedStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse|null|undefined} velocityAdvancedStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocityAdvancedStepResponse = null;

                /**
                 * SetSignalGeneratorParameters velocityRamp.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp|null|undefined} velocityRamp
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocityRamp = null;

                /**
                 * SetSignalGeneratorParameters velocityTrapezoidal.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal|null|undefined} velocityTrapezoidal
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocityTrapezoidal = null;

                /**
                 * SetSignalGeneratorParameters velocityBidirectional.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional|null|undefined} velocityBidirectional
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocityBidirectional = null;

                /**
                 * SetSignalGeneratorParameters velocitySineWave.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave|null|undefined} velocitySineWave
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.velocitySineWave = null;

                /**
                 * SetSignalGeneratorParameters torqueStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse|null|undefined} torqueStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueStepResponse = null;

                /**
                 * SetSignalGeneratorParameters torqueAdvancedStepResponse.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse|null|undefined} torqueAdvancedStepResponse
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueAdvancedStepResponse = null;

                /**
                 * SetSignalGeneratorParameters torqueRamp.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp|null|undefined} torqueRamp
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueRamp = null;

                /**
                 * SetSignalGeneratorParameters torqueTrapezoidal.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal|null|undefined} torqueTrapezoidal
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueTrapezoidal = null;

                /**
                 * SetSignalGeneratorParameters torqueBidirectional.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional|null|undefined} torqueBidirectional
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueBidirectional = null;

                /**
                 * SetSignalGeneratorParameters torqueSineWave.
                 * @member {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave|null|undefined} torqueSineWave
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                SetSignalGeneratorParameters.prototype.torqueSineWave = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SetSignalGeneratorParameters signal.
                 * @member {"positionStepResponse"|"positionAdvancedStepResponse"|"positionRamp"|"positionTrapezoidal"|"positionBidirectional"|"positionSineWave"|"velocityStepResponse"|"velocityAdvancedStepResponse"|"velocityRamp"|"velocityTrapezoidal"|"velocityBidirectional"|"velocitySineWave"|"torqueStepResponse"|"torqueAdvancedStepResponse"|"torqueRamp"|"torqueTrapezoidal"|"torqueBidirectional"|"torqueSineWave"|undefined} signal
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 */
                Object.defineProperty(SetSignalGeneratorParameters.prototype, "signal", {
                    get: $util.oneOfGetter($oneOfFields = ["positionStepResponse", "positionAdvancedStepResponse", "positionRamp", "positionTrapezoidal", "positionBidirectional", "positionSineWave", "velocityStepResponse", "velocityAdvancedStepResponse", "velocityRamp", "velocityTrapezoidal", "velocityBidirectional", "velocitySineWave", "torqueStepResponse", "torqueAdvancedStepResponse", "torqueRamp", "torqueTrapezoidal", "torqueBidirectional", "torqueSineWave"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SetSignalGeneratorParameters instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters} SetSignalGeneratorParameters instance
                 */
                SetSignalGeneratorParameters.create = function create(properties) {
                    return new SetSignalGeneratorParameters(properties);
                };

                /**
                 * Encodes the specified SetSignalGeneratorParameters message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters} message SetSignalGeneratorParameters message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetSignalGeneratorParameters.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.positionStepResponse != null && Object.hasOwnProperty.call(message, "positionStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.encode(message.positionStepResponse, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.positionAdvancedStepResponse != null && Object.hasOwnProperty.call(message, "positionAdvancedStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.encode(message.positionAdvancedStepResponse, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.positionRamp != null && Object.hasOwnProperty.call(message, "positionRamp"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.encode(message.positionRamp, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.positionTrapezoidal != null && Object.hasOwnProperty.call(message, "positionTrapezoidal"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.encode(message.positionTrapezoidal, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.positionBidirectional != null && Object.hasOwnProperty.call(message, "positionBidirectional"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.encode(message.positionBidirectional, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.positionSineWave != null && Object.hasOwnProperty.call(message, "positionSineWave"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.encode(message.positionSineWave, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.velocityStepResponse != null && Object.hasOwnProperty.call(message, "velocityStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.encode(message.velocityStepResponse, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.velocityAdvancedStepResponse != null && Object.hasOwnProperty.call(message, "velocityAdvancedStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.encode(message.velocityAdvancedStepResponse, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.velocityRamp != null && Object.hasOwnProperty.call(message, "velocityRamp"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.encode(message.velocityRamp, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.velocityTrapezoidal != null && Object.hasOwnProperty.call(message, "velocityTrapezoidal"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.encode(message.velocityTrapezoidal, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.velocityBidirectional != null && Object.hasOwnProperty.call(message, "velocityBidirectional"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.encode(message.velocityBidirectional, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.velocitySineWave != null && Object.hasOwnProperty.call(message, "velocitySineWave"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.encode(message.velocitySineWave, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.torqueStepResponse != null && Object.hasOwnProperty.call(message, "torqueStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.encode(message.torqueStepResponse, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.torqueAdvancedStepResponse != null && Object.hasOwnProperty.call(message, "torqueAdvancedStepResponse"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.encode(message.torqueAdvancedStepResponse, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.torqueRamp != null && Object.hasOwnProperty.call(message, "torqueRamp"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.encode(message.torqueRamp, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.torqueTrapezoidal != null && Object.hasOwnProperty.call(message, "torqueTrapezoidal"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.encode(message.torqueTrapezoidal, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.torqueBidirectional != null && Object.hasOwnProperty.call(message, "torqueBidirectional"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.encode(message.torqueBidirectional, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.torqueSineWave != null && Object.hasOwnProperty.call(message, "torqueSineWave"))
                        $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.encode(message.torqueSineWave, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SetSignalGeneratorParameters message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSignalGeneratorParameters} message SetSignalGeneratorParameters message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetSignalGeneratorParameters.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetSignalGeneratorParameters message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters} SetSignalGeneratorParameters
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetSignalGeneratorParameters.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.positionStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.positionAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.positionRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.positionTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.positionBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.positionSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.velocityStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 9: {
                                message.velocityAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 10: {
                                message.velocityRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 11: {
                                message.velocityTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.velocityBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message.velocitySineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.decode(reader, reader.uint32());
                                break;
                            }
                        case 14: {
                                message.torqueStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 15: {
                                message.torqueAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.decode(reader, reader.uint32());
                                break;
                            }
                        case 16: {
                                message.torqueRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.decode(reader, reader.uint32());
                                break;
                            }
                        case 17: {
                                message.torqueTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.decode(reader, reader.uint32());
                                break;
                            }
                        case 18: {
                                message.torqueBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.decode(reader, reader.uint32());
                                break;
                            }
                        case 19: {
                                message.torqueSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetSignalGeneratorParameters message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters} SetSignalGeneratorParameters
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetSignalGeneratorParameters.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetSignalGeneratorParameters message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetSignalGeneratorParameters.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.positionStepResponse != null && message.hasOwnProperty("positionStepResponse")) {
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.verify(message.positionStepResponse);
                            if (error)
                                return "positionStepResponse." + error;
                        }
                    }
                    if (message.positionAdvancedStepResponse != null && message.hasOwnProperty("positionAdvancedStepResponse")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.verify(message.positionAdvancedStepResponse);
                            if (error)
                                return "positionAdvancedStepResponse." + error;
                        }
                    }
                    if (message.positionRamp != null && message.hasOwnProperty("positionRamp")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.verify(message.positionRamp);
                            if (error)
                                return "positionRamp." + error;
                        }
                    }
                    if (message.positionTrapezoidal != null && message.hasOwnProperty("positionTrapezoidal")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.verify(message.positionTrapezoidal);
                            if (error)
                                return "positionTrapezoidal." + error;
                        }
                    }
                    if (message.positionBidirectional != null && message.hasOwnProperty("positionBidirectional")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.verify(message.positionBidirectional);
                            if (error)
                                return "positionBidirectional." + error;
                        }
                    }
                    if (message.positionSineWave != null && message.hasOwnProperty("positionSineWave")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.verify(message.positionSineWave);
                            if (error)
                                return "positionSineWave." + error;
                        }
                    }
                    if (message.velocityStepResponse != null && message.hasOwnProperty("velocityStepResponse")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.verify(message.velocityStepResponse);
                            if (error)
                                return "velocityStepResponse." + error;
                        }
                    }
                    if (message.velocityAdvancedStepResponse != null && message.hasOwnProperty("velocityAdvancedStepResponse")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.verify(message.velocityAdvancedStepResponse);
                            if (error)
                                return "velocityAdvancedStepResponse." + error;
                        }
                    }
                    if (message.velocityRamp != null && message.hasOwnProperty("velocityRamp")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.verify(message.velocityRamp);
                            if (error)
                                return "velocityRamp." + error;
                        }
                    }
                    if (message.velocityTrapezoidal != null && message.hasOwnProperty("velocityTrapezoidal")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.verify(message.velocityTrapezoidal);
                            if (error)
                                return "velocityTrapezoidal." + error;
                        }
                    }
                    if (message.velocityBidirectional != null && message.hasOwnProperty("velocityBidirectional")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.verify(message.velocityBidirectional);
                            if (error)
                                return "velocityBidirectional." + error;
                        }
                    }
                    if (message.velocitySineWave != null && message.hasOwnProperty("velocitySineWave")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.verify(message.velocitySineWave);
                            if (error)
                                return "velocitySineWave." + error;
                        }
                    }
                    if (message.torqueStepResponse != null && message.hasOwnProperty("torqueStepResponse")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.verify(message.torqueStepResponse);
                            if (error)
                                return "torqueStepResponse." + error;
                        }
                    }
                    if (message.torqueAdvancedStepResponse != null && message.hasOwnProperty("torqueAdvancedStepResponse")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.verify(message.torqueAdvancedStepResponse);
                            if (error)
                                return "torqueAdvancedStepResponse." + error;
                        }
                    }
                    if (message.torqueRamp != null && message.hasOwnProperty("torqueRamp")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.verify(message.torqueRamp);
                            if (error)
                                return "torqueRamp." + error;
                        }
                    }
                    if (message.torqueTrapezoidal != null && message.hasOwnProperty("torqueTrapezoidal")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.verify(message.torqueTrapezoidal);
                            if (error)
                                return "torqueTrapezoidal." + error;
                        }
                    }
                    if (message.torqueBidirectional != null && message.hasOwnProperty("torqueBidirectional")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.verify(message.torqueBidirectional);
                            if (error)
                                return "torqueBidirectional." + error;
                        }
                    }
                    if (message.torqueSineWave != null && message.hasOwnProperty("torqueSineWave")) {
                        if (properties.signal === 1)
                            return "signal: multiple values";
                        properties.signal = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.verify(message.torqueSineWave);
                            if (error)
                                return "torqueSineWave." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SetSignalGeneratorParameters message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters} SetSignalGeneratorParameters
                 */
                SetSignalGeneratorParameters.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.positionStepResponse != null) {
                        if (typeof object.positionStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionStepResponse: object expected");
                        message.positionStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.fromObject(object.positionStepResponse);
                    }
                    if (object.positionAdvancedStepResponse != null) {
                        if (typeof object.positionAdvancedStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionAdvancedStepResponse: object expected");
                        message.positionAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.fromObject(object.positionAdvancedStepResponse);
                    }
                    if (object.positionRamp != null) {
                        if (typeof object.positionRamp !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionRamp: object expected");
                        message.positionRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.fromObject(object.positionRamp);
                    }
                    if (object.positionTrapezoidal != null) {
                        if (typeof object.positionTrapezoidal !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionTrapezoidal: object expected");
                        message.positionTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.fromObject(object.positionTrapezoidal);
                    }
                    if (object.positionBidirectional != null) {
                        if (typeof object.positionBidirectional !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionBidirectional: object expected");
                        message.positionBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.fromObject(object.positionBidirectional);
                    }
                    if (object.positionSineWave != null) {
                        if (typeof object.positionSineWave !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.positionSineWave: object expected");
                        message.positionSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.fromObject(object.positionSineWave);
                    }
                    if (object.velocityStepResponse != null) {
                        if (typeof object.velocityStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocityStepResponse: object expected");
                        message.velocityStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.fromObject(object.velocityStepResponse);
                    }
                    if (object.velocityAdvancedStepResponse != null) {
                        if (typeof object.velocityAdvancedStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocityAdvancedStepResponse: object expected");
                        message.velocityAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.fromObject(object.velocityAdvancedStepResponse);
                    }
                    if (object.velocityRamp != null) {
                        if (typeof object.velocityRamp !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocityRamp: object expected");
                        message.velocityRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.fromObject(object.velocityRamp);
                    }
                    if (object.velocityTrapezoidal != null) {
                        if (typeof object.velocityTrapezoidal !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocityTrapezoidal: object expected");
                        message.velocityTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.fromObject(object.velocityTrapezoidal);
                    }
                    if (object.velocityBidirectional != null) {
                        if (typeof object.velocityBidirectional !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocityBidirectional: object expected");
                        message.velocityBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.fromObject(object.velocityBidirectional);
                    }
                    if (object.velocitySineWave != null) {
                        if (typeof object.velocitySineWave !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.velocitySineWave: object expected");
                        message.velocitySineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.fromObject(object.velocitySineWave);
                    }
                    if (object.torqueStepResponse != null) {
                        if (typeof object.torqueStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueStepResponse: object expected");
                        message.torqueStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.fromObject(object.torqueStepResponse);
                    }
                    if (object.torqueAdvancedStepResponse != null) {
                        if (typeof object.torqueAdvancedStepResponse !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueAdvancedStepResponse: object expected");
                        message.torqueAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.fromObject(object.torqueAdvancedStepResponse);
                    }
                    if (object.torqueRamp != null) {
                        if (typeof object.torqueRamp !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueRamp: object expected");
                        message.torqueRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.fromObject(object.torqueRamp);
                    }
                    if (object.torqueTrapezoidal != null) {
                        if (typeof object.torqueTrapezoidal !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueTrapezoidal: object expected");
                        message.torqueTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.fromObject(object.torqueTrapezoidal);
                    }
                    if (object.torqueBidirectional != null) {
                        if (typeof object.torqueBidirectional !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueBidirectional: object expected");
                        message.torqueBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.fromObject(object.torqueBidirectional);
                    }
                    if (object.torqueSineWave != null) {
                        if (typeof object.torqueSineWave !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.torqueSineWave: object expected");
                        message.torqueSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.fromObject(object.torqueSineWave);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetSignalGeneratorParameters message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters} message SetSignalGeneratorParameters
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetSignalGeneratorParameters.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.positionStepResponse != null && message.hasOwnProperty("positionStepResponse")) {
                        object.positionStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.toObject(message.positionStepResponse, options);
                        if (options.oneofs)
                            object.signal = "positionStepResponse";
                    }
                    if (message.positionAdvancedStepResponse != null && message.hasOwnProperty("positionAdvancedStepResponse")) {
                        object.positionAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.toObject(message.positionAdvancedStepResponse, options);
                        if (options.oneofs)
                            object.signal = "positionAdvancedStepResponse";
                    }
                    if (message.positionRamp != null && message.hasOwnProperty("positionRamp")) {
                        object.positionRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.toObject(message.positionRamp, options);
                        if (options.oneofs)
                            object.signal = "positionRamp";
                    }
                    if (message.positionTrapezoidal != null && message.hasOwnProperty("positionTrapezoidal")) {
                        object.positionTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.toObject(message.positionTrapezoidal, options);
                        if (options.oneofs)
                            object.signal = "positionTrapezoidal";
                    }
                    if (message.positionBidirectional != null && message.hasOwnProperty("positionBidirectional")) {
                        object.positionBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.toObject(message.positionBidirectional, options);
                        if (options.oneofs)
                            object.signal = "positionBidirectional";
                    }
                    if (message.positionSineWave != null && message.hasOwnProperty("positionSineWave")) {
                        object.positionSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.toObject(message.positionSineWave, options);
                        if (options.oneofs)
                            object.signal = "positionSineWave";
                    }
                    if (message.velocityStepResponse != null && message.hasOwnProperty("velocityStepResponse")) {
                        object.velocityStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.toObject(message.velocityStepResponse, options);
                        if (options.oneofs)
                            object.signal = "velocityStepResponse";
                    }
                    if (message.velocityAdvancedStepResponse != null && message.hasOwnProperty("velocityAdvancedStepResponse")) {
                        object.velocityAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.toObject(message.velocityAdvancedStepResponse, options);
                        if (options.oneofs)
                            object.signal = "velocityAdvancedStepResponse";
                    }
                    if (message.velocityRamp != null && message.hasOwnProperty("velocityRamp")) {
                        object.velocityRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.toObject(message.velocityRamp, options);
                        if (options.oneofs)
                            object.signal = "velocityRamp";
                    }
                    if (message.velocityTrapezoidal != null && message.hasOwnProperty("velocityTrapezoidal")) {
                        object.velocityTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.toObject(message.velocityTrapezoidal, options);
                        if (options.oneofs)
                            object.signal = "velocityTrapezoidal";
                    }
                    if (message.velocityBidirectional != null && message.hasOwnProperty("velocityBidirectional")) {
                        object.velocityBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.toObject(message.velocityBidirectional, options);
                        if (options.oneofs)
                            object.signal = "velocityBidirectional";
                    }
                    if (message.velocitySineWave != null && message.hasOwnProperty("velocitySineWave")) {
                        object.velocitySineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.toObject(message.velocitySineWave, options);
                        if (options.oneofs)
                            object.signal = "velocitySineWave";
                    }
                    if (message.torqueStepResponse != null && message.hasOwnProperty("torqueStepResponse")) {
                        object.torqueStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.toObject(message.torqueStepResponse, options);
                        if (options.oneofs)
                            object.signal = "torqueStepResponse";
                    }
                    if (message.torqueAdvancedStepResponse != null && message.hasOwnProperty("torqueAdvancedStepResponse")) {
                        object.torqueAdvancedStepResponse = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.toObject(message.torqueAdvancedStepResponse, options);
                        if (options.oneofs)
                            object.signal = "torqueAdvancedStepResponse";
                    }
                    if (message.torqueRamp != null && message.hasOwnProperty("torqueRamp")) {
                        object.torqueRamp = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.toObject(message.torqueRamp, options);
                        if (options.oneofs)
                            object.signal = "torqueRamp";
                    }
                    if (message.torqueTrapezoidal != null && message.hasOwnProperty("torqueTrapezoidal")) {
                        object.torqueTrapezoidal = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.toObject(message.torqueTrapezoidal, options);
                        if (options.oneofs)
                            object.signal = "torqueTrapezoidal";
                    }
                    if (message.torqueBidirectional != null && message.hasOwnProperty("torqueBidirectional")) {
                        object.torqueBidirectional = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.toObject(message.torqueBidirectional, options);
                        if (options.oneofs)
                            object.signal = "torqueBidirectional";
                    }
                    if (message.torqueSineWave != null && message.hasOwnProperty("torqueSineWave")) {
                        object.torqueSineWave = $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.toObject(message.torqueSineWave, options);
                        if (options.oneofs)
                            object.signal = "torqueSineWave";
                    }
                    return object;
                };

                /**
                 * Converts this SetSignalGeneratorParameters to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetSignalGeneratorParameters.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetSignalGeneratorParameters
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetSignalGeneratorParameters.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters";
                };

                SetSignalGeneratorParameters.PositionStepResponse = (function() {

                    /**
                     * Properties of a PositionStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionStepResponse
                     * @property {number|null} [target] PositionStepResponse target
                     * @property {number|null} [sustainTime] PositionStepResponse sustainTime
                     * @property {boolean|null} [absoluteTarget] PositionStepResponse absoluteTarget
                     */

                    /**
                     * Constructs a new PositionStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionStepResponse.
                     * @implements IPositionStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse=} [properties] Properties to set
                     */
                    function PositionStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @instance
                     */
                    PositionStepResponse.prototype.target = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @instance
                     */
                    PositionStepResponse.prototype.sustainTime = 0;

                    /**
                     * PositionStepResponse absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @instance
                     */
                    PositionStepResponse.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse} PositionStepResponse instance
                     */
                    PositionStepResponse.create = function create(properties) {
                        return new PositionStepResponse(properties);
                    };

                    /**
                     * Encodes the specified PositionStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse} message PositionStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionStepResponse} message PositionStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse} PositionStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse} PositionStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target) && !(message.target && $util.isInteger(message.target.low) && $util.isInteger(message.target.high)))
                                return "target: integer|Long expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse} PositionStepResponse
                     */
                    PositionStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse();
                        if (object.target != null)
                            if ($util.Long)
                                (message.target = $util.Long.fromValue(object.target)).unsigned = false;
                            else if (typeof object.target === "string")
                                message.target = parseInt(object.target, 10);
                            else if (typeof object.target === "number")
                                message.target = object.target;
                            else if (typeof object.target === "object")
                                message.target = new $util.LongBits(object.target.low >>> 0, object.target.high >>> 0).toNumber();
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse} message PositionStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.target = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.target = options.longs === String ? "0" : 0;
                            object.sustainTime = 0;
                            object.absoluteTarget = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (typeof message.target === "number")
                                object.target = options.longs === String ? String(message.target) : message.target;
                            else
                                object.target = options.longs === String ? $util.Long.prototype.toString.call(message.target) : options.longs === Number ? new $util.LongBits(message.target.low >>> 0, message.target.high >>> 0).toNumber() : message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionStepResponse";
                    };

                    return PositionStepResponse;
                })();

                SetSignalGeneratorParameters.PositionAdvancedStepResponse = (function() {

                    /**
                     * Properties of a PositionAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionAdvancedStepResponse
                     * @property {number|null} [target] PositionAdvancedStepResponse target
                     * @property {number|null} [sustainTime] PositionAdvancedStepResponse sustainTime
                     * @property {boolean|null} [repeat] PositionAdvancedStepResponse repeat
                     * @property {boolean|null} [absoluteTarget] PositionAdvancedStepResponse absoluteTarget
                     */

                    /**
                     * Constructs a new PositionAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionAdvancedStepResponse.
                     * @implements IPositionAdvancedStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse=} [properties] Properties to set
                     */
                    function PositionAdvancedStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionAdvancedStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @instance
                     */
                    PositionAdvancedStepResponse.prototype.target = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionAdvancedStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @instance
                     */
                    PositionAdvancedStepResponse.prototype.sustainTime = 0;

                    /**
                     * PositionAdvancedStepResponse repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @instance
                     */
                    PositionAdvancedStepResponse.prototype.repeat = false;

                    /**
                     * PositionAdvancedStepResponse absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @instance
                     */
                    PositionAdvancedStepResponse.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionAdvancedStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse} PositionAdvancedStepResponse instance
                     */
                    PositionAdvancedStepResponse.create = function create(properties) {
                        return new PositionAdvancedStepResponse(properties);
                    };

                    /**
                     * Encodes the specified PositionAdvancedStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse} message PositionAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionAdvancedStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionAdvancedStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionAdvancedStepResponse} message PositionAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionAdvancedStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionAdvancedStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse} PositionAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionAdvancedStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionAdvancedStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse} PositionAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionAdvancedStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionAdvancedStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionAdvancedStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target) && !(message.target && $util.isInteger(message.target.low) && $util.isInteger(message.target.high)))
                                return "target: integer|Long expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionAdvancedStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse} PositionAdvancedStepResponse
                     */
                    PositionAdvancedStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse();
                        if (object.target != null)
                            if ($util.Long)
                                (message.target = $util.Long.fromValue(object.target)).unsigned = false;
                            else if (typeof object.target === "string")
                                message.target = parseInt(object.target, 10);
                            else if (typeof object.target === "number")
                                message.target = object.target;
                            else if (typeof object.target === "object")
                                message.target = new $util.LongBits(object.target.low >>> 0, object.target.high >>> 0).toNumber();
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionAdvancedStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse} message PositionAdvancedStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionAdvancedStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.target = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.target = options.longs === String ? "0" : 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.absoluteTarget = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (typeof message.target === "number")
                                object.target = options.longs === String ? String(message.target) : message.target;
                            else
                                object.target = options.longs === String ? $util.Long.prototype.toString.call(message.target) : options.longs === Number ? new $util.LongBits(message.target.low >>> 0, message.target.high >>> 0).toNumber() : message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionAdvancedStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionAdvancedStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionAdvancedStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionAdvancedStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionAdvancedStepResponse";
                    };

                    return PositionAdvancedStepResponse;
                })();

                SetSignalGeneratorParameters.PositionRamp = (function() {

                    /**
                     * Properties of a PositionRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionRamp
                     * @property {number|null} [target] PositionRamp target
                     * @property {number|null} [profileVelocity] PositionRamp profileVelocity
                     * @property {number|null} [profileAcceleration] PositionRamp profileAcceleration
                     * @property {number|null} [profileDeceleration] PositionRamp profileDeceleration
                     * @property {number|null} [sustainTime] PositionRamp sustainTime
                     * @property {boolean|null} [masterGenerated] PositionRamp masterGenerated
                     * @property {boolean|null} [absoluteTarget] PositionRamp absoluteTarget
                     */

                    /**
                     * Constructs a new PositionRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionRamp.
                     * @implements IPositionRamp
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp=} [properties] Properties to set
                     */
                    function PositionRamp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionRamp target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.target = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionRamp profileVelocity.
                     * @member {number} profileVelocity
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.profileVelocity = 0;

                    /**
                     * PositionRamp profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.profileAcceleration = 0;

                    /**
                     * PositionRamp profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.profileDeceleration = 0;

                    /**
                     * PositionRamp sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.sustainTime = 0;

                    /**
                     * PositionRamp masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.masterGenerated = false;

                    /**
                     * PositionRamp absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     */
                    PositionRamp.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionRamp instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp} PositionRamp instance
                     */
                    PositionRamp.create = function create(properties) {
                        return new PositionRamp(properties);
                    };

                    /**
                     * Encodes the specified PositionRamp message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp} message PositionRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionRamp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.target);
                        if (message.profileVelocity != null && Object.hasOwnProperty.call(message, "profileVelocity"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileVelocity);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.sustainTime);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.masterGenerated);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionRamp message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionRamp} message PositionRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionRamp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionRamp message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp} PositionRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionRamp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.profileVelocity = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 6: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            case 7: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionRamp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp} PositionRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionRamp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionRamp message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionRamp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target) && !(message.target && $util.isInteger(message.target.low) && $util.isInteger(message.target.high)))
                                return "target: integer|Long expected";
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            if (!$util.isInteger(message.profileVelocity))
                                return "profileVelocity: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionRamp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp} PositionRamp
                     */
                    PositionRamp.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp();
                        if (object.target != null)
                            if ($util.Long)
                                (message.target = $util.Long.fromValue(object.target)).unsigned = false;
                            else if (typeof object.target === "string")
                                message.target = parseInt(object.target, 10);
                            else if (typeof object.target === "number")
                                message.target = object.target;
                            else if (typeof object.target === "object")
                                message.target = new $util.LongBits(object.target.low >>> 0, object.target.high >>> 0).toNumber();
                        if (object.profileVelocity != null)
                            message.profileVelocity = object.profileVelocity >>> 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionRamp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp} message PositionRamp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionRamp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.target = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.target = options.longs === String ? "0" : 0;
                            object.profileVelocity = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.masterGenerated = false;
                            object.absoluteTarget = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (typeof message.target === "number")
                                object.target = options.longs === String ? String(message.target) : message.target;
                            else
                                object.target = options.longs === String ? $util.Long.prototype.toString.call(message.target) : options.longs === Number ? new $util.LongBits(message.target.low >>> 0, message.target.high >>> 0).toNumber() : message.target;
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            object.profileVelocity = message.profileVelocity;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionRamp to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionRamp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionRamp
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionRamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionRamp";
                    };

                    return PositionRamp;
                })();

                SetSignalGeneratorParameters.PositionTrapezoidal = (function() {

                    /**
                     * Properties of a PositionTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionTrapezoidal
                     * @property {number|null} [target] PositionTrapezoidal target
                     * @property {number|null} [profileVelocity] PositionTrapezoidal profileVelocity
                     * @property {number|null} [profileAcceleration] PositionTrapezoidal profileAcceleration
                     * @property {number|null} [profileDeceleration] PositionTrapezoidal profileDeceleration
                     * @property {number|null} [sustainTime] PositionTrapezoidal sustainTime
                     * @property {boolean|null} [repeat] PositionTrapezoidal repeat
                     * @property {boolean|null} [masterGenerated] PositionTrapezoidal masterGenerated
                     * @property {boolean|null} [absoluteTarget] PositionTrapezoidal absoluteTarget
                     */

                    /**
                     * Constructs a new PositionTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionTrapezoidal.
                     * @implements IPositionTrapezoidal
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal=} [properties] Properties to set
                     */
                    function PositionTrapezoidal(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionTrapezoidal target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.target = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionTrapezoidal profileVelocity.
                     * @member {number} profileVelocity
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.profileVelocity = 0;

                    /**
                     * PositionTrapezoidal profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.profileAcceleration = 0;

                    /**
                     * PositionTrapezoidal profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.profileDeceleration = 0;

                    /**
                     * PositionTrapezoidal sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.sustainTime = 0;

                    /**
                     * PositionTrapezoidal repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.repeat = false;

                    /**
                     * PositionTrapezoidal masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.masterGenerated = false;

                    /**
                     * PositionTrapezoidal absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     */
                    PositionTrapezoidal.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionTrapezoidal instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal} PositionTrapezoidal instance
                     */
                    PositionTrapezoidal.create = function create(properties) {
                        return new PositionTrapezoidal(properties);
                    };

                    /**
                     * Encodes the specified PositionTrapezoidal message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal} message PositionTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionTrapezoidal.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.target);
                        if (message.profileVelocity != null && Object.hasOwnProperty.call(message, "profileVelocity"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileVelocity);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.masterGenerated);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionTrapezoidal message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionTrapezoidal} message PositionTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionTrapezoidal.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionTrapezoidal message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal} PositionTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionTrapezoidal.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.profileVelocity = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 6: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 7: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionTrapezoidal message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal} PositionTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionTrapezoidal.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionTrapezoidal message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionTrapezoidal.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target) && !(message.target && $util.isInteger(message.target.low) && $util.isInteger(message.target.high)))
                                return "target: integer|Long expected";
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            if (!$util.isInteger(message.profileVelocity))
                                return "profileVelocity: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionTrapezoidal message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal} PositionTrapezoidal
                     */
                    PositionTrapezoidal.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal();
                        if (object.target != null)
                            if ($util.Long)
                                (message.target = $util.Long.fromValue(object.target)).unsigned = false;
                            else if (typeof object.target === "string")
                                message.target = parseInt(object.target, 10);
                            else if (typeof object.target === "number")
                                message.target = object.target;
                            else if (typeof object.target === "object")
                                message.target = new $util.LongBits(object.target.low >>> 0, object.target.high >>> 0).toNumber();
                        if (object.profileVelocity != null)
                            message.profileVelocity = object.profileVelocity >>> 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionTrapezoidal message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal} message PositionTrapezoidal
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionTrapezoidal.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.target = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.target = options.longs === String ? "0" : 0;
                            object.profileVelocity = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                            object.absoluteTarget = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (typeof message.target === "number")
                                object.target = options.longs === String ? String(message.target) : message.target;
                            else
                                object.target = options.longs === String ? $util.Long.prototype.toString.call(message.target) : options.longs === Number ? new $util.LongBits(message.target.low >>> 0, message.target.high >>> 0).toNumber() : message.target;
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            object.profileVelocity = message.profileVelocity;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionTrapezoidal to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionTrapezoidal.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionTrapezoidal
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionTrapezoidal.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionTrapezoidal";
                    };

                    return PositionTrapezoidal;
                })();

                SetSignalGeneratorParameters.PositionBidirectional = (function() {

                    /**
                     * Properties of a PositionBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionBidirectional
                     * @property {number|null} [target] PositionBidirectional target
                     * @property {number|null} [profileVelocity] PositionBidirectional profileVelocity
                     * @property {number|null} [profileAcceleration] PositionBidirectional profileAcceleration
                     * @property {number|null} [profileDeceleration] PositionBidirectional profileDeceleration
                     * @property {number|null} [sustainTime] PositionBidirectional sustainTime
                     * @property {boolean|null} [repeat] PositionBidirectional repeat
                     * @property {boolean|null} [masterGenerated] PositionBidirectional masterGenerated
                     * @property {boolean|null} [absoluteTarget] PositionBidirectional absoluteTarget
                     */

                    /**
                     * Constructs a new PositionBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionBidirectional.
                     * @implements IPositionBidirectional
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional=} [properties] Properties to set
                     */
                    function PositionBidirectional(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionBidirectional target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.target = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionBidirectional profileVelocity.
                     * @member {number} profileVelocity
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.profileVelocity = 0;

                    /**
                     * PositionBidirectional profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.profileAcceleration = 0;

                    /**
                     * PositionBidirectional profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.profileDeceleration = 0;

                    /**
                     * PositionBidirectional sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.sustainTime = 0;

                    /**
                     * PositionBidirectional repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.repeat = false;

                    /**
                     * PositionBidirectional masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.masterGenerated = false;

                    /**
                     * PositionBidirectional absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     */
                    PositionBidirectional.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionBidirectional instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional} PositionBidirectional instance
                     */
                    PositionBidirectional.create = function create(properties) {
                        return new PositionBidirectional(properties);
                    };

                    /**
                     * Encodes the specified PositionBidirectional message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional} message PositionBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionBidirectional.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.target);
                        if (message.profileVelocity != null && Object.hasOwnProperty.call(message, "profileVelocity"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileVelocity);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.masterGenerated);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionBidirectional message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionBidirectional} message PositionBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionBidirectional.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionBidirectional message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional} PositionBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionBidirectional.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.profileVelocity = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 6: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 7: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionBidirectional message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional} PositionBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionBidirectional.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionBidirectional message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionBidirectional.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target) && !(message.target && $util.isInteger(message.target.low) && $util.isInteger(message.target.high)))
                                return "target: integer|Long expected";
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            if (!$util.isInteger(message.profileVelocity))
                                return "profileVelocity: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionBidirectional message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional} PositionBidirectional
                     */
                    PositionBidirectional.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional();
                        if (object.target != null)
                            if ($util.Long)
                                (message.target = $util.Long.fromValue(object.target)).unsigned = false;
                            else if (typeof object.target === "string")
                                message.target = parseInt(object.target, 10);
                            else if (typeof object.target === "number")
                                message.target = object.target;
                            else if (typeof object.target === "object")
                                message.target = new $util.LongBits(object.target.low >>> 0, object.target.high >>> 0).toNumber();
                        if (object.profileVelocity != null)
                            message.profileVelocity = object.profileVelocity >>> 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionBidirectional message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional} message PositionBidirectional
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionBidirectional.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.target = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.target = options.longs === String ? "0" : 0;
                            object.profileVelocity = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                            object.absoluteTarget = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (typeof message.target === "number")
                                object.target = options.longs === String ? String(message.target) : message.target;
                            else
                                object.target = options.longs === String ? $util.Long.prototype.toString.call(message.target) : options.longs === Number ? new $util.LongBits(message.target.low >>> 0, message.target.high >>> 0).toNumber() : message.target;
                        if (message.profileVelocity != null && message.hasOwnProperty("profileVelocity"))
                            object.profileVelocity = message.profileVelocity;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionBidirectional to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionBidirectional.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionBidirectional
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionBidirectional.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionBidirectional";
                    };

                    return PositionBidirectional;
                })();

                SetSignalGeneratorParameters.PositionSineWave = (function() {

                    /**
                     * Properties of a PositionSineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IPositionSineWave
                     * @property {number|null} [amplitude] PositionSineWave amplitude
                     * @property {number|null} [frequency] PositionSineWave frequency
                     * @property {boolean|null} [repeat] PositionSineWave repeat
                     * @property {boolean|null} [absoluteTarget] PositionSineWave absoluteTarget
                     */

                    /**
                     * Constructs a new PositionSineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a PositionSineWave.
                     * @implements IPositionSineWave
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave=} [properties] Properties to set
                     */
                    function PositionSineWave(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PositionSineWave amplitude.
                     * @member {number} amplitude
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @instance
                     */
                    PositionSineWave.prototype.amplitude = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PositionSineWave frequency.
                     * @member {number} frequency
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @instance
                     */
                    PositionSineWave.prototype.frequency = 0;

                    /**
                     * PositionSineWave repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @instance
                     */
                    PositionSineWave.prototype.repeat = false;

                    /**
                     * PositionSineWave absoluteTarget.
                     * @member {boolean} absoluteTarget
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @instance
                     */
                    PositionSineWave.prototype.absoluteTarget = false;

                    /**
                     * Creates a new PositionSineWave instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave} PositionSineWave instance
                     */
                    PositionSineWave.create = function create(properties) {
                        return new PositionSineWave(properties);
                    };

                    /**
                     * Encodes the specified PositionSineWave message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave} message PositionSineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionSineWave.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.amplitude != null && Object.hasOwnProperty.call(message, "amplitude"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.amplitude);
                        if (message.frequency != null && Object.hasOwnProperty.call(message, "frequency"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.frequency);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        if (message.absoluteTarget != null && Object.hasOwnProperty.call(message, "absoluteTarget"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.absoluteTarget);
                        return writer;
                    };

                    /**
                     * Encodes the specified PositionSineWave message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IPositionSineWave} message PositionSineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PositionSineWave.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PositionSineWave message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave} PositionSineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionSineWave.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.amplitude = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.frequency = reader.float();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.absoluteTarget = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PositionSineWave message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave} PositionSineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PositionSineWave.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PositionSineWave message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PositionSineWave.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            if (!$util.isInteger(message.amplitude) && !(message.amplitude && $util.isInteger(message.amplitude.low) && $util.isInteger(message.amplitude.high)))
                                return "amplitude: integer|Long expected";
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            if (typeof message.frequency !== "number")
                                return "frequency: number expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            if (typeof message.absoluteTarget !== "boolean")
                                return "absoluteTarget: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a PositionSineWave message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave} PositionSineWave
                     */
                    PositionSineWave.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave();
                        if (object.amplitude != null)
                            if ($util.Long)
                                (message.amplitude = $util.Long.fromValue(object.amplitude)).unsigned = false;
                            else if (typeof object.amplitude === "string")
                                message.amplitude = parseInt(object.amplitude, 10);
                            else if (typeof object.amplitude === "number")
                                message.amplitude = object.amplitude;
                            else if (typeof object.amplitude === "object")
                                message.amplitude = new $util.LongBits(object.amplitude.low >>> 0, object.amplitude.high >>> 0).toNumber();
                        if (object.frequency != null)
                            message.frequency = Number(object.frequency);
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.absoluteTarget != null)
                            message.absoluteTarget = Boolean(object.absoluteTarget);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PositionSineWave message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave} message PositionSineWave
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PositionSineWave.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.amplitude = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.amplitude = options.longs === String ? "0" : 0;
                            object.frequency = 0;
                            object.repeat = false;
                            object.absoluteTarget = false;
                        }
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            if (typeof message.amplitude === "number")
                                object.amplitude = options.longs === String ? String(message.amplitude) : message.amplitude;
                            else
                                object.amplitude = options.longs === String ? $util.Long.prototype.toString.call(message.amplitude) : options.longs === Number ? new $util.LongBits(message.amplitude.low >>> 0, message.amplitude.high >>> 0).toNumber() : message.amplitude;
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            object.frequency = options.json && !isFinite(message.frequency) ? String(message.frequency) : message.frequency;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.absoluteTarget != null && message.hasOwnProperty("absoluteTarget"))
                            object.absoluteTarget = message.absoluteTarget;
                        return object;
                    };

                    /**
                     * Converts this PositionSineWave to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PositionSineWave.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PositionSineWave
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PositionSineWave.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.PositionSineWave";
                    };

                    return PositionSineWave;
                })();

                SetSignalGeneratorParameters.VelocityStepResponse = (function() {

                    /**
                     * Properties of a VelocityStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocityStepResponse
                     * @property {number|null} [target] VelocityStepResponse target
                     * @property {number|null} [sustainTime] VelocityStepResponse sustainTime
                     */

                    /**
                     * Constructs a new VelocityStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocityStepResponse.
                     * @implements IVelocityStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse=} [properties] Properties to set
                     */
                    function VelocityStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @instance
                     */
                    VelocityStepResponse.prototype.target = 0;

                    /**
                     * VelocityStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @instance
                     */
                    VelocityStepResponse.prototype.sustainTime = 0;

                    /**
                     * Creates a new VelocityStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse} VelocityStepResponse instance
                     */
                    VelocityStepResponse.create = function create(properties) {
                        return new VelocityStepResponse(properties);
                    };

                    /**
                     * Encodes the specified VelocityStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse} message VelocityStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityStepResponse} message VelocityStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse} VelocityStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse} VelocityStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse} VelocityStepResponse
                     */
                    VelocityStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse} message VelocityStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.sustainTime = 0;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        return object;
                    };

                    /**
                     * Converts this VelocityStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityStepResponse";
                    };

                    return VelocityStepResponse;
                })();

                SetSignalGeneratorParameters.VelocityAdvancedStepResponse = (function() {

                    /**
                     * Properties of a VelocityAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocityAdvancedStepResponse
                     * @property {number|null} [target] VelocityAdvancedStepResponse target
                     * @property {number|null} [sustainTime] VelocityAdvancedStepResponse sustainTime
                     * @property {boolean|null} [repeat] VelocityAdvancedStepResponse repeat
                     */

                    /**
                     * Constructs a new VelocityAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocityAdvancedStepResponse.
                     * @implements IVelocityAdvancedStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse=} [properties] Properties to set
                     */
                    function VelocityAdvancedStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityAdvancedStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @instance
                     */
                    VelocityAdvancedStepResponse.prototype.target = 0;

                    /**
                     * VelocityAdvancedStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @instance
                     */
                    VelocityAdvancedStepResponse.prototype.sustainTime = 0;

                    /**
                     * VelocityAdvancedStepResponse repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @instance
                     */
                    VelocityAdvancedStepResponse.prototype.repeat = false;

                    /**
                     * Creates a new VelocityAdvancedStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse} VelocityAdvancedStepResponse instance
                     */
                    VelocityAdvancedStepResponse.create = function create(properties) {
                        return new VelocityAdvancedStepResponse(properties);
                    };

                    /**
                     * Encodes the specified VelocityAdvancedStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse} message VelocityAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityAdvancedStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityAdvancedStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityAdvancedStepResponse} message VelocityAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityAdvancedStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityAdvancedStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse} VelocityAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityAdvancedStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityAdvancedStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse} VelocityAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityAdvancedStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityAdvancedStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityAdvancedStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityAdvancedStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse} VelocityAdvancedStepResponse
                     */
                    VelocityAdvancedStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityAdvancedStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse} message VelocityAdvancedStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityAdvancedStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        return object;
                    };

                    /**
                     * Converts this VelocityAdvancedStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityAdvancedStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityAdvancedStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityAdvancedStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityAdvancedStepResponse";
                    };

                    return VelocityAdvancedStepResponse;
                })();

                SetSignalGeneratorParameters.VelocityRamp = (function() {

                    /**
                     * Properties of a VelocityRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocityRamp
                     * @property {number|null} [target] VelocityRamp target
                     * @property {number|null} [profileAcceleration] VelocityRamp profileAcceleration
                     * @property {number|null} [profileDeceleration] VelocityRamp profileDeceleration
                     * @property {number|null} [sustainTime] VelocityRamp sustainTime
                     * @property {boolean|null} [masterGenerated] VelocityRamp masterGenerated
                     */

                    /**
                     * Constructs a new VelocityRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocityRamp.
                     * @implements IVelocityRamp
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp=} [properties] Properties to set
                     */
                    function VelocityRamp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityRamp target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     */
                    VelocityRamp.prototype.target = 0;

                    /**
                     * VelocityRamp profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     */
                    VelocityRamp.prototype.profileAcceleration = 0;

                    /**
                     * VelocityRamp profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     */
                    VelocityRamp.prototype.profileDeceleration = 0;

                    /**
                     * VelocityRamp sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     */
                    VelocityRamp.prototype.sustainTime = 0;

                    /**
                     * VelocityRamp masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     */
                    VelocityRamp.prototype.masterGenerated = false;

                    /**
                     * Creates a new VelocityRamp instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp} VelocityRamp instance
                     */
                    VelocityRamp.create = function create(properties) {
                        return new VelocityRamp(properties);
                    };

                    /**
                     * Encodes the specified VelocityRamp message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp} message VelocityRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityRamp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.sustainTime);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityRamp message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityRamp} message VelocityRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityRamp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityRamp message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp} VelocityRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityRamp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityRamp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp} VelocityRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityRamp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityRamp message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityRamp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityRamp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp} VelocityRamp
                     */
                    VelocityRamp.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityRamp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp} message VelocityRamp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityRamp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this VelocityRamp to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityRamp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityRamp
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityRamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityRamp";
                    };

                    return VelocityRamp;
                })();

                SetSignalGeneratorParameters.VelocityTrapezoidal = (function() {

                    /**
                     * Properties of a VelocityTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocityTrapezoidal
                     * @property {number|null} [target] VelocityTrapezoidal target
                     * @property {number|null} [profileAcceleration] VelocityTrapezoidal profileAcceleration
                     * @property {number|null} [profileDeceleration] VelocityTrapezoidal profileDeceleration
                     * @property {number|null} [sustainTime] VelocityTrapezoidal sustainTime
                     * @property {boolean|null} [repeat] VelocityTrapezoidal repeat
                     * @property {boolean|null} [masterGenerated] VelocityTrapezoidal masterGenerated
                     */

                    /**
                     * Constructs a new VelocityTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocityTrapezoidal.
                     * @implements IVelocityTrapezoidal
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal=} [properties] Properties to set
                     */
                    function VelocityTrapezoidal(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityTrapezoidal target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.target = 0;

                    /**
                     * VelocityTrapezoidal profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.profileAcceleration = 0;

                    /**
                     * VelocityTrapezoidal profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.profileDeceleration = 0;

                    /**
                     * VelocityTrapezoidal sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.sustainTime = 0;

                    /**
                     * VelocityTrapezoidal repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.repeat = false;

                    /**
                     * VelocityTrapezoidal masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     */
                    VelocityTrapezoidal.prototype.masterGenerated = false;

                    /**
                     * Creates a new VelocityTrapezoidal instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal} VelocityTrapezoidal instance
                     */
                    VelocityTrapezoidal.create = function create(properties) {
                        return new VelocityTrapezoidal(properties);
                    };

                    /**
                     * Encodes the specified VelocityTrapezoidal message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal} message VelocityTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityTrapezoidal.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityTrapezoidal message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityTrapezoidal} message VelocityTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityTrapezoidal.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityTrapezoidal message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal} VelocityTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityTrapezoidal.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 6: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityTrapezoidal message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal} VelocityTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityTrapezoidal.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityTrapezoidal message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityTrapezoidal.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityTrapezoidal message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal} VelocityTrapezoidal
                     */
                    VelocityTrapezoidal.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityTrapezoidal message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal} message VelocityTrapezoidal
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityTrapezoidal.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this VelocityTrapezoidal to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityTrapezoidal.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityTrapezoidal
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityTrapezoidal.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityTrapezoidal";
                    };

                    return VelocityTrapezoidal;
                })();

                SetSignalGeneratorParameters.VelocityBidirectional = (function() {

                    /**
                     * Properties of a VelocityBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocityBidirectional
                     * @property {number|null} [target] VelocityBidirectional target
                     * @property {number|null} [profileAcceleration] VelocityBidirectional profileAcceleration
                     * @property {number|null} [profileDeceleration] VelocityBidirectional profileDeceleration
                     * @property {number|null} [sustainTime] VelocityBidirectional sustainTime
                     * @property {boolean|null} [repeat] VelocityBidirectional repeat
                     * @property {boolean|null} [masterGenerated] VelocityBidirectional masterGenerated
                     */

                    /**
                     * Constructs a new VelocityBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocityBidirectional.
                     * @implements IVelocityBidirectional
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional=} [properties] Properties to set
                     */
                    function VelocityBidirectional(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocityBidirectional target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.target = 0;

                    /**
                     * VelocityBidirectional profileAcceleration.
                     * @member {number} profileAcceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.profileAcceleration = 0;

                    /**
                     * VelocityBidirectional profileDeceleration.
                     * @member {number} profileDeceleration
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.profileDeceleration = 0;

                    /**
                     * VelocityBidirectional sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.sustainTime = 0;

                    /**
                     * VelocityBidirectional repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.repeat = false;

                    /**
                     * VelocityBidirectional masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     */
                    VelocityBidirectional.prototype.masterGenerated = false;

                    /**
                     * Creates a new VelocityBidirectional instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional} VelocityBidirectional instance
                     */
                    VelocityBidirectional.create = function create(properties) {
                        return new VelocityBidirectional(properties);
                    };

                    /**
                     * Encodes the specified VelocityBidirectional message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional} message VelocityBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityBidirectional.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.profileAcceleration != null && Object.hasOwnProperty.call(message, "profileAcceleration"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.profileAcceleration);
                        if (message.profileDeceleration != null && Object.hasOwnProperty.call(message, "profileDeceleration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.profileDeceleration);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocityBidirectional message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocityBidirectional} message VelocityBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocityBidirectional.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocityBidirectional message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional} VelocityBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityBidirectional.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.profileAcceleration = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.profileDeceleration = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 6: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocityBidirectional message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional} VelocityBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocityBidirectional.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocityBidirectional message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocityBidirectional.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            if (!$util.isInteger(message.profileAcceleration))
                                return "profileAcceleration: integer expected";
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            if (!$util.isInteger(message.profileDeceleration))
                                return "profileDeceleration: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a VelocityBidirectional message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional} VelocityBidirectional
                     */
                    VelocityBidirectional.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.profileAcceleration != null)
                            message.profileAcceleration = object.profileAcceleration >>> 0;
                        if (object.profileDeceleration != null)
                            message.profileDeceleration = object.profileDeceleration >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocityBidirectional message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional} message VelocityBidirectional
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocityBidirectional.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.profileAcceleration = 0;
                            object.profileDeceleration = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.profileAcceleration != null && message.hasOwnProperty("profileAcceleration"))
                            object.profileAcceleration = message.profileAcceleration;
                        if (message.profileDeceleration != null && message.hasOwnProperty("profileDeceleration"))
                            object.profileDeceleration = message.profileDeceleration;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this VelocityBidirectional to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocityBidirectional.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocityBidirectional
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocityBidirectional.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocityBidirectional";
                    };

                    return VelocityBidirectional;
                })();

                SetSignalGeneratorParameters.VelocitySineWave = (function() {

                    /**
                     * Properties of a VelocitySineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface IVelocitySineWave
                     * @property {number|null} [amplitude] VelocitySineWave amplitude
                     * @property {number|null} [frequency] VelocitySineWave frequency
                     * @property {boolean|null} [repeat] VelocitySineWave repeat
                     */

                    /**
                     * Constructs a new VelocitySineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a VelocitySineWave.
                     * @implements IVelocitySineWave
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave=} [properties] Properties to set
                     */
                    function VelocitySineWave(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * VelocitySineWave amplitude.
                     * @member {number} amplitude
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @instance
                     */
                    VelocitySineWave.prototype.amplitude = 0;

                    /**
                     * VelocitySineWave frequency.
                     * @member {number} frequency
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @instance
                     */
                    VelocitySineWave.prototype.frequency = 0;

                    /**
                     * VelocitySineWave repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @instance
                     */
                    VelocitySineWave.prototype.repeat = false;

                    /**
                     * Creates a new VelocitySineWave instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave} VelocitySineWave instance
                     */
                    VelocitySineWave.create = function create(properties) {
                        return new VelocitySineWave(properties);
                    };

                    /**
                     * Encodes the specified VelocitySineWave message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave} message VelocitySineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocitySineWave.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.amplitude != null && Object.hasOwnProperty.call(message, "amplitude"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.amplitude);
                        if (message.frequency != null && Object.hasOwnProperty.call(message, "frequency"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.frequency);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        return writer;
                    };

                    /**
                     * Encodes the specified VelocitySineWave message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.IVelocitySineWave} message VelocitySineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VelocitySineWave.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a VelocitySineWave message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave} VelocitySineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocitySineWave.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.amplitude = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.frequency = reader.float();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a VelocitySineWave message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave} VelocitySineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VelocitySineWave.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a VelocitySineWave message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VelocitySineWave.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            if (!$util.isInteger(message.amplitude))
                                return "amplitude: integer expected";
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            if (typeof message.frequency !== "number")
                                return "frequency: number expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a VelocitySineWave message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave} VelocitySineWave
                     */
                    VelocitySineWave.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave();
                        if (object.amplitude != null)
                            message.amplitude = object.amplitude | 0;
                        if (object.frequency != null)
                            message.frequency = Number(object.frequency);
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        return message;
                    };

                    /**
                     * Creates a plain object from a VelocitySineWave message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave} message VelocitySineWave
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VelocitySineWave.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.amplitude = 0;
                            object.frequency = 0;
                            object.repeat = false;
                        }
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            object.amplitude = message.amplitude;
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            object.frequency = options.json && !isFinite(message.frequency) ? String(message.frequency) : message.frequency;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        return object;
                    };

                    /**
                     * Converts this VelocitySineWave to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VelocitySineWave.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for VelocitySineWave
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    VelocitySineWave.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.VelocitySineWave";
                    };

                    return VelocitySineWave;
                })();

                SetSignalGeneratorParameters.TorqueStepResponse = (function() {

                    /**
                     * Properties of a TorqueStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueStepResponse
                     * @property {number|null} [target] TorqueStepResponse target
                     * @property {number|null} [sustainTime] TorqueStepResponse sustainTime
                     */

                    /**
                     * Constructs a new TorqueStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueStepResponse.
                     * @implements ITorqueStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse=} [properties] Properties to set
                     */
                    function TorqueStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @instance
                     */
                    TorqueStepResponse.prototype.target = 0;

                    /**
                     * TorqueStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @instance
                     */
                    TorqueStepResponse.prototype.sustainTime = 0;

                    /**
                     * Creates a new TorqueStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse} TorqueStepResponse instance
                     */
                    TorqueStepResponse.create = function create(properties) {
                        return new TorqueStepResponse(properties);
                    };

                    /**
                     * Encodes the specified TorqueStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse} message TorqueStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueStepResponse} message TorqueStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse} TorqueStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse} TorqueStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse} TorqueStepResponse
                     */
                    TorqueStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse} message TorqueStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.sustainTime = 0;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        return object;
                    };

                    /**
                     * Converts this TorqueStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueStepResponse";
                    };

                    return TorqueStepResponse;
                })();

                SetSignalGeneratorParameters.TorqueAdvancedStepResponse = (function() {

                    /**
                     * Properties of a TorqueAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueAdvancedStepResponse
                     * @property {number|null} [target] TorqueAdvancedStepResponse target
                     * @property {number|null} [sustainTime] TorqueAdvancedStepResponse sustainTime
                     * @property {boolean|null} [repeat] TorqueAdvancedStepResponse repeat
                     */

                    /**
                     * Constructs a new TorqueAdvancedStepResponse.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueAdvancedStepResponse.
                     * @implements ITorqueAdvancedStepResponse
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse=} [properties] Properties to set
                     */
                    function TorqueAdvancedStepResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueAdvancedStepResponse target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @instance
                     */
                    TorqueAdvancedStepResponse.prototype.target = 0;

                    /**
                     * TorqueAdvancedStepResponse sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @instance
                     */
                    TorqueAdvancedStepResponse.prototype.sustainTime = 0;

                    /**
                     * TorqueAdvancedStepResponse repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @instance
                     */
                    TorqueAdvancedStepResponse.prototype.repeat = false;

                    /**
                     * Creates a new TorqueAdvancedStepResponse instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse} TorqueAdvancedStepResponse instance
                     */
                    TorqueAdvancedStepResponse.create = function create(properties) {
                        return new TorqueAdvancedStepResponse(properties);
                    };

                    /**
                     * Encodes the specified TorqueAdvancedStepResponse message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse} message TorqueAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueAdvancedStepResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueAdvancedStepResponse message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueAdvancedStepResponse} message TorqueAdvancedStepResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueAdvancedStepResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueAdvancedStepResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse} TorqueAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueAdvancedStepResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueAdvancedStepResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse} TorqueAdvancedStepResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueAdvancedStepResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueAdvancedStepResponse message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueAdvancedStepResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueAdvancedStepResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse} TorqueAdvancedStepResponse
                     */
                    TorqueAdvancedStepResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueAdvancedStepResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse} message TorqueAdvancedStepResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueAdvancedStepResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        return object;
                    };

                    /**
                     * Converts this TorqueAdvancedStepResponse to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueAdvancedStepResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueAdvancedStepResponse
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueAdvancedStepResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueAdvancedStepResponse";
                    };

                    return TorqueAdvancedStepResponse;
                })();

                SetSignalGeneratorParameters.TorqueRamp = (function() {

                    /**
                     * Properties of a TorqueRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueRamp
                     * @property {number|null} [target] TorqueRamp target
                     * @property {number|null} [torqueSlope] TorqueRamp torqueSlope
                     * @property {number|null} [sustainTime] TorqueRamp sustainTime
                     * @property {boolean|null} [masterGenerated] TorqueRamp masterGenerated
                     */

                    /**
                     * Constructs a new TorqueRamp.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueRamp.
                     * @implements ITorqueRamp
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp=} [properties] Properties to set
                     */
                    function TorqueRamp(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueRamp target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @instance
                     */
                    TorqueRamp.prototype.target = 0;

                    /**
                     * TorqueRamp torqueSlope.
                     * @member {number} torqueSlope
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @instance
                     */
                    TorqueRamp.prototype.torqueSlope = 0;

                    /**
                     * TorqueRamp sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @instance
                     */
                    TorqueRamp.prototype.sustainTime = 0;

                    /**
                     * TorqueRamp masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @instance
                     */
                    TorqueRamp.prototype.masterGenerated = false;

                    /**
                     * Creates a new TorqueRamp instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp} TorqueRamp instance
                     */
                    TorqueRamp.create = function create(properties) {
                        return new TorqueRamp(properties);
                    };

                    /**
                     * Encodes the specified TorqueRamp message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp} message TorqueRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueRamp.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.torqueSlope != null && Object.hasOwnProperty.call(message, "torqueSlope"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.torqueSlope);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.sustainTime);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueRamp message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueRamp} message TorqueRamp message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueRamp.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueRamp message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp} TorqueRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueRamp.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.torqueSlope = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueRamp message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp} TorqueRamp
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueRamp.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueRamp message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueRamp.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            if (!$util.isInteger(message.torqueSlope))
                                return "torqueSlope: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueRamp message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp} TorqueRamp
                     */
                    TorqueRamp.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.torqueSlope != null)
                            message.torqueSlope = object.torqueSlope >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueRamp message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp} message TorqueRamp
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueRamp.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.torqueSlope = 0;
                            object.sustainTime = 0;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            object.torqueSlope = message.torqueSlope;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this TorqueRamp to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueRamp.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueRamp
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueRamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueRamp";
                    };

                    return TorqueRamp;
                })();

                SetSignalGeneratorParameters.TorqueTrapezoidal = (function() {

                    /**
                     * Properties of a TorqueTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueTrapezoidal
                     * @property {number|null} [target] TorqueTrapezoidal target
                     * @property {number|null} [torqueSlope] TorqueTrapezoidal torqueSlope
                     * @property {number|null} [sustainTime] TorqueTrapezoidal sustainTime
                     * @property {boolean|null} [repeat] TorqueTrapezoidal repeat
                     * @property {boolean|null} [masterGenerated] TorqueTrapezoidal masterGenerated
                     */

                    /**
                     * Constructs a new TorqueTrapezoidal.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueTrapezoidal.
                     * @implements ITorqueTrapezoidal
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal=} [properties] Properties to set
                     */
                    function TorqueTrapezoidal(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueTrapezoidal target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     */
                    TorqueTrapezoidal.prototype.target = 0;

                    /**
                     * TorqueTrapezoidal torqueSlope.
                     * @member {number} torqueSlope
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     */
                    TorqueTrapezoidal.prototype.torqueSlope = 0;

                    /**
                     * TorqueTrapezoidal sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     */
                    TorqueTrapezoidal.prototype.sustainTime = 0;

                    /**
                     * TorqueTrapezoidal repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     */
                    TorqueTrapezoidal.prototype.repeat = false;

                    /**
                     * TorqueTrapezoidal masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     */
                    TorqueTrapezoidal.prototype.masterGenerated = false;

                    /**
                     * Creates a new TorqueTrapezoidal instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal} TorqueTrapezoidal instance
                     */
                    TorqueTrapezoidal.create = function create(properties) {
                        return new TorqueTrapezoidal(properties);
                    };

                    /**
                     * Encodes the specified TorqueTrapezoidal message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal} message TorqueTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueTrapezoidal.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.torqueSlope != null && Object.hasOwnProperty.call(message, "torqueSlope"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.torqueSlope);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueTrapezoidal message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueTrapezoidal} message TorqueTrapezoidal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueTrapezoidal.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueTrapezoidal message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal} TorqueTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueTrapezoidal.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.torqueSlope = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueTrapezoidal message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal} TorqueTrapezoidal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueTrapezoidal.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueTrapezoidal message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueTrapezoidal.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            if (!$util.isInteger(message.torqueSlope))
                                return "torqueSlope: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueTrapezoidal message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal} TorqueTrapezoidal
                     */
                    TorqueTrapezoidal.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.torqueSlope != null)
                            message.torqueSlope = object.torqueSlope >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueTrapezoidal message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal} message TorqueTrapezoidal
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueTrapezoidal.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.torqueSlope = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            object.torqueSlope = message.torqueSlope;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this TorqueTrapezoidal to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueTrapezoidal.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueTrapezoidal
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueTrapezoidal.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueTrapezoidal";
                    };

                    return TorqueTrapezoidal;
                })();

                SetSignalGeneratorParameters.TorqueBidirectional = (function() {

                    /**
                     * Properties of a TorqueBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueBidirectional
                     * @property {number|null} [target] TorqueBidirectional target
                     * @property {number|null} [torqueSlope] TorqueBidirectional torqueSlope
                     * @property {number|null} [sustainTime] TorqueBidirectional sustainTime
                     * @property {boolean|null} [repeat] TorqueBidirectional repeat
                     * @property {boolean|null} [masterGenerated] TorqueBidirectional masterGenerated
                     */

                    /**
                     * Constructs a new TorqueBidirectional.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueBidirectional.
                     * @implements ITorqueBidirectional
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional=} [properties] Properties to set
                     */
                    function TorqueBidirectional(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueBidirectional target.
                     * @member {number} target
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     */
                    TorqueBidirectional.prototype.target = 0;

                    /**
                     * TorqueBidirectional torqueSlope.
                     * @member {number} torqueSlope
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     */
                    TorqueBidirectional.prototype.torqueSlope = 0;

                    /**
                     * TorqueBidirectional sustainTime.
                     * @member {number} sustainTime
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     */
                    TorqueBidirectional.prototype.sustainTime = 0;

                    /**
                     * TorqueBidirectional repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     */
                    TorqueBidirectional.prototype.repeat = false;

                    /**
                     * TorqueBidirectional masterGenerated.
                     * @member {boolean} masterGenerated
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     */
                    TorqueBidirectional.prototype.masterGenerated = false;

                    /**
                     * Creates a new TorqueBidirectional instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional} TorqueBidirectional instance
                     */
                    TorqueBidirectional.create = function create(properties) {
                        return new TorqueBidirectional(properties);
                    };

                    /**
                     * Encodes the specified TorqueBidirectional message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional} message TorqueBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueBidirectional.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.target);
                        if (message.torqueSlope != null && Object.hasOwnProperty.call(message, "torqueSlope"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.torqueSlope);
                        if (message.sustainTime != null && Object.hasOwnProperty.call(message, "sustainTime"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.sustainTime);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.repeat);
                        if (message.masterGenerated != null && Object.hasOwnProperty.call(message, "masterGenerated"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.masterGenerated);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueBidirectional message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueBidirectional} message TorqueBidirectional message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueBidirectional.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueBidirectional message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional} TorqueBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueBidirectional.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.target = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.torqueSlope = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.sustainTime = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.masterGenerated = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueBidirectional message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional} TorqueBidirectional
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueBidirectional.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueBidirectional message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueBidirectional.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.target != null && message.hasOwnProperty("target"))
                            if (!$util.isInteger(message.target))
                                return "target: integer expected";
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            if (!$util.isInteger(message.torqueSlope))
                                return "torqueSlope: integer expected";
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            if (!$util.isInteger(message.sustainTime))
                                return "sustainTime: integer expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            if (typeof message.masterGenerated !== "boolean")
                                return "masterGenerated: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueBidirectional message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional} TorqueBidirectional
                     */
                    TorqueBidirectional.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional();
                        if (object.target != null)
                            message.target = object.target | 0;
                        if (object.torqueSlope != null)
                            message.torqueSlope = object.torqueSlope >>> 0;
                        if (object.sustainTime != null)
                            message.sustainTime = object.sustainTime >>> 0;
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        if (object.masterGenerated != null)
                            message.masterGenerated = Boolean(object.masterGenerated);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueBidirectional message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional} message TorqueBidirectional
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueBidirectional.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.target = 0;
                            object.torqueSlope = 0;
                            object.sustainTime = 0;
                            object.repeat = false;
                            object.masterGenerated = false;
                        }
                        if (message.target != null && message.hasOwnProperty("target"))
                            object.target = message.target;
                        if (message.torqueSlope != null && message.hasOwnProperty("torqueSlope"))
                            object.torqueSlope = message.torqueSlope;
                        if (message.sustainTime != null && message.hasOwnProperty("sustainTime"))
                            object.sustainTime = message.sustainTime;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        if (message.masterGenerated != null && message.hasOwnProperty("masterGenerated"))
                            object.masterGenerated = message.masterGenerated;
                        return object;
                    };

                    /**
                     * Converts this TorqueBidirectional to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueBidirectional.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueBidirectional
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueBidirectional.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueBidirectional";
                    };

                    return TorqueBidirectional;
                })();

                SetSignalGeneratorParameters.TorqueSineWave = (function() {

                    /**
                     * Properties of a TorqueSineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @interface ITorqueSineWave
                     * @property {number|null} [amplitude] TorqueSineWave amplitude
                     * @property {number|null} [frequency] TorqueSineWave frequency
                     * @property {boolean|null} [repeat] TorqueSineWave repeat
                     */

                    /**
                     * Constructs a new TorqueSineWave.
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters
                     * @classdesc Represents a TorqueSineWave.
                     * @implements ITorqueSineWave
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave=} [properties] Properties to set
                     */
                    function TorqueSineWave(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TorqueSineWave amplitude.
                     * @member {number} amplitude
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @instance
                     */
                    TorqueSineWave.prototype.amplitude = 0;

                    /**
                     * TorqueSineWave frequency.
                     * @member {number} frequency
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @instance
                     */
                    TorqueSineWave.prototype.frequency = 0;

                    /**
                     * TorqueSineWave repeat.
                     * @member {boolean} repeat
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @instance
                     */
                    TorqueSineWave.prototype.repeat = false;

                    /**
                     * Creates a new TorqueSineWave instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave} TorqueSineWave instance
                     */
                    TorqueSineWave.create = function create(properties) {
                        return new TorqueSineWave(properties);
                    };

                    /**
                     * Encodes the specified TorqueSineWave message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave} message TorqueSineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueSineWave.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.amplitude != null && Object.hasOwnProperty.call(message, "amplitude"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.amplitude);
                        if (message.frequency != null && Object.hasOwnProperty.call(message, "frequency"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.frequency);
                        if (message.repeat != null && Object.hasOwnProperty.call(message, "repeat"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.repeat);
                        return writer;
                    };

                    /**
                     * Encodes the specified TorqueSineWave message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.ITorqueSineWave} message TorqueSineWave message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TorqueSineWave.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TorqueSineWave message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave} TorqueSineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueSineWave.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.amplitude = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.frequency = reader.float();
                                    break;
                                }
                            case 3: {
                                    message.repeat = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TorqueSineWave message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave} TorqueSineWave
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TorqueSineWave.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TorqueSineWave message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TorqueSineWave.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            if (!$util.isInteger(message.amplitude))
                                return "amplitude: integer expected";
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            if (typeof message.frequency !== "number")
                                return "frequency: number expected";
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            if (typeof message.repeat !== "boolean")
                                return "repeat: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a TorqueSineWave message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave} TorqueSineWave
                     */
                    TorqueSineWave.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave();
                        if (object.amplitude != null)
                            message.amplitude = object.amplitude | 0;
                        if (object.frequency != null)
                            message.frequency = Number(object.frequency);
                        if (object.repeat != null)
                            message.repeat = Boolean(object.repeat);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TorqueSineWave message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave} message TorqueSineWave
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TorqueSineWave.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.amplitude = 0;
                            object.frequency = 0;
                            object.repeat = false;
                        }
                        if (message.amplitude != null && message.hasOwnProperty("amplitude"))
                            object.amplitude = message.amplitude;
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            object.frequency = options.json && !isFinite(message.frequency) ? String(message.frequency) : message.frequency;
                        if (message.repeat != null && message.hasOwnProperty("repeat"))
                            object.repeat = message.repeat;
                        return object;
                    };

                    /**
                     * Converts this TorqueSineWave to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TorqueSineWave.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TorqueSineWave
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TorqueSineWave.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSignalGeneratorParameters.TorqueSineWave";
                    };

                    return TorqueSineWave;
                })();

                return SetSignalGeneratorParameters;
            })();

            Request.StartSignalGenerator = (function() {

                /**
                 * Properties of a StartSignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartSignalGenerator
                 * @property {number|null} [deviceAddress] StartSignalGenerator deviceAddress
                 */

                /**
                 * Constructs a new StartSignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartSignalGenerator.
                 * @implements IStartSignalGenerator
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator=} [properties] Properties to set
                 */
                function StartSignalGenerator(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartSignalGenerator deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @instance
                 */
                StartSignalGenerator.prototype.deviceAddress = 0;

                /**
                 * Creates a new StartSignalGenerator instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSignalGenerator} StartSignalGenerator instance
                 */
                StartSignalGenerator.create = function create(properties) {
                    return new StartSignalGenerator(properties);
                };

                /**
                 * Encodes the specified StartSignalGenerator message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartSignalGenerator.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator} message StartSignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartSignalGenerator.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StartSignalGenerator message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartSignalGenerator.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartSignalGenerator} message StartSignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartSignalGenerator.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartSignalGenerator message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSignalGenerator} StartSignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartSignalGenerator.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartSignalGenerator message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSignalGenerator} StartSignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartSignalGenerator.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartSignalGenerator message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartSignalGenerator.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StartSignalGenerator message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartSignalGenerator} StartSignalGenerator
                 */
                StartSignalGenerator.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartSignalGenerator();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartSignalGenerator message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartSignalGenerator} message StartSignalGenerator
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartSignalGenerator.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StartSignalGenerator to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartSignalGenerator.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartSignalGenerator
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartSignalGenerator
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartSignalGenerator.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartSignalGenerator";
                };

                return StartSignalGenerator;
            })();

            Request.StopSignalGenerator = (function() {

                /**
                 * Properties of a StopSignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStopSignalGenerator
                 * @property {number|null} [deviceAddress] StopSignalGenerator deviceAddress
                 */

                /**
                 * Constructs a new StopSignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StopSignalGenerator.
                 * @implements IStopSignalGenerator
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator=} [properties] Properties to set
                 */
                function StopSignalGenerator(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StopSignalGenerator deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @instance
                 */
                StopSignalGenerator.prototype.deviceAddress = 0;

                /**
                 * Creates a new StopSignalGenerator instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StopSignalGenerator} StopSignalGenerator instance
                 */
                StopSignalGenerator.create = function create(properties) {
                    return new StopSignalGenerator(properties);
                };

                /**
                 * Encodes the specified StopSignalGenerator message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopSignalGenerator.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator} message StopSignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopSignalGenerator.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StopSignalGenerator message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopSignalGenerator.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopSignalGenerator} message StopSignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopSignalGenerator.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StopSignalGenerator message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StopSignalGenerator} StopSignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopSignalGenerator.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StopSignalGenerator message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StopSignalGenerator} StopSignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopSignalGenerator.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StopSignalGenerator message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StopSignalGenerator.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StopSignalGenerator message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StopSignalGenerator} StopSignalGenerator
                 */
                StopSignalGenerator.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StopSignalGenerator();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StopSignalGenerator message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StopSignalGenerator} message StopSignalGenerator
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StopSignalGenerator.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StopSignalGenerator to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StopSignalGenerator.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StopSignalGenerator
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StopSignalGenerator
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StopSignalGenerator.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StopSignalGenerator";
                };

                return StopSignalGenerator;
            })();

            Request.StartMonitoringDeviceParameterValues = (function() {

                /**
                 * Properties of a StartMonitoringDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartMonitoringDeviceParameterValues
                 * @property {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues|null} [getDeviceParameterValues] StartMonitoringDeviceParameterValues getDeviceParameterValues
                 * @property {number|null} [interval] StartMonitoringDeviceParameterValues interval
                 * @property {string|null} [topic] StartMonitoringDeviceParameterValues topic
                 */

                /**
                 * Constructs a new StartMonitoringDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartMonitoringDeviceParameterValues.
                 * @implements IStartMonitoringDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues=} [properties] Properties to set
                 */
                function StartMonitoringDeviceParameterValues(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartMonitoringDeviceParameterValues getDeviceParameterValues.
                 * @member {motionmaster.MotionMasterMessage.Request.IGetDeviceParameterValues|null|undefined} getDeviceParameterValues
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @instance
                 */
                StartMonitoringDeviceParameterValues.prototype.getDeviceParameterValues = null;

                /**
                 * StartMonitoringDeviceParameterValues interval.
                 * @member {number} interval
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @instance
                 */
                StartMonitoringDeviceParameterValues.prototype.interval = 0;

                /**
                 * StartMonitoringDeviceParameterValues topic.
                 * @member {string} topic
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @instance
                 */
                StartMonitoringDeviceParameterValues.prototype.topic = "";

                /**
                 * Creates a new StartMonitoringDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues} StartMonitoringDeviceParameterValues instance
                 */
                StartMonitoringDeviceParameterValues.create = function create(properties) {
                    return new StartMonitoringDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified StartMonitoringDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues} message StartMonitoringDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartMonitoringDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.getDeviceParameterValues != null && Object.hasOwnProperty.call(message, "getDeviceParameterValues"))
                        $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.encode(message.getDeviceParameterValues, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.interval != null && Object.hasOwnProperty.call(message, "interval"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.interval);
                    if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.topic);
                    return writer;
                };

                /**
                 * Encodes the specified StartMonitoringDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartMonitoringDeviceParameterValues} message StartMonitoringDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartMonitoringDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartMonitoringDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues} StartMonitoringDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartMonitoringDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.interval = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.topic = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartMonitoringDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues} StartMonitoringDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartMonitoringDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartMonitoringDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartMonitoringDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.getDeviceParameterValues != null && message.hasOwnProperty("getDeviceParameterValues")) {
                        let error = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.verify(message.getDeviceParameterValues);
                        if (error)
                            return "getDeviceParameterValues." + error;
                    }
                    if (message.interval != null && message.hasOwnProperty("interval"))
                        if (!$util.isInteger(message.interval))
                            return "interval: integer expected";
                    if (message.topic != null && message.hasOwnProperty("topic"))
                        if (!$util.isString(message.topic))
                            return "topic: string expected";
                    return null;
                };

                /**
                 * Creates a StartMonitoringDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues} StartMonitoringDeviceParameterValues
                 */
                StartMonitoringDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues();
                    if (object.getDeviceParameterValues != null) {
                        if (typeof object.getDeviceParameterValues !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues.getDeviceParameterValues: object expected");
                        message.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.fromObject(object.getDeviceParameterValues);
                    }
                    if (object.interval != null)
                        message.interval = object.interval >>> 0;
                    if (object.topic != null)
                        message.topic = String(object.topic);
                    return message;
                };

                /**
                 * Creates a plain object from a StartMonitoringDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues} message StartMonitoringDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartMonitoringDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.getDeviceParameterValues = null;
                        object.interval = 0;
                        object.topic = "";
                    }
                    if (message.getDeviceParameterValues != null && message.hasOwnProperty("getDeviceParameterValues"))
                        object.getDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Request.GetDeviceParameterValues.toObject(message.getDeviceParameterValues, options);
                    if (message.interval != null && message.hasOwnProperty("interval"))
                        object.interval = message.interval;
                    if (message.topic != null && message.hasOwnProperty("topic"))
                        object.topic = message.topic;
                    return object;
                };

                /**
                 * Converts this StartMonitoringDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartMonitoringDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartMonitoringDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartMonitoringDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartMonitoringDeviceParameterValues";
                };

                return StartMonitoringDeviceParameterValues;
            })();

            Request.StopMonitoringDeviceParameterValues = (function() {

                /**
                 * Properties of a StopMonitoringDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStopMonitoringDeviceParameterValues
                 * @property {string|null} [startMonitoringRequestId] StopMonitoringDeviceParameterValues startMonitoringRequestId
                 */

                /**
                 * Constructs a new StopMonitoringDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StopMonitoringDeviceParameterValues.
                 * @implements IStopMonitoringDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues=} [properties] Properties to set
                 */
                function StopMonitoringDeviceParameterValues(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StopMonitoringDeviceParameterValues startMonitoringRequestId.
                 * @member {string} startMonitoringRequestId
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @instance
                 */
                StopMonitoringDeviceParameterValues.prototype.startMonitoringRequestId = "";

                /**
                 * Creates a new StopMonitoringDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues} StopMonitoringDeviceParameterValues instance
                 */
                StopMonitoringDeviceParameterValues.create = function create(properties) {
                    return new StopMonitoringDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified StopMonitoringDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues} message StopMonitoringDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopMonitoringDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.startMonitoringRequestId != null && Object.hasOwnProperty.call(message, "startMonitoringRequestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.startMonitoringRequestId);
                    return writer;
                };

                /**
                 * Encodes the specified StopMonitoringDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopMonitoringDeviceParameterValues} message StopMonitoringDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopMonitoringDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StopMonitoringDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues} StopMonitoringDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopMonitoringDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.startMonitoringRequestId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StopMonitoringDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues} StopMonitoringDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopMonitoringDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StopMonitoringDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StopMonitoringDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.startMonitoringRequestId != null && message.hasOwnProperty("startMonitoringRequestId"))
                        if (!$util.isString(message.startMonitoringRequestId))
                            return "startMonitoringRequestId: string expected";
                    return null;
                };

                /**
                 * Creates a StopMonitoringDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues} StopMonitoringDeviceParameterValues
                 */
                StopMonitoringDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues();
                    if (object.startMonitoringRequestId != null)
                        message.startMonitoringRequestId = String(object.startMonitoringRequestId);
                    return message;
                };

                /**
                 * Creates a plain object from a StopMonitoringDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues} message StopMonitoringDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StopMonitoringDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.startMonitoringRequestId = "";
                    if (message.startMonitoringRequestId != null && message.hasOwnProperty("startMonitoringRequestId"))
                        object.startMonitoringRequestId = message.startMonitoringRequestId;
                    return object;
                };

                /**
                 * Converts this StopMonitoringDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StopMonitoringDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StopMonitoringDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StopMonitoringDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StopMonitoringDeviceParameterValues";
                };

                return StopMonitoringDeviceParameterValues;
            })();

            Request.GetEthercatNetworkState = (function() {

                /**
                 * Properties of a GetEthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetEthercatNetworkState
                 * @property {number|null} [deviceAddress] GetEthercatNetworkState deviceAddress
                 */

                /**
                 * Constructs a new GetEthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetEthercatNetworkState.
                 * @implements IGetEthercatNetworkState
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState=} [properties] Properties to set
                 */
                function GetEthercatNetworkState(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetEthercatNetworkState deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @instance
                 */
                GetEthercatNetworkState.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetEthercatNetworkState instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState} GetEthercatNetworkState instance
                 */
                GetEthercatNetworkState.create = function create(properties) {
                    return new GetEthercatNetworkState(properties);
                };

                /**
                 * Encodes the specified GetEthercatNetworkState message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState} message GetEthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetEthercatNetworkState.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetEthercatNetworkState message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetEthercatNetworkState} message GetEthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetEthercatNetworkState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetEthercatNetworkState message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState} GetEthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetEthercatNetworkState.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetEthercatNetworkState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState} GetEthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetEthercatNetworkState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetEthercatNetworkState message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetEthercatNetworkState.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetEthercatNetworkState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState} GetEthercatNetworkState
                 */
                GetEthercatNetworkState.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetEthercatNetworkState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState} message GetEthercatNetworkState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetEthercatNetworkState.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetEthercatNetworkState to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetEthercatNetworkState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetEthercatNetworkState
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetEthercatNetworkState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetEthercatNetworkState";
                };

                return GetEthercatNetworkState;
            })();

            Request.SetEthercatNetworkState = (function() {

                /**
                 * Properties of a SetEthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetEthercatNetworkState
                 * @property {number|null} [deviceAddress] SetEthercatNetworkState deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.State|null} [state] SetEthercatNetworkState state
                 */

                /**
                 * Constructs a new SetEthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetEthercatNetworkState.
                 * @implements ISetEthercatNetworkState
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState=} [properties] Properties to set
                 */
                function SetEthercatNetworkState(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetEthercatNetworkState deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @instance
                 */
                SetEthercatNetworkState.prototype.deviceAddress = 0;

                /**
                 * SetEthercatNetworkState state.
                 * @member {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.State} state
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @instance
                 */
                SetEthercatNetworkState.prototype.state = 0;

                /**
                 * Creates a new SetEthercatNetworkState instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState} SetEthercatNetworkState instance
                 */
                SetEthercatNetworkState.create = function create(properties) {
                    return new SetEthercatNetworkState(properties);
                };

                /**
                 * Encodes the specified SetEthercatNetworkState message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState} message SetEthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetEthercatNetworkState.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                    return writer;
                };

                /**
                 * Encodes the specified SetEthercatNetworkState message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetEthercatNetworkState} message SetEthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetEthercatNetworkState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetEthercatNetworkState message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState} SetEthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetEthercatNetworkState.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.state = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetEthercatNetworkState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState} SetEthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetEthercatNetworkState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetEthercatNetworkState message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetEthercatNetworkState.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a SetEthercatNetworkState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState} SetEthercatNetworkState
                 */
                SetEthercatNetworkState.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "INIT":
                    case 1:
                        message.state = 1;
                        break;
                    case "PREOP":
                    case 2:
                        message.state = 2;
                        break;
                    case "BOOT":
                    case 3:
                        message.state = 3;
                        break;
                    case "SAFEOP":
                    case 4:
                        message.state = 4;
                        break;
                    case "OP":
                    case 5:
                        message.state = 5;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetEthercatNetworkState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState} message SetEthercatNetworkState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetEthercatNetworkState.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.state = options.enums === String ? "UNSPECIFIED" : 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.State[message.state] === undefined ? message.state : $root.motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.State[message.state] : message.state;
                    return object;
                };

                /**
                 * Converts this SetEthercatNetworkState to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetEthercatNetworkState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetEthercatNetworkState
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetEthercatNetworkState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState";
                };

                /**
                 * State enum.
                 * @name motionmaster.MotionMasterMessage.Request.SetEthercatNetworkState.State
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} INIT=1 INIT value
                 * @property {number} PREOP=2 PREOP value
                 * @property {number} BOOT=3 BOOT value
                 * @property {number} SAFEOP=4 SAFEOP value
                 * @property {number} OP=5 OP value
                 */
                SetEthercatNetworkState.State = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "INIT"] = 1;
                    values[valuesById[2] = "PREOP"] = 2;
                    values[valuesById[3] = "BOOT"] = 3;
                    values[valuesById[4] = "SAFEOP"] = 4;
                    values[valuesById[5] = "OP"] = 5;
                    return values;
                })();

                return SetEthercatNetworkState;
            })();

            Request.StartNarrowAngleCalibration = (function() {

                /**
                 * Properties of a StartNarrowAngleCalibration.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartNarrowAngleCalibration
                 * @property {number|null} [deviceAddress] StartNarrowAngleCalibration deviceAddress
                 */

                /**
                 * Constructs a new StartNarrowAngleCalibration.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartNarrowAngleCalibration.
                 * @implements IStartNarrowAngleCalibration
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration=} [properties] Properties to set
                 */
                function StartNarrowAngleCalibration(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartNarrowAngleCalibration deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @instance
                 */
                StartNarrowAngleCalibration.prototype.deviceAddress = 0;

                /**
                 * Creates a new StartNarrowAngleCalibration instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration} StartNarrowAngleCalibration instance
                 */
                StartNarrowAngleCalibration.create = function create(properties) {
                    return new StartNarrowAngleCalibration(properties);
                };

                /**
                 * Encodes the specified StartNarrowAngleCalibration message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration} message StartNarrowAngleCalibration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartNarrowAngleCalibration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StartNarrowAngleCalibration message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartNarrowAngleCalibration} message StartNarrowAngleCalibration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartNarrowAngleCalibration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartNarrowAngleCalibration message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration} StartNarrowAngleCalibration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartNarrowAngleCalibration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartNarrowAngleCalibration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration} StartNarrowAngleCalibration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartNarrowAngleCalibration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartNarrowAngleCalibration message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartNarrowAngleCalibration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StartNarrowAngleCalibration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration} StartNarrowAngleCalibration
                 */
                StartNarrowAngleCalibration.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartNarrowAngleCalibration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration} message StartNarrowAngleCalibration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartNarrowAngleCalibration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StartNarrowAngleCalibration to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartNarrowAngleCalibration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartNarrowAngleCalibration
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartNarrowAngleCalibration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartNarrowAngleCalibration";
                };

                return StartNarrowAngleCalibration;
            })();

            Request.SetSystemClientTimeout = (function() {

                /**
                 * Properties of a SetSystemClientTimeout.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetSystemClientTimeout
                 * @property {number|null} [timeoutMs] SetSystemClientTimeout timeoutMs
                 */

                /**
                 * Constructs a new SetSystemClientTimeout.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetSystemClientTimeout.
                 * @implements ISetSystemClientTimeout
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout=} [properties] Properties to set
                 */
                function SetSystemClientTimeout(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetSystemClientTimeout timeoutMs.
                 * @member {number} timeoutMs
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @instance
                 */
                SetSystemClientTimeout.prototype.timeoutMs = 0;

                /**
                 * Creates a new SetSystemClientTimeout instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout} SetSystemClientTimeout instance
                 */
                SetSystemClientTimeout.create = function create(properties) {
                    return new SetSystemClientTimeout(properties);
                };

                /**
                 * Encodes the specified SetSystemClientTimeout message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout} message SetSystemClientTimeout message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetSystemClientTimeout.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.timeoutMs != null && Object.hasOwnProperty.call(message, "timeoutMs"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.timeoutMs);
                    return writer;
                };

                /**
                 * Encodes the specified SetSystemClientTimeout message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetSystemClientTimeout} message SetSystemClientTimeout message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetSystemClientTimeout.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetSystemClientTimeout message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout} SetSystemClientTimeout
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetSystemClientTimeout.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.timeoutMs = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetSystemClientTimeout message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout} SetSystemClientTimeout
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetSystemClientTimeout.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetSystemClientTimeout message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetSystemClientTimeout.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.timeoutMs != null && message.hasOwnProperty("timeoutMs"))
                        if (!$util.isInteger(message.timeoutMs))
                            return "timeoutMs: integer expected";
                    return null;
                };

                /**
                 * Creates a SetSystemClientTimeout message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout} SetSystemClientTimeout
                 */
                SetSystemClientTimeout.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout();
                    if (object.timeoutMs != null)
                        message.timeoutMs = object.timeoutMs >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SetSystemClientTimeout message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout} message SetSystemClientTimeout
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetSystemClientTimeout.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.timeoutMs = 0;
                    if (message.timeoutMs != null && message.hasOwnProperty("timeoutMs"))
                        object.timeoutMs = message.timeoutMs;
                    return object;
                };

                /**
                 * Converts this SetSystemClientTimeout to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetSystemClientTimeout.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetSystemClientTimeout
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetSystemClientTimeout.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetSystemClientTimeout";
                };

                return SetSystemClientTimeout;
            })();

            Request.GetCirculoEncoderMagnetDistance = (function() {

                /**
                 * Properties of a GetCirculoEncoderMagnetDistance.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetCirculoEncoderMagnetDistance
                 * @property {number|null} [deviceAddress] GetCirculoEncoderMagnetDistance deviceAddress
                 * @property {number|null} [encoderOrdinal] GetCirculoEncoderMagnetDistance encoderOrdinal
                 * @property {number|null} [ringRevision] GetCirculoEncoderMagnetDistance ringRevision
                 */

                /**
                 * Constructs a new GetCirculoEncoderMagnetDistance.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetCirculoEncoderMagnetDistance.
                 * @implements IGetCirculoEncoderMagnetDistance
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance=} [properties] Properties to set
                 */
                function GetCirculoEncoderMagnetDistance(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetCirculoEncoderMagnetDistance deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @instance
                 */
                GetCirculoEncoderMagnetDistance.prototype.deviceAddress = 0;

                /**
                 * GetCirculoEncoderMagnetDistance encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @instance
                 */
                GetCirculoEncoderMagnetDistance.prototype.encoderOrdinal = 0;

                /**
                 * GetCirculoEncoderMagnetDistance ringRevision.
                 * @member {number} ringRevision
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @instance
                 */
                GetCirculoEncoderMagnetDistance.prototype.ringRevision = 0;

                /**
                 * Creates a new GetCirculoEncoderMagnetDistance instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance} GetCirculoEncoderMagnetDistance instance
                 */
                GetCirculoEncoderMagnetDistance.create = function create(properties) {
                    return new GetCirculoEncoderMagnetDistance(properties);
                };

                /**
                 * Encodes the specified GetCirculoEncoderMagnetDistance message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance} message GetCirculoEncoderMagnetDistance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCirculoEncoderMagnetDistance.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.ringRevision != null && Object.hasOwnProperty.call(message, "ringRevision"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.ringRevision);
                    return writer;
                };

                /**
                 * Encodes the specified GetCirculoEncoderMagnetDistance message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetCirculoEncoderMagnetDistance} message GetCirculoEncoderMagnetDistance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCirculoEncoderMagnetDistance.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetCirculoEncoderMagnetDistance message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance} GetCirculoEncoderMagnetDistance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCirculoEncoderMagnetDistance.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.ringRevision = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetCirculoEncoderMagnetDistance message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance} GetCirculoEncoderMagnetDistance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCirculoEncoderMagnetDistance.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetCirculoEncoderMagnetDistance message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetCirculoEncoderMagnetDistance.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.ringRevision != null && message.hasOwnProperty("ringRevision"))
                        if (!$util.isInteger(message.ringRevision))
                            return "ringRevision: integer expected";
                    return null;
                };

                /**
                 * Creates a GetCirculoEncoderMagnetDistance message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance} GetCirculoEncoderMagnetDistance
                 */
                GetCirculoEncoderMagnetDistance.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.ringRevision != null)
                        message.ringRevision = object.ringRevision >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetCirculoEncoderMagnetDistance message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance} message GetCirculoEncoderMagnetDistance
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetCirculoEncoderMagnetDistance.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                        object.ringRevision = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.ringRevision != null && message.hasOwnProperty("ringRevision"))
                        object.ringRevision = message.ringRevision;
                    return object;
                };

                /**
                 * Converts this GetCirculoEncoderMagnetDistance to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetCirculoEncoderMagnetDistance.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetCirculoEncoderMagnetDistance
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetCirculoEncoderMagnetDistance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetCirculoEncoderMagnetDistance";
                };

                return GetCirculoEncoderMagnetDistance;
            })();

            Request.StartCirculoEncoderNarrowAngleCalibrationProcedure = (function() {

                /**
                 * Properties of a StartCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @property {number|null} [deviceAddress] StartCirculoEncoderNarrowAngleCalibrationProcedure deviceAddress
                 * @property {number|null} [encoderOrdinal] StartCirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal
                 * @property {boolean|null} [activateHealthMonitoring] StartCirculoEncoderNarrowAngleCalibrationProcedure activateHealthMonitoring
                 * @property {boolean|null} [measurementOnly] StartCirculoEncoderNarrowAngleCalibrationProcedure measurementOnly
                 * @property {number|null} [externalEncoderType] StartCirculoEncoderNarrowAngleCalibrationProcedure externalEncoderType
                 * @property {number|null} [velocityBaseValueRpm] StartCirculoEncoderNarrowAngleCalibrationProcedure velocityBaseValueRpm
                 */

                /**
                 * Constructs a new StartCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @implements IStartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 */
                function StartCirculoEncoderNarrowAngleCalibrationProcedure(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.deviceAddress = 0;

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.encoderOrdinal = 0;

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure activateHealthMonitoring.
                 * @member {boolean} activateHealthMonitoring
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.activateHealthMonitoring = false;

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure measurementOnly.
                 * @member {boolean} measurementOnly
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.measurementOnly = false;

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure externalEncoderType.
                 * @member {number} externalEncoderType
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.externalEncoderType = 0;

                /**
                 * StartCirculoEncoderNarrowAngleCalibrationProcedure velocityBaseValueRpm.
                 * @member {number} velocityBaseValueRpm
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.velocityBaseValueRpm = 0;

                /**
                 * Creates a new StartCirculoEncoderNarrowAngleCalibrationProcedure instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure} StartCirculoEncoderNarrowAngleCalibrationProcedure instance
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.create = function create(properties) {
                    return new StartCirculoEncoderNarrowAngleCalibrationProcedure(properties);
                };

                /**
                 * Encodes the specified StartCirculoEncoderNarrowAngleCalibrationProcedure message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure} message StartCirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.activateHealthMonitoring != null && Object.hasOwnProperty.call(message, "activateHealthMonitoring"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.activateHealthMonitoring);
                    if (message.measurementOnly != null && Object.hasOwnProperty.call(message, "measurementOnly"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.measurementOnly);
                    if (message.externalEncoderType != null && Object.hasOwnProperty.call(message, "externalEncoderType"))
                        writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.externalEncoderType);
                    if (message.velocityBaseValueRpm != null && Object.hasOwnProperty.call(message, "velocityBaseValueRpm"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.velocityBaseValueRpm);
                    return writer;
                };

                /**
                 * Encodes the specified StartCirculoEncoderNarrowAngleCalibrationProcedure message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderNarrowAngleCalibrationProcedure} message StartCirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartCirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure} StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.activateHealthMonitoring = reader.bool();
                                break;
                            }
                        case 4: {
                                message.measurementOnly = reader.bool();
                                break;
                            }
                        case 5: {
                                message.externalEncoderType = reader.uint32();
                                break;
                            }
                        case 6: {
                                message.velocityBaseValueRpm = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartCirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure} StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartCirculoEncoderNarrowAngleCalibrationProcedure message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.activateHealthMonitoring != null && message.hasOwnProperty("activateHealthMonitoring"))
                        if (typeof message.activateHealthMonitoring !== "boolean")
                            return "activateHealthMonitoring: boolean expected";
                    if (message.measurementOnly != null && message.hasOwnProperty("measurementOnly"))
                        if (typeof message.measurementOnly !== "boolean")
                            return "measurementOnly: boolean expected";
                    if (message.externalEncoderType != null && message.hasOwnProperty("externalEncoderType"))
                        if (!$util.isInteger(message.externalEncoderType))
                            return "externalEncoderType: integer expected";
                    if (message.velocityBaseValueRpm != null && message.hasOwnProperty("velocityBaseValueRpm"))
                        if (!$util.isInteger(message.velocityBaseValueRpm))
                            return "velocityBaseValueRpm: integer expected";
                    return null;
                };

                /**
                 * Creates a StartCirculoEncoderNarrowAngleCalibrationProcedure message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure} StartCirculoEncoderNarrowAngleCalibrationProcedure
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.activateHealthMonitoring != null)
                        message.activateHealthMonitoring = Boolean(object.activateHealthMonitoring);
                    if (object.measurementOnly != null)
                        message.measurementOnly = Boolean(object.measurementOnly);
                    if (object.externalEncoderType != null)
                        message.externalEncoderType = object.externalEncoderType >>> 0;
                    if (object.velocityBaseValueRpm != null)
                        message.velocityBaseValueRpm = object.velocityBaseValueRpm | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartCirculoEncoderNarrowAngleCalibrationProcedure message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure} message StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                        object.activateHealthMonitoring = false;
                        object.measurementOnly = false;
                        object.externalEncoderType = 0;
                        object.velocityBaseValueRpm = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.activateHealthMonitoring != null && message.hasOwnProperty("activateHealthMonitoring"))
                        object.activateHealthMonitoring = message.activateHealthMonitoring;
                    if (message.measurementOnly != null && message.hasOwnProperty("measurementOnly"))
                        object.measurementOnly = message.measurementOnly;
                    if (message.externalEncoderType != null && message.hasOwnProperty("externalEncoderType"))
                        object.externalEncoderType = message.externalEncoderType;
                    if (message.velocityBaseValueRpm != null && message.hasOwnProperty("velocityBaseValueRpm"))
                        object.velocityBaseValueRpm = message.velocityBaseValueRpm;
                    return object;
                };

                /**
                 * Converts this StartCirculoEncoderNarrowAngleCalibrationProcedure to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartCirculoEncoderNarrowAngleCalibrationProcedure.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartCirculoEncoderNarrowAngleCalibrationProcedure";
                };

                return StartCirculoEncoderNarrowAngleCalibrationProcedure;
            })();

            Request.GetDeviceCiA402State = (function() {

                /**
                 * Properties of a GetDeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceCiA402State
                 * @property {number|null} [deviceAddress] GetDeviceCiA402State deviceAddress
                 */

                /**
                 * Constructs a new GetDeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceCiA402State.
                 * @implements IGetDeviceCiA402State
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State=} [properties] Properties to set
                 */
                function GetDeviceCiA402State(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceCiA402State deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @instance
                 */
                GetDeviceCiA402State.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetDeviceCiA402State instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State} GetDeviceCiA402State instance
                 */
                GetDeviceCiA402State.create = function create(properties) {
                    return new GetDeviceCiA402State(properties);
                };

                /**
                 * Encodes the specified GetDeviceCiA402State message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State} message GetDeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceCiA402State.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceCiA402State message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceCiA402State} message GetDeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceCiA402State.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceCiA402State message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State} GetDeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceCiA402State.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceCiA402State message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State} GetDeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceCiA402State.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceCiA402State message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceCiA402State.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceCiA402State message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State} GetDeviceCiA402State
                 */
                GetDeviceCiA402State.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceCiA402State message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State} message GetDeviceCiA402State
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceCiA402State.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetDeviceCiA402State to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceCiA402State.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceCiA402State
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceCiA402State.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceCiA402State";
                };

                return GetDeviceCiA402State;
            })();

            Request.SetDeviceCiA402State = (function() {

                /**
                 * Properties of a SetDeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetDeviceCiA402State
                 * @property {number|null} [deviceAddress] SetDeviceCiA402State deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.State|null} [state] SetDeviceCiA402State state
                 */

                /**
                 * Constructs a new SetDeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetDeviceCiA402State.
                 * @implements ISetDeviceCiA402State
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State=} [properties] Properties to set
                 */
                function SetDeviceCiA402State(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetDeviceCiA402State deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @instance
                 */
                SetDeviceCiA402State.prototype.deviceAddress = 0;

                /**
                 * SetDeviceCiA402State state.
                 * @member {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.State} state
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @instance
                 */
                SetDeviceCiA402State.prototype.state = 0;

                /**
                 * Creates a new SetDeviceCiA402State instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State} SetDeviceCiA402State instance
                 */
                SetDeviceCiA402State.create = function create(properties) {
                    return new SetDeviceCiA402State(properties);
                };

                /**
                 * Encodes the specified SetDeviceCiA402State message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State} message SetDeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceCiA402State.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                    return writer;
                };

                /**
                 * Encodes the specified SetDeviceCiA402State message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetDeviceCiA402State} message SetDeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetDeviceCiA402State.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetDeviceCiA402State message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State} SetDeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceCiA402State.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.state = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetDeviceCiA402State message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State} SetDeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetDeviceCiA402State.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetDeviceCiA402State message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetDeviceCiA402State.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a SetDeviceCiA402State message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State} SetDeviceCiA402State
                 */
                SetDeviceCiA402State.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "NOT_READY":
                    case 1:
                        message.state = 1;
                        break;
                    case "SWITCH_ON_DISABLED":
                    case 2:
                        message.state = 2;
                        break;
                    case "READY_SWITCH_ON":
                    case 3:
                        message.state = 3;
                        break;
                    case "SWITCHED_ON":
                    case 4:
                        message.state = 4;
                        break;
                    case "OP_ENABLED":
                    case 5:
                        message.state = 5;
                        break;
                    case "QUICK_STOP_ACTIVE":
                    case 6:
                        message.state = 6;
                        break;
                    case "FAULT_REACTION_ACTIVE":
                    case 7:
                        message.state = 7;
                        break;
                    case "FAULT":
                    case 8:
                        message.state = 8;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetDeviceCiA402State message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State} message SetDeviceCiA402State
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetDeviceCiA402State.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.state = options.enums === String ? "UNSPECIFIED" : 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.State[message.state] === undefined ? message.state : $root.motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.State[message.state] : message.state;
                    return object;
                };

                /**
                 * Converts this SetDeviceCiA402State to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetDeviceCiA402State.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetDeviceCiA402State
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetDeviceCiA402State.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State";
                };

                /**
                 * State enum.
                 * @name motionmaster.MotionMasterMessage.Request.SetDeviceCiA402State.State
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} NOT_READY=1 NOT_READY value
                 * @property {number} SWITCH_ON_DISABLED=2 SWITCH_ON_DISABLED value
                 * @property {number} READY_SWITCH_ON=3 READY_SWITCH_ON value
                 * @property {number} SWITCHED_ON=4 SWITCHED_ON value
                 * @property {number} OP_ENABLED=5 OP_ENABLED value
                 * @property {number} QUICK_STOP_ACTIVE=6 QUICK_STOP_ACTIVE value
                 * @property {number} FAULT_REACTION_ACTIVE=7 FAULT_REACTION_ACTIVE value
                 * @property {number} FAULT=8 FAULT value
                 */
                SetDeviceCiA402State.State = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "NOT_READY"] = 1;
                    values[valuesById[2] = "SWITCH_ON_DISABLED"] = 2;
                    values[valuesById[3] = "READY_SWITCH_ON"] = 3;
                    values[valuesById[4] = "SWITCHED_ON"] = 4;
                    values[valuesById[5] = "OP_ENABLED"] = 5;
                    values[valuesById[6] = "QUICK_STOP_ACTIVE"] = 6;
                    values[valuesById[7] = "FAULT_REACTION_ACTIVE"] = 7;
                    values[valuesById[8] = "FAULT"] = 8;
                    return values;
                })();

                return SetDeviceCiA402State;
            })();

            Request.GetSystemLog = (function() {

                /**
                 * Properties of a GetSystemLog.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetSystemLog
                 */

                /**
                 * Constructs a new GetSystemLog.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetSystemLog.
                 * @implements IGetSystemLog
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemLog=} [properties] Properties to set
                 */
                function GetSystemLog(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new GetSystemLog instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemLog=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemLog} GetSystemLog instance
                 */
                GetSystemLog.create = function create(properties) {
                    return new GetSystemLog(properties);
                };

                /**
                 * Encodes the specified GetSystemLog message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemLog.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemLog} message GetSystemLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemLog.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified GetSystemLog message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemLog.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemLog} message GetSystemLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemLog.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetSystemLog message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemLog} GetSystemLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemLog.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetSystemLog();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetSystemLog message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemLog} GetSystemLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemLog.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetSystemLog message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetSystemLog.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a GetSystemLog message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemLog} GetSystemLog
                 */
                GetSystemLog.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetSystemLog)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Request.GetSystemLog();
                };

                /**
                 * Creates a plain object from a GetSystemLog message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetSystemLog} message GetSystemLog
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetSystemLog.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this GetSystemLog to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetSystemLog.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetSystemLog
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemLog
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetSystemLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetSystemLog";
                };

                return GetSystemLog;
            })();

            Request.StartDeviceSiiRestore = (function() {

                /**
                 * Properties of a StartDeviceSiiRestore.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartDeviceSiiRestore
                 * @property {number|null} [devicePosition] StartDeviceSiiRestore devicePosition
                 * @property {Uint8Array|null} [siiContent] StartDeviceSiiRestore siiContent
                 */

                /**
                 * Constructs a new StartDeviceSiiRestore.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartDeviceSiiRestore.
                 * @implements IStartDeviceSiiRestore
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore=} [properties] Properties to set
                 */
                function StartDeviceSiiRestore(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartDeviceSiiRestore devicePosition.
                 * @member {number} devicePosition
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @instance
                 */
                StartDeviceSiiRestore.prototype.devicePosition = 0;

                /**
                 * StartDeviceSiiRestore siiContent.
                 * @member {Uint8Array} siiContent
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @instance
                 */
                StartDeviceSiiRestore.prototype.siiContent = $util.newBuffer([]);

                /**
                 * Creates a new StartDeviceSiiRestore instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore} StartDeviceSiiRestore instance
                 */
                StartDeviceSiiRestore.create = function create(properties) {
                    return new StartDeviceSiiRestore(properties);
                };

                /**
                 * Encodes the specified StartDeviceSiiRestore message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore} message StartDeviceSiiRestore message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartDeviceSiiRestore.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.devicePosition != null && Object.hasOwnProperty.call(message, "devicePosition"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.devicePosition);
                    if (message.siiContent != null && Object.hasOwnProperty.call(message, "siiContent"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.siiContent);
                    return writer;
                };

                /**
                 * Encodes the specified StartDeviceSiiRestore message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartDeviceSiiRestore} message StartDeviceSiiRestore message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartDeviceSiiRestore.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartDeviceSiiRestore message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore} StartDeviceSiiRestore
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartDeviceSiiRestore.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.devicePosition = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.siiContent = reader.bytes();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartDeviceSiiRestore message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore} StartDeviceSiiRestore
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartDeviceSiiRestore.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartDeviceSiiRestore message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartDeviceSiiRestore.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.devicePosition != null && message.hasOwnProperty("devicePosition"))
                        if (!$util.isInteger(message.devicePosition))
                            return "devicePosition: integer expected";
                    if (message.siiContent != null && message.hasOwnProperty("siiContent"))
                        if (!(message.siiContent && typeof message.siiContent.length === "number" || $util.isString(message.siiContent)))
                            return "siiContent: buffer expected";
                    return null;
                };

                /**
                 * Creates a StartDeviceSiiRestore message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore} StartDeviceSiiRestore
                 */
                StartDeviceSiiRestore.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore();
                    if (object.devicePosition != null)
                        message.devicePosition = object.devicePosition >>> 0;
                    if (object.siiContent != null)
                        if (typeof object.siiContent === "string")
                            $util.base64.decode(object.siiContent, message.siiContent = $util.newBuffer($util.base64.length(object.siiContent)), 0);
                        else if (object.siiContent.length >= 0)
                            message.siiContent = object.siiContent;
                    return message;
                };

                /**
                 * Creates a plain object from a StartDeviceSiiRestore message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore} message StartDeviceSiiRestore
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartDeviceSiiRestore.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.devicePosition = 0;
                        if (options.bytes === String)
                            object.siiContent = "";
                        else {
                            object.siiContent = [];
                            if (options.bytes !== Array)
                                object.siiContent = $util.newBuffer(object.siiContent);
                        }
                    }
                    if (message.devicePosition != null && message.hasOwnProperty("devicePosition"))
                        object.devicePosition = message.devicePosition;
                    if (message.siiContent != null && message.hasOwnProperty("siiContent"))
                        object.siiContent = options.bytes === String ? $util.base64.encode(message.siiContent, 0, message.siiContent.length) : options.bytes === Array ? Array.prototype.slice.call(message.siiContent) : message.siiContent;
                    return object;
                };

                /**
                 * Converts this StartDeviceSiiRestore to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartDeviceSiiRestore.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartDeviceSiiRestore
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartDeviceSiiRestore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartDeviceSiiRestore";
                };

                return StartDeviceSiiRestore;
            })();

            Request.StartOpenLoopFieldControl = (function() {

                /**
                 * Properties of a StartOpenLoopFieldControl.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartOpenLoopFieldControl
                 * @property {number|null} [deviceAddress] StartOpenLoopFieldControl deviceAddress
                 * @property {number|null} [angle] StartOpenLoopFieldControl angle
                 * @property {number|null} [velocity] StartOpenLoopFieldControl velocity
                 * @property {number|null} [acceleration] StartOpenLoopFieldControl acceleration
                 * @property {number|null} [torque] StartOpenLoopFieldControl torque
                 * @property {number|null} [torqueSpeed] StartOpenLoopFieldControl torqueSpeed
                 */

                /**
                 * Constructs a new StartOpenLoopFieldControl.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartOpenLoopFieldControl.
                 * @implements IStartOpenLoopFieldControl
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl=} [properties] Properties to set
                 */
                function StartOpenLoopFieldControl(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartOpenLoopFieldControl deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.deviceAddress = 0;

                /**
                 * StartOpenLoopFieldControl angle.
                 * @member {number} angle
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.angle = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StartOpenLoopFieldControl velocity.
                 * @member {number} velocity
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.velocity = 0;

                /**
                 * StartOpenLoopFieldControl acceleration.
                 * @member {number} acceleration
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.acceleration = 0;

                /**
                 * StartOpenLoopFieldControl torque.
                 * @member {number} torque
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.torque = 0;

                /**
                 * StartOpenLoopFieldControl torqueSpeed.
                 * @member {number} torqueSpeed
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 */
                StartOpenLoopFieldControl.prototype.torqueSpeed = 0;

                /**
                 * Creates a new StartOpenLoopFieldControl instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl} StartOpenLoopFieldControl instance
                 */
                StartOpenLoopFieldControl.create = function create(properties) {
                    return new StartOpenLoopFieldControl(properties);
                };

                /**
                 * Encodes the specified StartOpenLoopFieldControl message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl} message StartOpenLoopFieldControl message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOpenLoopFieldControl.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.angle != null && Object.hasOwnProperty.call(message, "angle"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.angle);
                    if (message.velocity != null && Object.hasOwnProperty.call(message, "velocity"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.velocity);
                    if (message.acceleration != null && Object.hasOwnProperty.call(message, "acceleration"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.acceleration);
                    if (message.torque != null && Object.hasOwnProperty.call(message, "torque"))
                        writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.torque);
                    if (message.torqueSpeed != null && Object.hasOwnProperty.call(message, "torqueSpeed"))
                        writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.torqueSpeed);
                    return writer;
                };

                /**
                 * Encodes the specified StartOpenLoopFieldControl message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOpenLoopFieldControl} message StartOpenLoopFieldControl message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOpenLoopFieldControl.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartOpenLoopFieldControl message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl} StartOpenLoopFieldControl
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOpenLoopFieldControl.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.angle = reader.int64();
                                break;
                            }
                        case 3: {
                                message.velocity = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.acceleration = reader.uint32();
                                break;
                            }
                        case 5: {
                                message.torque = reader.uint32();
                                break;
                            }
                        case 6: {
                                message.torqueSpeed = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartOpenLoopFieldControl message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl} StartOpenLoopFieldControl
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOpenLoopFieldControl.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartOpenLoopFieldControl message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartOpenLoopFieldControl.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.angle != null && message.hasOwnProperty("angle"))
                        if (!$util.isInteger(message.angle) && !(message.angle && $util.isInteger(message.angle.low) && $util.isInteger(message.angle.high)))
                            return "angle: integer|Long expected";
                    if (message.velocity != null && message.hasOwnProperty("velocity"))
                        if (!$util.isInteger(message.velocity))
                            return "velocity: integer expected";
                    if (message.acceleration != null && message.hasOwnProperty("acceleration"))
                        if (!$util.isInteger(message.acceleration))
                            return "acceleration: integer expected";
                    if (message.torque != null && message.hasOwnProperty("torque"))
                        if (!$util.isInteger(message.torque))
                            return "torque: integer expected";
                    if (message.torqueSpeed != null && message.hasOwnProperty("torqueSpeed"))
                        if (!$util.isInteger(message.torqueSpeed))
                            return "torqueSpeed: integer expected";
                    return null;
                };

                /**
                 * Creates a StartOpenLoopFieldControl message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl} StartOpenLoopFieldControl
                 */
                StartOpenLoopFieldControl.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.angle != null)
                        if ($util.Long)
                            (message.angle = $util.Long.fromValue(object.angle)).unsigned = false;
                        else if (typeof object.angle === "string")
                            message.angle = parseInt(object.angle, 10);
                        else if (typeof object.angle === "number")
                            message.angle = object.angle;
                        else if (typeof object.angle === "object")
                            message.angle = new $util.LongBits(object.angle.low >>> 0, object.angle.high >>> 0).toNumber();
                    if (object.velocity != null)
                        message.velocity = object.velocity >>> 0;
                    if (object.acceleration != null)
                        message.acceleration = object.acceleration >>> 0;
                    if (object.torque != null)
                        message.torque = object.torque >>> 0;
                    if (object.torqueSpeed != null)
                        message.torqueSpeed = object.torqueSpeed >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartOpenLoopFieldControl message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl} message StartOpenLoopFieldControl
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartOpenLoopFieldControl.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.angle = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.angle = options.longs === String ? "0" : 0;
                        object.velocity = 0;
                        object.acceleration = 0;
                        object.torque = 0;
                        object.torqueSpeed = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.angle != null && message.hasOwnProperty("angle"))
                        if (typeof message.angle === "number")
                            object.angle = options.longs === String ? String(message.angle) : message.angle;
                        else
                            object.angle = options.longs === String ? $util.Long.prototype.toString.call(message.angle) : options.longs === Number ? new $util.LongBits(message.angle.low >>> 0, message.angle.high >>> 0).toNumber() : message.angle;
                    if (message.velocity != null && message.hasOwnProperty("velocity"))
                        object.velocity = message.velocity;
                    if (message.acceleration != null && message.hasOwnProperty("acceleration"))
                        object.acceleration = message.acceleration;
                    if (message.torque != null && message.hasOwnProperty("torque"))
                        object.torque = message.torque;
                    if (message.torqueSpeed != null && message.hasOwnProperty("torqueSpeed"))
                        object.torqueSpeed = message.torqueSpeed;
                    return object;
                };

                /**
                 * Converts this StartOpenLoopFieldControl to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartOpenLoopFieldControl.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartOpenLoopFieldControl
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartOpenLoopFieldControl.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartOpenLoopFieldControl";
                };

                return StartOpenLoopFieldControl;
            })();

            Request.ComputeFullAutoTuningGains = (function() {

                /**
                 * Properties of a ComputeFullAutoTuningGains.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IComputeFullAutoTuningGains
                 * @property {number|null} [deviceAddress] ComputeFullAutoTuningGains deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.Type|null} [type] ComputeFullAutoTuningGains type
                 * @property {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.ControllerType|null} [controllerType] ComputeFullAutoTuningGains controllerType
                 */

                /**
                 * Constructs a new ComputeFullAutoTuningGains.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a ComputeFullAutoTuningGains.
                 * @implements IComputeFullAutoTuningGains
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains=} [properties] Properties to set
                 */
                function ComputeFullAutoTuningGains(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ComputeFullAutoTuningGains deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @instance
                 */
                ComputeFullAutoTuningGains.prototype.deviceAddress = 0;

                /**
                 * ComputeFullAutoTuningGains type.
                 * @member {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.Type} type
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @instance
                 */
                ComputeFullAutoTuningGains.prototype.type = 0;

                /**
                 * ComputeFullAutoTuningGains controllerType.
                 * @member {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.ControllerType} controllerType
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @instance
                 */
                ComputeFullAutoTuningGains.prototype.controllerType = 0;

                /**
                 * Creates a new ComputeFullAutoTuningGains instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains} ComputeFullAutoTuningGains instance
                 */
                ComputeFullAutoTuningGains.create = function create(properties) {
                    return new ComputeFullAutoTuningGains(properties);
                };

                /**
                 * Encodes the specified ComputeFullAutoTuningGains message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains} message ComputeFullAutoTuningGains message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComputeFullAutoTuningGains.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                    if (message.controllerType != null && Object.hasOwnProperty.call(message, "controllerType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.controllerType);
                    return writer;
                };

                /**
                 * Encodes the specified ComputeFullAutoTuningGains message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IComputeFullAutoTuningGains} message ComputeFullAutoTuningGains message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ComputeFullAutoTuningGains.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ComputeFullAutoTuningGains message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains} ComputeFullAutoTuningGains
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComputeFullAutoTuningGains.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.type = reader.int32();
                                break;
                            }
                        case 3: {
                                message.controllerType = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ComputeFullAutoTuningGains message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains} ComputeFullAutoTuningGains
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ComputeFullAutoTuningGains.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ComputeFullAutoTuningGains message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ComputeFullAutoTuningGains.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        switch (message.controllerType) {
                        default:
                            return "controllerType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ComputeFullAutoTuningGains message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains} ComputeFullAutoTuningGains
                 */
                ComputeFullAutoTuningGains.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "POSITION":
                    case 0:
                        message.type = 0;
                        break;
                    case "VELOCITY":
                    case 1:
                        message.type = 1;
                        break;
                    }
                    switch (object.controllerType) {
                    default:
                        if (typeof object.controllerType === "number") {
                            message.controllerType = object.controllerType;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.controllerType = 0;
                        break;
                    case "PI_P":
                    case 1:
                        message.controllerType = 1;
                        break;
                    case "P_PI":
                    case 2:
                        message.controllerType = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ComputeFullAutoTuningGains message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains} message ComputeFullAutoTuningGains
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ComputeFullAutoTuningGains.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.type = options.enums === String ? "POSITION" : 0;
                        object.controllerType = options.enums === String ? "UNSPECIFIED" : 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.Type[message.type] === undefined ? message.type : $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.Type[message.type] : message.type;
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        object.controllerType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.ControllerType[message.controllerType] === undefined ? message.controllerType : $root.motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.ControllerType[message.controllerType] : message.controllerType;
                    return object;
                };

                /**
                 * Converts this ComputeFullAutoTuningGains to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ComputeFullAutoTuningGains.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ComputeFullAutoTuningGains
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ComputeFullAutoTuningGains.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains";
                };

                /**
                 * Type enum.
                 * @name motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.Type
                 * @enum {number}
                 * @property {number} POSITION=0 POSITION value
                 * @property {number} VELOCITY=1 VELOCITY value
                 */
                ComputeFullAutoTuningGains.Type = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "POSITION"] = 0;
                    values[valuesById[1] = "VELOCITY"] = 1;
                    return values;
                })();

                /**
                 * ControllerType enum.
                 * @name motionmaster.MotionMasterMessage.Request.ComputeFullAutoTuningGains.ControllerType
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} PI_P=1 PI_P value
                 * @property {number} P_PI=2 P_PI value
                 */
                ComputeFullAutoTuningGains.ControllerType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PI_P"] = 1;
                    values[valuesById[2] = "P_PI"] = 2;
                    return values;
                })();

                return ComputeFullAutoTuningGains;
            })();

            Request.StartFullAutoTuning = (function() {

                /**
                 * Properties of a StartFullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartFullAutoTuning
                 * @property {number|null} [deviceAddress] StartFullAutoTuning deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.Type|null} [type] StartFullAutoTuning type
                 * @property {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.ControllerType|null} [controllerType] StartFullAutoTuning controllerType
                 */

                /**
                 * Constructs a new StartFullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartFullAutoTuning.
                 * @implements IStartFullAutoTuning
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning=} [properties] Properties to set
                 */
                function StartFullAutoTuning(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartFullAutoTuning deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @instance
                 */
                StartFullAutoTuning.prototype.deviceAddress = 0;

                /**
                 * StartFullAutoTuning type.
                 * @member {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.Type} type
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @instance
                 */
                StartFullAutoTuning.prototype.type = 0;

                /**
                 * StartFullAutoTuning controllerType.
                 * @member {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.ControllerType} controllerType
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @instance
                 */
                StartFullAutoTuning.prototype.controllerType = 0;

                /**
                 * Creates a new StartFullAutoTuning instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning} StartFullAutoTuning instance
                 */
                StartFullAutoTuning.create = function create(properties) {
                    return new StartFullAutoTuning(properties);
                };

                /**
                 * Encodes the specified StartFullAutoTuning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning} message StartFullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartFullAutoTuning.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                    if (message.controllerType != null && Object.hasOwnProperty.call(message, "controllerType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.controllerType);
                    return writer;
                };

                /**
                 * Encodes the specified StartFullAutoTuning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartFullAutoTuning} message StartFullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartFullAutoTuning.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartFullAutoTuning message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning} StartFullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartFullAutoTuning.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.type = reader.int32();
                                break;
                            }
                        case 3: {
                                message.controllerType = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartFullAutoTuning message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning} StartFullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartFullAutoTuning.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartFullAutoTuning message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartFullAutoTuning.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        switch (message.controllerType) {
                        default:
                            return "controllerType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a StartFullAutoTuning message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning} StartFullAutoTuning
                 */
                StartFullAutoTuning.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "POSITION":
                    case 0:
                        message.type = 0;
                        break;
                    case "VELOCITY":
                    case 1:
                        message.type = 1;
                        break;
                    }
                    switch (object.controllerType) {
                    default:
                        if (typeof object.controllerType === "number") {
                            message.controllerType = object.controllerType;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.controllerType = 0;
                        break;
                    case "PI_P":
                    case 1:
                        message.controllerType = 1;
                        break;
                    case "P_PI":
                    case 2:
                        message.controllerType = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartFullAutoTuning message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartFullAutoTuning} message StartFullAutoTuning
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartFullAutoTuning.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.type = options.enums === String ? "POSITION" : 0;
                        object.controllerType = options.enums === String ? "UNSPECIFIED" : 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.Type[message.type] === undefined ? message.type : $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.Type[message.type] : message.type;
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        object.controllerType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.ControllerType[message.controllerType] === undefined ? message.controllerType : $root.motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.ControllerType[message.controllerType] : message.controllerType;
                    return object;
                };

                /**
                 * Converts this StartFullAutoTuning to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartFullAutoTuning.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartFullAutoTuning
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartFullAutoTuning
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartFullAutoTuning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartFullAutoTuning";
                };

                /**
                 * Type enum.
                 * @name motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.Type
                 * @enum {number}
                 * @property {number} POSITION=0 POSITION value
                 * @property {number} VELOCITY=1 VELOCITY value
                 */
                StartFullAutoTuning.Type = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "POSITION"] = 0;
                    values[valuesById[1] = "VELOCITY"] = 1;
                    return values;
                })();

                /**
                 * ControllerType enum.
                 * @name motionmaster.MotionMasterMessage.Request.StartFullAutoTuning.ControllerType
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} PI_P=1 PI_P value
                 * @property {number} P_PI=2 P_PI value
                 */
                StartFullAutoTuning.ControllerType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PI_P"] = 1;
                    values[valuesById[2] = "P_PI"] = 2;
                    return values;
                })();

                return StartFullAutoTuning;
            })();

            Request.StopFullAutoTuning = (function() {

                /**
                 * Properties of a StopFullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStopFullAutoTuning
                 * @property {number|null} [deviceAddress] StopFullAutoTuning deviceAddress
                 */

                /**
                 * Constructs a new StopFullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StopFullAutoTuning.
                 * @implements IStopFullAutoTuning
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning=} [properties] Properties to set
                 */
                function StopFullAutoTuning(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StopFullAutoTuning deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @instance
                 */
                StopFullAutoTuning.prototype.deviceAddress = 0;

                /**
                 * Creates a new StopFullAutoTuning instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StopFullAutoTuning} StopFullAutoTuning instance
                 */
                StopFullAutoTuning.create = function create(properties) {
                    return new StopFullAutoTuning(properties);
                };

                /**
                 * Encodes the specified StopFullAutoTuning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning} message StopFullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopFullAutoTuning.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified StopFullAutoTuning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopFullAutoTuning.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopFullAutoTuning} message StopFullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopFullAutoTuning.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StopFullAutoTuning message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StopFullAutoTuning} StopFullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopFullAutoTuning.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StopFullAutoTuning message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StopFullAutoTuning} StopFullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopFullAutoTuning.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StopFullAutoTuning message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StopFullAutoTuning.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a StopFullAutoTuning message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StopFullAutoTuning} StopFullAutoTuning
                 */
                StopFullAutoTuning.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StopFullAutoTuning();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StopFullAutoTuning message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StopFullAutoTuning} message StopFullAutoTuning
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StopFullAutoTuning.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this StopFullAutoTuning to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StopFullAutoTuning.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StopFullAutoTuning
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StopFullAutoTuning
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StopFullAutoTuning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StopFullAutoTuning";
                };

                return StopFullAutoTuning;
            })();

            Request.StartCirculoEncoderConfiguration = (function() {

                /**
                 * Properties of a StartCirculoEncoderConfiguration.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartCirculoEncoderConfiguration
                 * @property {number|null} [deviceAddress] StartCirculoEncoderConfiguration deviceAddress
                 * @property {number|null} [encoderOrdinal] StartCirculoEncoderConfiguration encoderOrdinal
                 * @property {number|null} [batteryModeMaxAcceleration] StartCirculoEncoderConfiguration batteryModeMaxAcceleration
                 * @property {number|null} [externalCirculoType] StartCirculoEncoderConfiguration externalCirculoType
                 */

                /**
                 * Constructs a new StartCirculoEncoderConfiguration.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartCirculoEncoderConfiguration.
                 * @implements IStartCirculoEncoderConfiguration
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration=} [properties] Properties to set
                 */
                function StartCirculoEncoderConfiguration(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartCirculoEncoderConfiguration deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @instance
                 */
                StartCirculoEncoderConfiguration.prototype.deviceAddress = 0;

                /**
                 * StartCirculoEncoderConfiguration encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @instance
                 */
                StartCirculoEncoderConfiguration.prototype.encoderOrdinal = 0;

                /**
                 * StartCirculoEncoderConfiguration batteryModeMaxAcceleration.
                 * @member {number} batteryModeMaxAcceleration
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @instance
                 */
                StartCirculoEncoderConfiguration.prototype.batteryModeMaxAcceleration = 0;

                /**
                 * StartCirculoEncoderConfiguration externalCirculoType.
                 * @member {number} externalCirculoType
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @instance
                 */
                StartCirculoEncoderConfiguration.prototype.externalCirculoType = 0;

                /**
                 * Creates a new StartCirculoEncoderConfiguration instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration} StartCirculoEncoderConfiguration instance
                 */
                StartCirculoEncoderConfiguration.create = function create(properties) {
                    return new StartCirculoEncoderConfiguration(properties);
                };

                /**
                 * Encodes the specified StartCirculoEncoderConfiguration message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration} message StartCirculoEncoderConfiguration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCirculoEncoderConfiguration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.batteryModeMaxAcceleration != null && Object.hasOwnProperty.call(message, "batteryModeMaxAcceleration"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.batteryModeMaxAcceleration);
                    if (message.externalCirculoType != null && Object.hasOwnProperty.call(message, "externalCirculoType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.externalCirculoType);
                    return writer;
                };

                /**
                 * Encodes the specified StartCirculoEncoderConfiguration message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartCirculoEncoderConfiguration} message StartCirculoEncoderConfiguration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartCirculoEncoderConfiguration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartCirculoEncoderConfiguration message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration} StartCirculoEncoderConfiguration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCirculoEncoderConfiguration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.batteryModeMaxAcceleration = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.externalCirculoType = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartCirculoEncoderConfiguration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration} StartCirculoEncoderConfiguration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartCirculoEncoderConfiguration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartCirculoEncoderConfiguration message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartCirculoEncoderConfiguration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.batteryModeMaxAcceleration != null && message.hasOwnProperty("batteryModeMaxAcceleration"))
                        if (!$util.isInteger(message.batteryModeMaxAcceleration))
                            return "batteryModeMaxAcceleration: integer expected";
                    if (message.externalCirculoType != null && message.hasOwnProperty("externalCirculoType"))
                        if (!$util.isInteger(message.externalCirculoType))
                            return "externalCirculoType: integer expected";
                    return null;
                };

                /**
                 * Creates a StartCirculoEncoderConfiguration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration} StartCirculoEncoderConfiguration
                 */
                StartCirculoEncoderConfiguration.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.batteryModeMaxAcceleration != null)
                        message.batteryModeMaxAcceleration = object.batteryModeMaxAcceleration >>> 0;
                    if (object.externalCirculoType != null)
                        message.externalCirculoType = object.externalCirculoType >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StartCirculoEncoderConfiguration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration} message StartCirculoEncoderConfiguration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartCirculoEncoderConfiguration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                        object.batteryModeMaxAcceleration = 0;
                        object.externalCirculoType = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.batteryModeMaxAcceleration != null && message.hasOwnProperty("batteryModeMaxAcceleration"))
                        object.batteryModeMaxAcceleration = message.batteryModeMaxAcceleration;
                    if (message.externalCirculoType != null && message.hasOwnProperty("externalCirculoType"))
                        object.externalCirculoType = message.externalCirculoType;
                    return object;
                };

                /**
                 * Converts this StartCirculoEncoderConfiguration to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartCirculoEncoderConfiguration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartCirculoEncoderConfiguration
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartCirculoEncoderConfiguration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartCirculoEncoderConfiguration";
                };

                return StartCirculoEncoderConfiguration;
            })();

            Request.StopCirculoEncoderNarrowAngleCalibrationProcedure = (function() {

                /**
                 * Properties of a StopCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @property {number|null} [deviceAddress] StopCirculoEncoderNarrowAngleCalibrationProcedure deviceAddress
                 * @property {number|null} [encoderOrdinal] StopCirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal
                 */

                /**
                 * Constructs a new StopCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StopCirculoEncoderNarrowAngleCalibrationProcedure.
                 * @implements IStopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 */
                function StopCirculoEncoderNarrowAngleCalibrationProcedure(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StopCirculoEncoderNarrowAngleCalibrationProcedure deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.prototype.deviceAddress = 0;

                /**
                 * StopCirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.prototype.encoderOrdinal = 0;

                /**
                 * Creates a new StopCirculoEncoderNarrowAngleCalibrationProcedure instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure} StopCirculoEncoderNarrowAngleCalibrationProcedure instance
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.create = function create(properties) {
                    return new StopCirculoEncoderNarrowAngleCalibrationProcedure(properties);
                };

                /**
                 * Encodes the specified StopCirculoEncoderNarrowAngleCalibrationProcedure message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure} message StopCirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    return writer;
                };

                /**
                 * Encodes the specified StopCirculoEncoderNarrowAngleCalibrationProcedure message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStopCirculoEncoderNarrowAngleCalibrationProcedure} message StopCirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StopCirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure} StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StopCirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure} StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StopCirculoEncoderNarrowAngleCalibrationProcedure message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    return null;
                };

                /**
                 * Creates a StopCirculoEncoderNarrowAngleCalibrationProcedure message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure} StopCirculoEncoderNarrowAngleCalibrationProcedure
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StopCirculoEncoderNarrowAngleCalibrationProcedure message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure} message StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    return object;
                };

                /**
                 * Converts this StopCirculoEncoderNarrowAngleCalibrationProcedure to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StopCirculoEncoderNarrowAngleCalibrationProcedure.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StopCirculoEncoderNarrowAngleCalibrationProcedure";
                };

                return StopCirculoEncoderNarrowAngleCalibrationProcedure;
            })();

            Request.StartOsCommand = (function() {

                /**
                 * Properties of a StartOsCommand.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IStartOsCommand
                 * @property {number|null} [deviceAddress] StartOsCommand deviceAddress
                 * @property {number|null} [timeoutMs] StartOsCommand timeoutMs
                 * @property {Uint8Array|null} [command] StartOsCommand command
                 */

                /**
                 * Constructs a new StartOsCommand.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a StartOsCommand.
                 * @implements IStartOsCommand
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOsCommand=} [properties] Properties to set
                 */
                function StartOsCommand(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartOsCommand deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @instance
                 */
                StartOsCommand.prototype.deviceAddress = 0;

                /**
                 * StartOsCommand timeoutMs.
                 * @member {number} timeoutMs
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @instance
                 */
                StartOsCommand.prototype.timeoutMs = 0;

                /**
                 * StartOsCommand command.
                 * @member {Uint8Array} command
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @instance
                 */
                StartOsCommand.prototype.command = $util.newBuffer([]);

                /**
                 * Creates a new StartOsCommand instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOsCommand=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOsCommand} StartOsCommand instance
                 */
                StartOsCommand.create = function create(properties) {
                    return new StartOsCommand(properties);
                };

                /**
                 * Encodes the specified StartOsCommand message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOsCommand.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOsCommand} message StartOsCommand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOsCommand.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.timeoutMs != null && Object.hasOwnProperty.call(message, "timeoutMs"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.timeoutMs);
                    if (message.command != null && Object.hasOwnProperty.call(message, "command"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.command);
                    return writer;
                };

                /**
                 * Encodes the specified StartOsCommand message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.StartOsCommand.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IStartOsCommand} message StartOsCommand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartOsCommand.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartOsCommand message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOsCommand} StartOsCommand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOsCommand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.StartOsCommand();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.timeoutMs = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.command = reader.bytes();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartOsCommand message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOsCommand} StartOsCommand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartOsCommand.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartOsCommand message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartOsCommand.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.timeoutMs != null && message.hasOwnProperty("timeoutMs"))
                        if (!$util.isInteger(message.timeoutMs))
                            return "timeoutMs: integer expected";
                    if (message.command != null && message.hasOwnProperty("command"))
                        if (!(message.command && typeof message.command.length === "number" || $util.isString(message.command)))
                            return "command: buffer expected";
                    return null;
                };

                /**
                 * Creates a StartOsCommand message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.StartOsCommand} StartOsCommand
                 */
                StartOsCommand.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.StartOsCommand)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.StartOsCommand();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.timeoutMs != null)
                        message.timeoutMs = object.timeoutMs >>> 0;
                    if (object.command != null)
                        if (typeof object.command === "string")
                            $util.base64.decode(object.command, message.command = $util.newBuffer($util.base64.length(object.command)), 0);
                        else if (object.command.length >= 0)
                            message.command = object.command;
                    return message;
                };

                /**
                 * Creates a plain object from a StartOsCommand message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.StartOsCommand} message StartOsCommand
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartOsCommand.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.timeoutMs = 0;
                        if (options.bytes === String)
                            object.command = "";
                        else {
                            object.command = [];
                            if (options.bytes !== Array)
                                object.command = $util.newBuffer(object.command);
                        }
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.timeoutMs != null && message.hasOwnProperty("timeoutMs"))
                        object.timeoutMs = message.timeoutMs;
                    if (message.command != null && message.hasOwnProperty("command"))
                        object.command = options.bytes === String ? $util.base64.encode(message.command, 0, message.command.length) : options.bytes === Array ? Array.prototype.slice.call(message.command) : message.command;
                    return object;
                };

                /**
                 * Converts this StartOsCommand to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartOsCommand.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StartOsCommand
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.StartOsCommand
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StartOsCommand.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.StartOsCommand";
                };

                return StartOsCommand;
            })();

            Request.ExecuteForwardCall = (function() {

                /**
                 * Properties of an ExecuteForwardCall.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IExecuteForwardCall
                 * @property {Uint8Array|null} [message] ExecuteForwardCall message
                 */

                /**
                 * Constructs a new ExecuteForwardCall.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents an ExecuteForwardCall.
                 * @implements IExecuteForwardCall
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall=} [properties] Properties to set
                 */
                function ExecuteForwardCall(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExecuteForwardCall message.
                 * @member {Uint8Array} message
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @instance
                 */
                ExecuteForwardCall.prototype.message = $util.newBuffer([]);

                /**
                 * Creates a new ExecuteForwardCall instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.ExecuteForwardCall} ExecuteForwardCall instance
                 */
                ExecuteForwardCall.create = function create(properties) {
                    return new ExecuteForwardCall(properties);
                };

                /**
                 * Encodes the specified ExecuteForwardCall message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall} message ExecuteForwardCall message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteForwardCall.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.message);
                    return writer;
                };

                /**
                 * Encodes the specified ExecuteForwardCall message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.ExecuteForwardCall.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IExecuteForwardCall} message ExecuteForwardCall message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteForwardCall.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExecuteForwardCall message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.ExecuteForwardCall} ExecuteForwardCall
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteForwardCall.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.message = reader.bytes();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExecuteForwardCall message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.ExecuteForwardCall} ExecuteForwardCall
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteForwardCall.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExecuteForwardCall message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExecuteForwardCall.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                            return "message: buffer expected";
                    return null;
                };

                /**
                 * Creates an ExecuteForwardCall message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.ExecuteForwardCall} ExecuteForwardCall
                 */
                ExecuteForwardCall.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.ExecuteForwardCall();
                    if (object.message != null)
                        if (typeof object.message === "string")
                            $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
                        else if (object.message.length >= 0)
                            message.message = object.message;
                    return message;
                };

                /**
                 * Creates a plain object from an ExecuteForwardCall message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ExecuteForwardCall} message ExecuteForwardCall
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExecuteForwardCall.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        if (options.bytes === String)
                            object.message = "";
                        else {
                            object.message = [];
                            if (options.bytes !== Array)
                                object.message = $util.newBuffer(object.message);
                        }
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
                    return object;
                };

                /**
                 * Converts this ExecuteForwardCall to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExecuteForwardCall.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ExecuteForwardCall
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.ExecuteForwardCall
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ExecuteForwardCall.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.ExecuteForwardCall";
                };

                return ExecuteForwardCall;
            })();

            Request.GetSystemInformation = (function() {

                /**
                 * Properties of a GetSystemInformation.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetSystemInformation
                 */

                /**
                 * Constructs a new GetSystemInformation.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetSystemInformation.
                 * @implements IGetSystemInformation
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemInformation=} [properties] Properties to set
                 */
                function GetSystemInformation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new GetSystemInformation instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemInformation=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemInformation} GetSystemInformation instance
                 */
                GetSystemInformation.create = function create(properties) {
                    return new GetSystemInformation(properties);
                };

                /**
                 * Encodes the specified GetSystemInformation message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemInformation.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemInformation} message GetSystemInformation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemInformation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified GetSystemInformation message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetSystemInformation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetSystemInformation} message GetSystemInformation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetSystemInformation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetSystemInformation message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemInformation} GetSystemInformation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemInformation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetSystemInformation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemInformation} GetSystemInformation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetSystemInformation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetSystemInformation message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetSystemInformation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a GetSystemInformation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetSystemInformation} GetSystemInformation
                 */
                GetSystemInformation.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Request.GetSystemInformation();
                };

                /**
                 * Creates a plain object from a GetSystemInformation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetSystemInformation} message GetSystemInformation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetSystemInformation.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this GetSystemInformation to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetSystemInformation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetSystemInformation
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetSystemInformation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetSystemInformation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetSystemInformation";
                };

                return GetSystemInformation;
            })();

            Request.SetPdoMode = (function() {

                /**
                 * Properties of a SetPdoMode.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface ISetPdoMode
                 * @property {number|null} [deviceAddress] SetPdoMode deviceAddress
                 * @property {number|null} [mode] SetPdoMode mode
                 */

                /**
                 * Constructs a new SetPdoMode.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a SetPdoMode.
                 * @implements ISetPdoMode
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.ISetPdoMode=} [properties] Properties to set
                 */
                function SetPdoMode(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetPdoMode deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @instance
                 */
                SetPdoMode.prototype.deviceAddress = 0;

                /**
                 * SetPdoMode mode.
                 * @member {number} mode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @instance
                 */
                SetPdoMode.prototype.mode = 0;

                /**
                 * Creates a new SetPdoMode instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetPdoMode=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.SetPdoMode} SetPdoMode instance
                 */
                SetPdoMode.create = function create(properties) {
                    return new SetPdoMode(properties);
                };

                /**
                 * Encodes the specified SetPdoMode message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetPdoMode.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetPdoMode} message SetPdoMode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetPdoMode.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.mode);
                    return writer;
                };

                /**
                 * Encodes the specified SetPdoMode message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.SetPdoMode.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.ISetPdoMode} message SetPdoMode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetPdoMode.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetPdoMode message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.SetPdoMode} SetPdoMode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetPdoMode.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.SetPdoMode();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.mode = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetPdoMode message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.SetPdoMode} SetPdoMode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetPdoMode.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetPdoMode message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetPdoMode.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.mode != null && message.hasOwnProperty("mode"))
                        if (!$util.isInteger(message.mode))
                            return "mode: integer expected";
                    return null;
                };

                /**
                 * Creates a SetPdoMode message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.SetPdoMode} SetPdoMode
                 */
                SetPdoMode.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.SetPdoMode)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.SetPdoMode();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.mode != null)
                        message.mode = object.mode >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SetPdoMode message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.SetPdoMode} message SetPdoMode
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetPdoMode.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.mode = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.mode != null && message.hasOwnProperty("mode"))
                        object.mode = message.mode;
                    return object;
                };

                /**
                 * Converts this SetPdoMode to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetPdoMode.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SetPdoMode
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.SetPdoMode
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SetPdoMode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.SetPdoMode";
                };

                return SetPdoMode;
            })();

            Request.GetDeviceSii = (function() {

                /**
                 * Properties of a GetDeviceSii.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @interface IGetDeviceSii
                 * @property {number|null} [deviceAddress] GetDeviceSii deviceAddress
                 */

                /**
                 * Constructs a new GetDeviceSii.
                 * @memberof motionmaster.MotionMasterMessage.Request
                 * @classdesc Represents a GetDeviceSii.
                 * @implements IGetDeviceSii
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceSii=} [properties] Properties to set
                 */
                function GetDeviceSii(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetDeviceSii deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @instance
                 */
                GetDeviceSii.prototype.deviceAddress = 0;

                /**
                 * Creates a new GetDeviceSii instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceSii=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceSii} GetDeviceSii instance
                 */
                GetDeviceSii.create = function create(properties) {
                    return new GetDeviceSii(properties);
                };

                /**
                 * Encodes the specified GetDeviceSii message. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceSii.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceSii} message GetDeviceSii message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceSii.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    return writer;
                };

                /**
                 * Encodes the specified GetDeviceSii message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Request.GetDeviceSii.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.IGetDeviceSii} message GetDeviceSii message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetDeviceSii.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetDeviceSii message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceSii} GetDeviceSii
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceSii.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetDeviceSii message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceSii} GetDeviceSii
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetDeviceSii.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetDeviceSii message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetDeviceSii.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    return null;
                };

                /**
                 * Creates a GetDeviceSii message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Request.GetDeviceSii} GetDeviceSii
                 */
                GetDeviceSii.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Request.GetDeviceSii();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    return message;
                };

                /**
                 * Creates a plain object from a GetDeviceSii message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Request.GetDeviceSii} message GetDeviceSii
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetDeviceSii.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    return object;
                };

                /**
                 * Converts this GetDeviceSii to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetDeviceSii.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for GetDeviceSii
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Request.GetDeviceSii
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                GetDeviceSii.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Request.GetDeviceSii";
                };

                return GetDeviceSii;
            })();

            return Request;
        })();

        MotionMasterMessage.Status = (function() {

            /**
             * Properties of a Status.
             * @memberof motionmaster.MotionMasterMessage
             * @interface IStatus
             * @property {motionmaster.MotionMasterMessage.Status.ISystemPong|null} [systemPong] Status systemPong
             * @property {motionmaster.MotionMasterMessage.Status.ISystemVersion|null} [systemVersion] Status systemVersion
             * @property {motionmaster.MotionMasterMessage.Status.ISystemEvent|null} [systemEvent] Status systemEvent
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceInfo|null} [deviceInfo] Status deviceInfo
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo|null} [deviceParameterInfo] Status deviceParameterInfo
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues|null} [deviceParameterValues] Status deviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues|null} [multiDeviceParameterValues] Status multiDeviceParameterValues
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceFileList|null} [deviceFileList] Status deviceFileList
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceFile|null} [deviceFile] Status deviceFile
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceEvent|null} [deviceEvent] Status deviceEvent
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation|null} [deviceFirmwareInstallation] Status deviceFirmwareInstallation
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceLog|null} [deviceLog] Status deviceLog
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset|null} [deviceFaultReset] Status deviceFaultReset
             * @property {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording|null} [coggingTorqueRecording] Status coggingTorqueRecording
             * @property {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData|null} [coggingTorqueData] Status coggingTorqueData
             * @property {motionmaster.MotionMasterMessage.Status.IOffsetDetection|null} [offsetDetection] Status offsetDetection
             * @property {motionmaster.MotionMasterMessage.Status.IPlantIdentification|null} [plantIdentification] Status plantIdentification
             * @property {motionmaster.MotionMasterMessage.Status.IAutoTuning|null} [autoTuning] Status autoTuning
             * @property {motionmaster.MotionMasterMessage.Status.IMotionController|null} [motionController] Status motionController
             * @property {motionmaster.MotionMasterMessage.Status.ISignalGenerator|null} [signalGenerator] Status signalGenerator
             * @property {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues|null} [monitoringParameterValues] Status monitoringParameterValues
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceStop|null} [deviceStop] Status deviceStop
             * @property {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState|null} [ethercatNetworkState] Status ethercatNetworkState
             * @property {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration|null} [narrowAngleCalibration] Status narrowAngleCalibration
             * @property {motionmaster.MotionMasterMessage.Status.ISystemIdentification|null} [systemIdentification] Status systemIdentification
             * @property {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance|null} [circuloEncoderMagnetDistance] Status circuloEncoderMagnetDistance
             * @property {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure|null} [circuloEncoderNarrowAngleCalibrationProcedure] Status circuloEncoderNarrowAngleCalibrationProcedure
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State|null} [deviceCia402State] Status deviceCia402State
             * @property {motionmaster.MotionMasterMessage.Status.ISystemLog|null} [systemLog] Status systemLog
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore|null} [deviceSiiRestore] Status deviceSiiRestore
             * @property {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl|null} [openLoopFieldControl] Status openLoopFieldControl
             * @property {motionmaster.MotionMasterMessage.Status.IFullAutoTuning|null} [fullAutoTuning] Status fullAutoTuning
             * @property {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration|null} [circuloEncoderConfiguration] Status circuloEncoderConfiguration
             * @property {motionmaster.MotionMasterMessage.Status.IOsCommand|null} [osCommand] Status osCommand
             * @property {motionmaster.MotionMasterMessage.Status.IForwardCall|null} [forwardCall] Status forwardCall
             * @property {motionmaster.MotionMasterMessage.Status.ISystemInformation|null} [systemInformation] Status systemInformation
             * @property {motionmaster.MotionMasterMessage.Status.IPdoMode|null} [pdoMode] Status pdoMode
             * @property {motionmaster.MotionMasterMessage.Status.IDeviceSii|null} [deviceSii] Status deviceSii
             */

            /**
             * Constructs a new Status.
             * @memberof motionmaster.MotionMasterMessage
             * @classdesc Represents a Status.
             * @implements IStatus
             * @constructor
             * @param {motionmaster.MotionMasterMessage.IStatus=} [properties] Properties to set
             */
            function Status(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Status systemPong.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemPong|null|undefined} systemPong
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemPong = null;

            /**
             * Status systemVersion.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemVersion|null|undefined} systemVersion
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemVersion = null;

            /**
             * Status systemEvent.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemEvent|null|undefined} systemEvent
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemEvent = null;

            /**
             * Status deviceInfo.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceInfo|null|undefined} deviceInfo
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceInfo = null;

            /**
             * Status deviceParameterInfo.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo|null|undefined} deviceParameterInfo
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceParameterInfo = null;

            /**
             * Status deviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues|null|undefined} deviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceParameterValues = null;

            /**
             * Status multiDeviceParameterValues.
             * @member {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues|null|undefined} multiDeviceParameterValues
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.multiDeviceParameterValues = null;

            /**
             * Status deviceFileList.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceFileList|null|undefined} deviceFileList
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceFileList = null;

            /**
             * Status deviceFile.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceFile|null|undefined} deviceFile
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceFile = null;

            /**
             * Status deviceEvent.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceEvent|null|undefined} deviceEvent
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceEvent = null;

            /**
             * Status deviceFirmwareInstallation.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation|null|undefined} deviceFirmwareInstallation
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceFirmwareInstallation = null;

            /**
             * Status deviceLog.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceLog|null|undefined} deviceLog
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceLog = null;

            /**
             * Status deviceFaultReset.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset|null|undefined} deviceFaultReset
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceFaultReset = null;

            /**
             * Status coggingTorqueRecording.
             * @member {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording|null|undefined} coggingTorqueRecording
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.coggingTorqueRecording = null;

            /**
             * Status coggingTorqueData.
             * @member {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData|null|undefined} coggingTorqueData
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.coggingTorqueData = null;

            /**
             * Status offsetDetection.
             * @member {motionmaster.MotionMasterMessage.Status.IOffsetDetection|null|undefined} offsetDetection
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.offsetDetection = null;

            /**
             * Status plantIdentification.
             * @member {motionmaster.MotionMasterMessage.Status.IPlantIdentification|null|undefined} plantIdentification
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.plantIdentification = null;

            /**
             * Status autoTuning.
             * @member {motionmaster.MotionMasterMessage.Status.IAutoTuning|null|undefined} autoTuning
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.autoTuning = null;

            /**
             * Status motionController.
             * @member {motionmaster.MotionMasterMessage.Status.IMotionController|null|undefined} motionController
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.motionController = null;

            /**
             * Status signalGenerator.
             * @member {motionmaster.MotionMasterMessage.Status.ISignalGenerator|null|undefined} signalGenerator
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.signalGenerator = null;

            /**
             * Status monitoringParameterValues.
             * @member {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues|null|undefined} monitoringParameterValues
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.monitoringParameterValues = null;

            /**
             * Status deviceStop.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceStop|null|undefined} deviceStop
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceStop = null;

            /**
             * Status ethercatNetworkState.
             * @member {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState|null|undefined} ethercatNetworkState
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.ethercatNetworkState = null;

            /**
             * Status narrowAngleCalibration.
             * @member {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration|null|undefined} narrowAngleCalibration
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.narrowAngleCalibration = null;

            /**
             * Status systemIdentification.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemIdentification|null|undefined} systemIdentification
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemIdentification = null;

            /**
             * Status circuloEncoderMagnetDistance.
             * @member {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance|null|undefined} circuloEncoderMagnetDistance
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.circuloEncoderMagnetDistance = null;

            /**
             * Status circuloEncoderNarrowAngleCalibrationProcedure.
             * @member {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure|null|undefined} circuloEncoderNarrowAngleCalibrationProcedure
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.circuloEncoderNarrowAngleCalibrationProcedure = null;

            /**
             * Status deviceCia402State.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State|null|undefined} deviceCia402State
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceCia402State = null;

            /**
             * Status systemLog.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemLog|null|undefined} systemLog
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemLog = null;

            /**
             * Status deviceSiiRestore.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore|null|undefined} deviceSiiRestore
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceSiiRestore = null;

            /**
             * Status openLoopFieldControl.
             * @member {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl|null|undefined} openLoopFieldControl
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.openLoopFieldControl = null;

            /**
             * Status fullAutoTuning.
             * @member {motionmaster.MotionMasterMessage.Status.IFullAutoTuning|null|undefined} fullAutoTuning
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.fullAutoTuning = null;

            /**
             * Status circuloEncoderConfiguration.
             * @member {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration|null|undefined} circuloEncoderConfiguration
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.circuloEncoderConfiguration = null;

            /**
             * Status osCommand.
             * @member {motionmaster.MotionMasterMessage.Status.IOsCommand|null|undefined} osCommand
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.osCommand = null;

            /**
             * Status forwardCall.
             * @member {motionmaster.MotionMasterMessage.Status.IForwardCall|null|undefined} forwardCall
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.forwardCall = null;

            /**
             * Status systemInformation.
             * @member {motionmaster.MotionMasterMessage.Status.ISystemInformation|null|undefined} systemInformation
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.systemInformation = null;

            /**
             * Status pdoMode.
             * @member {motionmaster.MotionMasterMessage.Status.IPdoMode|null|undefined} pdoMode
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.pdoMode = null;

            /**
             * Status deviceSii.
             * @member {motionmaster.MotionMasterMessage.Status.IDeviceSii|null|undefined} deviceSii
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Status.prototype.deviceSii = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Status type.
             * @member {"systemPong"|"systemVersion"|"systemEvent"|"deviceInfo"|"deviceParameterInfo"|"deviceParameterValues"|"multiDeviceParameterValues"|"deviceFileList"|"deviceFile"|"deviceEvent"|"deviceFirmwareInstallation"|"deviceLog"|"deviceFaultReset"|"coggingTorqueRecording"|"coggingTorqueData"|"offsetDetection"|"plantIdentification"|"autoTuning"|"motionController"|"signalGenerator"|"monitoringParameterValues"|"deviceStop"|"ethercatNetworkState"|"narrowAngleCalibration"|"systemIdentification"|"circuloEncoderMagnetDistance"|"circuloEncoderNarrowAngleCalibrationProcedure"|"deviceCia402State"|"systemLog"|"deviceSiiRestore"|"openLoopFieldControl"|"fullAutoTuning"|"circuloEncoderConfiguration"|"osCommand"|"forwardCall"|"systemInformation"|"pdoMode"|"deviceSii"|undefined} type
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             */
            Object.defineProperty(Status.prototype, "type", {
                get: $util.oneOfGetter($oneOfFields = ["systemPong", "systemVersion", "systemEvent", "deviceInfo", "deviceParameterInfo", "deviceParameterValues", "multiDeviceParameterValues", "deviceFileList", "deviceFile", "deviceEvent", "deviceFirmwareInstallation", "deviceLog", "deviceFaultReset", "coggingTorqueRecording", "coggingTorqueData", "offsetDetection", "plantIdentification", "autoTuning", "motionController", "signalGenerator", "monitoringParameterValues", "deviceStop", "ethercatNetworkState", "narrowAngleCalibration", "systemIdentification", "circuloEncoderMagnetDistance", "circuloEncoderNarrowAngleCalibrationProcedure", "deviceCia402State", "systemLog", "deviceSiiRestore", "openLoopFieldControl", "fullAutoTuning", "circuloEncoderConfiguration", "osCommand", "forwardCall", "systemInformation", "pdoMode", "deviceSii"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Status instance using the specified properties.
             * @function create
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {motionmaster.MotionMasterMessage.IStatus=} [properties] Properties to set
             * @returns {motionmaster.MotionMasterMessage.Status} Status instance
             */
            Status.create = function create(properties) {
                return new Status(properties);
            };

            /**
             * Encodes the specified Status message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.verify|verify} messages.
             * @function encode
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {motionmaster.MotionMasterMessage.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.systemPong != null && Object.hasOwnProperty.call(message, "systemPong"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemPong.encode(message.systemPong, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
                if (message.systemVersion != null && Object.hasOwnProperty.call(message, "systemVersion"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemVersion.encode(message.systemVersion, writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
                if (message.systemEvent != null && Object.hasOwnProperty.call(message, "systemEvent"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemEvent.encode(message.systemEvent, writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
                if (message.deviceInfo != null && Object.hasOwnProperty.call(message, "deviceInfo"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.encode(message.deviceInfo, writer.uint32(/* id 104, wireType 2 =*/834).fork()).ldelim();
                if (message.deviceParameterInfo != null && Object.hasOwnProperty.call(message, "deviceParameterInfo"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.encode(message.deviceParameterInfo, writer.uint32(/* id 105, wireType 2 =*/842).fork()).ldelim();
                if (message.deviceParameterValues != null && Object.hasOwnProperty.call(message, "deviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.encode(message.deviceParameterValues, writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
                if (message.multiDeviceParameterValues != null && Object.hasOwnProperty.call(message, "multiDeviceParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.encode(message.multiDeviceParameterValues, writer.uint32(/* id 107, wireType 2 =*/858).fork()).ldelim();
                if (message.deviceFileList != null && Object.hasOwnProperty.call(message, "deviceFileList"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.encode(message.deviceFileList, writer.uint32(/* id 108, wireType 2 =*/866).fork()).ldelim();
                if (message.deviceFile != null && Object.hasOwnProperty.call(message, "deviceFile"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceFile.encode(message.deviceFile, writer.uint32(/* id 109, wireType 2 =*/874).fork()).ldelim();
                if (message.deviceEvent != null && Object.hasOwnProperty.call(message, "deviceEvent"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.encode(message.deviceEvent, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
                if (message.deviceFirmwareInstallation != null && Object.hasOwnProperty.call(message, "deviceFirmwareInstallation"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.encode(message.deviceFirmwareInstallation, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
                if (message.deviceLog != null && Object.hasOwnProperty.call(message, "deviceLog"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceLog.encode(message.deviceLog, writer.uint32(/* id 112, wireType 2 =*/898).fork()).ldelim();
                if (message.deviceFaultReset != null && Object.hasOwnProperty.call(message, "deviceFaultReset"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.encode(message.deviceFaultReset, writer.uint32(/* id 113, wireType 2 =*/906).fork()).ldelim();
                if (message.coggingTorqueRecording != null && Object.hasOwnProperty.call(message, "coggingTorqueRecording"))
                    $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.encode(message.coggingTorqueRecording, writer.uint32(/* id 114, wireType 2 =*/914).fork()).ldelim();
                if (message.coggingTorqueData != null && Object.hasOwnProperty.call(message, "coggingTorqueData"))
                    $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.encode(message.coggingTorqueData, writer.uint32(/* id 115, wireType 2 =*/922).fork()).ldelim();
                if (message.offsetDetection != null && Object.hasOwnProperty.call(message, "offsetDetection"))
                    $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.encode(message.offsetDetection, writer.uint32(/* id 116, wireType 2 =*/930).fork()).ldelim();
                if (message.plantIdentification != null && Object.hasOwnProperty.call(message, "plantIdentification"))
                    $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.encode(message.plantIdentification, writer.uint32(/* id 117, wireType 2 =*/938).fork()).ldelim();
                if (message.autoTuning != null && Object.hasOwnProperty.call(message, "autoTuning"))
                    $root.motionmaster.MotionMasterMessage.Status.AutoTuning.encode(message.autoTuning, writer.uint32(/* id 118, wireType 2 =*/946).fork()).ldelim();
                if (message.motionController != null && Object.hasOwnProperty.call(message, "motionController"))
                    $root.motionmaster.MotionMasterMessage.Status.MotionController.encode(message.motionController, writer.uint32(/* id 119, wireType 2 =*/954).fork()).ldelim();
                if (message.signalGenerator != null && Object.hasOwnProperty.call(message, "signalGenerator"))
                    $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.encode(message.signalGenerator, writer.uint32(/* id 120, wireType 2 =*/962).fork()).ldelim();
                if (message.monitoringParameterValues != null && Object.hasOwnProperty.call(message, "monitoringParameterValues"))
                    $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.encode(message.monitoringParameterValues, writer.uint32(/* id 121, wireType 2 =*/970).fork()).ldelim();
                if (message.deviceStop != null && Object.hasOwnProperty.call(message, "deviceStop"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceStop.encode(message.deviceStop, writer.uint32(/* id 122, wireType 2 =*/978).fork()).ldelim();
                if (message.ethercatNetworkState != null && Object.hasOwnProperty.call(message, "ethercatNetworkState"))
                    $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.encode(message.ethercatNetworkState, writer.uint32(/* id 123, wireType 2 =*/986).fork()).ldelim();
                if (message.narrowAngleCalibration != null && Object.hasOwnProperty.call(message, "narrowAngleCalibration"))
                    $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.encode(message.narrowAngleCalibration, writer.uint32(/* id 124, wireType 2 =*/994).fork()).ldelim();
                if (message.systemIdentification != null && Object.hasOwnProperty.call(message, "systemIdentification"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.encode(message.systemIdentification, writer.uint32(/* id 125, wireType 2 =*/1002).fork()).ldelim();
                if (message.circuloEncoderMagnetDistance != null && Object.hasOwnProperty.call(message, "circuloEncoderMagnetDistance"))
                    $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.encode(message.circuloEncoderMagnetDistance, writer.uint32(/* id 126, wireType 2 =*/1010).fork()).ldelim();
                if (message.circuloEncoderNarrowAngleCalibrationProcedure != null && Object.hasOwnProperty.call(message, "circuloEncoderNarrowAngleCalibrationProcedure"))
                    $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.encode(message.circuloEncoderNarrowAngleCalibrationProcedure, writer.uint32(/* id 127, wireType 2 =*/1018).fork()).ldelim();
                if (message.deviceCia402State != null && Object.hasOwnProperty.call(message, "deviceCia402State"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.encode(message.deviceCia402State, writer.uint32(/* id 128, wireType 2 =*/1026).fork()).ldelim();
                if (message.systemLog != null && Object.hasOwnProperty.call(message, "systemLog"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemLog.encode(message.systemLog, writer.uint32(/* id 129, wireType 2 =*/1034).fork()).ldelim();
                if (message.deviceSiiRestore != null && Object.hasOwnProperty.call(message, "deviceSiiRestore"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.encode(message.deviceSiiRestore, writer.uint32(/* id 130, wireType 2 =*/1042).fork()).ldelim();
                if (message.openLoopFieldControl != null && Object.hasOwnProperty.call(message, "openLoopFieldControl"))
                    $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.encode(message.openLoopFieldControl, writer.uint32(/* id 131, wireType 2 =*/1050).fork()).ldelim();
                if (message.fullAutoTuning != null && Object.hasOwnProperty.call(message, "fullAutoTuning"))
                    $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.encode(message.fullAutoTuning, writer.uint32(/* id 132, wireType 2 =*/1058).fork()).ldelim();
                if (message.circuloEncoderConfiguration != null && Object.hasOwnProperty.call(message, "circuloEncoderConfiguration"))
                    $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.encode(message.circuloEncoderConfiguration, writer.uint32(/* id 133, wireType 2 =*/1066).fork()).ldelim();
                if (message.osCommand != null && Object.hasOwnProperty.call(message, "osCommand"))
                    $root.motionmaster.MotionMasterMessage.Status.OsCommand.encode(message.osCommand, writer.uint32(/* id 134, wireType 2 =*/1074).fork()).ldelim();
                if (message.forwardCall != null && Object.hasOwnProperty.call(message, "forwardCall"))
                    $root.motionmaster.MotionMasterMessage.Status.ForwardCall.encode(message.forwardCall, writer.uint32(/* id 135, wireType 2 =*/1082).fork()).ldelim();
                if (message.systemInformation != null && Object.hasOwnProperty.call(message, "systemInformation"))
                    $root.motionmaster.MotionMasterMessage.Status.SystemInformation.encode(message.systemInformation, writer.uint32(/* id 136, wireType 2 =*/1090).fork()).ldelim();
                if (message.pdoMode != null && Object.hasOwnProperty.call(message, "pdoMode"))
                    $root.motionmaster.MotionMasterMessage.Status.PdoMode.encode(message.pdoMode, writer.uint32(/* id 137, wireType 2 =*/1098).fork()).ldelim();
                if (message.deviceSii != null && Object.hasOwnProperty.call(message, "deviceSii"))
                    $root.motionmaster.MotionMasterMessage.Status.DeviceSii.encode(message.deviceSii, writer.uint32(/* id 138, wireType 2 =*/1106).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Status message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.verify|verify} messages.
             * @function encodeDelimited
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {motionmaster.MotionMasterMessage.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Status message from the specified reader or buffer.
             * @function decode
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {motionmaster.MotionMasterMessage.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 101: {
                            message.systemPong = $root.motionmaster.MotionMasterMessage.Status.SystemPong.decode(reader, reader.uint32());
                            break;
                        }
                    case 102: {
                            message.systemVersion = $root.motionmaster.MotionMasterMessage.Status.SystemVersion.decode(reader, reader.uint32());
                            break;
                        }
                    case 103: {
                            message.systemEvent = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.decode(reader, reader.uint32());
                            break;
                        }
                    case 104: {
                            message.deviceInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.decode(reader, reader.uint32());
                            break;
                        }
                    case 105: {
                            message.deviceParameterInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.decode(reader, reader.uint32());
                            break;
                        }
                    case 106: {
                            message.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 107: {
                            message.multiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 108: {
                            message.deviceFileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.decode(reader, reader.uint32());
                            break;
                        }
                    case 109: {
                            message.deviceFile = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.decode(reader, reader.uint32());
                            break;
                        }
                    case 110: {
                            message.deviceEvent = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.decode(reader, reader.uint32());
                            break;
                        }
                    case 111: {
                            message.deviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.decode(reader, reader.uint32());
                            break;
                        }
                    case 112: {
                            message.deviceLog = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.decode(reader, reader.uint32());
                            break;
                        }
                    case 113: {
                            message.deviceFaultReset = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.decode(reader, reader.uint32());
                            break;
                        }
                    case 114: {
                            message.coggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.decode(reader, reader.uint32());
                            break;
                        }
                    case 115: {
                            message.coggingTorqueData = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.decode(reader, reader.uint32());
                            break;
                        }
                    case 116: {
                            message.offsetDetection = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.decode(reader, reader.uint32());
                            break;
                        }
                    case 117: {
                            message.plantIdentification = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.decode(reader, reader.uint32());
                            break;
                        }
                    case 118: {
                            message.autoTuning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.decode(reader, reader.uint32());
                            break;
                        }
                    case 119: {
                            message.motionController = $root.motionmaster.MotionMasterMessage.Status.MotionController.decode(reader, reader.uint32());
                            break;
                        }
                    case 120: {
                            message.signalGenerator = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.decode(reader, reader.uint32());
                            break;
                        }
                    case 121: {
                            message.monitoringParameterValues = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.decode(reader, reader.uint32());
                            break;
                        }
                    case 122: {
                            message.deviceStop = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.decode(reader, reader.uint32());
                            break;
                        }
                    case 123: {
                            message.ethercatNetworkState = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.decode(reader, reader.uint32());
                            break;
                        }
                    case 124: {
                            message.narrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.decode(reader, reader.uint32());
                            break;
                        }
                    case 125: {
                            message.systemIdentification = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.decode(reader, reader.uint32());
                            break;
                        }
                    case 126: {
                            message.circuloEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.decode(reader, reader.uint32());
                            break;
                        }
                    case 127: {
                            message.circuloEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.decode(reader, reader.uint32());
                            break;
                        }
                    case 128: {
                            message.deviceCia402State = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.decode(reader, reader.uint32());
                            break;
                        }
                    case 129: {
                            message.systemLog = $root.motionmaster.MotionMasterMessage.Status.SystemLog.decode(reader, reader.uint32());
                            break;
                        }
                    case 130: {
                            message.deviceSiiRestore = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.decode(reader, reader.uint32());
                            break;
                        }
                    case 131: {
                            message.openLoopFieldControl = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.decode(reader, reader.uint32());
                            break;
                        }
                    case 132: {
                            message.fullAutoTuning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.decode(reader, reader.uint32());
                            break;
                        }
                    case 133: {
                            message.circuloEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.decode(reader, reader.uint32());
                            break;
                        }
                    case 134: {
                            message.osCommand = $root.motionmaster.MotionMasterMessage.Status.OsCommand.decode(reader, reader.uint32());
                            break;
                        }
                    case 135: {
                            message.forwardCall = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.decode(reader, reader.uint32());
                            break;
                        }
                    case 136: {
                            message.systemInformation = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.decode(reader, reader.uint32());
                            break;
                        }
                    case 137: {
                            message.pdoMode = $root.motionmaster.MotionMasterMessage.Status.PdoMode.decode(reader, reader.uint32());
                            break;
                        }
                    case 138: {
                            message.deviceSii = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Status message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {motionmaster.MotionMasterMessage.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Status message.
             * @function verify
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Status.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.systemPong != null && message.hasOwnProperty("systemPong")) {
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemPong.verify(message.systemPong);
                        if (error)
                            return "systemPong." + error;
                    }
                }
                if (message.systemVersion != null && message.hasOwnProperty("systemVersion")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemVersion.verify(message.systemVersion);
                        if (error)
                            return "systemVersion." + error;
                    }
                }
                if (message.systemEvent != null && message.hasOwnProperty("systemEvent")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.verify(message.systemEvent);
                        if (error)
                            return "systemEvent." + error;
                    }
                }
                if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.verify(message.deviceInfo);
                        if (error)
                            return "deviceInfo." + error;
                    }
                }
                if (message.deviceParameterInfo != null && message.hasOwnProperty("deviceParameterInfo")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.verify(message.deviceParameterInfo);
                        if (error)
                            return "deviceParameterInfo." + error;
                    }
                }
                if (message.deviceParameterValues != null && message.hasOwnProperty("deviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.verify(message.deviceParameterValues);
                        if (error)
                            return "deviceParameterValues." + error;
                    }
                }
                if (message.multiDeviceParameterValues != null && message.hasOwnProperty("multiDeviceParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.verify(message.multiDeviceParameterValues);
                        if (error)
                            return "multiDeviceParameterValues." + error;
                    }
                }
                if (message.deviceFileList != null && message.hasOwnProperty("deviceFileList")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.verify(message.deviceFileList);
                        if (error)
                            return "deviceFileList." + error;
                    }
                }
                if (message.deviceFile != null && message.hasOwnProperty("deviceFile")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.verify(message.deviceFile);
                        if (error)
                            return "deviceFile." + error;
                    }
                }
                if (message.deviceEvent != null && message.hasOwnProperty("deviceEvent")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.verify(message.deviceEvent);
                        if (error)
                            return "deviceEvent." + error;
                    }
                }
                if (message.deviceFirmwareInstallation != null && message.hasOwnProperty("deviceFirmwareInstallation")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.verify(message.deviceFirmwareInstallation);
                        if (error)
                            return "deviceFirmwareInstallation." + error;
                    }
                }
                if (message.deviceLog != null && message.hasOwnProperty("deviceLog")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.verify(message.deviceLog);
                        if (error)
                            return "deviceLog." + error;
                    }
                }
                if (message.deviceFaultReset != null && message.hasOwnProperty("deviceFaultReset")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.verify(message.deviceFaultReset);
                        if (error)
                            return "deviceFaultReset." + error;
                    }
                }
                if (message.coggingTorqueRecording != null && message.hasOwnProperty("coggingTorqueRecording")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.verify(message.coggingTorqueRecording);
                        if (error)
                            return "coggingTorqueRecording." + error;
                    }
                }
                if (message.coggingTorqueData != null && message.hasOwnProperty("coggingTorqueData")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.verify(message.coggingTorqueData);
                        if (error)
                            return "coggingTorqueData." + error;
                    }
                }
                if (message.offsetDetection != null && message.hasOwnProperty("offsetDetection")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.verify(message.offsetDetection);
                        if (error)
                            return "offsetDetection." + error;
                    }
                }
                if (message.plantIdentification != null && message.hasOwnProperty("plantIdentification")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.verify(message.plantIdentification);
                        if (error)
                            return "plantIdentification." + error;
                    }
                }
                if (message.autoTuning != null && message.hasOwnProperty("autoTuning")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.verify(message.autoTuning);
                        if (error)
                            return "autoTuning." + error;
                    }
                }
                if (message.motionController != null && message.hasOwnProperty("motionController")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.MotionController.verify(message.motionController);
                        if (error)
                            return "motionController." + error;
                    }
                }
                if (message.signalGenerator != null && message.hasOwnProperty("signalGenerator")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.verify(message.signalGenerator);
                        if (error)
                            return "signalGenerator." + error;
                    }
                }
                if (message.monitoringParameterValues != null && message.hasOwnProperty("monitoringParameterValues")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.verify(message.monitoringParameterValues);
                        if (error)
                            return "monitoringParameterValues." + error;
                    }
                }
                if (message.deviceStop != null && message.hasOwnProperty("deviceStop")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.verify(message.deviceStop);
                        if (error)
                            return "deviceStop." + error;
                    }
                }
                if (message.ethercatNetworkState != null && message.hasOwnProperty("ethercatNetworkState")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.verify(message.ethercatNetworkState);
                        if (error)
                            return "ethercatNetworkState." + error;
                    }
                }
                if (message.narrowAngleCalibration != null && message.hasOwnProperty("narrowAngleCalibration")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.verify(message.narrowAngleCalibration);
                        if (error)
                            return "narrowAngleCalibration." + error;
                    }
                }
                if (message.systemIdentification != null && message.hasOwnProperty("systemIdentification")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.verify(message.systemIdentification);
                        if (error)
                            return "systemIdentification." + error;
                    }
                }
                if (message.circuloEncoderMagnetDistance != null && message.hasOwnProperty("circuloEncoderMagnetDistance")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.verify(message.circuloEncoderMagnetDistance);
                        if (error)
                            return "circuloEncoderMagnetDistance." + error;
                    }
                }
                if (message.circuloEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("circuloEncoderNarrowAngleCalibrationProcedure")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.verify(message.circuloEncoderNarrowAngleCalibrationProcedure);
                        if (error)
                            return "circuloEncoderNarrowAngleCalibrationProcedure." + error;
                    }
                }
                if (message.deviceCia402State != null && message.hasOwnProperty("deviceCia402State")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.verify(message.deviceCia402State);
                        if (error)
                            return "deviceCia402State." + error;
                    }
                }
                if (message.systemLog != null && message.hasOwnProperty("systemLog")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemLog.verify(message.systemLog);
                        if (error)
                            return "systemLog." + error;
                    }
                }
                if (message.deviceSiiRestore != null && message.hasOwnProperty("deviceSiiRestore")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.verify(message.deviceSiiRestore);
                        if (error)
                            return "deviceSiiRestore." + error;
                    }
                }
                if (message.openLoopFieldControl != null && message.hasOwnProperty("openLoopFieldControl")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.verify(message.openLoopFieldControl);
                        if (error)
                            return "openLoopFieldControl." + error;
                    }
                }
                if (message.fullAutoTuning != null && message.hasOwnProperty("fullAutoTuning")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.verify(message.fullAutoTuning);
                        if (error)
                            return "fullAutoTuning." + error;
                    }
                }
                if (message.circuloEncoderConfiguration != null && message.hasOwnProperty("circuloEncoderConfiguration")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.verify(message.circuloEncoderConfiguration);
                        if (error)
                            return "circuloEncoderConfiguration." + error;
                    }
                }
                if (message.osCommand != null && message.hasOwnProperty("osCommand")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.verify(message.osCommand);
                        if (error)
                            return "osCommand." + error;
                    }
                }
                if (message.forwardCall != null && message.hasOwnProperty("forwardCall")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.verify(message.forwardCall);
                        if (error)
                            return "forwardCall." + error;
                    }
                }
                if (message.systemInformation != null && message.hasOwnProperty("systemInformation")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.verify(message.systemInformation);
                        if (error)
                            return "systemInformation." + error;
                    }
                }
                if (message.pdoMode != null && message.hasOwnProperty("pdoMode")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.verify(message.pdoMode);
                        if (error)
                            return "pdoMode." + error;
                    }
                }
                if (message.deviceSii != null && message.hasOwnProperty("deviceSii")) {
                    if (properties.type === 1)
                        return "type: multiple values";
                    properties.type = 1;
                    {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.verify(message.deviceSii);
                        if (error)
                            return "deviceSii." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Status message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {motionmaster.MotionMasterMessage.Status} Status
             */
            Status.fromObject = function fromObject(object) {
                if (object instanceof $root.motionmaster.MotionMasterMessage.Status)
                    return object;
                let message = new $root.motionmaster.MotionMasterMessage.Status();
                if (object.systemPong != null) {
                    if (typeof object.systemPong !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemPong: object expected");
                    message.systemPong = $root.motionmaster.MotionMasterMessage.Status.SystemPong.fromObject(object.systemPong);
                }
                if (object.systemVersion != null) {
                    if (typeof object.systemVersion !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemVersion: object expected");
                    message.systemVersion = $root.motionmaster.MotionMasterMessage.Status.SystemVersion.fromObject(object.systemVersion);
                }
                if (object.systemEvent != null) {
                    if (typeof object.systemEvent !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemEvent: object expected");
                    message.systemEvent = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.fromObject(object.systemEvent);
                }
                if (object.deviceInfo != null) {
                    if (typeof object.deviceInfo !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceInfo: object expected");
                    message.deviceInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.fromObject(object.deviceInfo);
                }
                if (object.deviceParameterInfo != null) {
                    if (typeof object.deviceParameterInfo !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceParameterInfo: object expected");
                    message.deviceParameterInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.fromObject(object.deviceParameterInfo);
                }
                if (object.deviceParameterValues != null) {
                    if (typeof object.deviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceParameterValues: object expected");
                    message.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.fromObject(object.deviceParameterValues);
                }
                if (object.multiDeviceParameterValues != null) {
                    if (typeof object.multiDeviceParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.multiDeviceParameterValues: object expected");
                    message.multiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.fromObject(object.multiDeviceParameterValues);
                }
                if (object.deviceFileList != null) {
                    if (typeof object.deviceFileList !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceFileList: object expected");
                    message.deviceFileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.fromObject(object.deviceFileList);
                }
                if (object.deviceFile != null) {
                    if (typeof object.deviceFile !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceFile: object expected");
                    message.deviceFile = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.fromObject(object.deviceFile);
                }
                if (object.deviceEvent != null) {
                    if (typeof object.deviceEvent !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceEvent: object expected");
                    message.deviceEvent = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.fromObject(object.deviceEvent);
                }
                if (object.deviceFirmwareInstallation != null) {
                    if (typeof object.deviceFirmwareInstallation !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceFirmwareInstallation: object expected");
                    message.deviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.fromObject(object.deviceFirmwareInstallation);
                }
                if (object.deviceLog != null) {
                    if (typeof object.deviceLog !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceLog: object expected");
                    message.deviceLog = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.fromObject(object.deviceLog);
                }
                if (object.deviceFaultReset != null) {
                    if (typeof object.deviceFaultReset !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceFaultReset: object expected");
                    message.deviceFaultReset = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.fromObject(object.deviceFaultReset);
                }
                if (object.coggingTorqueRecording != null) {
                    if (typeof object.coggingTorqueRecording !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.coggingTorqueRecording: object expected");
                    message.coggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.fromObject(object.coggingTorqueRecording);
                }
                if (object.coggingTorqueData != null) {
                    if (typeof object.coggingTorqueData !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.coggingTorqueData: object expected");
                    message.coggingTorqueData = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.fromObject(object.coggingTorqueData);
                }
                if (object.offsetDetection != null) {
                    if (typeof object.offsetDetection !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.offsetDetection: object expected");
                    message.offsetDetection = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.fromObject(object.offsetDetection);
                }
                if (object.plantIdentification != null) {
                    if (typeof object.plantIdentification !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.plantIdentification: object expected");
                    message.plantIdentification = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.fromObject(object.plantIdentification);
                }
                if (object.autoTuning != null) {
                    if (typeof object.autoTuning !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.autoTuning: object expected");
                    message.autoTuning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.fromObject(object.autoTuning);
                }
                if (object.motionController != null) {
                    if (typeof object.motionController !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.motionController: object expected");
                    message.motionController = $root.motionmaster.MotionMasterMessage.Status.MotionController.fromObject(object.motionController);
                }
                if (object.signalGenerator != null) {
                    if (typeof object.signalGenerator !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.signalGenerator: object expected");
                    message.signalGenerator = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.fromObject(object.signalGenerator);
                }
                if (object.monitoringParameterValues != null) {
                    if (typeof object.monitoringParameterValues !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.monitoringParameterValues: object expected");
                    message.monitoringParameterValues = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.fromObject(object.monitoringParameterValues);
                }
                if (object.deviceStop != null) {
                    if (typeof object.deviceStop !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceStop: object expected");
                    message.deviceStop = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.fromObject(object.deviceStop);
                }
                if (object.ethercatNetworkState != null) {
                    if (typeof object.ethercatNetworkState !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.ethercatNetworkState: object expected");
                    message.ethercatNetworkState = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.fromObject(object.ethercatNetworkState);
                }
                if (object.narrowAngleCalibration != null) {
                    if (typeof object.narrowAngleCalibration !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.narrowAngleCalibration: object expected");
                    message.narrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.fromObject(object.narrowAngleCalibration);
                }
                if (object.systemIdentification != null) {
                    if (typeof object.systemIdentification !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemIdentification: object expected");
                    message.systemIdentification = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.fromObject(object.systemIdentification);
                }
                if (object.circuloEncoderMagnetDistance != null) {
                    if (typeof object.circuloEncoderMagnetDistance !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.circuloEncoderMagnetDistance: object expected");
                    message.circuloEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.fromObject(object.circuloEncoderMagnetDistance);
                }
                if (object.circuloEncoderNarrowAngleCalibrationProcedure != null) {
                    if (typeof object.circuloEncoderNarrowAngleCalibrationProcedure !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.circuloEncoderNarrowAngleCalibrationProcedure: object expected");
                    message.circuloEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.fromObject(object.circuloEncoderNarrowAngleCalibrationProcedure);
                }
                if (object.deviceCia402State != null) {
                    if (typeof object.deviceCia402State !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceCia402State: object expected");
                    message.deviceCia402State = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.fromObject(object.deviceCia402State);
                }
                if (object.systemLog != null) {
                    if (typeof object.systemLog !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemLog: object expected");
                    message.systemLog = $root.motionmaster.MotionMasterMessage.Status.SystemLog.fromObject(object.systemLog);
                }
                if (object.deviceSiiRestore != null) {
                    if (typeof object.deviceSiiRestore !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceSiiRestore: object expected");
                    message.deviceSiiRestore = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.fromObject(object.deviceSiiRestore);
                }
                if (object.openLoopFieldControl != null) {
                    if (typeof object.openLoopFieldControl !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.openLoopFieldControl: object expected");
                    message.openLoopFieldControl = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.fromObject(object.openLoopFieldControl);
                }
                if (object.fullAutoTuning != null) {
                    if (typeof object.fullAutoTuning !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.fullAutoTuning: object expected");
                    message.fullAutoTuning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.fromObject(object.fullAutoTuning);
                }
                if (object.circuloEncoderConfiguration != null) {
                    if (typeof object.circuloEncoderConfiguration !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.circuloEncoderConfiguration: object expected");
                    message.circuloEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.fromObject(object.circuloEncoderConfiguration);
                }
                if (object.osCommand != null) {
                    if (typeof object.osCommand !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.osCommand: object expected");
                    message.osCommand = $root.motionmaster.MotionMasterMessage.Status.OsCommand.fromObject(object.osCommand);
                }
                if (object.forwardCall != null) {
                    if (typeof object.forwardCall !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.forwardCall: object expected");
                    message.forwardCall = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.fromObject(object.forwardCall);
                }
                if (object.systemInformation != null) {
                    if (typeof object.systemInformation !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.systemInformation: object expected");
                    message.systemInformation = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.fromObject(object.systemInformation);
                }
                if (object.pdoMode != null) {
                    if (typeof object.pdoMode !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.pdoMode: object expected");
                    message.pdoMode = $root.motionmaster.MotionMasterMessage.Status.PdoMode.fromObject(object.pdoMode);
                }
                if (object.deviceSii != null) {
                    if (typeof object.deviceSii !== "object")
                        throw TypeError(".motionmaster.MotionMasterMessage.Status.deviceSii: object expected");
                    message.deviceSii = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.fromObject(object.deviceSii);
                }
                return message;
            };

            /**
             * Creates a plain object from a Status message. Also converts values to other types if specified.
             * @function toObject
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {motionmaster.MotionMasterMessage.Status} message Status
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Status.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (message.systemPong != null && message.hasOwnProperty("systemPong")) {
                    object.systemPong = $root.motionmaster.MotionMasterMessage.Status.SystemPong.toObject(message.systemPong, options);
                    if (options.oneofs)
                        object.type = "systemPong";
                }
                if (message.systemVersion != null && message.hasOwnProperty("systemVersion")) {
                    object.systemVersion = $root.motionmaster.MotionMasterMessage.Status.SystemVersion.toObject(message.systemVersion, options);
                    if (options.oneofs)
                        object.type = "systemVersion";
                }
                if (message.systemEvent != null && message.hasOwnProperty("systemEvent")) {
                    object.systemEvent = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.toObject(message.systemEvent, options);
                    if (options.oneofs)
                        object.type = "systemEvent";
                }
                if (message.deviceInfo != null && message.hasOwnProperty("deviceInfo")) {
                    object.deviceInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.toObject(message.deviceInfo, options);
                    if (options.oneofs)
                        object.type = "deviceInfo";
                }
                if (message.deviceParameterInfo != null && message.hasOwnProperty("deviceParameterInfo")) {
                    object.deviceParameterInfo = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.toObject(message.deviceParameterInfo, options);
                    if (options.oneofs)
                        object.type = "deviceParameterInfo";
                }
                if (message.deviceParameterValues != null && message.hasOwnProperty("deviceParameterValues")) {
                    object.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.toObject(message.deviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "deviceParameterValues";
                }
                if (message.multiDeviceParameterValues != null && message.hasOwnProperty("multiDeviceParameterValues")) {
                    object.multiDeviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.toObject(message.multiDeviceParameterValues, options);
                    if (options.oneofs)
                        object.type = "multiDeviceParameterValues";
                }
                if (message.deviceFileList != null && message.hasOwnProperty("deviceFileList")) {
                    object.deviceFileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.toObject(message.deviceFileList, options);
                    if (options.oneofs)
                        object.type = "deviceFileList";
                }
                if (message.deviceFile != null && message.hasOwnProperty("deviceFile")) {
                    object.deviceFile = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.toObject(message.deviceFile, options);
                    if (options.oneofs)
                        object.type = "deviceFile";
                }
                if (message.deviceEvent != null && message.hasOwnProperty("deviceEvent")) {
                    object.deviceEvent = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.toObject(message.deviceEvent, options);
                    if (options.oneofs)
                        object.type = "deviceEvent";
                }
                if (message.deviceFirmwareInstallation != null && message.hasOwnProperty("deviceFirmwareInstallation")) {
                    object.deviceFirmwareInstallation = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.toObject(message.deviceFirmwareInstallation, options);
                    if (options.oneofs)
                        object.type = "deviceFirmwareInstallation";
                }
                if (message.deviceLog != null && message.hasOwnProperty("deviceLog")) {
                    object.deviceLog = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.toObject(message.deviceLog, options);
                    if (options.oneofs)
                        object.type = "deviceLog";
                }
                if (message.deviceFaultReset != null && message.hasOwnProperty("deviceFaultReset")) {
                    object.deviceFaultReset = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.toObject(message.deviceFaultReset, options);
                    if (options.oneofs)
                        object.type = "deviceFaultReset";
                }
                if (message.coggingTorqueRecording != null && message.hasOwnProperty("coggingTorqueRecording")) {
                    object.coggingTorqueRecording = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.toObject(message.coggingTorqueRecording, options);
                    if (options.oneofs)
                        object.type = "coggingTorqueRecording";
                }
                if (message.coggingTorqueData != null && message.hasOwnProperty("coggingTorqueData")) {
                    object.coggingTorqueData = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.toObject(message.coggingTorqueData, options);
                    if (options.oneofs)
                        object.type = "coggingTorqueData";
                }
                if (message.offsetDetection != null && message.hasOwnProperty("offsetDetection")) {
                    object.offsetDetection = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.toObject(message.offsetDetection, options);
                    if (options.oneofs)
                        object.type = "offsetDetection";
                }
                if (message.plantIdentification != null && message.hasOwnProperty("plantIdentification")) {
                    object.plantIdentification = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.toObject(message.plantIdentification, options);
                    if (options.oneofs)
                        object.type = "plantIdentification";
                }
                if (message.autoTuning != null && message.hasOwnProperty("autoTuning")) {
                    object.autoTuning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.toObject(message.autoTuning, options);
                    if (options.oneofs)
                        object.type = "autoTuning";
                }
                if (message.motionController != null && message.hasOwnProperty("motionController")) {
                    object.motionController = $root.motionmaster.MotionMasterMessage.Status.MotionController.toObject(message.motionController, options);
                    if (options.oneofs)
                        object.type = "motionController";
                }
                if (message.signalGenerator != null && message.hasOwnProperty("signalGenerator")) {
                    object.signalGenerator = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.toObject(message.signalGenerator, options);
                    if (options.oneofs)
                        object.type = "signalGenerator";
                }
                if (message.monitoringParameterValues != null && message.hasOwnProperty("monitoringParameterValues")) {
                    object.monitoringParameterValues = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.toObject(message.monitoringParameterValues, options);
                    if (options.oneofs)
                        object.type = "monitoringParameterValues";
                }
                if (message.deviceStop != null && message.hasOwnProperty("deviceStop")) {
                    object.deviceStop = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.toObject(message.deviceStop, options);
                    if (options.oneofs)
                        object.type = "deviceStop";
                }
                if (message.ethercatNetworkState != null && message.hasOwnProperty("ethercatNetworkState")) {
                    object.ethercatNetworkState = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.toObject(message.ethercatNetworkState, options);
                    if (options.oneofs)
                        object.type = "ethercatNetworkState";
                }
                if (message.narrowAngleCalibration != null && message.hasOwnProperty("narrowAngleCalibration")) {
                    object.narrowAngleCalibration = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.toObject(message.narrowAngleCalibration, options);
                    if (options.oneofs)
                        object.type = "narrowAngleCalibration";
                }
                if (message.systemIdentification != null && message.hasOwnProperty("systemIdentification")) {
                    object.systemIdentification = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.toObject(message.systemIdentification, options);
                    if (options.oneofs)
                        object.type = "systemIdentification";
                }
                if (message.circuloEncoderMagnetDistance != null && message.hasOwnProperty("circuloEncoderMagnetDistance")) {
                    object.circuloEncoderMagnetDistance = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.toObject(message.circuloEncoderMagnetDistance, options);
                    if (options.oneofs)
                        object.type = "circuloEncoderMagnetDistance";
                }
                if (message.circuloEncoderNarrowAngleCalibrationProcedure != null && message.hasOwnProperty("circuloEncoderNarrowAngleCalibrationProcedure")) {
                    object.circuloEncoderNarrowAngleCalibrationProcedure = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.toObject(message.circuloEncoderNarrowAngleCalibrationProcedure, options);
                    if (options.oneofs)
                        object.type = "circuloEncoderNarrowAngleCalibrationProcedure";
                }
                if (message.deviceCia402State != null && message.hasOwnProperty("deviceCia402State")) {
                    object.deviceCia402State = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.toObject(message.deviceCia402State, options);
                    if (options.oneofs)
                        object.type = "deviceCia402State";
                }
                if (message.systemLog != null && message.hasOwnProperty("systemLog")) {
                    object.systemLog = $root.motionmaster.MotionMasterMessage.Status.SystemLog.toObject(message.systemLog, options);
                    if (options.oneofs)
                        object.type = "systemLog";
                }
                if (message.deviceSiiRestore != null && message.hasOwnProperty("deviceSiiRestore")) {
                    object.deviceSiiRestore = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.toObject(message.deviceSiiRestore, options);
                    if (options.oneofs)
                        object.type = "deviceSiiRestore";
                }
                if (message.openLoopFieldControl != null && message.hasOwnProperty("openLoopFieldControl")) {
                    object.openLoopFieldControl = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.toObject(message.openLoopFieldControl, options);
                    if (options.oneofs)
                        object.type = "openLoopFieldControl";
                }
                if (message.fullAutoTuning != null && message.hasOwnProperty("fullAutoTuning")) {
                    object.fullAutoTuning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.toObject(message.fullAutoTuning, options);
                    if (options.oneofs)
                        object.type = "fullAutoTuning";
                }
                if (message.circuloEncoderConfiguration != null && message.hasOwnProperty("circuloEncoderConfiguration")) {
                    object.circuloEncoderConfiguration = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.toObject(message.circuloEncoderConfiguration, options);
                    if (options.oneofs)
                        object.type = "circuloEncoderConfiguration";
                }
                if (message.osCommand != null && message.hasOwnProperty("osCommand")) {
                    object.osCommand = $root.motionmaster.MotionMasterMessage.Status.OsCommand.toObject(message.osCommand, options);
                    if (options.oneofs)
                        object.type = "osCommand";
                }
                if (message.forwardCall != null && message.hasOwnProperty("forwardCall")) {
                    object.forwardCall = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.toObject(message.forwardCall, options);
                    if (options.oneofs)
                        object.type = "forwardCall";
                }
                if (message.systemInformation != null && message.hasOwnProperty("systemInformation")) {
                    object.systemInformation = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.toObject(message.systemInformation, options);
                    if (options.oneofs)
                        object.type = "systemInformation";
                }
                if (message.pdoMode != null && message.hasOwnProperty("pdoMode")) {
                    object.pdoMode = $root.motionmaster.MotionMasterMessage.Status.PdoMode.toObject(message.pdoMode, options);
                    if (options.oneofs)
                        object.type = "pdoMode";
                }
                if (message.deviceSii != null && message.hasOwnProperty("deviceSii")) {
                    object.deviceSii = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.toObject(message.deviceSii, options);
                    if (options.oneofs)
                        object.type = "deviceSii";
                }
                return object;
            };

            /**
             * Converts this Status to JSON.
             * @function toJSON
             * @memberof motionmaster.MotionMasterMessage.Status
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Status.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Status
             * @function getTypeUrl
             * @memberof motionmaster.MotionMasterMessage.Status
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status";
            };

            Status.SystemPong = (function() {

                /**
                 * Properties of a SystemPong.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemPong
                 */

                /**
                 * Constructs a new SystemPong.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemPong.
                 * @implements ISystemPong
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemPong=} [properties] Properties to set
                 */
                function SystemPong(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new SystemPong instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemPong=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemPong} SystemPong instance
                 */
                SystemPong.create = function create(properties) {
                    return new SystemPong(properties);
                };

                /**
                 * Encodes the specified SystemPong message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemPong.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemPong} message SystemPong message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPong.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified SystemPong message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemPong.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemPong} message SystemPong message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPong.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemPong message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemPong} SystemPong
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPong.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemPong();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemPong message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemPong} SystemPong
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPong.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemPong message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemPong.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a SystemPong message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemPong} SystemPong
                 */
                SystemPong.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemPong)
                        return object;
                    return new $root.motionmaster.MotionMasterMessage.Status.SystemPong();
                };

                /**
                 * Creates a plain object from a SystemPong message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemPong} message SystemPong
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemPong.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this SystemPong to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemPong.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemPong
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemPong
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemPong.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemPong";
                };

                return SystemPong;
            })();

            Status.SystemVersion = (function() {

                /**
                 * Properties of a SystemVersion.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemVersion
                 * @property {string|null} [version] SystemVersion version
                 */

                /**
                 * Constructs a new SystemVersion.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemVersion.
                 * @implements ISystemVersion
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemVersion=} [properties] Properties to set
                 */
                function SystemVersion(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemVersion version.
                 * @member {string} version
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @instance
                 */
                SystemVersion.prototype.version = "";

                /**
                 * Creates a new SystemVersion instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemVersion=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemVersion} SystemVersion instance
                 */
                SystemVersion.create = function create(properties) {
                    return new SystemVersion(properties);
                };

                /**
                 * Encodes the specified SystemVersion message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemVersion.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemVersion} message SystemVersion message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemVersion.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
                    return writer;
                };

                /**
                 * Encodes the specified SystemVersion message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemVersion.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemVersion} message SystemVersion message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemVersion.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemVersion message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemVersion} SystemVersion
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemVersion.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemVersion();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.version = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemVersion message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemVersion} SystemVersion
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemVersion.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemVersion message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemVersion.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.version != null && message.hasOwnProperty("version"))
                        if (!$util.isString(message.version))
                            return "version: string expected";
                    return null;
                };

                /**
                 * Creates a SystemVersion message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemVersion} SystemVersion
                 */
                SystemVersion.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemVersion)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SystemVersion();
                    if (object.version != null)
                        message.version = String(object.version);
                    return message;
                };

                /**
                 * Creates a plain object from a SystemVersion message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemVersion} message SystemVersion
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemVersion.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.version = "";
                    if (message.version != null && message.hasOwnProperty("version"))
                        object.version = message.version;
                    return object;
                };

                /**
                 * Converts this SystemVersion to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemVersion.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemVersion
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemVersion
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemVersion";
                };

                return SystemVersion;
            })();

            Status.SystemEvent = (function() {

                /**
                 * Properties of a SystemEvent.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemEvent
                 * @property {number|null} [deviceAddress] SystemEvent deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo|null} [info] SystemEvent info
                 * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess|null} [success] SystemEvent success
                 * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning|null} [warning] SystemEvent warning
                 * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.IError|null} [error] SystemEvent error
                 * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.State|null} [state] SystemEvent state
                 */

                /**
                 * Constructs a new SystemEvent.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemEvent.
                 * @implements ISystemEvent
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemEvent=} [properties] Properties to set
                 */
                function SystemEvent(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemEvent deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.deviceAddress = 0;

                /**
                 * SystemEvent info.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo|null|undefined} info
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.info = null;

                /**
                 * SystemEvent success.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.success = null;

                /**
                 * SystemEvent warning.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.warning = null;

                /**
                 * SystemEvent error.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.error = null;

                /**
                 * SystemEvent state.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.State|null|undefined} state
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                SystemEvent.prototype.state = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SystemEvent status.
                 * @member {"info"|"success"|"warning"|"error"|"state"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 */
                Object.defineProperty(SystemEvent.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["info", "success", "warning", "error", "state"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SystemEvent instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemEvent=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent} SystemEvent instance
                 */
                SystemEvent.create = function create(properties) {
                    return new SystemEvent(properties);
                };

                /**
                 * Encodes the specified SystemEvent message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemEvent} message SystemEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemEvent.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.encode(message.info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.encode(message.warning, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.state);
                    return writer;
                };

                /**
                 * Encodes the specified SystemEvent message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemEvent} message SystemEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemEvent.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemEvent message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent} SystemEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemEvent.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.info = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.state = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemEvent message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent} SystemEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemEvent.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemEvent message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemEvent.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.info != null && message.hasOwnProperty("info")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.verify(message.info);
                            if (error)
                                return "info." + error;
                        }
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.state != null && message.hasOwnProperty("state")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                            break;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SystemEvent message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent} SystemEvent
                 */
                SystemEvent.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemEvent)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.info != null) {
                        if (typeof object.info !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemEvent.info: object expected");
                        message.info = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.fromObject(object.info);
                    }
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemEvent.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemEvent.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemEvent.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.fromObject(object.error);
                    }
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "WAITING_FOR_SLAVES":
                    case 1:
                        message.state = 1;
                        break;
                    case "SLAVES_FOUND":
                    case 2:
                        message.state = 2;
                        break;
                    case "INITIALIZING":
                    case 3:
                        message.state = 3;
                        break;
                    case "INITIALIZED":
                    case 4:
                        message.state = 4;
                        break;
                    case "DEINITIALIZING":
                    case 5:
                        message.state = 5;
                        break;
                    case "DEINITIALIZED":
                    case 6:
                        message.state = 6;
                        break;
                    case "TERMINATING":
                    case 7:
                        message.state = 7;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemEvent message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemEvent} message SystemEvent
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemEvent.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.info != null && message.hasOwnProperty("info")) {
                        object.info = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.toObject(message.info, options);
                        if (options.oneofs)
                            object.status = "info";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.state != null && message.hasOwnProperty("state")) {
                        object.state = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemEvent.State[message.state] === undefined ? message.state : $root.motionmaster.MotionMasterMessage.Status.SystemEvent.State[message.state] : message.state;
                        if (options.oneofs)
                            object.status = "state";
                    }
                    return object;
                };

                /**
                 * Converts this SystemEvent to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemEvent.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemEvent
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemEvent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemEvent";
                };

                SystemEvent.Info = (function() {

                    /**
                     * Properties of an Info.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @interface IInfo
                     * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.Info.Code|null} [code] Info code
                     * @property {string|null} [message] Info message
                     */

                    /**
                     * Constructs a new Info.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @classdesc Represents an Info.
                     * @implements IInfo
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo=} [properties] Properties to set
                     */
                    function Info(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Info code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.Info.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @instance
                     */
                    Info.prototype.code = 0;

                    /**
                     * Info message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @instance
                     */
                    Info.prototype.message = "";

                    /**
                     * Creates a new Info instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Info} Info instance
                     */
                    Info.create = function create(properties) {
                        return new Info(properties);
                    };

                    /**
                     * Encodes the specified Info message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Info.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo} message Info message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Info.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Info message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Info.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IInfo} message Info message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Info.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Info message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Info} Info
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Info.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Info message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Info} Info
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Info.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Info message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Info.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Info message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Info} Info
                     */
                    Info.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SLAVE_NUMBER_CHANGED":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Info message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.Info} message Info
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Info.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Info.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Info to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Info.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Info
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Info
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Info.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemEvent.Info";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemEvent.Info.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SLAVE_NUMBER_CHANGED=1 SLAVE_NUMBER_CHANGED value
                     */
                    Info.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SLAVE_NUMBER_CHANGED"] = 1;
                        return values;
                    })();

                    return Info;
                })();

                SystemEvent.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemEvent.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemEvent.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        return values;
                    })();

                    return Success;
                })();

                SystemEvent.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DROPPING_CONNECTION":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemEvent.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemEvent.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DROPPING_CONNECTION=1 DROPPING_CONNECTION value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DROPPING_CONNECTION"] = 1;
                        return values;
                    })();

                    return Warning;
                })();

                SystemEvent.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.SystemEvent.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemEvent.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemEvent.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemEvent.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "UNKNOWN_MESSAGE_TYPE":
                        case 1:
                            message.code = 1;
                            break;
                        case "CANNOT_DETECT_SLAVES":
                        case 2:
                            message.code = 2;
                            break;
                        case "INVALID_DEVICE_ADDRESS":
                        case 3:
                            message.code = 3;
                            break;
                        case "CONFIGURATION_RELOAD_FAILED":
                        case 4:
                            message.code = 4;
                            break;
                        case "HARDWARE_DESCRIPTION_MISSING":
                        case 5:
                            message.code = 5;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemEvent.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemEvent.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemEvent.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemEvent.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemEvent.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} UNKNOWN_MESSAGE_TYPE=1 UNKNOWN_MESSAGE_TYPE value
                     * @property {number} CANNOT_DETECT_SLAVES=2 CANNOT_DETECT_SLAVES value
                     * @property {number} INVALID_DEVICE_ADDRESS=3 INVALID_DEVICE_ADDRESS value
                     * @property {number} CONFIGURATION_RELOAD_FAILED=4 CONFIGURATION_RELOAD_FAILED value
                     * @property {number} HARDWARE_DESCRIPTION_MISSING=5 HARDWARE_DESCRIPTION_MISSING value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "UNKNOWN_MESSAGE_TYPE"] = 1;
                        values[valuesById[2] = "CANNOT_DETECT_SLAVES"] = 2;
                        values[valuesById[3] = "INVALID_DEVICE_ADDRESS"] = 3;
                        values[valuesById[4] = "CONFIGURATION_RELOAD_FAILED"] = 4;
                        values[valuesById[5] = "HARDWARE_DESCRIPTION_MISSING"] = 5;
                        return values;
                    })();

                    return Error;
                })();

                /**
                 * State enum.
                 * @name motionmaster.MotionMasterMessage.Status.SystemEvent.State
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} WAITING_FOR_SLAVES=1 WAITING_FOR_SLAVES value
                 * @property {number} SLAVES_FOUND=2 SLAVES_FOUND value
                 * @property {number} INITIALIZING=3 INITIALIZING value
                 * @property {number} INITIALIZED=4 INITIALIZED value
                 * @property {number} DEINITIALIZING=5 DEINITIALIZING value
                 * @property {number} DEINITIALIZED=6 DEINITIALIZED value
                 * @property {number} TERMINATING=7 TERMINATING value
                 */
                SystemEvent.State = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "WAITING_FOR_SLAVES"] = 1;
                    values[valuesById[2] = "SLAVES_FOUND"] = 2;
                    values[valuesById[3] = "INITIALIZING"] = 3;
                    values[valuesById[4] = "INITIALIZED"] = 4;
                    values[valuesById[5] = "DEINITIALIZING"] = 5;
                    values[valuesById[6] = "DEINITIALIZED"] = 6;
                    values[valuesById[7] = "TERMINATING"] = 7;
                    return values;
                })();

                return SystemEvent;
            })();

            Status.DeviceInfo = (function() {

                /**
                 * Properties of a DeviceInfo.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceInfo
                 * @property {Array.<motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice>|null} [devices] DeviceInfo devices
                 */

                /**
                 * Constructs a new DeviceInfo.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceInfo.
                 * @implements IDeviceInfo
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceInfo=} [properties] Properties to set
                 */
                function DeviceInfo(properties) {
                    this.devices = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceInfo devices.
                 * @member {Array.<motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice>} devices
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @instance
                 */
                DeviceInfo.prototype.devices = $util.emptyArray;

                /**
                 * Creates a new DeviceInfo instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceInfo=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo} DeviceInfo instance
                 */
                DeviceInfo.create = function create(properties) {
                    return new DeviceInfo(properties);
                };

                /**
                 * Encodes the specified DeviceInfo message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceInfo.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceInfo} message DeviceInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.devices != null && message.devices.length)
                        for (let i = 0; i < message.devices.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.encode(message.devices[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceInfo message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceInfo} message DeviceInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo} DeviceInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceInfo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.devices && message.devices.length))
                                    message.devices = [];
                                message.devices.push($root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo} DeviceInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceInfo message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.devices != null && message.hasOwnProperty("devices")) {
                        if (!Array.isArray(message.devices))
                            return "devices: array expected";
                        for (let i = 0; i < message.devices.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.verify(message.devices[i]);
                            if (error)
                                return "devices." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo} DeviceInfo
                 */
                DeviceInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceInfo)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceInfo();
                    if (object.devices) {
                        if (!Array.isArray(object.devices))
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceInfo.devices: array expected");
                        message.devices = [];
                        for (let i = 0; i < object.devices.length; ++i) {
                            if (typeof object.devices[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceInfo.devices: object expected");
                            message.devices[i] = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.fromObject(object.devices[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo} message DeviceInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.devices = [];
                    if (message.devices && message.devices.length) {
                        object.devices = [];
                        for (let j = 0; j < message.devices.length; ++j)
                            object.devices[j] = $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.toObject(message.devices[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DeviceInfo to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceInfo
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceInfo";
                };

                DeviceInfo.Device = (function() {

                    /**
                     * Properties of a Device.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                     * @interface IDevice
                     * @property {number|null} [deviceAddress] Device deviceAddress
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.Type|null} [type] Device type
                     * @property {number|null} [position] Device position
                     * @property {number|null} [alias] Device alias
                     */

                    /**
                     * Constructs a new Device.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo
                     * @classdesc Represents a Device.
                     * @implements IDevice
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice=} [properties] Properties to set
                     */
                    function Device(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Device deviceAddress.
                     * @member {number} deviceAddress
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @instance
                     */
                    Device.prototype.deviceAddress = 0;

                    /**
                     * Device type.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.Type} type
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @instance
                     */
                    Device.prototype.type = 0;

                    /**
                     * Device position.
                     * @member {number} position
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @instance
                     */
                    Device.prototype.position = 0;

                    /**
                     * Device alias.
                     * @member {number} alias
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @instance
                     */
                    Device.prototype.alias = 0;

                    /**
                     * Creates a new Device instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device} Device instance
                     */
                    Device.create = function create(properties) {
                        return new Device(properties);
                    };

                    /**
                     * Encodes the specified Device message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice} message Device message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Device.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                        if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.position);
                        if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.alias);
                        return writer;
                    };

                    /**
                     * Encodes the specified Device message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo.IDevice} message Device message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Device.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Device message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device} Device
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Device.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.deviceAddress = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.position = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.alias = reader.uint32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Device message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device} Device
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Device.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Device message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Device.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                            if (!$util.isInteger(message.deviceAddress))
                                return "deviceAddress: integer expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.position != null && message.hasOwnProperty("position"))
                            if (!$util.isInteger(message.position))
                                return "position: integer expected";
                        if (message.alias != null && message.hasOwnProperty("alias"))
                            if (!$util.isInteger(message.alias))
                                return "alias: integer expected";
                        return null;
                    };

                    /**
                     * Creates a Device message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device} Device
                     */
                    Device.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device();
                        if (object.deviceAddress != null)
                            message.deviceAddress = object.deviceAddress >>> 0;
                        switch (object.type) {
                        default:
                            if (typeof object.type === "number") {
                                message.type = object.type;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.type = 0;
                            break;
                        case "SOMANET_CIA401_ETHERCAT":
                        case 1:
                            message.type = 1;
                            break;
                        case "SOMANET_CIA402_ETHERCAT":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        if (object.position != null)
                            message.position = object.position >>> 0;
                        if (object.alias != null)
                            message.alias = object.alias >>> 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a Device message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceInfo.Device} message Device
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Device.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.deviceAddress = 0;
                            object.type = options.enums === String ? "UNSPECIFIED" : 0;
                            object.position = 0;
                            object.alias = 0;
                        }
                        if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                            object.deviceAddress = message.deviceAddress;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.Type[message.type] === undefined ? message.type : $root.motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.Type[message.type] : message.type;
                        if (message.position != null && message.hasOwnProperty("position"))
                            object.position = message.position;
                        if (message.alias != null && message.hasOwnProperty("alias"))
                            object.alias = message.alias;
                        return object;
                    };

                    /**
                     * Converts this Device to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Device.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Device
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceInfo.Device
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Device.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceInfo.Device";
                    };

                    /**
                     * Type enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceInfo.Device.Type
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SOMANET_CIA401_ETHERCAT=1 SOMANET_CIA401_ETHERCAT value
                     * @property {number} SOMANET_CIA402_ETHERCAT=2 SOMANET_CIA402_ETHERCAT value
                     */
                    Device.Type = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SOMANET_CIA401_ETHERCAT"] = 1;
                        values[valuesById[2] = "SOMANET_CIA402_ETHERCAT"] = 2;
                        return values;
                    })();

                    return Device;
                })();

                return DeviceInfo;
            })();

            Status.DeviceParameterInfo = (function() {

                /**
                 * Properties of a DeviceParameterInfo.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceParameterInfo
                 * @property {number|null} [deviceAddress] DeviceParameterInfo deviceAddress
                 * @property {Array.<motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter>|null} [parameters] DeviceParameterInfo parameters
                 */

                /**
                 * Constructs a new DeviceParameterInfo.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceParameterInfo.
                 * @implements IDeviceParameterInfo
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo=} [properties] Properties to set
                 */
                function DeviceParameterInfo(properties) {
                    this.parameters = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceParameterInfo deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @instance
                 */
                DeviceParameterInfo.prototype.deviceAddress = 0;

                /**
                 * DeviceParameterInfo parameters.
                 * @member {Array.<motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter>} parameters
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @instance
                 */
                DeviceParameterInfo.prototype.parameters = $util.emptyArray;

                /**
                 * Creates a new DeviceParameterInfo instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo} DeviceParameterInfo instance
                 */
                DeviceParameterInfo.create = function create(properties) {
                    return new DeviceParameterInfo(properties);
                };

                /**
                 * Encodes the specified DeviceParameterInfo message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo} message DeviceParameterInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceParameterInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.parameters != null && message.parameters.length)
                        for (let i = 0; i < message.parameters.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.encode(message.parameters[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceParameterInfo message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterInfo} message DeviceParameterInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceParameterInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceParameterInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo} DeviceParameterInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceParameterInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                if (!(message.parameters && message.parameters.length))
                                    message.parameters = [];
                                message.parameters.push($root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceParameterInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo} DeviceParameterInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceParameterInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceParameterInfo message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceParameterInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.parameters != null && message.hasOwnProperty("parameters")) {
                        if (!Array.isArray(message.parameters))
                            return "parameters: array expected";
                        for (let i = 0; i < message.parameters.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.verify(message.parameters[i]);
                            if (error)
                                return "parameters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceParameterInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo} DeviceParameterInfo
                 */
                DeviceParameterInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.parameters) {
                        if (!Array.isArray(object.parameters))
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.parameters: array expected");
                        message.parameters = [];
                        for (let i = 0; i < object.parameters.length; ++i) {
                            if (typeof object.parameters[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.parameters: object expected");
                            message.parameters[i] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.fromObject(object.parameters[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceParameterInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo} message DeviceParameterInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceParameterInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.parameters = [];
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.parameters && message.parameters.length) {
                        object.parameters = [];
                        for (let j = 0; j < message.parameters.length; ++j)
                            object.parameters[j] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.toObject(message.parameters[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DeviceParameterInfo to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceParameterInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceParameterInfo
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceParameterInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterInfo";
                };

                DeviceParameterInfo.Parameter = (function() {

                    /**
                     * Properties of a Parameter.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                     * @interface IParameter
                     * @property {number|null} [index] Parameter index
                     * @property {number|null} [subindex] Parameter subindex
                     * @property {string|null} [name] Parameter name
                     * @property {string|null} [unit] Parameter unit
                     * @property {string|null} [group] Parameter group
                     * @property {boolean|null} [readAccess] Parameter readAccess
                     * @property {boolean|null} [writeAccess] Parameter writeAccess
                     * @property {number|null} [min] Parameter min
                     * @property {number|null} [max] Parameter max
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.ValueType|null} [valueType] Parameter valueType
                     */

                    /**
                     * Constructs a new Parameter.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo
                     * @classdesc Represents a Parameter.
                     * @implements IParameter
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter=} [properties] Properties to set
                     */
                    function Parameter(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Parameter index.
                     * @member {number} index
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.index = 0;

                    /**
                     * Parameter subindex.
                     * @member {number} subindex
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.subindex = 0;

                    /**
                     * Parameter name.
                     * @member {string} name
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.name = "";

                    /**
                     * Parameter unit.
                     * @member {string} unit
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.unit = "";

                    /**
                     * Parameter group.
                     * @member {string} group
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.group = "";

                    /**
                     * Parameter readAccess.
                     * @member {boolean} readAccess
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.readAccess = false;

                    /**
                     * Parameter writeAccess.
                     * @member {boolean} writeAccess
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.writeAccess = false;

                    /**
                     * Parameter min.
                     * @member {number} min
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.min = 0;

                    /**
                     * Parameter max.
                     * @member {number} max
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.max = 0;

                    /**
                     * Parameter valueType.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.ValueType} valueType
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     */
                    Parameter.prototype.valueType = 0;

                    /**
                     * Creates a new Parameter instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter} Parameter instance
                     */
                    Parameter.create = function create(properties) {
                        return new Parameter(properties);
                    };

                    /**
                     * Encodes the specified Parameter message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                        if (message.subindex != null && Object.hasOwnProperty.call(message, "subindex"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.subindex);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.unit);
                        if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.group);
                        if (message.readAccess != null && Object.hasOwnProperty.call(message, "readAccess"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.readAccess);
                        if (message.writeAccess != null && Object.hasOwnProperty.call(message, "writeAccess"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.writeAccess);
                        if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.min);
                        if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.max);
                        if (message.valueType != null && Object.hasOwnProperty.call(message, "valueType"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.valueType);
                        return writer;
                    };

                    /**
                     * Encodes the specified Parameter message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Parameter message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.index = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.subindex = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.name = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.unit = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.group = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.readAccess = reader.bool();
                                    break;
                                }
                            case 7: {
                                    message.writeAccess = reader.bool();
                                    break;
                                }
                            case 8: {
                                    message.min = reader.int32();
                                    break;
                                }
                            case 9: {
                                    message.max = reader.int32();
                                    break;
                                }
                            case 10: {
                                    message.valueType = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Parameter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Parameter message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Parameter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.index != null && message.hasOwnProperty("index"))
                            if (!$util.isInteger(message.index))
                                return "index: integer expected";
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            if (!$util.isInteger(message.subindex))
                                return "subindex: integer expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            if (!$util.isString(message.unit))
                                return "unit: string expected";
                        if (message.group != null && message.hasOwnProperty("group"))
                            if (!$util.isString(message.group))
                                return "group: string expected";
                        if (message.readAccess != null && message.hasOwnProperty("readAccess"))
                            if (typeof message.readAccess !== "boolean")
                                return "readAccess: boolean expected";
                        if (message.writeAccess != null && message.hasOwnProperty("writeAccess"))
                            if (typeof message.writeAccess !== "boolean")
                                return "writeAccess: boolean expected";
                        if (message.min != null && message.hasOwnProperty("min"))
                            if (!$util.isInteger(message.min))
                                return "min: integer expected";
                        if (message.max != null && message.hasOwnProperty("max"))
                            if (!$util.isInteger(message.max))
                                return "max: integer expected";
                        if (message.valueType != null && message.hasOwnProperty("valueType"))
                            switch (message.valueType) {
                            default:
                                return "valueType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a Parameter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter} Parameter
                     */
                    Parameter.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter();
                        if (object.index != null)
                            message.index = object.index >>> 0;
                        if (object.subindex != null)
                            message.subindex = object.subindex >>> 0;
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.unit != null)
                            message.unit = String(object.unit);
                        if (object.group != null)
                            message.group = String(object.group);
                        if (object.readAccess != null)
                            message.readAccess = Boolean(object.readAccess);
                        if (object.writeAccess != null)
                            message.writeAccess = Boolean(object.writeAccess);
                        if (object.min != null)
                            message.min = object.min | 0;
                        if (object.max != null)
                            message.max = object.max | 0;
                        switch (object.valueType) {
                        default:
                            if (typeof object.valueType === "number") {
                                message.valueType = object.valueType;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.valueType = 0;
                            break;
                        case "BOOLEAN":
                        case 1:
                            message.valueType = 1;
                            break;
                        case "INTEGER8":
                        case 2:
                            message.valueType = 2;
                            break;
                        case "INTEGER16":
                        case 3:
                            message.valueType = 3;
                            break;
                        case "INTEGER32":
                        case 4:
                            message.valueType = 4;
                            break;
                        case "UNSIGNED8":
                        case 5:
                            message.valueType = 5;
                            break;
                        case "UNSIGNED16":
                        case 6:
                            message.valueType = 6;
                            break;
                        case "UNSIGNED32":
                        case 7:
                            message.valueType = 7;
                            break;
                        case "REAL32":
                        case 8:
                            message.valueType = 8;
                            break;
                        case "VISIBLE_STRING":
                        case 9:
                            message.valueType = 9;
                            break;
                        case "OCTET_STRING":
                        case 10:
                            message.valueType = 10;
                            break;
                        case "UNICODE_STRING":
                        case 11:
                            message.valueType = 11;
                            break;
                        case "TIME_OF_DAY":
                        case 12:
                            message.valueType = 12;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Parameter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter} message Parameter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Parameter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.index = 0;
                            object.subindex = 0;
                            object.name = "";
                            object.unit = "";
                            object.group = "";
                            object.readAccess = false;
                            object.writeAccess = false;
                            object.min = 0;
                            object.max = 0;
                            object.valueType = options.enums === String ? "UNSPECIFIED" : 0;
                        }
                        if (message.index != null && message.hasOwnProperty("index"))
                            object.index = message.index;
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            object.subindex = message.subindex;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            object.unit = message.unit;
                        if (message.group != null && message.hasOwnProperty("group"))
                            object.group = message.group;
                        if (message.readAccess != null && message.hasOwnProperty("readAccess"))
                            object.readAccess = message.readAccess;
                        if (message.writeAccess != null && message.hasOwnProperty("writeAccess"))
                            object.writeAccess = message.writeAccess;
                        if (message.min != null && message.hasOwnProperty("min"))
                            object.min = message.min;
                        if (message.max != null && message.hasOwnProperty("max"))
                            object.max = message.max;
                        if (message.valueType != null && message.hasOwnProperty("valueType"))
                            object.valueType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.ValueType[message.valueType] === undefined ? message.valueType : $root.motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.ValueType[message.valueType] : message.valueType;
                        return object;
                    };

                    /**
                     * Converts this Parameter to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Parameter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Parameter
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Parameter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter";
                    };

                    /**
                     * ValueType enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceParameterInfo.Parameter.ValueType
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} BOOLEAN=1 BOOLEAN value
                     * @property {number} INTEGER8=2 INTEGER8 value
                     * @property {number} INTEGER16=3 INTEGER16 value
                     * @property {number} INTEGER32=4 INTEGER32 value
                     * @property {number} UNSIGNED8=5 UNSIGNED8 value
                     * @property {number} UNSIGNED16=6 UNSIGNED16 value
                     * @property {number} UNSIGNED32=7 UNSIGNED32 value
                     * @property {number} REAL32=8 REAL32 value
                     * @property {number} VISIBLE_STRING=9 VISIBLE_STRING value
                     * @property {number} OCTET_STRING=10 OCTET_STRING value
                     * @property {number} UNICODE_STRING=11 UNICODE_STRING value
                     * @property {number} TIME_OF_DAY=12 TIME_OF_DAY value
                     */
                    Parameter.ValueType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "BOOLEAN"] = 1;
                        values[valuesById[2] = "INTEGER8"] = 2;
                        values[valuesById[3] = "INTEGER16"] = 3;
                        values[valuesById[4] = "INTEGER32"] = 4;
                        values[valuesById[5] = "UNSIGNED8"] = 5;
                        values[valuesById[6] = "UNSIGNED16"] = 6;
                        values[valuesById[7] = "UNSIGNED32"] = 7;
                        values[valuesById[8] = "REAL32"] = 8;
                        values[valuesById[9] = "VISIBLE_STRING"] = 9;
                        values[valuesById[10] = "OCTET_STRING"] = 10;
                        values[valuesById[11] = "UNICODE_STRING"] = 11;
                        values[valuesById[12] = "TIME_OF_DAY"] = 12;
                        return values;
                    })();

                    return Parameter;
                })();

                return DeviceParameterInfo;
            })();

            Status.DeviceParameterValues = (function() {

                /**
                 * Properties of a DeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceParameterValues
                 * @property {number|null} [deviceAddress] DeviceParameterValues deviceAddress
                 * @property {Array.<motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue>|null} [parameterValues] DeviceParameterValues parameterValues
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress|null} [progress] DeviceParameterValues progress
                 */

                /**
                 * Constructs a new DeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceParameterValues.
                 * @implements IDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues=} [properties] Properties to set
                 */
                function DeviceParameterValues(properties) {
                    this.parameterValues = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceParameterValues deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @instance
                 */
                DeviceParameterValues.prototype.deviceAddress = 0;

                /**
                 * DeviceParameterValues parameterValues.
                 * @member {Array.<motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue>} parameterValues
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @instance
                 */
                DeviceParameterValues.prototype.parameterValues = $util.emptyArray;

                /**
                 * DeviceParameterValues progress.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @instance
                 */
                DeviceParameterValues.prototype.progress = null;

                /**
                 * Creates a new DeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues} DeviceParameterValues instance
                 */
                DeviceParameterValues.create = function create(properties) {
                    return new DeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified DeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues} message DeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.parameterValues != null && message.parameterValues.length)
                        for (let i = 0; i < message.parameterValues.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.encode(message.parameterValues[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.encode(message.progress, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues} message DeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues} DeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                if (!(message.parameterValues && message.parameterValues.length))
                                    message.parameterValues = [];
                                message.parameterValues.push($root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues} DeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.parameterValues != null && message.hasOwnProperty("parameterValues")) {
                        if (!Array.isArray(message.parameterValues))
                            return "parameterValues: array expected";
                        for (let i = 0; i < message.parameterValues.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.verify(message.parameterValues[i]);
                            if (error)
                                return "parameterValues." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.verify(message.progress);
                        if (error)
                            return "progress." + error;
                    }
                    return null;
                };

                /**
                 * Creates a DeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues} DeviceParameterValues
                 */
                DeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.parameterValues) {
                        if (!Array.isArray(object.parameterValues))
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterValues.parameterValues: array expected");
                        message.parameterValues = [];
                        for (let i = 0; i < object.parameterValues.length; ++i) {
                            if (typeof object.parameterValues[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterValues.parameterValues: object expected");
                            message.parameterValues[i] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.fromObject(object.parameterValues[i]);
                        }
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterValues.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.fromObject(object.progress);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues} message DeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.parameterValues = [];
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.progress = null;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.parameterValues && message.parameterValues.length) {
                        object.parameterValues = [];
                        for (let j = 0; j < message.parameterValues.length; ++j)
                            object.parameterValues[j] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.toObject(message.parameterValues[j], options);
                    }
                    if (message.progress != null && message.hasOwnProperty("progress"))
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.toObject(message.progress, options);
                    return object;
                };

                /**
                 * Converts this DeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterValues";
                };

                DeviceParameterValues.ParameterValue = (function() {

                    /**
                     * Properties of a ParameterValue.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                     * @interface IParameterValue
                     * @property {number|null} [index] ParameterValue index
                     * @property {number|null} [subindex] ParameterValue subindex
                     * @property {number|null} [intValue] ParameterValue intValue
                     * @property {number|null} [uintValue] ParameterValue uintValue
                     * @property {number|null} [floatValue] ParameterValue floatValue
                     * @property {string|null} [stringValue] ParameterValue stringValue
                     * @property {Uint8Array|null} [rawValue] ParameterValue rawValue
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess|null} [success] ParameterValue success
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError|null} [error] ParameterValue error
                     */

                    /**
                     * Constructs a new ParameterValue.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                     * @classdesc Represents a ParameterValue.
                     * @implements IParameterValue
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue=} [properties] Properties to set
                     */
                    function ParameterValue(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ParameterValue index.
                     * @member {number} index
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.index = 0;

                    /**
                     * ParameterValue subindex.
                     * @member {number} subindex
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.subindex = 0;

                    /**
                     * ParameterValue intValue.
                     * @member {number|null|undefined} intValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.intValue = null;

                    /**
                     * ParameterValue uintValue.
                     * @member {number|null|undefined} uintValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.uintValue = null;

                    /**
                     * ParameterValue floatValue.
                     * @member {number|null|undefined} floatValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.floatValue = null;

                    /**
                     * ParameterValue stringValue.
                     * @member {string|null|undefined} stringValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.stringValue = null;

                    /**
                     * ParameterValue rawValue.
                     * @member {Uint8Array|null|undefined} rawValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.rawValue = null;

                    /**
                     * ParameterValue success.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess|null|undefined} success
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.success = null;

                    /**
                     * ParameterValue error.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError|null|undefined} error
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    ParameterValue.prototype.error = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * ParameterValue typeValue.
                     * @member {"intValue"|"uintValue"|"floatValue"|"stringValue"|"rawValue"|undefined} typeValue
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    Object.defineProperty(ParameterValue.prototype, "typeValue", {
                        get: $util.oneOfGetter($oneOfFields = ["intValue", "uintValue", "floatValue", "stringValue", "rawValue"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * ParameterValue status.
                     * @member {"success"|"error"|undefined} status
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     */
                    Object.defineProperty(ParameterValue.prototype, "status", {
                        get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new ParameterValue instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue} ParameterValue instance
                     */
                    ParameterValue.create = function create(properties) {
                        return new ParameterValue(properties);
                    };

                    /**
                     * Encodes the specified ParameterValue message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue} message ParameterValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.index);
                        if (message.subindex != null && Object.hasOwnProperty.call(message, "subindex"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.subindex);
                        if (message.intValue != null && Object.hasOwnProperty.call(message, "intValue"))
                            writer.uint32(/* id 3, wireType 0 =*/24).sint64(message.intValue);
                        if (message.uintValue != null && Object.hasOwnProperty.call(message, "uintValue"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.uintValue);
                        if (message.floatValue != null && Object.hasOwnProperty.call(message, "floatValue"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.floatValue);
                        if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.stringValue);
                        if (message.rawValue != null && Object.hasOwnProperty.call(message, "rawValue"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.rawValue);
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.encode(message.success, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                            $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.encode(message.error, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified ParameterValue message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IParameterValue} message ParameterValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ParameterValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue} ParameterValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.index = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.subindex = reader.uint32();
                                    break;
                                }
                            case 3: {
                                    message.intValue = reader.sint64();
                                    break;
                                }
                            case 4: {
                                    message.uintValue = reader.uint64();
                                    break;
                                }
                            case 5: {
                                    message.floatValue = reader.float();
                                    break;
                                }
                            case 6: {
                                    message.stringValue = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.rawValue = reader.bytes();
                                    break;
                                }
                            case 8: {
                                    message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.decode(reader, reader.uint32());
                                    break;
                                }
                            case 9: {
                                    message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ParameterValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue} ParameterValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ParameterValue message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ParameterValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        let properties = {};
                        if (message.index != null && message.hasOwnProperty("index"))
                            if (!$util.isInteger(message.index))
                                return "index: integer expected";
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            if (!$util.isInteger(message.subindex))
                                return "subindex: integer expected";
                        if (message.intValue != null && message.hasOwnProperty("intValue")) {
                            properties.typeValue = 1;
                            if (!$util.isInteger(message.intValue) && !(message.intValue && $util.isInteger(message.intValue.low) && $util.isInteger(message.intValue.high)))
                                return "intValue: integer|Long expected";
                        }
                        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!$util.isInteger(message.uintValue) && !(message.uintValue && $util.isInteger(message.uintValue.low) && $util.isInteger(message.uintValue.high)))
                                return "uintValue: integer|Long expected";
                        }
                        if (message.floatValue != null && message.hasOwnProperty("floatValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (typeof message.floatValue !== "number")
                                return "floatValue: number expected";
                        }
                        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!$util.isString(message.stringValue))
                                return "stringValue: string expected";
                        }
                        if (message.rawValue != null && message.hasOwnProperty("rawValue")) {
                            if (properties.typeValue === 1)
                                return "typeValue: multiple values";
                            properties.typeValue = 1;
                            if (!(message.rawValue && typeof message.rawValue.length === "number" || $util.isString(message.rawValue)))
                                return "rawValue: buffer expected";
                        }
                        if (message.success != null && message.hasOwnProperty("success")) {
                            properties.status = 1;
                            {
                                let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.verify(message.success);
                                if (error)
                                    return "success." + error;
                            }
                        }
                        if (message.error != null && message.hasOwnProperty("error")) {
                            if (properties.status === 1)
                                return "status: multiple values";
                            properties.status = 1;
                            {
                                let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.verify(message.error);
                                if (error)
                                    return "error." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a ParameterValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue} ParameterValue
                     */
                    ParameterValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue();
                        if (object.index != null)
                            message.index = object.index >>> 0;
                        if (object.subindex != null)
                            message.subindex = object.subindex >>> 0;
                        if (object.intValue != null)
                            if ($util.Long)
                                (message.intValue = $util.Long.fromValue(object.intValue)).unsigned = false;
                            else if (typeof object.intValue === "string")
                                message.intValue = parseInt(object.intValue, 10);
                            else if (typeof object.intValue === "number")
                                message.intValue = object.intValue;
                            else if (typeof object.intValue === "object")
                                message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
                        if (object.uintValue != null)
                            if ($util.Long)
                                (message.uintValue = $util.Long.fromValue(object.uintValue)).unsigned = true;
                            else if (typeof object.uintValue === "string")
                                message.uintValue = parseInt(object.uintValue, 10);
                            else if (typeof object.uintValue === "number")
                                message.uintValue = object.uintValue;
                            else if (typeof object.uintValue === "object")
                                message.uintValue = new $util.LongBits(object.uintValue.low >>> 0, object.uintValue.high >>> 0).toNumber(true);
                        if (object.floatValue != null)
                            message.floatValue = Number(object.floatValue);
                        if (object.stringValue != null)
                            message.stringValue = String(object.stringValue);
                        if (object.rawValue != null)
                            if (typeof object.rawValue === "string")
                                $util.base64.decode(object.rawValue, message.rawValue = $util.newBuffer($util.base64.length(object.rawValue)), 0);
                            else if (object.rawValue.length >= 0)
                                message.rawValue = object.rawValue;
                        if (object.success != null) {
                            if (typeof object.success !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.success: object expected");
                            message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.fromObject(object.success);
                        }
                        if (object.error != null) {
                            if (typeof object.error !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.error: object expected");
                            message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.fromObject(object.error);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ParameterValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue} message ParameterValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ParameterValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.index = 0;
                            object.subindex = 0;
                        }
                        if (message.index != null && message.hasOwnProperty("index"))
                            object.index = message.index;
                        if (message.subindex != null && message.hasOwnProperty("subindex"))
                            object.subindex = message.subindex;
                        if (message.intValue != null && message.hasOwnProperty("intValue")) {
                            if (typeof message.intValue === "number")
                                object.intValue = options.longs === String ? String(message.intValue) : message.intValue;
                            else
                                object.intValue = options.longs === String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
                            if (options.oneofs)
                                object.typeValue = "intValue";
                        }
                        if (message.uintValue != null && message.hasOwnProperty("uintValue")) {
                            if (typeof message.uintValue === "number")
                                object.uintValue = options.longs === String ? String(message.uintValue) : message.uintValue;
                            else
                                object.uintValue = options.longs === String ? $util.Long.prototype.toString.call(message.uintValue) : options.longs === Number ? new $util.LongBits(message.uintValue.low >>> 0, message.uintValue.high >>> 0).toNumber(true) : message.uintValue;
                            if (options.oneofs)
                                object.typeValue = "uintValue";
                        }
                        if (message.floatValue != null && message.hasOwnProperty("floatValue")) {
                            object.floatValue = options.json && !isFinite(message.floatValue) ? String(message.floatValue) : message.floatValue;
                            if (options.oneofs)
                                object.typeValue = "floatValue";
                        }
                        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
                            object.stringValue = message.stringValue;
                            if (options.oneofs)
                                object.typeValue = "stringValue";
                        }
                        if (message.rawValue != null && message.hasOwnProperty("rawValue")) {
                            object.rawValue = options.bytes === String ? $util.base64.encode(message.rawValue, 0, message.rawValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.rawValue) : message.rawValue;
                            if (options.oneofs)
                                object.typeValue = "rawValue";
                        }
                        if (message.success != null && message.hasOwnProperty("success")) {
                            object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.toObject(message.success, options);
                            if (options.oneofs)
                                object.status = "success";
                        }
                        if (message.error != null && message.hasOwnProperty("error")) {
                            object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.toObject(message.error, options);
                            if (options.oneofs)
                                object.status = "error";
                        }
                        return object;
                    };

                    /**
                     * Converts this ParameterValue to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ParameterValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ParameterValue
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ParameterValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue";
                    };

                    ParameterValue.Success = (function() {

                        /**
                         * Properties of a Success.
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                         * @interface ISuccess
                         * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.Code|null} [code] Success code
                         * @property {string|null} [message] Success message
                         */

                        /**
                         * Constructs a new Success.
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                         * @classdesc Represents a Success.
                         * @implements ISuccess
                         * @constructor
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess=} [properties] Properties to set
                         */
                        function Success(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Success code.
                         * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.Code} code
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @instance
                         */
                        Success.prototype.code = 0;

                        /**
                         * Success message.
                         * @member {string} message
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @instance
                         */
                        Success.prototype.message = "";

                        /**
                         * Creates a new Success instance using the specified properties.
                         * @function create
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess=} [properties] Properties to set
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success} Success instance
                         */
                        Success.create = function create(properties) {
                            return new Success(properties);
                        };

                        /**
                         * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.verify|verify} messages.
                         * @function encode
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess} message Success message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Success.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };

                        /**
                         * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.ISuccess} message Success message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Success.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Success message from the specified reader or buffer.
                         * @function decode
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success} Success
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Success.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.code = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.message = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Success message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success} Success
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Success.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Success message.
                         * @function verify
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Success.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.code != null && message.hasOwnProperty("code"))
                                switch (message.code) {
                                default:
                                    return "code: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.message != null && message.hasOwnProperty("message"))
                                if (!$util.isString(message.message))
                                    return "message: string expected";
                            return null;
                        };

                        /**
                         * Creates a Success message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success} Success
                         */
                        Success.fromObject = function fromObject(object) {
                            if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success)
                                return object;
                            let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success();
                            switch (object.code) {
                            default:
                                if (typeof object.code === "number") {
                                    message.code = object.code;
                                    break;
                                }
                                break;
                            case "UNSPECIFIED":
                            case 0:
                                message.code = 0;
                                break;
                            case "DONE":
                            case 1:
                                message.code = 1;
                                break;
                            case "CHANGED":
                            case 2:
                                message.code = 2;
                                break;
                            }
                            if (object.message != null)
                                message.message = String(object.message);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Success message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success} message Success
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Success.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.code = options.enums === String ? "UNSPECIFIED" : 0;
                                object.message = "";
                            }
                            if (message.code != null && message.hasOwnProperty("code"))
                                object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.Code[message.code] : message.code;
                            if (message.message != null && message.hasOwnProperty("message"))
                                object.message = message.message;
                            return object;
                        };

                        /**
                         * Converts this Success to JSON.
                         * @function toJSON
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Success.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Success
                         * @function getTypeUrl
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success";
                        };

                        /**
                         * Code enum.
                         * @name motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Success.Code
                         * @enum {number}
                         * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                         * @property {number} DONE=1 DONE value
                         * @property {number} CHANGED=2 CHANGED value
                         */
                        Success.Code = (function() {
                            const valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "UNSPECIFIED"] = 0;
                            values[valuesById[1] = "DONE"] = 1;
                            values[valuesById[2] = "CHANGED"] = 2;
                            return values;
                        })();

                        return Success;
                    })();

                    ParameterValue.Error = (function() {

                        /**
                         * Properties of an Error.
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                         * @interface IError
                         * @property {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.Code|null} [code] Error code
                         * @property {string|null} [message] Error message
                         */

                        /**
                         * Constructs a new Error.
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue
                         * @classdesc Represents an Error.
                         * @implements IError
                         * @constructor
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError=} [properties] Properties to set
                         */
                        function Error(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Error code.
                         * @member {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.Code} code
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @instance
                         */
                        Error.prototype.code = 0;

                        /**
                         * Error message.
                         * @member {string} message
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @instance
                         */
                        Error.prototype.message = "";

                        /**
                         * Creates a new Error instance using the specified properties.
                         * @function create
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError=} [properties] Properties to set
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error} Error instance
                         */
                        Error.create = function create(properties) {
                            return new Error(properties);
                        };

                        /**
                         * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.verify|verify} messages.
                         * @function encode
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError} message Error message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Error.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };

                        /**
                         * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.IError} message Error message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Error.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Error message from the specified reader or buffer.
                         * @function decode
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error} Error
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Error.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1: {
                                        message.code = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.message = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Error message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error} Error
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Error.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Error message.
                         * @function verify
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Error.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.code != null && message.hasOwnProperty("code"))
                                switch (message.code) {
                                default:
                                    return "code: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                            if (message.message != null && message.hasOwnProperty("message"))
                                if (!$util.isString(message.message))
                                    return "message: string expected";
                            return null;
                        };

                        /**
                         * Creates an Error message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error} Error
                         */
                        Error.fromObject = function fromObject(object) {
                            if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error)
                                return object;
                            let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error();
                            switch (object.code) {
                            default:
                                if (typeof object.code === "number") {
                                    message.code = object.code;
                                    break;
                                }
                                break;
                            case "UNSPECIFIED":
                            case 0:
                                message.code = 0;
                                break;
                            case "NOT_FOUND":
                            case 1:
                                message.code = 1;
                                break;
                            case "CANNOT_REFRESH_VALUE":
                            case 2:
                                message.code = 2;
                                break;
                            case "NOT_CHANGED":
                            case 3:
                                message.code = 3;
                                break;
                            }
                            if (object.message != null)
                                message.message = String(object.message);
                            return message;
                        };

                        /**
                         * Creates a plain object from an Error message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error} message Error
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Error.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.code = options.enums === String ? "UNSPECIFIED" : 0;
                                object.message = "";
                            }
                            if (message.code != null && message.hasOwnProperty("code"))
                                object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.Code[message.code] : message.code;
                            if (message.message != null && message.hasOwnProperty("message"))
                                object.message = message.message;
                            return object;
                        };

                        /**
                         * Converts this Error to JSON.
                         * @function toJSON
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Error.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for Error
                         * @function getTypeUrl
                         * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error";
                        };

                        /**
                         * Code enum.
                         * @name motionmaster.MotionMasterMessage.Status.DeviceParameterValues.ParameterValue.Error.Code
                         * @enum {number}
                         * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                         * @property {number} NOT_FOUND=1 NOT_FOUND value
                         * @property {number} CANNOT_REFRESH_VALUE=2 CANNOT_REFRESH_VALUE value
                         * @property {number} NOT_CHANGED=3 NOT_CHANGED value
                         */
                        Error.Code = (function() {
                            const valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "UNSPECIFIED"] = 0;
                            values[valuesById[1] = "NOT_FOUND"] = 1;
                            values[valuesById[2] = "CANNOT_REFRESH_VALUE"] = 2;
                            values[valuesById[3] = "NOT_CHANGED"] = 3;
                            return values;
                        })();

                        return Error;
                    })();

                    return ParameterValue;
                })();

                DeviceParameterValues.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                     * @interface IProgress
                     * @property {number|null} [percentage] Progress percentage
                     * @property {string|null} [message] Progress message
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Progress message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @instance
                     */
                    Progress.prototype.message = "";

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.percentage);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress();
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.percentage = 0;
                            object.message = "";
                        }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceParameterValues.Progress";
                    };

                    return Progress;
                })();

                return DeviceParameterValues;
            })();

            Status.MultiDeviceParameterValues = (function() {

                /**
                 * Properties of a MultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IMultiDeviceParameterValues
                 * @property {Array.<motionmaster.MotionMasterMessage.Status.IDeviceParameterValues>|null} [collection] MultiDeviceParameterValues collection
                 */

                /**
                 * Constructs a new MultiDeviceParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a MultiDeviceParameterValues.
                 * @implements IMultiDeviceParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues=} [properties] Properties to set
                 */
                function MultiDeviceParameterValues(properties) {
                    this.collection = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MultiDeviceParameterValues collection.
                 * @member {Array.<motionmaster.MotionMasterMessage.Status.IDeviceParameterValues>} collection
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @instance
                 */
                MultiDeviceParameterValues.prototype.collection = $util.emptyArray;

                /**
                 * Creates a new MultiDeviceParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues} MultiDeviceParameterValues instance
                 */
                MultiDeviceParameterValues.create = function create(properties) {
                    return new MultiDeviceParameterValues(properties);
                };

                /**
                 * Encodes the specified MultiDeviceParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues} message MultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MultiDeviceParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.collection != null && message.collection.length)
                        for (let i = 0; i < message.collection.length; ++i)
                            $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.encode(message.collection[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MultiDeviceParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMultiDeviceParameterValues} message MultiDeviceParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MultiDeviceParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MultiDeviceParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues} MultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MultiDeviceParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.collection && message.collection.length))
                                    message.collection = [];
                                message.collection.push($root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MultiDeviceParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues} MultiDeviceParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MultiDeviceParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MultiDeviceParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MultiDeviceParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.collection != null && message.hasOwnProperty("collection")) {
                        if (!Array.isArray(message.collection))
                            return "collection: array expected";
                        for (let i = 0; i < message.collection.length; ++i) {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.verify(message.collection[i]);
                            if (error)
                                return "collection." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MultiDeviceParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues} MultiDeviceParameterValues
                 */
                MultiDeviceParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues();
                    if (object.collection) {
                        if (!Array.isArray(object.collection))
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.collection: array expected");
                        message.collection = [];
                        for (let i = 0; i < object.collection.length; ++i) {
                            if (typeof object.collection[i] !== "object")
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues.collection: object expected");
                            message.collection[i] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.fromObject(object.collection[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MultiDeviceParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues} message MultiDeviceParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MultiDeviceParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.collection = [];
                    if (message.collection && message.collection.length) {
                        object.collection = [];
                        for (let j = 0; j < message.collection.length; ++j)
                            object.collection[j] = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.toObject(message.collection[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this MultiDeviceParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MultiDeviceParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MultiDeviceParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MultiDeviceParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MultiDeviceParameterValues";
                };

                return MultiDeviceParameterValues;
            })();

            Status.DeviceFileList = (function() {

                /**
                 * Properties of a DeviceFileList.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceFileList
                 * @property {number|null} [deviceAddress] DeviceFileList deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList|null} [fileList] DeviceFileList fileList
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError|null} [error] DeviceFileList error
                 */

                /**
                 * Constructs a new DeviceFileList.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceFileList.
                 * @implements IDeviceFileList
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFileList=} [properties] Properties to set
                 */
                function DeviceFileList(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceFileList deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @instance
                 */
                DeviceFileList.prototype.deviceAddress = 0;

                /**
                 * DeviceFileList fileList.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList|null|undefined} fileList
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @instance
                 */
                DeviceFileList.prototype.fileList = null;

                /**
                 * DeviceFileList error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @instance
                 */
                DeviceFileList.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceFileList data.
                 * @member {"fileList"|"error"|undefined} data
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @instance
                 */
                Object.defineProperty(DeviceFileList.prototype, "data", {
                    get: $util.oneOfGetter($oneOfFields = ["fileList", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceFileList instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFileList=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList} DeviceFileList instance
                 */
                DeviceFileList.create = function create(properties) {
                    return new DeviceFileList(properties);
                };

                /**
                 * Encodes the specified DeviceFileList message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFileList} message DeviceFileList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFileList.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.fileList != null && Object.hasOwnProperty.call(message, "fileList"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.encode(message.fileList, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceFileList message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFileList} message DeviceFileList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFileList.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceFileList message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList} DeviceFileList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFileList.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.fileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceFileList message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList} DeviceFileList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFileList.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceFileList message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceFileList.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.fileList != null && message.hasOwnProperty("fileList")) {
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.verify(message.fileList);
                            if (error)
                                return "fileList." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceFileList message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList} DeviceFileList
                 */
                DeviceFileList.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFileList)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.fileList != null) {
                        if (typeof object.fileList !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFileList.fileList: object expected");
                        message.fileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.fromObject(object.fileList);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFileList.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceFileList message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList} message DeviceFileList
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceFileList.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.fileList != null && message.hasOwnProperty("fileList")) {
                        object.fileList = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.toObject(message.fileList, options);
                        if (options.oneofs)
                            object.data = "fileList";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.data = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceFileList to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceFileList.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceFileList
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceFileList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFileList";
                };

                DeviceFileList.FileList = (function() {

                    /**
                     * Properties of a FileList.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                     * @interface IFileList
                     * @property {Array.<string>|null} [files] FileList files
                     */

                    /**
                     * Constructs a new FileList.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                     * @classdesc Represents a FileList.
                     * @implements IFileList
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList=} [properties] Properties to set
                     */
                    function FileList(properties) {
                        this.files = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FileList files.
                     * @member {Array.<string>} files
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @instance
                     */
                    FileList.prototype.files = $util.emptyArray;

                    /**
                     * Creates a new FileList instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList} FileList instance
                     */
                    FileList.create = function create(properties) {
                        return new FileList(properties);
                    };

                    /**
                     * Encodes the specified FileList message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList} message FileList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.files != null && message.files.length)
                            for (let i = 0; i < message.files.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.files[i]);
                        return writer;
                    };

                    /**
                     * Encodes the specified FileList message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IFileList} message FileList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FileList message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList} FileList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.files && message.files.length))
                                        message.files = [];
                                    message.files.push(reader.string());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FileList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList} FileList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FileList message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FileList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.files != null && message.hasOwnProperty("files")) {
                            if (!Array.isArray(message.files))
                                return "files: array expected";
                            for (let i = 0; i < message.files.length; ++i)
                                if (!$util.isString(message.files[i]))
                                    return "files: string[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a FileList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList} FileList
                     */
                    FileList.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList();
                        if (object.files) {
                            if (!Array.isArray(object.files))
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList.files: array expected");
                            message.files = [];
                            for (let i = 0; i < object.files.length; ++i)
                                message.files[i] = String(object.files[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a FileList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList} message FileList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FileList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.files = [];
                        if (message.files && message.files.length) {
                            object.files = [];
                            for (let j = 0; j < message.files.length; ++j)
                                object.files[j] = message.files[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this FileList to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FileList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FileList
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FileList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFileList.FileList";
                    };

                    return FileList;
                })();

                DeviceFileList.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NOT_SUPPORTED":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFileList.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFileList.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFileList.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFileList.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NOT_SUPPORTED=1 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_SUPPORTED"] = 1;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceFileList;
            })();

            Status.DeviceFile = (function() {

                /**
                 * Properties of a DeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceFile
                 * @property {number|null} [deviceAddress] DeviceFile deviceAddress
                 * @property {string|null} [name] DeviceFile name
                 * @property {Uint8Array|null} [content] DeviceFile content
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess|null} [success] DeviceFile success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFile.IError|null} [error] DeviceFile error
                 */

                /**
                 * Constructs a new DeviceFile.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceFile.
                 * @implements IDeviceFile
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFile=} [properties] Properties to set
                 */
                function DeviceFile(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceFile deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                DeviceFile.prototype.deviceAddress = 0;

                /**
                 * DeviceFile name.
                 * @member {string} name
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                DeviceFile.prototype.name = "";

                /**
                 * DeviceFile content.
                 * @member {Uint8Array|null|undefined} content
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                DeviceFile.prototype.content = null;

                /**
                 * DeviceFile success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                DeviceFile.prototype.success = null;

                /**
                 * DeviceFile error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFile.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                DeviceFile.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceFile data.
                 * @member {"content"|"success"|"error"|undefined} data
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 */
                Object.defineProperty(DeviceFile.prototype, "data", {
                    get: $util.oneOfGetter($oneOfFields = ["content", "success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceFile instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFile=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile} DeviceFile instance
                 */
                DeviceFile.create = function create(properties) {
                    return new DeviceFile(properties);
                };

                /**
                 * Encodes the specified DeviceFile message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFile} message DeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFile.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.encode(message.success, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceFile message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFile} message DeviceFile message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFile.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceFile message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile} DeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFile.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.content = reader.bytes();
                                break;
                            }
                        case 4: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceFile message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile} DeviceFile
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFile.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceFile message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceFile.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.content != null && message.hasOwnProperty("content")) {
                        properties.data = 1;
                        if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                            return "content: buffer expected";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceFile message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile} DeviceFile
                 */
                DeviceFile.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFile)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.content != null)
                        if (typeof object.content === "string")
                            $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                        else if (object.content.length >= 0)
                            message.content = object.content;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFile.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFile.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceFile message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceFile} message DeviceFile
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceFile.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.name = "";
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.content != null && message.hasOwnProperty("content")) {
                        object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                        if (options.oneofs)
                            object.data = "content";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.data = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.data = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceFile to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceFile.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceFile
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFile";
                };

                DeviceFile.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFile.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFile.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SET":
                        case 1:
                            message.code = 1;
                            break;
                        case "DELETED":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFile.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFile.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SET=1 SET value
                     * @property {number} DELETED=2 DELETED value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SET"] = 1;
                        values[valuesById[2] = "DELETED"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                DeviceFile.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFile.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFile.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFile.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFile.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NOT_FOUND":
                        case 1:
                            message.code = 1;
                            break;
                        case "FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "NOT_SUPPORTED":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFile.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFile.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFile.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFile.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFile.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NOT_FOUND=1 NOT_FOUND value
                     * @property {number} FAILED=2 FAILED value
                     * @property {number} NOT_SUPPORTED=3 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_FOUND"] = 1;
                        values[valuesById[2] = "FAILED"] = 2;
                        values[valuesById[3] = "NOT_SUPPORTED"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceFile;
            })();

            Status.DeviceEvent = (function() {

                /**
                 * Properties of a DeviceEvent.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceEvent
                 * @property {number|null} [deviceAddress] DeviceEvent deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo|null} [info] DeviceEvent info
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess|null} [success] DeviceEvent success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning|null} [warning] DeviceEvent warning
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError|null} [error] DeviceEvent error
                 */

                /**
                 * Constructs a new DeviceEvent.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceEvent.
                 * @implements IDeviceEvent
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceEvent=} [properties] Properties to set
                 */
                function DeviceEvent(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceEvent deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                DeviceEvent.prototype.deviceAddress = 0;

                /**
                 * DeviceEvent info.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo|null|undefined} info
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                DeviceEvent.prototype.info = null;

                /**
                 * DeviceEvent success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                DeviceEvent.prototype.success = null;

                /**
                 * DeviceEvent warning.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                DeviceEvent.prototype.warning = null;

                /**
                 * DeviceEvent error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                DeviceEvent.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceEvent status.
                 * @member {"info"|"success"|"warning"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 */
                Object.defineProperty(DeviceEvent.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["info", "success", "warning", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceEvent instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceEvent=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent} DeviceEvent instance
                 */
                DeviceEvent.create = function create(properties) {
                    return new DeviceEvent(properties);
                };

                /**
                 * Encodes the specified DeviceEvent message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceEvent} message DeviceEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceEvent.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.encode(message.info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.encode(message.warning, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceEvent message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceEvent} message DeviceEvent message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceEvent.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceEvent message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent} DeviceEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceEvent.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.info = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceEvent message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent} DeviceEvent
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceEvent.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceEvent message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceEvent.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.info != null && message.hasOwnProperty("info")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.verify(message.info);
                            if (error)
                                return "info." + error;
                        }
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceEvent message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent} DeviceEvent
                 */
                DeviceEvent.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceEvent)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.info != null) {
                        if (typeof object.info !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceEvent.info: object expected");
                        message.info = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.fromObject(object.info);
                    }
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceEvent.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceEvent.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceEvent.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceEvent message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent} message DeviceEvent
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceEvent.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.info != null && message.hasOwnProperty("info")) {
                        object.info = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.toObject(message.info, options);
                        if (options.oneofs)
                            object.status = "info";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceEvent to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceEvent.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceEvent
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceEvent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceEvent";
                };

                DeviceEvent.Info = (function() {

                    /**
                     * Properties of an Info.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @interface IInfo
                     * @property {number|null} [code] Info code
                     * @property {string|null} [message] Info message
                     */

                    /**
                     * Constructs a new Info.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @classdesc Represents an Info.
                     * @implements IInfo
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo=} [properties] Properties to set
                     */
                    function Info(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Info code.
                     * @member {number} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @instance
                     */
                    Info.prototype.code = 0;

                    /**
                     * Info message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @instance
                     */
                    Info.prototype.message = "";

                    /**
                     * Creates a new Info instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Info} Info instance
                     */
                    Info.create = function create(properties) {
                        return new Info(properties);
                    };

                    /**
                     * Encodes the specified Info message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo} message Info message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Info.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Info message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Info.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IInfo} message Info message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Info.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Info message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Info} Info
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Info.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Info message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Info} Info
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Info.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Info message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Info.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isInteger(message.code))
                                return "code: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Info message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Info} Info
                     */
                    Info.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Info();
                        if (object.code != null)
                            message.code = object.code >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Info message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.Info} message Info
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Info.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Info to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Info.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Info
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Info
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Info.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceEvent.Info";
                    };

                    return Info;
                })();

                DeviceEvent.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @interface ISuccess
                     * @property {number|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {number} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isInteger(message.code))
                                return "code: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Success();
                        if (object.code != null)
                            message.code = object.code >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceEvent.Success";
                    };

                    return Success;
                })();

                DeviceEvent.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @interface IWarning
                     * @property {number|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {number} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isInteger(message.code))
                                return "code: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning();
                        if (object.code != null)
                            message.code = object.code >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceEvent.Warning";
                    };

                    return Warning;
                })();

                DeviceEvent.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @interface IError
                     * @property {number|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {number} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceEvent.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isInteger(message.code))
                                return "code: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceEvent.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceEvent.Error();
                        if (object.code != null)
                            message.code = object.code >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceEvent.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceEvent.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceEvent.Error";
                    };

                    return Error;
                })();

                return DeviceEvent;
            })();

            Status.DeviceFirmwareInstallation = (function() {

                /**
                 * Properties of a DeviceFirmwareInstallation.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceFirmwareInstallation
                 * @property {number|null} [deviceAddress] DeviceFirmwareInstallation deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess|null} [success] DeviceFirmwareInstallation success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError|null} [error] DeviceFirmwareInstallation error
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress|null} [progress] DeviceFirmwareInstallation progress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning|null} [warning] DeviceFirmwareInstallation warning
                 */

                /**
                 * Constructs a new DeviceFirmwareInstallation.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceFirmwareInstallation.
                 * @implements IDeviceFirmwareInstallation
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation=} [properties] Properties to set
                 */
                function DeviceFirmwareInstallation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceFirmwareInstallation deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                DeviceFirmwareInstallation.prototype.deviceAddress = 0;

                /**
                 * DeviceFirmwareInstallation success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                DeviceFirmwareInstallation.prototype.success = null;

                /**
                 * DeviceFirmwareInstallation error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                DeviceFirmwareInstallation.prototype.error = null;

                /**
                 * DeviceFirmwareInstallation progress.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                DeviceFirmwareInstallation.prototype.progress = null;

                /**
                 * DeviceFirmwareInstallation warning.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                DeviceFirmwareInstallation.prototype.warning = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceFirmwareInstallation status.
                 * @member {"success"|"error"|"progress"|"warning"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 */
                Object.defineProperty(DeviceFirmwareInstallation.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress", "warning"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceFirmwareInstallation instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation} DeviceFirmwareInstallation instance
                 */
                DeviceFirmwareInstallation.create = function create(properties) {
                    return new DeviceFirmwareInstallation(properties);
                };

                /**
                 * Encodes the specified DeviceFirmwareInstallation message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation} message DeviceFirmwareInstallation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFirmwareInstallation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.encode(message.progress, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.encode(message.warning, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceFirmwareInstallation message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFirmwareInstallation} message DeviceFirmwareInstallation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFirmwareInstallation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceFirmwareInstallation message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation} DeviceFirmwareInstallation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFirmwareInstallation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceFirmwareInstallation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation} DeviceFirmwareInstallation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFirmwareInstallation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceFirmwareInstallation message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceFirmwareInstallation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceFirmwareInstallation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation} DeviceFirmwareInstallation
                 */
                DeviceFirmwareInstallation.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.fromObject(object.progress);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.fromObject(object.warning);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceFirmwareInstallation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation} message DeviceFirmwareInstallation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceFirmwareInstallation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceFirmwareInstallation to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceFirmwareInstallation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceFirmwareInstallation
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceFirmwareInstallation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation";
                };

                DeviceFirmwareInstallation.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                DeviceFirmwareInstallation.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "PACKAGE_CORRUPTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "SII_CORRUPTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "IMAGE_NOT_FOUND":
                        case 3:
                            message.code = 3;
                            break;
                        case "REFUSED":
                        case 4:
                            message.code = 4;
                            break;
                        case "NOT_SUPPORTED":
                        case 5:
                            message.code = 5;
                            break;
                        case "SII_WRITE_FAILED":
                        case 6:
                            message.code = 6;
                            break;
                        case "FILE_WRITE_FAILED":
                        case 7:
                            message.code = 7;
                            break;
                        case "FILE_DELETE_FAILED":
                        case 8:
                            message.code = 8;
                            break;
                        case "DEVICE_NOT_FOUND":
                        case 9:
                            message.code = 9;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} PACKAGE_CORRUPTED=1 PACKAGE_CORRUPTED value
                     * @property {number} SII_CORRUPTED=2 SII_CORRUPTED value
                     * @property {number} IMAGE_NOT_FOUND=3 IMAGE_NOT_FOUND value
                     * @property {number} REFUSED=4 REFUSED value
                     * @property {number} NOT_SUPPORTED=5 NOT_SUPPORTED value
                     * @property {number} SII_WRITE_FAILED=6 SII_WRITE_FAILED value
                     * @property {number} FILE_WRITE_FAILED=7 FILE_WRITE_FAILED value
                     * @property {number} FILE_DELETE_FAILED=8 FILE_DELETE_FAILED value
                     * @property {number} DEVICE_NOT_FOUND=9 DEVICE_NOT_FOUND value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PACKAGE_CORRUPTED"] = 1;
                        values[valuesById[2] = "SII_CORRUPTED"] = 2;
                        values[valuesById[3] = "IMAGE_NOT_FOUND"] = 3;
                        values[valuesById[4] = "REFUSED"] = 4;
                        values[valuesById[5] = "NOT_SUPPORTED"] = 5;
                        values[valuesById[6] = "SII_WRITE_FAILED"] = 6;
                        values[valuesById[7] = "FILE_WRITE_FAILED"] = 7;
                        values[valuesById[8] = "FILE_DELETE_FAILED"] = 8;
                        values[valuesById[9] = "DEVICE_NOT_FOUND"] = 9;
                        return values;
                    })();

                    return Error;
                })();

                DeviceFirmwareInstallation.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @interface IProgress
                     * @property {number|null} [percentage] Progress percentage
                     * @property {string|null} [message] Progress message
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Progress message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @instance
                     */
                    Progress.prototype.message = "";

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.percentage);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress();
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.percentage = 0;
                            object.message = "";
                        }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Progress";
                    };

                    return Progress;
                })();

                DeviceFirmwareInstallation.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SII_WRITE_FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "CANNOT_SWITCH_TO_BOOT":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFirmwareInstallation.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SII_WRITE_FAILED=1 SII_WRITE_FAILED value
                     * @property {number} CANNOT_SWITCH_TO_BOOT=2 CANNOT_SWITCH_TO_BOOT value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SII_WRITE_FAILED"] = 1;
                        values[valuesById[2] = "CANNOT_SWITCH_TO_BOOT"] = 2;
                        return values;
                    })();

                    return Warning;
                })();

                return DeviceFirmwareInstallation;
            })();

            Status.DeviceLog = (function() {

                /**
                 * Properties of a DeviceLog.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceLog
                 * @property {number|null} [deviceAddress] DeviceLog deviceAddress
                 * @property {string|null} [content] DeviceLog content
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceLog.IError|null} [error] DeviceLog error
                 */

                /**
                 * Constructs a new DeviceLog.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceLog.
                 * @implements IDeviceLog
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceLog=} [properties] Properties to set
                 */
                function DeviceLog(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceLog deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @instance
                 */
                DeviceLog.prototype.deviceAddress = 0;

                /**
                 * DeviceLog content.
                 * @member {string|null|undefined} content
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @instance
                 */
                DeviceLog.prototype.content = null;

                /**
                 * DeviceLog error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceLog.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @instance
                 */
                DeviceLog.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceLog data.
                 * @member {"content"|"error"|undefined} data
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @instance
                 */
                Object.defineProperty(DeviceLog.prototype, "data", {
                    get: $util.oneOfGetter($oneOfFields = ["content", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceLog instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceLog=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog} DeviceLog instance
                 */
                DeviceLog.create = function create(properties) {
                    return new DeviceLog(properties);
                };

                /**
                 * Encodes the specified DeviceLog message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceLog.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceLog} message DeviceLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceLog.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceLog message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceLog.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceLog} message DeviceLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceLog.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceLog message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog} DeviceLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceLog.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceLog();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.content = reader.string();
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceLog message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog} DeviceLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceLog.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceLog message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceLog.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.content != null && message.hasOwnProperty("content")) {
                        properties.data = 1;
                        if (!$util.isString(message.content))
                            return "content: string expected";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceLog message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog} DeviceLog
                 */
                DeviceLog.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceLog)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceLog();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.content != null)
                        message.content = String(object.content);
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceLog.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceLog message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceLog} message DeviceLog
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceLog.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.content != null && message.hasOwnProperty("content")) {
                        object.content = message.content;
                        if (options.oneofs)
                            object.data = "content";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.data = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceLog to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceLog.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceLog
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceLog";
                };

                DeviceLog.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceLog.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceLog.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceLog.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceLog.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceLog.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceLog.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceLog.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceLog.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceLog.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NOT_FOUND":
                        case 1:
                            message.code = 1;
                            break;
                        case "NOT_SUPPORTED":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceLog.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceLog.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceLog.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceLog.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceLog.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NOT_FOUND=1 NOT_FOUND value
                     * @property {number} NOT_SUPPORTED=2 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_FOUND"] = 1;
                        values[valuesById[2] = "NOT_SUPPORTED"] = 2;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceLog;
            })();

            Status.DeviceFaultReset = (function() {

                /**
                 * Properties of a DeviceFaultReset.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceFaultReset
                 * @property {number|null} [deviceAddress] DeviceFaultReset deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess|null} [success] DeviceFaultReset success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning|null} [warning] DeviceFaultReset warning
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError|null} [error] DeviceFaultReset error
                 */

                /**
                 * Constructs a new DeviceFaultReset.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceFaultReset.
                 * @implements IDeviceFaultReset
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset=} [properties] Properties to set
                 */
                function DeviceFaultReset(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceFaultReset deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 */
                DeviceFaultReset.prototype.deviceAddress = 0;

                /**
                 * DeviceFaultReset success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 */
                DeviceFaultReset.prototype.success = null;

                /**
                 * DeviceFaultReset warning.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 */
                DeviceFaultReset.prototype.warning = null;

                /**
                 * DeviceFaultReset error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 */
                DeviceFaultReset.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceFaultReset status.
                 * @member {"success"|"warning"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 */
                Object.defineProperty(DeviceFaultReset.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "warning", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceFaultReset instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset} DeviceFaultReset instance
                 */
                DeviceFaultReset.create = function create(properties) {
                    return new DeviceFaultReset(properties);
                };

                /**
                 * Encodes the specified DeviceFaultReset message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset} message DeviceFaultReset message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFaultReset.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.encode(message.warning, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceFaultReset message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceFaultReset} message DeviceFaultReset message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceFaultReset.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceFaultReset message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset} DeviceFaultReset
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFaultReset.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceFaultReset message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset} DeviceFaultReset
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceFaultReset.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceFaultReset message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceFaultReset.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceFaultReset message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset} DeviceFaultReset
                 */
                DeviceFaultReset.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFaultReset.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFaultReset.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceFaultReset.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceFaultReset message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset} message DeviceFaultReset
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceFaultReset.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceFaultReset to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceFaultReset.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceFaultReset
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceFaultReset.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFaultReset";
                };

                DeviceFaultReset.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                DeviceFaultReset.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NO_FAULT":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NO_FAULT=1 NO_FAULT value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NO_FAULT"] = 1;
                        return values;
                    })();

                    return Warning;
                })();

                DeviceFaultReset.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "TIMED_OUT":
                        case 2:
                            message.code = 2;
                            break;
                        case "NOT_SUPPORTED":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceFaultReset.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} TIMED_OUT=2 TIMED_OUT value
                     * @property {number} NOT_SUPPORTED=3 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "TIMED_OUT"] = 2;
                        values[valuesById[3] = "NOT_SUPPORTED"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceFaultReset;
            })();

            Status.CoggingTorqueRecording = (function() {

                /**
                 * Properties of a CoggingTorqueRecording.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ICoggingTorqueRecording
                 * @property {number|null} [deviceAddress] CoggingTorqueRecording deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess|null} [success] CoggingTorqueRecording success
                 * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError|null} [error] CoggingTorqueRecording error
                 */

                /**
                 * Constructs a new CoggingTorqueRecording.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a CoggingTorqueRecording.
                 * @implements ICoggingTorqueRecording
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording=} [properties] Properties to set
                 */
                function CoggingTorqueRecording(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CoggingTorqueRecording deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @instance
                 */
                CoggingTorqueRecording.prototype.deviceAddress = 0;

                /**
                 * CoggingTorqueRecording success.
                 * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @instance
                 */
                CoggingTorqueRecording.prototype.success = null;

                /**
                 * CoggingTorqueRecording error.
                 * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @instance
                 */
                CoggingTorqueRecording.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * CoggingTorqueRecording status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @instance
                 */
                Object.defineProperty(CoggingTorqueRecording.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CoggingTorqueRecording instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording} CoggingTorqueRecording instance
                 */
                CoggingTorqueRecording.create = function create(properties) {
                    return new CoggingTorqueRecording(properties);
                };

                /**
                 * Encodes the specified CoggingTorqueRecording message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording} message CoggingTorqueRecording message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CoggingTorqueRecording.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CoggingTorqueRecording message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueRecording} message CoggingTorqueRecording message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CoggingTorqueRecording.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CoggingTorqueRecording message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording} CoggingTorqueRecording
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CoggingTorqueRecording.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CoggingTorqueRecording message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording} CoggingTorqueRecording
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CoggingTorqueRecording.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CoggingTorqueRecording message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CoggingTorqueRecording.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CoggingTorqueRecording message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording} CoggingTorqueRecording
                 */
                CoggingTorqueRecording.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CoggingTorqueRecording message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording} message CoggingTorqueRecording
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CoggingTorqueRecording.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this CoggingTorqueRecording to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CoggingTorqueRecording.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CoggingTorqueRecording
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CoggingTorqueRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording";
                };

                CoggingTorqueRecording.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                CoggingTorqueRecording.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "FAILED_HALL_SENSOR":
                        case 1:
                            message.code = 1;
                            break;
                        case "INVALID_RESOLUTION":
                        case 2:
                            message.code = 2;
                            break;
                        case "NO_COMMUTATION_SENSOR":
                        case 3:
                            message.code = 3;
                            break;
                        case "NO_COMMUTATION_AND_MOTION_SENSOR":
                        case 4:
                            message.code = 4;
                            break;
                        case "POSITION_CONTROLLER_NOT_TUNED":
                        case 5:
                            message.code = 5;
                            break;
                        case "INIT_FAILED":
                        case 6:
                            message.code = 6;
                            break;
                        case "FAILED":
                        case 7:
                            message.code = 7;
                            break;
                        case "ABORTED":
                        case 8:
                            message.code = 8;
                            break;
                        case "TIMEOUT":
                        case 9:
                            message.code = 9;
                            break;
                        case "SAVING_FAILED":
                        case 10:
                            message.code = 10;
                            break;
                        case "SAVING_ABORTED":
                        case 11:
                            message.code = 11;
                            break;
                        case "SAVING_TIMEOUT":
                        case 12:
                            message.code = 12;
                            break;
                        case "NO_POSITION_CONTROL_FUNCTION":
                        case 13:
                            message.code = 13;
                            break;
                        case "NOT_SUPPORTED":
                        case 14:
                            message.code = 14;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CoggingTorqueRecording.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} FAILED_HALL_SENSOR=1 FAILED_HALL_SENSOR value
                     * @property {number} INVALID_RESOLUTION=2 INVALID_RESOLUTION value
                     * @property {number} NO_COMMUTATION_SENSOR=3 NO_COMMUTATION_SENSOR value
                     * @property {number} NO_COMMUTATION_AND_MOTION_SENSOR=4 NO_COMMUTATION_AND_MOTION_SENSOR value
                     * @property {number} POSITION_CONTROLLER_NOT_TUNED=5 POSITION_CONTROLLER_NOT_TUNED value
                     * @property {number} INIT_FAILED=6 INIT_FAILED value
                     * @property {number} FAILED=7 FAILED value
                     * @property {number} ABORTED=8 ABORTED value
                     * @property {number} TIMEOUT=9 TIMEOUT value
                     * @property {number} SAVING_FAILED=10 SAVING_FAILED value
                     * @property {number} SAVING_ABORTED=11 SAVING_ABORTED value
                     * @property {number} SAVING_TIMEOUT=12 SAVING_TIMEOUT value
                     * @property {number} NO_POSITION_CONTROL_FUNCTION=13 NO_POSITION_CONTROL_FUNCTION value
                     * @property {number} NOT_SUPPORTED=14 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FAILED_HALL_SENSOR"] = 1;
                        values[valuesById[2] = "INVALID_RESOLUTION"] = 2;
                        values[valuesById[3] = "NO_COMMUTATION_SENSOR"] = 3;
                        values[valuesById[4] = "NO_COMMUTATION_AND_MOTION_SENSOR"] = 4;
                        values[valuesById[5] = "POSITION_CONTROLLER_NOT_TUNED"] = 5;
                        values[valuesById[6] = "INIT_FAILED"] = 6;
                        values[valuesById[7] = "FAILED"] = 7;
                        values[valuesById[8] = "ABORTED"] = 8;
                        values[valuesById[9] = "TIMEOUT"] = 9;
                        values[valuesById[10] = "SAVING_FAILED"] = 10;
                        values[valuesById[11] = "SAVING_ABORTED"] = 11;
                        values[valuesById[12] = "SAVING_TIMEOUT"] = 12;
                        values[valuesById[13] = "NO_POSITION_CONTROL_FUNCTION"] = 13;
                        values[valuesById[14] = "NOT_SUPPORTED"] = 14;
                        return values;
                    })();

                    return Error;
                })();

                return CoggingTorqueRecording;
            })();

            Status.CoggingTorqueData = (function() {

                /**
                 * Properties of a CoggingTorqueData.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ICoggingTorqueData
                 * @property {number|null} [deviceAddress] CoggingTorqueData deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable|null} [table] CoggingTorqueData table
                 * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError|null} [error] CoggingTorqueData error
                 */

                /**
                 * Constructs a new CoggingTorqueData.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a CoggingTorqueData.
                 * @implements ICoggingTorqueData
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData=} [properties] Properties to set
                 */
                function CoggingTorqueData(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CoggingTorqueData deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @instance
                 */
                CoggingTorqueData.prototype.deviceAddress = 0;

                /**
                 * CoggingTorqueData table.
                 * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable|null|undefined} table
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @instance
                 */
                CoggingTorqueData.prototype.table = null;

                /**
                 * CoggingTorqueData error.
                 * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @instance
                 */
                CoggingTorqueData.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * CoggingTorqueData data.
                 * @member {"table"|"error"|undefined} data
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @instance
                 */
                Object.defineProperty(CoggingTorqueData.prototype, "data", {
                    get: $util.oneOfGetter($oneOfFields = ["table", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CoggingTorqueData instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData} CoggingTorqueData instance
                 */
                CoggingTorqueData.create = function create(properties) {
                    return new CoggingTorqueData(properties);
                };

                /**
                 * Encodes the specified CoggingTorqueData message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData} message CoggingTorqueData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CoggingTorqueData.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.table != null && Object.hasOwnProperty.call(message, "table"))
                        $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.encode(message.table, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CoggingTorqueData message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICoggingTorqueData} message CoggingTorqueData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CoggingTorqueData.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CoggingTorqueData message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData} CoggingTorqueData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CoggingTorqueData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.table = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CoggingTorqueData message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData} CoggingTorqueData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CoggingTorqueData.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CoggingTorqueData message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CoggingTorqueData.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.table != null && message.hasOwnProperty("table")) {
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.verify(message.table);
                            if (error)
                                return "table." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CoggingTorqueData message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData} CoggingTorqueData
                 */
                CoggingTorqueData.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.table != null) {
                        if (typeof object.table !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CoggingTorqueData.table: object expected");
                        message.table = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.fromObject(object.table);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CoggingTorqueData.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CoggingTorqueData message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData} message CoggingTorqueData
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CoggingTorqueData.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.table != null && message.hasOwnProperty("table")) {
                        object.table = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.toObject(message.table, options);
                        if (options.oneofs)
                            object.data = "table";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.data = "error";
                    }
                    return object;
                };

                /**
                 * Converts this CoggingTorqueData to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CoggingTorqueData.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CoggingTorqueData
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CoggingTorqueData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueData";
                };

                CoggingTorqueData.Table = (function() {

                    /**
                     * Properties of a Table.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                     * @interface ITable
                     * @property {Array.<number>|null} [data] Table data
                     */

                    /**
                     * Constructs a new Table.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                     * @classdesc Represents a Table.
                     * @implements ITable
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable=} [properties] Properties to set
                     */
                    function Table(properties) {
                        this.data = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Table data.
                     * @member {Array.<number>} data
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @instance
                     */
                    Table.prototype.data = $util.emptyArray;

                    /**
                     * Creates a new Table instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table} Table instance
                     */
                    Table.create = function create(properties) {
                        return new Table(properties);
                    };

                    /**
                     * Encodes the specified Table message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable} message Table message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Table.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.data != null && message.data.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (let i = 0; i < message.data.length; ++i)
                                writer.int32(message.data[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified Table message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.ITable} message Table message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Table.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Table message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table} Table
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Table.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.data && message.data.length))
                                        message.data = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.data.push(reader.int32());
                                    } else
                                        message.data.push(reader.int32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Table message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table} Table
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Table.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Table message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Table.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.data != null && message.hasOwnProperty("data")) {
                            if (!Array.isArray(message.data))
                                return "data: array expected";
                            for (let i = 0; i < message.data.length; ++i)
                                if (!$util.isInteger(message.data[i]))
                                    return "data: integer[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a Table message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table} Table
                     */
                    Table.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table();
                        if (object.data) {
                            if (!Array.isArray(object.data))
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table.data: array expected");
                            message.data = [];
                            for (let i = 0; i < object.data.length; ++i)
                                message.data[i] = object.data[i] | 0;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a Table message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table} message Table
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Table.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.data = [];
                        if (message.data && message.data.length) {
                            object.data = [];
                            for (let j = 0; j < message.data.length; ++j)
                                object.data[j] = message.data[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this Table to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Table.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Table
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Table.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Table";
                    };

                    return Table;
                })();

                CoggingTorqueData.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NOT_FOUND":
                        case 1:
                            message.code = 1;
                            break;
                        case "CORRUPTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "NOT_SUPPORTED":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CoggingTorqueData.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NOT_FOUND=1 NOT_FOUND value
                     * @property {number} CORRUPTED=2 CORRUPTED value
                     * @property {number} NOT_SUPPORTED=3 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_FOUND"] = 1;
                        values[valuesById[2] = "CORRUPTED"] = 2;
                        values[valuesById[3] = "NOT_SUPPORTED"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return CoggingTorqueData;
            })();

            Status.OffsetDetection = (function() {

                /**
                 * Properties of an OffsetDetection.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IOffsetDetection
                 * @property {number|null} [deviceAddress] OffsetDetection deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess|null} [success] OffsetDetection success
                 * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError|null} [error] OffsetDetection error
                 * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress|null} [progress] OffsetDetection progress
                 */

                /**
                 * Constructs a new OffsetDetection.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents an OffsetDetection.
                 * @implements IOffsetDetection
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IOffsetDetection=} [properties] Properties to set
                 */
                function OffsetDetection(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OffsetDetection deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 */
                OffsetDetection.prototype.deviceAddress = 0;

                /**
                 * OffsetDetection success.
                 * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 */
                OffsetDetection.prototype.success = null;

                /**
                 * OffsetDetection error.
                 * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 */
                OffsetDetection.prototype.error = null;

                /**
                 * OffsetDetection progress.
                 * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 */
                OffsetDetection.prototype.progress = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * OffsetDetection status.
                 * @member {"success"|"error"|"progress"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 */
                Object.defineProperty(OffsetDetection.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new OffsetDetection instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOffsetDetection=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection} OffsetDetection instance
                 */
                OffsetDetection.create = function create(properties) {
                    return new OffsetDetection(properties);
                };

                /**
                 * Encodes the specified OffsetDetection message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOffsetDetection} message OffsetDetection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OffsetDetection.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.encode(message.progress, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OffsetDetection message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOffsetDetection} message OffsetDetection message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OffsetDetection.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OffsetDetection message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection} OffsetDetection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OffsetDetection.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OffsetDetection message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection} OffsetDetection
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OffsetDetection.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OffsetDetection message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OffsetDetection.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OffsetDetection message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection} OffsetDetection
                 */
                OffsetDetection.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OffsetDetection)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OffsetDetection.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OffsetDetection.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OffsetDetection.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.fromObject(object.progress);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OffsetDetection message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection} message OffsetDetection
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OffsetDetection.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    return object;
                };

                /**
                 * Converts this OffsetDetection to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OffsetDetection.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OffsetDetection
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OffsetDetection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OffsetDetection";
                };

                OffsetDetection.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OffsetDetection.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OffsetDetection.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                OffsetDetection.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "INIT_FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "TIMEOUT":
                        case 2:
                            message.code = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.code = 3;
                            break;
                        case "ABORTED":
                        case 4:
                            message.code = 4;
                            break;
                        case "NOT_SUPPORTED":
                        case 5:
                            message.code = 5;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OffsetDetection.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OffsetDetection.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} INIT_FAILED=1 INIT_FAILED value
                     * @property {number} TIMEOUT=2 TIMEOUT value
                     * @property {number} FAILED=3 FAILED value
                     * @property {number} ABORTED=4 ABORTED value
                     * @property {number} NOT_SUPPORTED=5 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "INIT_FAILED"] = 1;
                        values[valuesById[2] = "TIMEOUT"] = 2;
                        values[valuesById[3] = "FAILED"] = 3;
                        values[valuesById[4] = "ABORTED"] = 4;
                        values[valuesById[5] = "NOT_SUPPORTED"] = 5;
                        return values;
                    })();

                    return Error;
                })();

                OffsetDetection.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @interface IProgress
                     * @property {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.Code|null} [code] Progress code
                     * @property {number|null} [percentage] Progress percentage
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress code.
                     * @member {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @instance
                     */
                    Progress.prototype.code = 0;

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.percentage);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "OPEN_PHASE_DETECTION":
                        case 1:
                            message.code = 1;
                            break;
                        case "PHASE_RESISTANCE_MEASUREMENT":
                        case 2:
                            message.code = 2;
                            break;
                        case "PHASE_INDUCTANCE_MEASUREMENT":
                        case 3:
                            message.code = 3;
                            break;
                        case "POLE_PAIR_DETECTION":
                        case 4:
                            message.code = 4;
                            break;
                        case "MOTOR_PHASE_ORDER_DETECTION":
                        case 5:
                            message.code = 5;
                            break;
                        case "COMMUTATION_OFFSET_MEASUREMENT":
                        case 6:
                            message.code = 6;
                            break;
                        }
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.percentage = 0;
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.Code[message.code] : message.code;
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OffsetDetection.Progress.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} OPEN_PHASE_DETECTION=1 OPEN_PHASE_DETECTION value
                     * @property {number} PHASE_RESISTANCE_MEASUREMENT=2 PHASE_RESISTANCE_MEASUREMENT value
                     * @property {number} PHASE_INDUCTANCE_MEASUREMENT=3 PHASE_INDUCTANCE_MEASUREMENT value
                     * @property {number} POLE_PAIR_DETECTION=4 POLE_PAIR_DETECTION value
                     * @property {number} MOTOR_PHASE_ORDER_DETECTION=5 MOTOR_PHASE_ORDER_DETECTION value
                     * @property {number} COMMUTATION_OFFSET_MEASUREMENT=6 COMMUTATION_OFFSET_MEASUREMENT value
                     */
                    Progress.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "OPEN_PHASE_DETECTION"] = 1;
                        values[valuesById[2] = "PHASE_RESISTANCE_MEASUREMENT"] = 2;
                        values[valuesById[3] = "PHASE_INDUCTANCE_MEASUREMENT"] = 3;
                        values[valuesById[4] = "POLE_PAIR_DETECTION"] = 4;
                        values[valuesById[5] = "MOTOR_PHASE_ORDER_DETECTION"] = 5;
                        values[valuesById[6] = "COMMUTATION_OFFSET_MEASUREMENT"] = 6;
                        return values;
                    })();

                    return Progress;
                })();

                return OffsetDetection;
            })();

            Status.PlantIdentification = (function() {

                /**
                 * Properties of a PlantIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IPlantIdentification
                 * @property {number|null} [deviceAddress] PlantIdentification deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess|null} [success] PlantIdentification success
                 * @property {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError|null} [error] PlantIdentification error
                 */

                /**
                 * Constructs a new PlantIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a PlantIdentification.
                 * @implements IPlantIdentification
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IPlantIdentification=} [properties] Properties to set
                 */
                function PlantIdentification(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PlantIdentification deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @instance
                 */
                PlantIdentification.prototype.deviceAddress = 0;

                /**
                 * PlantIdentification success.
                 * @member {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @instance
                 */
                PlantIdentification.prototype.success = null;

                /**
                 * PlantIdentification error.
                 * @member {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @instance
                 */
                PlantIdentification.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PlantIdentification status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @instance
                 */
                Object.defineProperty(PlantIdentification.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PlantIdentification instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPlantIdentification=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification} PlantIdentification instance
                 */
                PlantIdentification.create = function create(properties) {
                    return new PlantIdentification(properties);
                };

                /**
                 * Encodes the specified PlantIdentification message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPlantIdentification} message PlantIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlantIdentification.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PlantIdentification message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPlantIdentification} message PlantIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PlantIdentification.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PlantIdentification message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification} PlantIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlantIdentification.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PlantIdentification message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification} PlantIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PlantIdentification.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PlantIdentification message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PlantIdentification.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PlantIdentification message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification} PlantIdentification
                 */
                PlantIdentification.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PlantIdentification)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.PlantIdentification.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.PlantIdentification.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PlantIdentification message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification} message PlantIdentification
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PlantIdentification.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this PlantIdentification to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PlantIdentification.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PlantIdentification
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PlantIdentification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PlantIdentification";
                };

                PlantIdentification.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PlantIdentification.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.PlantIdentification.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                PlantIdentification.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NO_POSITION_CONTROL_SENSOR":
                        case 1:
                            message.code = 1;
                            break;
                        case "INIT_FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.code = 3;
                            break;
                        case "ABORTED":
                        case 4:
                            message.code = 4;
                            break;
                        case "TIMED_OUT":
                        case 5:
                            message.code = 5;
                            break;
                        case "ZERO_TORQUE_AMPLITUDE":
                        case 6:
                            message.code = 6;
                            break;
                        case "ZERO_VELOCITY_AMPLITUDE":
                        case 7:
                            message.code = 7;
                            break;
                        case "WRONG_SENSOR_POLARITY":
                        case 8:
                            message.code = 8;
                            break;
                        case "SMALL_MOTION_AMPLITUDE":
                        case 9:
                            message.code = 9;
                            break;
                        case "NOT_SUPPORTED":
                        case 10:
                            message.code = 10;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PlantIdentification.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.PlantIdentification.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PlantIdentification.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.PlantIdentification.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NO_POSITION_CONTROL_SENSOR=1 NO_POSITION_CONTROL_SENSOR value
                     * @property {number} INIT_FAILED=2 INIT_FAILED value
                     * @property {number} FAILED=3 FAILED value
                     * @property {number} ABORTED=4 ABORTED value
                     * @property {number} TIMED_OUT=5 TIMED_OUT value
                     * @property {number} ZERO_TORQUE_AMPLITUDE=6 ZERO_TORQUE_AMPLITUDE value
                     * @property {number} ZERO_VELOCITY_AMPLITUDE=7 ZERO_VELOCITY_AMPLITUDE value
                     * @property {number} WRONG_SENSOR_POLARITY=8 WRONG_SENSOR_POLARITY value
                     * @property {number} SMALL_MOTION_AMPLITUDE=9 SMALL_MOTION_AMPLITUDE value
                     * @property {number} NOT_SUPPORTED=10 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NO_POSITION_CONTROL_SENSOR"] = 1;
                        values[valuesById[2] = "INIT_FAILED"] = 2;
                        values[valuesById[3] = "FAILED"] = 3;
                        values[valuesById[4] = "ABORTED"] = 4;
                        values[valuesById[5] = "TIMED_OUT"] = 5;
                        values[valuesById[6] = "ZERO_TORQUE_AMPLITUDE"] = 6;
                        values[valuesById[7] = "ZERO_VELOCITY_AMPLITUDE"] = 7;
                        values[valuesById[8] = "WRONG_SENSOR_POLARITY"] = 8;
                        values[valuesById[9] = "SMALL_MOTION_AMPLITUDE"] = 9;
                        values[valuesById[10] = "NOT_SUPPORTED"] = 10;
                        return values;
                    })();

                    return Error;
                })();

                return PlantIdentification;
            })();

            Status.SystemIdentification = (function() {

                /**
                 * Properties of a SystemIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemIdentification
                 * @property {number|null} [deviceAddress] SystemIdentification deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess|null} [success] SystemIdentification success
                 * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError|null} [error] SystemIdentification error
                 * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning|null} [warning] SystemIdentification warning
                 * @property {string|null} [bodeFileContent] SystemIdentification bodeFileContent
                 */

                /**
                 * Constructs a new SystemIdentification.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemIdentification.
                 * @implements ISystemIdentification
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemIdentification=} [properties] Properties to set
                 */
                function SystemIdentification(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemIdentification deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                SystemIdentification.prototype.deviceAddress = 0;

                /**
                 * SystemIdentification success.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                SystemIdentification.prototype.success = null;

                /**
                 * SystemIdentification error.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                SystemIdentification.prototype.error = null;

                /**
                 * SystemIdentification warning.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                SystemIdentification.prototype.warning = null;

                /**
                 * SystemIdentification bodeFileContent.
                 * @member {string} bodeFileContent
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                SystemIdentification.prototype.bodeFileContent = "";

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SystemIdentification status.
                 * @member {"success"|"error"|"warning"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 */
                Object.defineProperty(SystemIdentification.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "warning"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SystemIdentification instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemIdentification=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification} SystemIdentification instance
                 */
                SystemIdentification.create = function create(properties) {
                    return new SystemIdentification(properties);
                };

                /**
                 * Encodes the specified SystemIdentification message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemIdentification} message SystemIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemIdentification.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.encode(message.warning, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.bodeFileContent != null && Object.hasOwnProperty.call(message, "bodeFileContent"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.bodeFileContent);
                    return writer;
                };

                /**
                 * Encodes the specified SystemIdentification message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemIdentification} message SystemIdentification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemIdentification.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemIdentification message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification} SystemIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemIdentification.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.bodeFileContent = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemIdentification message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification} SystemIdentification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemIdentification.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemIdentification message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemIdentification.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.bodeFileContent != null && message.hasOwnProperty("bodeFileContent"))
                        if (!$util.isString(message.bodeFileContent))
                            return "bodeFileContent: string expected";
                    return null;
                };

                /**
                 * Creates a SystemIdentification message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification} SystemIdentification
                 */
                SystemIdentification.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemIdentification)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemIdentification.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemIdentification.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.fromObject(object.error);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemIdentification.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.fromObject(object.warning);
                    }
                    if (object.bodeFileContent != null)
                        message.bodeFileContent = String(object.bodeFileContent);
                    return message;
                };

                /**
                 * Creates a plain object from a SystemIdentification message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification} message SystemIdentification
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemIdentification.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.bodeFileContent = "";
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.bodeFileContent != null && message.hasOwnProperty("bodeFileContent"))
                        object.bodeFileContent = message.bodeFileContent;
                    return object;
                };

                /**
                 * Converts this SystemIdentification to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemIdentification.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemIdentification
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemIdentification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemIdentification";
                };

                SystemIdentification.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemIdentification.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemIdentification.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                SystemIdentification.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NO_POSITION_CONTROL_SENSOR":
                        case 1:
                            message.code = 1;
                            break;
                        case "INIT_FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.code = 3;
                            break;
                        case "ABORTED":
                        case 4:
                            message.code = 4;
                            break;
                        case "TIMED_OUT":
                        case 5:
                            message.code = 5;
                            break;
                        case "ZERO_TORQUE_AMPLITUDE":
                        case 6:
                            message.code = 6;
                            break;
                        case "ZERO_VELOCITY_AMPLITUDE":
                        case 7:
                            message.code = 7;
                            break;
                        case "WRONG_SENSOR_POLARITY":
                        case 8:
                            message.code = 8;
                            break;
                        case "SMALL_MOTION_AMPLITUDE":
                        case 9:
                            message.code = 9;
                            break;
                        case "NOT_SUPPORTED":
                        case 10:
                            message.code = 10;
                            break;
                        case "INSUFFICIENT_VELOCITY_RESOLUTION":
                        case 11:
                            message.code = 11;
                            break;
                        case "BAD_DATA_QUALITY":
                        case 12:
                            message.code = 12;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemIdentification.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemIdentification.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NO_POSITION_CONTROL_SENSOR=1 NO_POSITION_CONTROL_SENSOR value
                     * @property {number} INIT_FAILED=2 INIT_FAILED value
                     * @property {number} FAILED=3 FAILED value
                     * @property {number} ABORTED=4 ABORTED value
                     * @property {number} TIMED_OUT=5 TIMED_OUT value
                     * @property {number} ZERO_TORQUE_AMPLITUDE=6 ZERO_TORQUE_AMPLITUDE value
                     * @property {number} ZERO_VELOCITY_AMPLITUDE=7 ZERO_VELOCITY_AMPLITUDE value
                     * @property {number} WRONG_SENSOR_POLARITY=8 WRONG_SENSOR_POLARITY value
                     * @property {number} SMALL_MOTION_AMPLITUDE=9 SMALL_MOTION_AMPLITUDE value
                     * @property {number} NOT_SUPPORTED=10 NOT_SUPPORTED value
                     * @property {number} INSUFFICIENT_VELOCITY_RESOLUTION=11 INSUFFICIENT_VELOCITY_RESOLUTION value
                     * @property {number} BAD_DATA_QUALITY=12 BAD_DATA_QUALITY value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NO_POSITION_CONTROL_SENSOR"] = 1;
                        values[valuesById[2] = "INIT_FAILED"] = 2;
                        values[valuesById[3] = "FAILED"] = 3;
                        values[valuesById[4] = "ABORTED"] = 4;
                        values[valuesById[5] = "TIMED_OUT"] = 5;
                        values[valuesById[6] = "ZERO_TORQUE_AMPLITUDE"] = 6;
                        values[valuesById[7] = "ZERO_VELOCITY_AMPLITUDE"] = 7;
                        values[valuesById[8] = "WRONG_SENSOR_POLARITY"] = 8;
                        values[valuesById[9] = "SMALL_MOTION_AMPLITUDE"] = 9;
                        values[valuesById[10] = "NOT_SUPPORTED"] = 10;
                        values[valuesById[11] = "INSUFFICIENT_VELOCITY_RESOLUTION"] = 11;
                        values[valuesById[12] = "BAD_DATA_QUALITY"] = 12;
                        return values;
                    })();

                    return Error;
                })();

                SystemIdentification.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SMALL_VELOCITY_AMPLITUDE":
                        case 1:
                            message.code = 1;
                            break;
                        case "LOW_DATA_QUALITY":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SystemIdentification.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SMALL_VELOCITY_AMPLITUDE=1 SMALL_VELOCITY_AMPLITUDE value
                     * @property {number} LOW_DATA_QUALITY=2 LOW_DATA_QUALITY value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SMALL_VELOCITY_AMPLITUDE"] = 1;
                        values[valuesById[2] = "LOW_DATA_QUALITY"] = 2;
                        return values;
                    })();

                    return Warning;
                })();

                return SystemIdentification;
            })();

            Status.AutoTuning = (function() {

                /**
                 * Properties of an AutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IAutoTuning
                 * @property {number|null} [deviceAddress] AutoTuning deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess|null} [success] AutoTuning success
                 * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning|null} [warning] AutoTuning warning
                 * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.IError|null} [error] AutoTuning error
                 */

                /**
                 * Constructs a new AutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents an AutoTuning.
                 * @implements IAutoTuning
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IAutoTuning=} [properties] Properties to set
                 */
                function AutoTuning(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AutoTuning deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 */
                AutoTuning.prototype.deviceAddress = 0;

                /**
                 * AutoTuning success.
                 * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 */
                AutoTuning.prototype.success = null;

                /**
                 * AutoTuning warning.
                 * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 */
                AutoTuning.prototype.warning = null;

                /**
                 * AutoTuning error.
                 * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 */
                AutoTuning.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * AutoTuning status.
                 * @member {"success"|"warning"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 */
                Object.defineProperty(AutoTuning.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "warning", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new AutoTuning instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IAutoTuning=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning} AutoTuning instance
                 */
                AutoTuning.create = function create(properties) {
                    return new AutoTuning(properties);
                };

                /**
                 * Encodes the specified AutoTuning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IAutoTuning} message AutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AutoTuning.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.encode(message.warning, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AutoTuning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IAutoTuning} message AutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AutoTuning.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AutoTuning message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning} AutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AutoTuning.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AutoTuning message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning} AutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AutoTuning.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AutoTuning message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AutoTuning.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an AutoTuning message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning} AutoTuning
                 */
                AutoTuning.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.AutoTuning)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.AutoTuning.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.AutoTuning.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.AutoTuning.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AutoTuning message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.AutoTuning} message AutoTuning
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AutoTuning.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this AutoTuning to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AutoTuning.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AutoTuning
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AutoTuning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.AutoTuning";
                };

                AutoTuning.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "POSITION_STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "POSITION_DONE":
                        case 2:
                            message.code = 2;
                            break;
                        case "VELOCITY_STARTED":
                        case 3:
                            message.code = 3;
                            break;
                        case "VELOCITY_DONE":
                        case 4:
                            message.code = 4;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.AutoTuning.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.AutoTuning.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} POSITION_STARTED=1 POSITION_STARTED value
                     * @property {number} POSITION_DONE=2 POSITION_DONE value
                     * @property {number} VELOCITY_STARTED=3 VELOCITY_STARTED value
                     * @property {number} VELOCITY_DONE=4 VELOCITY_DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "POSITION_STARTED"] = 1;
                        values[valuesById[2] = "POSITION_DONE"] = 2;
                        values[valuesById[3] = "VELOCITY_STARTED"] = 3;
                        values[valuesById[4] = "VELOCITY_DONE"] = 4;
                        return values;
                    })();

                    return Success;
                })();

                AutoTuning.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SETTLING_TIME_NOT_REACHED":
                        case 1:
                            message.code = 1;
                            break;
                        case "VELOCITY_UNSTABLE":
                        case 2:
                            message.code = 2;
                            break;
                        case "SMALL_VELOCITY_AMPLITUDE":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.AutoTuning.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.AutoTuning.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SETTLING_TIME_NOT_REACHED=1 SETTLING_TIME_NOT_REACHED value
                     * @property {number} VELOCITY_UNSTABLE=2 VELOCITY_UNSTABLE value
                     * @property {number} SMALL_VELOCITY_AMPLITUDE=3 SMALL_VELOCITY_AMPLITUDE value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SETTLING_TIME_NOT_REACHED"] = 1;
                        values[valuesById[2] = "VELOCITY_UNSTABLE"] = 2;
                        values[valuesById[3] = "SMALL_VELOCITY_AMPLITUDE"] = 3;
                        return values;
                    })();

                    return Warning;
                })();

                AutoTuning.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.AutoTuning.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.AutoTuning.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.AutoTuning.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.AutoTuning.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "PLANT_MODEL_INVALID":
                        case 1:
                            message.code = 1;
                            break;
                        case "PLANT_MODEL_NOT_FOUND":
                        case 2:
                            message.code = 2;
                            break;
                        case "CANNOT_ACHIEVE_SETTLING_TIME":
                        case 3:
                            message.code = 3;
                            break;
                        case "POSITION_FAILED":
                        case 4:
                            message.code = 4;
                            break;
                        case "VELOCITY_FAILED":
                        case 5:
                            message.code = 5;
                            break;
                        case "NOT_SUPPORTED":
                        case 6:
                            message.code = 6;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.AutoTuning.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.AutoTuning.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.AutoTuning.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.AutoTuning.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.AutoTuning.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} PLANT_MODEL_INVALID=1 PLANT_MODEL_INVALID value
                     * @property {number} PLANT_MODEL_NOT_FOUND=2 PLANT_MODEL_NOT_FOUND value
                     * @property {number} CANNOT_ACHIEVE_SETTLING_TIME=3 CANNOT_ACHIEVE_SETTLING_TIME value
                     * @property {number} POSITION_FAILED=4 POSITION_FAILED value
                     * @property {number} VELOCITY_FAILED=5 VELOCITY_FAILED value
                     * @property {number} NOT_SUPPORTED=6 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PLANT_MODEL_INVALID"] = 1;
                        values[valuesById[2] = "PLANT_MODEL_NOT_FOUND"] = 2;
                        values[valuesById[3] = "CANNOT_ACHIEVE_SETTLING_TIME"] = 3;
                        values[valuesById[4] = "POSITION_FAILED"] = 4;
                        values[valuesById[5] = "VELOCITY_FAILED"] = 5;
                        values[valuesById[6] = "NOT_SUPPORTED"] = 6;
                        return values;
                    })();

                    return Error;
                })();

                return AutoTuning;
            })();

            Status.MotionController = (function() {

                /**
                 * Properties of a MotionController.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IMotionController
                 * @property {number|null} [deviceAddress] MotionController deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.MotionController.ControllerType|null} [controllerType] MotionController controllerType
                 * @property {boolean|null} [enabled] MotionController enabled
                 * @property {boolean|null} [filter] MotionController filter
                 * @property {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess|null} [success] MotionController success
                 * @property {motionmaster.MotionMasterMessage.Status.MotionController.IError|null} [error] MotionController error
                 */

                /**
                 * Constructs a new MotionController.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a MotionController.
                 * @implements IMotionController
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IMotionController=} [properties] Properties to set
                 */
                function MotionController(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MotionController deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.deviceAddress = 0;

                /**
                 * MotionController controllerType.
                 * @member {motionmaster.MotionMasterMessage.Status.MotionController.ControllerType} controllerType
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.controllerType = 0;

                /**
                 * MotionController enabled.
                 * @member {boolean} enabled
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.enabled = false;

                /**
                 * MotionController filter.
                 * @member {boolean} filter
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.filter = false;

                /**
                 * MotionController success.
                 * @member {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.success = null;

                /**
                 * MotionController error.
                 * @member {motionmaster.MotionMasterMessage.Status.MotionController.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                MotionController.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * MotionController status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 */
                Object.defineProperty(MotionController.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MotionController instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMotionController=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.MotionController} MotionController instance
                 */
                MotionController.create = function create(properties) {
                    return new MotionController(properties);
                };

                /**
                 * Encodes the specified MotionController message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMotionController} message MotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MotionController.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.controllerType != null && Object.hasOwnProperty.call(message, "controllerType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.controllerType);
                    if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.enabled);
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.filter);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.encode(message.success, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.encode(message.error, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MotionController message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMotionController} message MotionController message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MotionController.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MotionController message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.MotionController} MotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MotionController.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MotionController();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.controllerType = reader.int32();
                                break;
                            }
                        case 3: {
                                message.enabled = reader.bool();
                                break;
                            }
                        case 4: {
                                message.filter = reader.bool();
                                break;
                            }
                        case 5: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MotionController message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.MotionController} MotionController
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MotionController.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MotionController message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MotionController.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        switch (message.controllerType) {
                        default:
                            return "controllerType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        if (typeof message.enabled !== "boolean")
                            return "enabled: boolean expected";
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        if (typeof message.filter !== "boolean")
                            return "filter: boolean expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MotionController message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.MotionController} MotionController
                 */
                MotionController.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MotionController)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.MotionController();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.controllerType) {
                    default:
                        if (typeof object.controllerType === "number") {
                            message.controllerType = object.controllerType;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.controllerType = 0;
                        break;
                    case "POSITION":
                    case 1:
                        message.controllerType = 1;
                        break;
                    case "VELOCITY":
                    case 2:
                        message.controllerType = 2;
                        break;
                    case "TORQUE":
                    case 3:
                        message.controllerType = 3;
                        break;
                    }
                    if (object.enabled != null)
                        message.enabled = Boolean(object.enabled);
                    if (object.filter != null)
                        message.filter = Boolean(object.filter);
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MotionController.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MotionController.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MotionController message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.MotionController} message MotionController
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MotionController.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.controllerType = options.enums === String ? "UNSPECIFIED" : 0;
                        object.enabled = false;
                        object.filter = false;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.controllerType != null && message.hasOwnProperty("controllerType"))
                        object.controllerType = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MotionController.ControllerType[message.controllerType] === undefined ? message.controllerType : $root.motionmaster.MotionMasterMessage.Status.MotionController.ControllerType[message.controllerType] : message.controllerType;
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        object.enabled = message.enabled;
                    if (message.filter != null && message.hasOwnProperty("filter"))
                        object.filter = message.filter;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this MotionController to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MotionController.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MotionController
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MotionController.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MotionController";
                };

                /**
                 * ControllerType enum.
                 * @name motionmaster.MotionMasterMessage.Status.MotionController.ControllerType
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} POSITION=1 POSITION value
                 * @property {number} VELOCITY=2 VELOCITY value
                 * @property {number} TORQUE=3 TORQUE value
                 */
                MotionController.ControllerType = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "POSITION"] = 1;
                    values[valuesById[2] = "VELOCITY"] = 2;
                    values[valuesById[3] = "TORQUE"] = 3;
                    return values;
                })();

                MotionController.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.MotionController.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.MotionController.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MotionController.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MotionController.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.MotionController.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.MotionController.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MotionController.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.MotionController.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                MotionController.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.MotionController.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.MotionController.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MotionController.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MotionController.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.MotionController.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MotionController.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.MotionController.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "CANNOT_GET_STATE":
                        case 1:
                            message.code = 1;
                            break;
                        case "CANNOT_GET_OP_MODE":
                        case 2:
                            message.code = 2;
                            break;
                        case "CANNOT_SET_STATE":
                        case 3:
                            message.code = 3;
                            break;
                        case "CANNOT_SET_OP_MODE":
                        case 4:
                            message.code = 4;
                            break;
                        case "CANNOT_SET_STATE_OP_MODE":
                        case 5:
                            message.code = 5;
                            break;
                        case "FAULT_STATE":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_SUPPORTED":
                        case 7:
                            message.code = 7;
                            break;
                        case "IN_PROGRESS":
                        case 8:
                            message.code = 8;
                            break;
                        case "ABORTED":
                        case 9:
                            message.code = 9;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MotionController.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.MotionController.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.MotionController.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MotionController.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.MotionController.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} CANNOT_GET_STATE=1 CANNOT_GET_STATE value
                     * @property {number} CANNOT_GET_OP_MODE=2 CANNOT_GET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE=3 CANNOT_SET_STATE value
                     * @property {number} CANNOT_SET_OP_MODE=4 CANNOT_SET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE_OP_MODE=5 CANNOT_SET_STATE_OP_MODE value
                     * @property {number} FAULT_STATE=6 FAULT_STATE value
                     * @property {number} NOT_SUPPORTED=7 NOT_SUPPORTED value
                     * @property {number} IN_PROGRESS=8 IN_PROGRESS value
                     * @property {number} ABORTED=9 ABORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CANNOT_GET_STATE"] = 1;
                        values[valuesById[2] = "CANNOT_GET_OP_MODE"] = 2;
                        values[valuesById[3] = "CANNOT_SET_STATE"] = 3;
                        values[valuesById[4] = "CANNOT_SET_OP_MODE"] = 4;
                        values[valuesById[5] = "CANNOT_SET_STATE_OP_MODE"] = 5;
                        values[valuesById[6] = "FAULT_STATE"] = 6;
                        values[valuesById[7] = "NOT_SUPPORTED"] = 7;
                        values[valuesById[8] = "IN_PROGRESS"] = 8;
                        values[valuesById[9] = "ABORTED"] = 9;
                        return values;
                    })();

                    return Error;
                })();

                return MotionController;
            })();

            Status.SignalGenerator = (function() {

                /**
                 * Properties of a SignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISignalGenerator
                 * @property {number|null} [deviceAddress] SignalGenerator deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess|null} [success] SignalGenerator success
                 * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning|null} [warning] SignalGenerator warning
                 * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError|null} [error] SignalGenerator error
                 */

                /**
                 * Constructs a new SignalGenerator.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SignalGenerator.
                 * @implements ISignalGenerator
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISignalGenerator=} [properties] Properties to set
                 */
                function SignalGenerator(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SignalGenerator deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 */
                SignalGenerator.prototype.deviceAddress = 0;

                /**
                 * SignalGenerator success.
                 * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 */
                SignalGenerator.prototype.success = null;

                /**
                 * SignalGenerator warning.
                 * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 */
                SignalGenerator.prototype.warning = null;

                /**
                 * SignalGenerator error.
                 * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 */
                SignalGenerator.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SignalGenerator status.
                 * @member {"success"|"warning"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 */
                Object.defineProperty(SignalGenerator.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "warning", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SignalGenerator instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISignalGenerator=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator} SignalGenerator instance
                 */
                SignalGenerator.create = function create(properties) {
                    return new SignalGenerator(properties);
                };

                /**
                 * Encodes the specified SignalGenerator message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISignalGenerator} message SignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SignalGenerator.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.encode(message.warning, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SignalGenerator message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISignalGenerator} message SignalGenerator message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SignalGenerator.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SignalGenerator message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator} SignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SignalGenerator.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SignalGenerator message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator} SignalGenerator
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SignalGenerator.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SignalGenerator message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SignalGenerator.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SignalGenerator message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator} SignalGenerator
                 */
                SignalGenerator.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SignalGenerator)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SignalGenerator.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SignalGenerator.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SignalGenerator.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SignalGenerator message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator} message SignalGenerator
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SignalGenerator.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this SignalGenerator to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SignalGenerator.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SignalGenerator
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SignalGenerator.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SignalGenerator";
                };

                SignalGenerator.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        case "PARAMETERS_SET":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SignalGenerator.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SignalGenerator.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     * @property {number} PARAMETERS_SET=3 PARAMETERS_SET value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        values[valuesById[3] = "PARAMETERS_SET"] = 3;
                        return values;
                    })();

                    return Success;
                })();

                SignalGenerator.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "ACC_DEC_VEL_CONSTRAINT":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SignalGenerator.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} ACC_DEC_VEL_CONSTRAINT=1 ACC_DEC_VEL_CONSTRAINT value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "ACC_DEC_VEL_CONSTRAINT"] = 1;
                        return values;
                    })();

                    return Warning;
                })();

                SignalGenerator.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "CANNOT_GET_STATE":
                        case 1:
                            message.code = 1;
                            break;
                        case "CANNOT_GET_OP_MODE":
                        case 2:
                            message.code = 2;
                            break;
                        case "CANNOT_SET_STATE":
                        case 3:
                            message.code = 3;
                            break;
                        case "CANNOT_SET_OP_MODE":
                        case 4:
                            message.code = 4;
                            break;
                        case "CANNOT_SET_STATE_OP_MODE":
                        case 5:
                            message.code = 5;
                            break;
                        case "FAULT_STATE":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_SUPPORTED":
                        case 7:
                            message.code = 7;
                            break;
                        case "NOT_DEFINED":
                        case 8:
                            message.code = 8;
                            break;
                        case "ALREADY_RUNNING":
                        case 9:
                            message.code = 9;
                            break;
                        case "ABORTED":
                        case 10:
                            message.code = 10;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SignalGenerator.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SignalGenerator.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SignalGenerator.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.SignalGenerator.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} CANNOT_GET_STATE=1 CANNOT_GET_STATE value
                     * @property {number} CANNOT_GET_OP_MODE=2 CANNOT_GET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE=3 CANNOT_SET_STATE value
                     * @property {number} CANNOT_SET_OP_MODE=4 CANNOT_SET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE_OP_MODE=5 CANNOT_SET_STATE_OP_MODE value
                     * @property {number} FAULT_STATE=6 FAULT_STATE value
                     * @property {number} NOT_SUPPORTED=7 NOT_SUPPORTED value
                     * @property {number} NOT_DEFINED=8 NOT_DEFINED value
                     * @property {number} ALREADY_RUNNING=9 ALREADY_RUNNING value
                     * @property {number} ABORTED=10 ABORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CANNOT_GET_STATE"] = 1;
                        values[valuesById[2] = "CANNOT_GET_OP_MODE"] = 2;
                        values[valuesById[3] = "CANNOT_SET_STATE"] = 3;
                        values[valuesById[4] = "CANNOT_SET_OP_MODE"] = 4;
                        values[valuesById[5] = "CANNOT_SET_STATE_OP_MODE"] = 5;
                        values[valuesById[6] = "FAULT_STATE"] = 6;
                        values[valuesById[7] = "NOT_SUPPORTED"] = 7;
                        values[valuesById[8] = "NOT_DEFINED"] = 8;
                        values[valuesById[9] = "ALREADY_RUNNING"] = 9;
                        values[valuesById[10] = "ABORTED"] = 10;
                        return values;
                    })();

                    return Error;
                })();

                return SignalGenerator;
            })();

            Status.MonitoringParameterValues = (function() {

                /**
                 * Properties of a MonitoringParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IMonitoringParameterValues
                 * @property {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues|null} [deviceParameterValues] MonitoringParameterValues deviceParameterValues
                 * @property {number|null} [timestamp] MonitoringParameterValues timestamp
                 * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess|null} [success] MonitoringParameterValues success
                 * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning|null} [warning] MonitoringParameterValues warning
                 * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError|null} [error] MonitoringParameterValues error
                 */

                /**
                 * Constructs a new MonitoringParameterValues.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a MonitoringParameterValues.
                 * @implements IMonitoringParameterValues
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues=} [properties] Properties to set
                 */
                function MonitoringParameterValues(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MonitoringParameterValues deviceParameterValues.
                 * @member {motionmaster.MotionMasterMessage.Status.IDeviceParameterValues|null|undefined} deviceParameterValues
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                MonitoringParameterValues.prototype.deviceParameterValues = null;

                /**
                 * MonitoringParameterValues timestamp.
                 * @member {number} timestamp
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                MonitoringParameterValues.prototype.timestamp = 0;

                /**
                 * MonitoringParameterValues success.
                 * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                MonitoringParameterValues.prototype.success = null;

                /**
                 * MonitoringParameterValues warning.
                 * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                MonitoringParameterValues.prototype.warning = null;

                /**
                 * MonitoringParameterValues error.
                 * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                MonitoringParameterValues.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * MonitoringParameterValues status.
                 * @member {"success"|"warning"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 */
                Object.defineProperty(MonitoringParameterValues.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "warning", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new MonitoringParameterValues instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues} MonitoringParameterValues instance
                 */
                MonitoringParameterValues.create = function create(properties) {
                    return new MonitoringParameterValues(properties);
                };

                /**
                 * Encodes the specified MonitoringParameterValues message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues} message MonitoringParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MonitoringParameterValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceParameterValues != null && Object.hasOwnProperty.call(message, "deviceParameterValues"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.encode(message.deviceParameterValues, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.timestamp);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.encode(message.warning, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MonitoringParameterValues message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IMonitoringParameterValues} message MonitoringParameterValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MonitoringParameterValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MonitoringParameterValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues} MonitoringParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MonitoringParameterValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.timestamp = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MonitoringParameterValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues} MonitoringParameterValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MonitoringParameterValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MonitoringParameterValues message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MonitoringParameterValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceParameterValues != null && message.hasOwnProperty("deviceParameterValues")) {
                        let error = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.verify(message.deviceParameterValues);
                        if (error)
                            return "deviceParameterValues." + error;
                    }
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (!$util.isInteger(message.timestamp))
                            return "timestamp: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a MonitoringParameterValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues} MonitoringParameterValues
                 */
                MonitoringParameterValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues();
                    if (object.deviceParameterValues != null) {
                        if (typeof object.deviceParameterValues !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.deviceParameterValues: object expected");
                        message.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.fromObject(object.deviceParameterValues);
                    }
                    if (object.timestamp != null)
                        message.timestamp = object.timestamp >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.fromObject(object.success);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.fromObject(object.warning);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MonitoringParameterValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues} message MonitoringParameterValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MonitoringParameterValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceParameterValues = null;
                        object.timestamp = 0;
                    }
                    if (message.deviceParameterValues != null && message.hasOwnProperty("deviceParameterValues"))
                        object.deviceParameterValues = $root.motionmaster.MotionMasterMessage.Status.DeviceParameterValues.toObject(message.deviceParameterValues, options);
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        object.timestamp = message.timestamp;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this MonitoringParameterValues to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MonitoringParameterValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MonitoringParameterValues
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MonitoringParameterValues.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MonitoringParameterValues";
                };

                MonitoringParameterValues.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                MonitoringParameterValues.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "PARAMETERS_MISSING":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} PARAMETERS_MISSING=1 PARAMETERS_MISSING value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PARAMETERS_MISSING"] = 1;
                        return values;
                    })();

                    return Warning;
                })();

                MonitoringParameterValues.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "REFUSED":
                        case 1:
                            message.code = 1;
                            break;
                        case "NOT_SUPPORTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "INVALID":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.MonitoringParameterValues.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} REFUSED=1 REFUSED value
                     * @property {number} NOT_SUPPORTED=2 NOT_SUPPORTED value
                     * @property {number} INVALID=3 INVALID value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "REFUSED"] = 1;
                        values[valuesById[2] = "NOT_SUPPORTED"] = 2;
                        values[valuesById[3] = "INVALID"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return MonitoringParameterValues;
            })();

            Status.DeviceStop = (function() {

                /**
                 * Properties of a DeviceStop.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceStop
                 * @property {number|null} [deviceAddress] DeviceStop deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess|null} [success] DeviceStop success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceStop.IError|null} [error] DeviceStop error
                 */

                /**
                 * Constructs a new DeviceStop.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceStop.
                 * @implements IDeviceStop
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceStop=} [properties] Properties to set
                 */
                function DeviceStop(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceStop deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @instance
                 */
                DeviceStop.prototype.deviceAddress = 0;

                /**
                 * DeviceStop success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @instance
                 */
                DeviceStop.prototype.success = null;

                /**
                 * DeviceStop error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceStop.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @instance
                 */
                DeviceStop.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceStop status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @instance
                 */
                Object.defineProperty(DeviceStop.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceStop instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceStop=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop} DeviceStop instance
                 */
                DeviceStop.create = function create(properties) {
                    return new DeviceStop(properties);
                };

                /**
                 * Encodes the specified DeviceStop message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceStop} message DeviceStop message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceStop.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceStop message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceStop} message DeviceStop message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceStop.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceStop message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop} DeviceStop
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceStop.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceStop message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop} DeviceStop
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceStop.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceStop message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceStop.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceStop message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop} DeviceStop
                 */
                DeviceStop.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceStop)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceStop.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceStop.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceStop message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceStop} message DeviceStop
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceStop.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceStop to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceStop.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceStop
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceStop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceStop";
                };

                DeviceStop.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceStop.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceStop.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceStop.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceStop.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                DeviceStop.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceStop.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceStop.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceStop.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceStop.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "TIMED_OUT":
                        case 1:
                            message.code = 1;
                            break;
                        case "NOT_SUPPORTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceStop.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceStop.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceStop.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceStop.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceStop.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} TIMED_OUT=1 TIMED_OUT value
                     * @property {number} NOT_SUPPORTED=2 NOT_SUPPORTED value
                     * @property {number} FAILED=3 FAILED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "TIMED_OUT"] = 1;
                        values[valuesById[2] = "NOT_SUPPORTED"] = 2;
                        values[valuesById[3] = "FAILED"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceStop;
            })();

            Status.EthercatNetworkState = (function() {

                /**
                 * Properties of an EthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IEthercatNetworkState
                 * @property {number|null} [deviceAddress] EthercatNetworkState deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.State|null} [state] EthercatNetworkState state
                 * @property {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess|null} [success] EthercatNetworkState success
                 * @property {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError|null} [error] EthercatNetworkState error
                 */

                /**
                 * Constructs a new EthercatNetworkState.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents an EthercatNetworkState.
                 * @implements IEthercatNetworkState
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState=} [properties] Properties to set
                 */
                function EthercatNetworkState(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EthercatNetworkState deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 */
                EthercatNetworkState.prototype.deviceAddress = 0;

                /**
                 * EthercatNetworkState state.
                 * @member {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.State|null|undefined} state
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 */
                EthercatNetworkState.prototype.state = null;

                /**
                 * EthercatNetworkState success.
                 * @member {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 */
                EthercatNetworkState.prototype.success = null;

                /**
                 * EthercatNetworkState error.
                 * @member {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 */
                EthercatNetworkState.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * EthercatNetworkState status.
                 * @member {"state"|"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 */
                Object.defineProperty(EthercatNetworkState.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["state", "success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new EthercatNetworkState instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState} EthercatNetworkState instance
                 */
                EthercatNetworkState.create = function create(properties) {
                    return new EthercatNetworkState(properties);
                };

                /**
                 * Encodes the specified EthercatNetworkState message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState} message EthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EthercatNetworkState.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EthercatNetworkState message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IEthercatNetworkState} message EthercatNetworkState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EthercatNetworkState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EthercatNetworkState message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState} EthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EthercatNetworkState.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.state = reader.int32();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EthercatNetworkState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState} EthercatNetworkState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EthercatNetworkState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EthercatNetworkState message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EthercatNetworkState.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.state != null && message.hasOwnProperty("state")) {
                        properties.status = 1;
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an EthercatNetworkState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState} EthercatNetworkState
                 */
                EthercatNetworkState.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "INIT":
                    case 1:
                        message.state = 1;
                        break;
                    case "PREOP":
                    case 2:
                        message.state = 2;
                        break;
                    case "BOOT":
                    case 3:
                        message.state = 3;
                        break;
                    case "SAFEOP":
                    case 4:
                        message.state = 4;
                        break;
                    case "OP":
                    case 5:
                        message.state = 5;
                        break;
                    }
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.EthercatNetworkState.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.EthercatNetworkState.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EthercatNetworkState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState} message EthercatNetworkState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EthercatNetworkState.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.state != null && message.hasOwnProperty("state")) {
                        object.state = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.State[message.state] === undefined ? message.state : $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.State[message.state] : message.state;
                        if (options.oneofs)
                            object.status = "state";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this EthercatNetworkState to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EthercatNetworkState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EthercatNetworkState
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EthercatNetworkState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.EthercatNetworkState";
                };

                /**
                 * State enum.
                 * @name motionmaster.MotionMasterMessage.Status.EthercatNetworkState.State
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} INIT=1 INIT value
                 * @property {number} PREOP=2 PREOP value
                 * @property {number} BOOT=3 BOOT value
                 * @property {number} SAFEOP=4 SAFEOP value
                 * @property {number} OP=5 OP value
                 */
                EthercatNetworkState.State = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "INIT"] = 1;
                    values[valuesById[2] = "PREOP"] = 2;
                    values[valuesById[3] = "BOOT"] = 3;
                    values[valuesById[4] = "SAFEOP"] = 4;
                    values[valuesById[5] = "OP"] = 5;
                    return values;
                })();

                EthercatNetworkState.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                EthercatNetworkState.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "TIMED_OUT":
                        case 1:
                            message.code = 1;
                            break;
                        case "NOT_SUPPORTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "UNKNOWN_STATE":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.EthercatNetworkState.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} TIMED_OUT=1 TIMED_OUT value
                     * @property {number} NOT_SUPPORTED=2 NOT_SUPPORTED value
                     * @property {number} UNKNOWN_STATE=3 UNKNOWN_STATE value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "TIMED_OUT"] = 1;
                        values[valuesById[2] = "NOT_SUPPORTED"] = 2;
                        values[valuesById[3] = "UNKNOWN_STATE"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                return EthercatNetworkState;
            })();

            Status.NarrowAngleCalibration = (function() {

                /**
                 * Properties of a NarrowAngleCalibration.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface INarrowAngleCalibration
                 * @property {number|null} [deviceAddress] NarrowAngleCalibration deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess|null} [success] NarrowAngleCalibration success
                 * @property {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError|null} [error] NarrowAngleCalibration error
                 */

                /**
                 * Constructs a new NarrowAngleCalibration.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a NarrowAngleCalibration.
                 * @implements INarrowAngleCalibration
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration=} [properties] Properties to set
                 */
                function NarrowAngleCalibration(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NarrowAngleCalibration deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @instance
                 */
                NarrowAngleCalibration.prototype.deviceAddress = 0;

                /**
                 * NarrowAngleCalibration success.
                 * @member {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @instance
                 */
                NarrowAngleCalibration.prototype.success = null;

                /**
                 * NarrowAngleCalibration error.
                 * @member {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @instance
                 */
                NarrowAngleCalibration.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * NarrowAngleCalibration status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @instance
                 */
                Object.defineProperty(NarrowAngleCalibration.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new NarrowAngleCalibration instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration} NarrowAngleCalibration instance
                 */
                NarrowAngleCalibration.create = function create(properties) {
                    return new NarrowAngleCalibration(properties);
                };

                /**
                 * Encodes the specified NarrowAngleCalibration message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration} message NarrowAngleCalibration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NarrowAngleCalibration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NarrowAngleCalibration message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.INarrowAngleCalibration} message NarrowAngleCalibration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NarrowAngleCalibration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NarrowAngleCalibration message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration} NarrowAngleCalibration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NarrowAngleCalibration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NarrowAngleCalibration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration} NarrowAngleCalibration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NarrowAngleCalibration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NarrowAngleCalibration message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NarrowAngleCalibration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a NarrowAngleCalibration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration} NarrowAngleCalibration
                 */
                NarrowAngleCalibration.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NarrowAngleCalibration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration} message NarrowAngleCalibration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NarrowAngleCalibration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this NarrowAngleCalibration to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NarrowAngleCalibration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NarrowAngleCalibration
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NarrowAngleCalibration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration";
                };

                NarrowAngleCalibration.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                NarrowAngleCalibration.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "INIT_FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "ABORTED":
                        case 3:
                            message.code = 3;
                            break;
                        case "TIMED_OUT":
                        case 4:
                            message.code = 4;
                            break;
                        case "NOT_SUPPORTED":
                        case 5:
                            message.code = 5;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.NarrowAngleCalibration.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} INIT_FAILED=1 INIT_FAILED value
                     * @property {number} FAILED=2 FAILED value
                     * @property {number} ABORTED=3 ABORTED value
                     * @property {number} TIMED_OUT=4 TIMED_OUT value
                     * @property {number} NOT_SUPPORTED=5 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "INIT_FAILED"] = 1;
                        values[valuesById[2] = "FAILED"] = 2;
                        values[valuesById[3] = "ABORTED"] = 3;
                        values[valuesById[4] = "TIMED_OUT"] = 4;
                        values[valuesById[5] = "NOT_SUPPORTED"] = 5;
                        return values;
                    })();

                    return Error;
                })();

                return NarrowAngleCalibration;
            })();

            Status.CirculoEncoderMagnetDistance = (function() {

                /**
                 * Properties of a CirculoEncoderMagnetDistance.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ICirculoEncoderMagnetDistance
                 * @property {number|null} [deviceAddress] CirculoEncoderMagnetDistance deviceAddress
                 * @property {number|null} [encoderOrdinal] CirculoEncoderMagnetDistance encoderOrdinal
                 * @property {number|null} [distance] CirculoEncoderMagnetDistance distance
                 * @property {number|null} [position] CirculoEncoderMagnetDistance position
                 */

                /**
                 * Constructs a new CirculoEncoderMagnetDistance.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a CirculoEncoderMagnetDistance.
                 * @implements ICirculoEncoderMagnetDistance
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance=} [properties] Properties to set
                 */
                function CirculoEncoderMagnetDistance(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CirculoEncoderMagnetDistance deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @instance
                 */
                CirculoEncoderMagnetDistance.prototype.deviceAddress = 0;

                /**
                 * CirculoEncoderMagnetDistance encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @instance
                 */
                CirculoEncoderMagnetDistance.prototype.encoderOrdinal = 0;

                /**
                 * CirculoEncoderMagnetDistance distance.
                 * @member {number} distance
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @instance
                 */
                CirculoEncoderMagnetDistance.prototype.distance = 0;

                /**
                 * CirculoEncoderMagnetDistance position.
                 * @member {number} position
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @instance
                 */
                CirculoEncoderMagnetDistance.prototype.position = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CirculoEncoderMagnetDistance instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance} CirculoEncoderMagnetDistance instance
                 */
                CirculoEncoderMagnetDistance.create = function create(properties) {
                    return new CirculoEncoderMagnetDistance(properties);
                };

                /**
                 * Encodes the specified CirculoEncoderMagnetDistance message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance} message CirculoEncoderMagnetDistance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderMagnetDistance.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.distance);
                    if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                        writer.uint32(/* id 4, wireType 0 =*/32).sint64(message.position);
                    return writer;
                };

                /**
                 * Encodes the specified CirculoEncoderMagnetDistance message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderMagnetDistance} message CirculoEncoderMagnetDistance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderMagnetDistance.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CirculoEncoderMagnetDistance message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance} CirculoEncoderMagnetDistance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderMagnetDistance.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.distance = reader.float();
                                break;
                            }
                        case 4: {
                                message.position = reader.sint64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CirculoEncoderMagnetDistance message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance} CirculoEncoderMagnetDistance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderMagnetDistance.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CirculoEncoderMagnetDistance message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CirculoEncoderMagnetDistance.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.distance != null && message.hasOwnProperty("distance"))
                        if (typeof message.distance !== "number")
                            return "distance: number expected";
                    if (message.position != null && message.hasOwnProperty("position"))
                        if (!$util.isInteger(message.position) && !(message.position && $util.isInteger(message.position.low) && $util.isInteger(message.position.high)))
                            return "position: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CirculoEncoderMagnetDistance message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance} CirculoEncoderMagnetDistance
                 */
                CirculoEncoderMagnetDistance.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.distance != null)
                        message.distance = Number(object.distance);
                    if (object.position != null)
                        if ($util.Long)
                            (message.position = $util.Long.fromValue(object.position)).unsigned = false;
                        else if (typeof object.position === "string")
                            message.position = parseInt(object.position, 10);
                        else if (typeof object.position === "number")
                            message.position = object.position;
                        else if (typeof object.position === "object")
                            message.position = new $util.LongBits(object.position.low >>> 0, object.position.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CirculoEncoderMagnetDistance message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance} message CirculoEncoderMagnetDistance
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CirculoEncoderMagnetDistance.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                        object.distance = 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.position = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.position = options.longs === String ? "0" : 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.distance != null && message.hasOwnProperty("distance"))
                        object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
                    if (message.position != null && message.hasOwnProperty("position"))
                        if (typeof message.position === "number")
                            object.position = options.longs === String ? String(message.position) : message.position;
                        else
                            object.position = options.longs === String ? $util.Long.prototype.toString.call(message.position) : options.longs === Number ? new $util.LongBits(message.position.low >>> 0, message.position.high >>> 0).toNumber() : message.position;
                    return object;
                };

                /**
                 * Converts this CirculoEncoderMagnetDistance to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CirculoEncoderMagnetDistance.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CirculoEncoderMagnetDistance
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CirculoEncoderMagnetDistance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderMagnetDistance";
                };

                return CirculoEncoderMagnetDistance;
            })();

            Status.CirculoEncoderNarrowAngleCalibrationProcedure = (function() {

                /**
                 * Properties of a CirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ICirculoEncoderNarrowAngleCalibrationProcedure
                 * @property {number|null} [deviceAddress] CirculoEncoderNarrowAngleCalibrationProcedure deviceAddress
                 * @property {number|null} [encoderOrdinal] CirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess|null} [success] CirculoEncoderNarrowAngleCalibrationProcedure success
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError|null} [error] CirculoEncoderNarrowAngleCalibrationProcedure error
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress|null} [progress] CirculoEncoderNarrowAngleCalibrationProcedure progress
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning|null} [warning] CirculoEncoderNarrowAngleCalibrationProcedure warning
                 */

                /**
                 * Constructs a new CirculoEncoderNarrowAngleCalibrationProcedure.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a CirculoEncoderNarrowAngleCalibrationProcedure.
                 * @implements ICirculoEncoderNarrowAngleCalibrationProcedure
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 */
                function CirculoEncoderNarrowAngleCalibrationProcedure(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.deviceAddress = 0;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.encoderOrdinal = 0;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure success.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.success = null;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure error.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.error = null;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure progress.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.progress = null;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure warning.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.warning = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * CirculoEncoderNarrowAngleCalibrationProcedure status.
                 * @member {"success"|"error"|"progress"|"warning"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 */
                Object.defineProperty(CirculoEncoderNarrowAngleCalibrationProcedure.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress", "warning"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CirculoEncoderNarrowAngleCalibrationProcedure instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure} CirculoEncoderNarrowAngleCalibrationProcedure instance
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.create = function create(properties) {
                    return new CirculoEncoderNarrowAngleCalibrationProcedure(properties);
                };

                /**
                 * Encodes the specified CirculoEncoderNarrowAngleCalibrationProcedure message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure} message CirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.encode(message.progress, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.encode(message.warning, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CirculoEncoderNarrowAngleCalibrationProcedure message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderNarrowAngleCalibrationProcedure} message CirculoEncoderNarrowAngleCalibrationProcedure message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure} CirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CirculoEncoderNarrowAngleCalibrationProcedure message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure} CirculoEncoderNarrowAngleCalibrationProcedure
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CirculoEncoderNarrowAngleCalibrationProcedure message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CirculoEncoderNarrowAngleCalibrationProcedure message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure} CirculoEncoderNarrowAngleCalibrationProcedure
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.fromObject(object.progress);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.fromObject(object.warning);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CirculoEncoderNarrowAngleCalibrationProcedure message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure} message CirculoEncoderNarrowAngleCalibrationProcedure
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    return object;
                };

                /**
                 * Converts this CirculoEncoderNarrowAngleCalibrationProcedure to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CirculoEncoderNarrowAngleCalibrationProcedure
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CirculoEncoderNarrowAngleCalibrationProcedure.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure";
                };

                CirculoEncoderNarrowAngleCalibrationProcedure.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        case "STOPPING":
                        case 3:
                            message.code = 3;
                            break;
                        case "STOPPED":
                        case 4:
                            message.code = 4;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     * @property {number} STOPPING=3 STOPPING value
                     * @property {number} STOPPED=4 STOPPED value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        values[valuesById[3] = "STOPPING"] = 3;
                        values[valuesById[4] = "STOPPED"] = 4;
                        return values;
                    })();

                    return Success;
                })();

                CirculoEncoderNarrowAngleCalibrationProcedure.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "INIT_FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "ABORTED":
                        case 3:
                            message.code = 3;
                            break;
                        case "TIMED_OUT":
                        case 4:
                            message.code = 4;
                            break;
                        case "NOT_SUPPORTED":
                        case 5:
                            message.code = 5;
                            break;
                        case "ALREADY_RUNNING":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_RUNNING":
                        case 7:
                            message.code = 7;
                            break;
                        case "OUTSIDE_POSITION_LIMITS":
                        case 8:
                            message.code = 8;
                            break;
                        case "ABSOLUTE_POSITION_RESET_FAILED":
                        case 9:
                            message.code = 9;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} INIT_FAILED=1 INIT_FAILED value
                     * @property {number} FAILED=2 FAILED value
                     * @property {number} ABORTED=3 ABORTED value
                     * @property {number} TIMED_OUT=4 TIMED_OUT value
                     * @property {number} NOT_SUPPORTED=5 NOT_SUPPORTED value
                     * @property {number} ALREADY_RUNNING=6 ALREADY_RUNNING value
                     * @property {number} NOT_RUNNING=7 NOT_RUNNING value
                     * @property {number} OUTSIDE_POSITION_LIMITS=8 OUTSIDE_POSITION_LIMITS value
                     * @property {number} ABSOLUTE_POSITION_RESET_FAILED=9 ABSOLUTE_POSITION_RESET_FAILED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "INIT_FAILED"] = 1;
                        values[valuesById[2] = "FAILED"] = 2;
                        values[valuesById[3] = "ABORTED"] = 3;
                        values[valuesById[4] = "TIMED_OUT"] = 4;
                        values[valuesById[5] = "NOT_SUPPORTED"] = 5;
                        values[valuesById[6] = "ALREADY_RUNNING"] = 6;
                        values[valuesById[7] = "NOT_RUNNING"] = 7;
                        values[valuesById[8] = "OUTSIDE_POSITION_LIMITS"] = 8;
                        values[valuesById[9] = "ABSOLUTE_POSITION_RESET_FAILED"] = 9;
                        return values;
                    })();

                    return Error;
                })();

                CirculoEncoderNarrowAngleCalibrationProcedure.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @interface IProgress
                     * @property {number|null} [iteration] Progress iteration
                     * @property {Array.<number>|null} [phaseError] Progress phaseError
                     * @property {Array.<number>|null} [position] Progress position
                     * @property {boolean|null} [final] Progress final
                     * @property {number|null} [maxPermissiblePhaseError] Progress maxPermissiblePhaseError
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        this.phaseError = [];
                        this.position = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress iteration.
                     * @member {number} iteration
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     */
                    Progress.prototype.iteration = 0;

                    /**
                     * Progress phaseError.
                     * @member {Array.<number>} phaseError
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     */
                    Progress.prototype.phaseError = $util.emptyArray;

                    /**
                     * Progress position.
                     * @member {Array.<number>} position
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     */
                    Progress.prototype.position = $util.emptyArray;

                    /**
                     * Progress final.
                     * @member {boolean} final
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     */
                    Progress.prototype.final = false;

                    /**
                     * Progress maxPermissiblePhaseError.
                     * @member {number} maxPermissiblePhaseError
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     */
                    Progress.prototype.maxPermissiblePhaseError = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.iteration != null && Object.hasOwnProperty.call(message, "iteration"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.iteration);
                        if (message.phaseError != null && message.phaseError.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (let i = 0; i < message.phaseError.length; ++i)
                                writer.int64(message.phaseError[i]);
                            writer.ldelim();
                        }
                        if (message.position != null && message.position.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (let i = 0; i < message.position.length; ++i)
                                writer.double(message.position[i]);
                            writer.ldelim();
                        }
                        if (message.final != null && Object.hasOwnProperty.call(message, "final"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.final);
                        if (message.maxPermissiblePhaseError != null && Object.hasOwnProperty.call(message, "maxPermissiblePhaseError"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.maxPermissiblePhaseError);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.iteration = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    if (!(message.phaseError && message.phaseError.length))
                                        message.phaseError = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.phaseError.push(reader.int64());
                                    } else
                                        message.phaseError.push(reader.int64());
                                    break;
                                }
                            case 3: {
                                    if (!(message.position && message.position.length))
                                        message.position = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.position.push(reader.double());
                                    } else
                                        message.position.push(reader.double());
                                    break;
                                }
                            case 4: {
                                    message.final = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.maxPermissiblePhaseError = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.iteration != null && message.hasOwnProperty("iteration"))
                            if (!$util.isInteger(message.iteration))
                                return "iteration: integer expected";
                        if (message.phaseError != null && message.hasOwnProperty("phaseError")) {
                            if (!Array.isArray(message.phaseError))
                                return "phaseError: array expected";
                            for (let i = 0; i < message.phaseError.length; ++i)
                                if (!$util.isInteger(message.phaseError[i]) && !(message.phaseError[i] && $util.isInteger(message.phaseError[i].low) && $util.isInteger(message.phaseError[i].high)))
                                    return "phaseError: integer|Long[] expected";
                        }
                        if (message.position != null && message.hasOwnProperty("position")) {
                            if (!Array.isArray(message.position))
                                return "position: array expected";
                            for (let i = 0; i < message.position.length; ++i)
                                if (typeof message.position[i] !== "number")
                                    return "position: number[] expected";
                        }
                        if (message.final != null && message.hasOwnProperty("final"))
                            if (typeof message.final !== "boolean")
                                return "final: boolean expected";
                        if (message.maxPermissiblePhaseError != null && message.hasOwnProperty("maxPermissiblePhaseError"))
                            if (!$util.isInteger(message.maxPermissiblePhaseError) && !(message.maxPermissiblePhaseError && $util.isInteger(message.maxPermissiblePhaseError.low) && $util.isInteger(message.maxPermissiblePhaseError.high)))
                                return "maxPermissiblePhaseError: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress();
                        if (object.iteration != null)
                            message.iteration = object.iteration >>> 0;
                        if (object.phaseError) {
                            if (!Array.isArray(object.phaseError))
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.phaseError: array expected");
                            message.phaseError = [];
                            for (let i = 0; i < object.phaseError.length; ++i)
                                if ($util.Long)
                                    (message.phaseError[i] = $util.Long.fromValue(object.phaseError[i])).unsigned = false;
                                else if (typeof object.phaseError[i] === "string")
                                    message.phaseError[i] = parseInt(object.phaseError[i], 10);
                                else if (typeof object.phaseError[i] === "number")
                                    message.phaseError[i] = object.phaseError[i];
                                else if (typeof object.phaseError[i] === "object")
                                    message.phaseError[i] = new $util.LongBits(object.phaseError[i].low >>> 0, object.phaseError[i].high >>> 0).toNumber();
                        }
                        if (object.position) {
                            if (!Array.isArray(object.position))
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress.position: array expected");
                            message.position = [];
                            for (let i = 0; i < object.position.length; ++i)
                                message.position[i] = Number(object.position[i]);
                        }
                        if (object.final != null)
                            message.final = Boolean(object.final);
                        if (object.maxPermissiblePhaseError != null)
                            if ($util.Long)
                                (message.maxPermissiblePhaseError = $util.Long.fromValue(object.maxPermissiblePhaseError)).unsigned = false;
                            else if (typeof object.maxPermissiblePhaseError === "string")
                                message.maxPermissiblePhaseError = parseInt(object.maxPermissiblePhaseError, 10);
                            else if (typeof object.maxPermissiblePhaseError === "number")
                                message.maxPermissiblePhaseError = object.maxPermissiblePhaseError;
                            else if (typeof object.maxPermissiblePhaseError === "object")
                                message.maxPermissiblePhaseError = new $util.LongBits(object.maxPermissiblePhaseError.low >>> 0, object.maxPermissiblePhaseError.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.phaseError = [];
                            object.position = [];
                        }
                        if (options.defaults) {
                            object.iteration = 0;
                            object.final = false;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.maxPermissiblePhaseError = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.maxPermissiblePhaseError = options.longs === String ? "0" : 0;
                        }
                        if (message.iteration != null && message.hasOwnProperty("iteration"))
                            object.iteration = message.iteration;
                        if (message.phaseError && message.phaseError.length) {
                            object.phaseError = [];
                            for (let j = 0; j < message.phaseError.length; ++j)
                                if (typeof message.phaseError[j] === "number")
                                    object.phaseError[j] = options.longs === String ? String(message.phaseError[j]) : message.phaseError[j];
                                else
                                    object.phaseError[j] = options.longs === String ? $util.Long.prototype.toString.call(message.phaseError[j]) : options.longs === Number ? new $util.LongBits(message.phaseError[j].low >>> 0, message.phaseError[j].high >>> 0).toNumber() : message.phaseError[j];
                        }
                        if (message.position && message.position.length) {
                            object.position = [];
                            for (let j = 0; j < message.position.length; ++j)
                                object.position[j] = options.json && !isFinite(message.position[j]) ? String(message.position[j]) : message.position[j];
                        }
                        if (message.final != null && message.hasOwnProperty("final"))
                            object.final = message.final;
                        if (message.maxPermissiblePhaseError != null && message.hasOwnProperty("maxPermissiblePhaseError"))
                            if (typeof message.maxPermissiblePhaseError === "number")
                                object.maxPermissiblePhaseError = options.longs === String ? String(message.maxPermissiblePhaseError) : message.maxPermissiblePhaseError;
                            else
                                object.maxPermissiblePhaseError = options.longs === String ? $util.Long.prototype.toString.call(message.maxPermissiblePhaseError) : options.longs === Number ? new $util.LongBits(message.maxPermissiblePhaseError.low >>> 0, message.maxPermissiblePhaseError.high >>> 0).toNumber() : message.maxPermissiblePhaseError;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Progress";
                    };

                    return Progress;
                })();

                CirculoEncoderNarrowAngleCalibrationProcedure.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "MAX_MOTOR_SPEED_TOO_LOW":
                        case 1:
                            message.code = 1;
                            break;
                        case "AUTO_COMMUTATION_OFFSET_MEASUREMENT_FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "NARROW_MOTION_RANGE":
                        case 3:
                            message.code = 3;
                            break;
                        case "ABSOLUTE_POSITION_CHANGED":
                        case 4:
                            message.code = 4;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CirculoEncoderNarrowAngleCalibrationProcedure.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} MAX_MOTOR_SPEED_TOO_LOW=1 MAX_MOTOR_SPEED_TOO_LOW value
                     * @property {number} AUTO_COMMUTATION_OFFSET_MEASUREMENT_FAILED=2 AUTO_COMMUTATION_OFFSET_MEASUREMENT_FAILED value
                     * @property {number} NARROW_MOTION_RANGE=3 NARROW_MOTION_RANGE value
                     * @property {number} ABSOLUTE_POSITION_CHANGED=4 ABSOLUTE_POSITION_CHANGED value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "MAX_MOTOR_SPEED_TOO_LOW"] = 1;
                        values[valuesById[2] = "AUTO_COMMUTATION_OFFSET_MEASUREMENT_FAILED"] = 2;
                        values[valuesById[3] = "NARROW_MOTION_RANGE"] = 3;
                        values[valuesById[4] = "ABSOLUTE_POSITION_CHANGED"] = 4;
                        return values;
                    })();

                    return Warning;
                })();

                return CirculoEncoderNarrowAngleCalibrationProcedure;
            })();

            Status.DeviceCiA402State = (function() {

                /**
                 * Properties of a DeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceCiA402State
                 * @property {number|null} [deviceAddress] DeviceCiA402State deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.State|null} [state] DeviceCiA402State state
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess|null} [success] DeviceCiA402State success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError|null} [error] DeviceCiA402State error
                 */

                /**
                 * Constructs a new DeviceCiA402State.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceCiA402State.
                 * @implements IDeviceCiA402State
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State=} [properties] Properties to set
                 */
                function DeviceCiA402State(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceCiA402State deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 */
                DeviceCiA402State.prototype.deviceAddress = 0;

                /**
                 * DeviceCiA402State state.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.State|null|undefined} state
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 */
                DeviceCiA402State.prototype.state = null;

                /**
                 * DeviceCiA402State success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 */
                DeviceCiA402State.prototype.success = null;

                /**
                 * DeviceCiA402State error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 */
                DeviceCiA402State.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceCiA402State status.
                 * @member {"state"|"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 */
                Object.defineProperty(DeviceCiA402State.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["state", "success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceCiA402State instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State} DeviceCiA402State instance
                 */
                DeviceCiA402State.create = function create(properties) {
                    return new DeviceCiA402State(properties);
                };

                /**
                 * Encodes the specified DeviceCiA402State message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State} message DeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceCiA402State.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceCiA402State message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceCiA402State} message DeviceCiA402State message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceCiA402State.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceCiA402State message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State} DeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceCiA402State.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.state = reader.int32();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceCiA402State message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State} DeviceCiA402State
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceCiA402State.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceCiA402State message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceCiA402State.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.state != null && message.hasOwnProperty("state")) {
                        properties.status = 1;
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceCiA402State message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State} DeviceCiA402State
                 */
                DeviceCiA402State.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    switch (object.state) {
                    default:
                        if (typeof object.state === "number") {
                            message.state = object.state;
                            break;
                        }
                        break;
                    case "UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "NOT_READY":
                    case 1:
                        message.state = 1;
                        break;
                    case "SWITCH_ON_DISABLED":
                    case 2:
                        message.state = 2;
                        break;
                    case "READY_SWITCH_ON":
                    case 3:
                        message.state = 3;
                        break;
                    case "SWITCHED_ON":
                    case 4:
                        message.state = 4;
                        break;
                    case "OP_ENABLED":
                    case 5:
                        message.state = 5;
                        break;
                    case "QUICK_STOP_ACTIVE":
                    case 6:
                        message.state = 6;
                        break;
                    case "FAULT_REACTION_ACTIVE":
                    case 7:
                        message.state = 7;
                        break;
                    case "FAULT":
                    case 8:
                        message.state = 8;
                        break;
                    }
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceCiA402State.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceCiA402State.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceCiA402State message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State} message DeviceCiA402State
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceCiA402State.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.state != null && message.hasOwnProperty("state")) {
                        object.state = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.State[message.state] === undefined ? message.state : $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.State[message.state] : message.state;
                        if (options.oneofs)
                            object.status = "state";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceCiA402State to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceCiA402State.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceCiA402State
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceCiA402State.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceCiA402State";
                };

                /**
                 * State enum.
                 * @name motionmaster.MotionMasterMessage.Status.DeviceCiA402State.State
                 * @enum {number}
                 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                 * @property {number} NOT_READY=1 NOT_READY value
                 * @property {number} SWITCH_ON_DISABLED=2 SWITCH_ON_DISABLED value
                 * @property {number} READY_SWITCH_ON=3 READY_SWITCH_ON value
                 * @property {number} SWITCHED_ON=4 SWITCHED_ON value
                 * @property {number} OP_ENABLED=5 OP_ENABLED value
                 * @property {number} QUICK_STOP_ACTIVE=6 QUICK_STOP_ACTIVE value
                 * @property {number} FAULT_REACTION_ACTIVE=7 FAULT_REACTION_ACTIVE value
                 * @property {number} FAULT=8 FAULT value
                 */
                DeviceCiA402State.State = (function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNSPECIFIED"] = 0;
                    values[valuesById[1] = "NOT_READY"] = 1;
                    values[valuesById[2] = "SWITCH_ON_DISABLED"] = 2;
                    values[valuesById[3] = "READY_SWITCH_ON"] = 3;
                    values[valuesById[4] = "SWITCHED_ON"] = 4;
                    values[valuesById[5] = "OP_ENABLED"] = 5;
                    values[valuesById[6] = "QUICK_STOP_ACTIVE"] = 6;
                    values[valuesById[7] = "FAULT_REACTION_ACTIVE"] = 7;
                    values[valuesById[8] = "FAULT"] = 8;
                    return values;
                })();

                DeviceCiA402State.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                DeviceCiA402State.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "TIMED_OUT":
                        case 1:
                            message.code = 1;
                            break;
                        case "FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "FAULT":
                        case 3:
                            message.code = 3;
                            break;
                        case "NOT_SUPPORTED":
                        case 4:
                            message.code = 4;
                            break;
                        case "UNKNOWN_STATE":
                        case 5:
                            message.code = 5;
                            break;
                        case "ABORTED":
                        case 6:
                            message.code = 6;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceCiA402State.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} TIMED_OUT=1 TIMED_OUT value
                     * @property {number} FAILED=2 FAILED value
                     * @property {number} FAULT=3 FAULT value
                     * @property {number} NOT_SUPPORTED=4 NOT_SUPPORTED value
                     * @property {number} UNKNOWN_STATE=5 UNKNOWN_STATE value
                     * @property {number} ABORTED=6 ABORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "TIMED_OUT"] = 1;
                        values[valuesById[2] = "FAILED"] = 2;
                        values[valuesById[3] = "FAULT"] = 3;
                        values[valuesById[4] = "NOT_SUPPORTED"] = 4;
                        values[valuesById[5] = "UNKNOWN_STATE"] = 5;
                        values[valuesById[6] = "ABORTED"] = 6;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceCiA402State;
            })();

            Status.SystemLog = (function() {

                /**
                 * Properties of a SystemLog.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemLog
                 * @property {string|null} [content] SystemLog content
                 * @property {string|null} [runEnv] SystemLog runEnv
                 */

                /**
                 * Constructs a new SystemLog.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemLog.
                 * @implements ISystemLog
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemLog=} [properties] Properties to set
                 */
                function SystemLog(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemLog content.
                 * @member {string} content
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @instance
                 */
                SystemLog.prototype.content = "";

                /**
                 * SystemLog runEnv.
                 * @member {string} runEnv
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @instance
                 */
                SystemLog.prototype.runEnv = "";

                /**
                 * Creates a new SystemLog instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemLog=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemLog} SystemLog instance
                 */
                SystemLog.create = function create(properties) {
                    return new SystemLog(properties);
                };

                /**
                 * Encodes the specified SystemLog message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemLog.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemLog} message SystemLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemLog.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.content);
                    if (message.runEnv != null && Object.hasOwnProperty.call(message, "runEnv"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.runEnv);
                    return writer;
                };

                /**
                 * Encodes the specified SystemLog message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemLog.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemLog} message SystemLog message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemLog.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemLog message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemLog} SystemLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemLog.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemLog();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.content = reader.string();
                                break;
                            }
                        case 2: {
                                message.runEnv = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemLog message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemLog} SystemLog
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemLog.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemLog message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemLog.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.content != null && message.hasOwnProperty("content"))
                        if (!$util.isString(message.content))
                            return "content: string expected";
                    if (message.runEnv != null && message.hasOwnProperty("runEnv"))
                        if (!$util.isString(message.runEnv))
                            return "runEnv: string expected";
                    return null;
                };

                /**
                 * Creates a SystemLog message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemLog} SystemLog
                 */
                SystemLog.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemLog)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SystemLog();
                    if (object.content != null)
                        message.content = String(object.content);
                    if (object.runEnv != null)
                        message.runEnv = String(object.runEnv);
                    return message;
                };

                /**
                 * Creates a plain object from a SystemLog message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemLog} message SystemLog
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemLog.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.content = "";
                        object.runEnv = "";
                    }
                    if (message.content != null && message.hasOwnProperty("content"))
                        object.content = message.content;
                    if (message.runEnv != null && message.hasOwnProperty("runEnv"))
                        object.runEnv = message.runEnv;
                    return object;
                };

                /**
                 * Converts this SystemLog to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemLog.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemLog
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemLog
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemLog";
                };

                return SystemLog;
            })();

            Status.DeviceSiiRestore = (function() {

                /**
                 * Properties of a DeviceSiiRestore.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceSiiRestore
                 * @property {number|null} [devicePosition] DeviceSiiRestore devicePosition
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess|null} [success] DeviceSiiRestore success
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError|null} [error] DeviceSiiRestore error
                 */

                /**
                 * Constructs a new DeviceSiiRestore.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceSiiRestore.
                 * @implements IDeviceSiiRestore
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore=} [properties] Properties to set
                 */
                function DeviceSiiRestore(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceSiiRestore devicePosition.
                 * @member {number} devicePosition
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @instance
                 */
                DeviceSiiRestore.prototype.devicePosition = 0;

                /**
                 * DeviceSiiRestore success.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @instance
                 */
                DeviceSiiRestore.prototype.success = null;

                /**
                 * DeviceSiiRestore error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @instance
                 */
                DeviceSiiRestore.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceSiiRestore status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @instance
                 */
                Object.defineProperty(DeviceSiiRestore.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceSiiRestore instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore} DeviceSiiRestore instance
                 */
                DeviceSiiRestore.create = function create(properties) {
                    return new DeviceSiiRestore(properties);
                };

                /**
                 * Encodes the specified DeviceSiiRestore message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore} message DeviceSiiRestore message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceSiiRestore.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.devicePosition != null && Object.hasOwnProperty.call(message, "devicePosition"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.devicePosition);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceSiiRestore message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSiiRestore} message DeviceSiiRestore message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceSiiRestore.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceSiiRestore message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore} DeviceSiiRestore
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceSiiRestore.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.devicePosition = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceSiiRestore message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore} DeviceSiiRestore
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceSiiRestore.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceSiiRestore message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceSiiRestore.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.devicePosition != null && message.hasOwnProperty("devicePosition"))
                        if (!$util.isInteger(message.devicePosition))
                            return "devicePosition: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceSiiRestore message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore} DeviceSiiRestore
                 */
                DeviceSiiRestore.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore();
                    if (object.devicePosition != null)
                        message.devicePosition = object.devicePosition >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceSiiRestore message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore} message DeviceSiiRestore
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceSiiRestore.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.devicePosition = 0;
                    if (message.devicePosition != null && message.hasOwnProperty("devicePosition"))
                        object.devicePosition = message.devicePosition;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceSiiRestore to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceSiiRestore.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceSiiRestore
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceSiiRestore.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceSiiRestore";
                };

                DeviceSiiRestore.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                DeviceSiiRestore.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "SII_CORRUPTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "REFUSED":
                        case 2:
                            message.code = 2;
                            break;
                        case "NOT_SUPPORTED":
                        case 3:
                            message.code = 3;
                            break;
                        case "SII_WRITE_FAILED":
                        case 4:
                            message.code = 4;
                            break;
                        case "DEVICE_NOT_FOUND":
                        case 5:
                            message.code = 5;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceSiiRestore.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} SII_CORRUPTED=1 SII_CORRUPTED value
                     * @property {number} REFUSED=2 REFUSED value
                     * @property {number} NOT_SUPPORTED=3 NOT_SUPPORTED value
                     * @property {number} SII_WRITE_FAILED=4 SII_WRITE_FAILED value
                     * @property {number} DEVICE_NOT_FOUND=5 DEVICE_NOT_FOUND value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SII_CORRUPTED"] = 1;
                        values[valuesById[2] = "REFUSED"] = 2;
                        values[valuesById[3] = "NOT_SUPPORTED"] = 3;
                        values[valuesById[4] = "SII_WRITE_FAILED"] = 4;
                        values[valuesById[5] = "DEVICE_NOT_FOUND"] = 5;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceSiiRestore;
            })();

            Status.OpenLoopFieldControl = (function() {

                /**
                 * Properties of an OpenLoopFieldControl.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IOpenLoopFieldControl
                 * @property {number|null} [deviceAddress] OpenLoopFieldControl deviceAddress
                 * @property {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess|null} [success] OpenLoopFieldControl success
                 * @property {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError|null} [error] OpenLoopFieldControl error
                 */

                /**
                 * Constructs a new OpenLoopFieldControl.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents an OpenLoopFieldControl.
                 * @implements IOpenLoopFieldControl
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl=} [properties] Properties to set
                 */
                function OpenLoopFieldControl(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OpenLoopFieldControl deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @instance
                 */
                OpenLoopFieldControl.prototype.deviceAddress = 0;

                /**
                 * OpenLoopFieldControl success.
                 * @member {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @instance
                 */
                OpenLoopFieldControl.prototype.success = null;

                /**
                 * OpenLoopFieldControl error.
                 * @member {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @instance
                 */
                OpenLoopFieldControl.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * OpenLoopFieldControl status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @instance
                 */
                Object.defineProperty(OpenLoopFieldControl.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new OpenLoopFieldControl instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl} OpenLoopFieldControl instance
                 */
                OpenLoopFieldControl.create = function create(properties) {
                    return new OpenLoopFieldControl(properties);
                };

                /**
                 * Encodes the specified OpenLoopFieldControl message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl} message OpenLoopFieldControl message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OpenLoopFieldControl.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OpenLoopFieldControl message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOpenLoopFieldControl} message OpenLoopFieldControl message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OpenLoopFieldControl.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OpenLoopFieldControl message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl} OpenLoopFieldControl
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OpenLoopFieldControl.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OpenLoopFieldControl message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl} OpenLoopFieldControl
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OpenLoopFieldControl.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OpenLoopFieldControl message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OpenLoopFieldControl.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OpenLoopFieldControl message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl} OpenLoopFieldControl
                 */
                OpenLoopFieldControl.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OpenLoopFieldControl message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl} message OpenLoopFieldControl
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OpenLoopFieldControl.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this OpenLoopFieldControl to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OpenLoopFieldControl.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OpenLoopFieldControl
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OpenLoopFieldControl.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl";
                };

                OpenLoopFieldControl.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                OpenLoopFieldControl.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "CANNOT_GET_STATE":
                        case 1:
                            message.code = 1;
                            break;
                        case "CANNOT_GET_OP_MODE":
                        case 2:
                            message.code = 2;
                            break;
                        case "CANNOT_SET_STATE":
                        case 3:
                            message.code = 3;
                            break;
                        case "CANNOT_SET_OP_MODE":
                        case 4:
                            message.code = 4;
                            break;
                        case "CANNOT_SET_STATE_OP_MODE":
                        case 5:
                            message.code = 5;
                            break;
                        case "FAULT_STATE":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_SUPPORTED":
                        case 7:
                            message.code = 7;
                            break;
                        case "ALREADY_RUNNING":
                        case 8:
                            message.code = 8;
                            break;
                        case "ABORTED":
                        case 9:
                            message.code = 9;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OpenLoopFieldControl.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} CANNOT_GET_STATE=1 CANNOT_GET_STATE value
                     * @property {number} CANNOT_GET_OP_MODE=2 CANNOT_GET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE=3 CANNOT_SET_STATE value
                     * @property {number} CANNOT_SET_OP_MODE=4 CANNOT_SET_OP_MODE value
                     * @property {number} CANNOT_SET_STATE_OP_MODE=5 CANNOT_SET_STATE_OP_MODE value
                     * @property {number} FAULT_STATE=6 FAULT_STATE value
                     * @property {number} NOT_SUPPORTED=7 NOT_SUPPORTED value
                     * @property {number} ALREADY_RUNNING=8 ALREADY_RUNNING value
                     * @property {number} ABORTED=9 ABORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CANNOT_GET_STATE"] = 1;
                        values[valuesById[2] = "CANNOT_GET_OP_MODE"] = 2;
                        values[valuesById[3] = "CANNOT_SET_STATE"] = 3;
                        values[valuesById[4] = "CANNOT_SET_OP_MODE"] = 4;
                        values[valuesById[5] = "CANNOT_SET_STATE_OP_MODE"] = 5;
                        values[valuesById[6] = "FAULT_STATE"] = 6;
                        values[valuesById[7] = "NOT_SUPPORTED"] = 7;
                        values[valuesById[8] = "ALREADY_RUNNING"] = 8;
                        values[valuesById[9] = "ABORTED"] = 9;
                        return values;
                    })();

                    return Error;
                })();

                return OpenLoopFieldControl;
            })();

            Status.FullAutoTuning = (function() {

                /**
                 * Properties of a FullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IFullAutoTuning
                 * @property {number|null} [deviceAddress] FullAutoTuning deviceAddress
                 * @property {number|null} [dampingRatio] FullAutoTuning dampingRatio
                 * @property {number|null} [settlingTime] FullAutoTuning settlingTime
                 * @property {number|null} [bandwidth] FullAutoTuning bandwidth
                 * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess|null} [success] FullAutoTuning success
                 * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError|null} [error] FullAutoTuning error
                 * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress|null} [progress] FullAutoTuning progress
                 * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning|null} [warning] FullAutoTuning warning
                 */

                /**
                 * Constructs a new FullAutoTuning.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a FullAutoTuning.
                 * @implements IFullAutoTuning
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IFullAutoTuning=} [properties] Properties to set
                 */
                function FullAutoTuning(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FullAutoTuning deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.deviceAddress = 0;

                /**
                 * FullAutoTuning dampingRatio.
                 * @member {number} dampingRatio
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.dampingRatio = 0;

                /**
                 * FullAutoTuning settlingTime.
                 * @member {number|null|undefined} settlingTime
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.settlingTime = null;

                /**
                 * FullAutoTuning bandwidth.
                 * @member {number|null|undefined} bandwidth
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.bandwidth = null;

                /**
                 * FullAutoTuning success.
                 * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.success = null;

                /**
                 * FullAutoTuning error.
                 * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.error = null;

                /**
                 * FullAutoTuning progress.
                 * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.progress = null;

                /**
                 * FullAutoTuning warning.
                 * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning|null|undefined} warning
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                FullAutoTuning.prototype.warning = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * FullAutoTuning settlingTimeOrBandwidth.
                 * @member {"settlingTime"|"bandwidth"|undefined} settlingTimeOrBandwidth
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                Object.defineProperty(FullAutoTuning.prototype, "settlingTimeOrBandwidth", {
                    get: $util.oneOfGetter($oneOfFields = ["settlingTime", "bandwidth"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * FullAutoTuning status.
                 * @member {"success"|"error"|"progress"|"warning"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 */
                Object.defineProperty(FullAutoTuning.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress", "warning"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new FullAutoTuning instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IFullAutoTuning=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning} FullAutoTuning instance
                 */
                FullAutoTuning.create = function create(properties) {
                    return new FullAutoTuning(properties);
                };

                /**
                 * Encodes the specified FullAutoTuning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IFullAutoTuning} message FullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FullAutoTuning.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.dampingRatio != null && Object.hasOwnProperty.call(message, "dampingRatio"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.dampingRatio);
                    if (message.settlingTime != null && Object.hasOwnProperty.call(message, "settlingTime"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.settlingTime);
                    if (message.bandwidth != null && Object.hasOwnProperty.call(message, "bandwidth"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.bandwidth);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.encode(message.success, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.encode(message.error, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.encode(message.progress, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.warning != null && Object.hasOwnProperty.call(message, "warning"))
                        $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.encode(message.warning, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FullAutoTuning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IFullAutoTuning} message FullAutoTuning message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FullAutoTuning.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FullAutoTuning message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning} FullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FullAutoTuning.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.dampingRatio = reader.double();
                                break;
                            }
                        case 3: {
                                message.settlingTime = reader.double();
                                break;
                            }
                        case 4: {
                                message.bandwidth = reader.double();
                                break;
                            }
                        case 5: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 7: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                message.warning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FullAutoTuning message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning} FullAutoTuning
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FullAutoTuning.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FullAutoTuning message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FullAutoTuning.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.dampingRatio != null && message.hasOwnProperty("dampingRatio"))
                        if (typeof message.dampingRatio !== "number")
                            return "dampingRatio: number expected";
                    if (message.settlingTime != null && message.hasOwnProperty("settlingTime")) {
                        properties.settlingTimeOrBandwidth = 1;
                        if (typeof message.settlingTime !== "number")
                            return "settlingTime: number expected";
                    }
                    if (message.bandwidth != null && message.hasOwnProperty("bandwidth")) {
                        if (properties.settlingTimeOrBandwidth === 1)
                            return "settlingTimeOrBandwidth: multiple values";
                        properties.settlingTimeOrBandwidth = 1;
                        if (typeof message.bandwidth !== "number")
                            return "bandwidth: number expected";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.verify(message.warning);
                            if (error)
                                return "warning." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a FullAutoTuning message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning} FullAutoTuning
                 */
                FullAutoTuning.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.dampingRatio != null)
                        message.dampingRatio = Number(object.dampingRatio);
                    if (object.settlingTime != null)
                        message.settlingTime = Number(object.settlingTime);
                    if (object.bandwidth != null)
                        message.bandwidth = Number(object.bandwidth);
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.FullAutoTuning.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.FullAutoTuning.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.FullAutoTuning.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.fromObject(object.progress);
                    }
                    if (object.warning != null) {
                        if (typeof object.warning !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.FullAutoTuning.warning: object expected");
                        message.warning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.fromObject(object.warning);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FullAutoTuning message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning} message FullAutoTuning
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FullAutoTuning.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.dampingRatio = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.dampingRatio != null && message.hasOwnProperty("dampingRatio"))
                        object.dampingRatio = options.json && !isFinite(message.dampingRatio) ? String(message.dampingRatio) : message.dampingRatio;
                    if (message.settlingTime != null && message.hasOwnProperty("settlingTime")) {
                        object.settlingTime = options.json && !isFinite(message.settlingTime) ? String(message.settlingTime) : message.settlingTime;
                        if (options.oneofs)
                            object.settlingTimeOrBandwidth = "settlingTime";
                    }
                    if (message.bandwidth != null && message.hasOwnProperty("bandwidth")) {
                        object.bandwidth = options.json && !isFinite(message.bandwidth) ? String(message.bandwidth) : message.bandwidth;
                        if (options.oneofs)
                            object.settlingTimeOrBandwidth = "bandwidth";
                    }
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    if (message.warning != null && message.hasOwnProperty("warning")) {
                        object.warning = $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.toObject(message.warning, options);
                        if (options.oneofs)
                            object.status = "warning";
                    }
                    return object;
                };

                /**
                 * Converts this FullAutoTuning to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FullAutoTuning.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for FullAutoTuning
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                FullAutoTuning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.FullAutoTuning";
                };

                FullAutoTuning.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "POSITION_STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "POSITION_DONE":
                        case 2:
                            message.code = 2;
                            break;
                        case "VELOCITY_STARTED":
                        case 3:
                            message.code = 3;
                            break;
                        case "VELOCITY_DONE":
                        case 4:
                            message.code = 4;
                            break;
                        case "POSITION_STOPPING":
                        case 5:
                            message.code = 5;
                            break;
                        case "VELOCITY_STOPPING":
                        case 6:
                            message.code = 6;
                            break;
                        case "POSITION_STOPPED":
                        case 7:
                            message.code = 7;
                            break;
                        case "VELOCITY_STOPPED":
                        case 8:
                            message.code = 8;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.FullAutoTuning.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} POSITION_STARTED=1 POSITION_STARTED value
                     * @property {number} POSITION_DONE=2 POSITION_DONE value
                     * @property {number} VELOCITY_STARTED=3 VELOCITY_STARTED value
                     * @property {number} VELOCITY_DONE=4 VELOCITY_DONE value
                     * @property {number} POSITION_STOPPING=5 POSITION_STOPPING value
                     * @property {number} VELOCITY_STOPPING=6 VELOCITY_STOPPING value
                     * @property {number} POSITION_STOPPED=7 POSITION_STOPPED value
                     * @property {number} VELOCITY_STOPPED=8 VELOCITY_STOPPED value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "POSITION_STARTED"] = 1;
                        values[valuesById[2] = "POSITION_DONE"] = 2;
                        values[valuesById[3] = "VELOCITY_STARTED"] = 3;
                        values[valuesById[4] = "VELOCITY_DONE"] = 4;
                        values[valuesById[5] = "POSITION_STOPPING"] = 5;
                        values[valuesById[6] = "VELOCITY_STOPPING"] = 6;
                        values[valuesById[7] = "POSITION_STOPPED"] = 7;
                        values[valuesById[8] = "VELOCITY_STOPPED"] = 8;
                        return values;
                    })();

                    return Success;
                })();

                FullAutoTuning.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "PLANT_MODEL_INVALID":
                        case 1:
                            message.code = 1;
                            break;
                        case "PLANT_MODEL_NOT_FOUND":
                        case 2:
                            message.code = 2;
                            break;
                        case "POSITION_FAILED":
                        case 3:
                            message.code = 3;
                            break;
                        case "VELOCITY_FAILED":
                        case 4:
                            message.code = 4;
                            break;
                        case "NOT_SUPPORTED":
                        case 5:
                            message.code = 5;
                            break;
                        case "ALREADY_RUNNING":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_RUNNING":
                        case 7:
                            message.code = 7;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.FullAutoTuning.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} PLANT_MODEL_INVALID=1 PLANT_MODEL_INVALID value
                     * @property {number} PLANT_MODEL_NOT_FOUND=2 PLANT_MODEL_NOT_FOUND value
                     * @property {number} POSITION_FAILED=3 POSITION_FAILED value
                     * @property {number} VELOCITY_FAILED=4 VELOCITY_FAILED value
                     * @property {number} NOT_SUPPORTED=5 NOT_SUPPORTED value
                     * @property {number} ALREADY_RUNNING=6 ALREADY_RUNNING value
                     * @property {number} NOT_RUNNING=7 NOT_RUNNING value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PLANT_MODEL_INVALID"] = 1;
                        values[valuesById[2] = "PLANT_MODEL_NOT_FOUND"] = 2;
                        values[valuesById[3] = "POSITION_FAILED"] = 3;
                        values[valuesById[4] = "VELOCITY_FAILED"] = 4;
                        values[valuesById[5] = "NOT_SUPPORTED"] = 5;
                        values[valuesById[6] = "ALREADY_RUNNING"] = 6;
                        values[valuesById[7] = "NOT_RUNNING"] = 7;
                        return values;
                    })();

                    return Error;
                })();

                FullAutoTuning.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @interface IProgress
                     * @property {number|null} [percentage] Progress percentage
                     * @property {string|null} [message] Progress message
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Progress message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @instance
                     */
                    Progress.prototype.message = "";

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.percentage);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress();
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.percentage = 0;
                            object.message = "";
                        }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.FullAutoTuning.Progress";
                    };

                    return Progress;
                })();

                FullAutoTuning.Warning = (function() {

                    /**
                     * Properties of a Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @interface IWarning
                     * @property {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.Code|null} [code] Warning code
                     * @property {string|null} [message] Warning message
                     */

                    /**
                     * Constructs a new Warning.
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning
                     * @classdesc Represents a Warning.
                     * @implements IWarning
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning=} [properties] Properties to set
                     */
                    function Warning(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Warning code.
                     * @member {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @instance
                     */
                    Warning.prototype.code = 0;

                    /**
                     * Warning message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @instance
                     */
                    Warning.prototype.message = "";

                    /**
                     * Creates a new Warning instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning} Warning instance
                     */
                    Warning.create = function create(properties) {
                        return new Warning(properties);
                    };

                    /**
                     * Encodes the specified Warning message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Warning message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.IWarning} message Warning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Warning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Warning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning} Warning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Warning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Warning message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Warning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning} Warning
                     */
                    Warning.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "VEL_NOISE_TEST_SKIPPED":
                        case 1:
                            message.code = 1;
                            break;
                        case "VEL_NOISE_TEST_LOW_DATA_QUALITY":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Warning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning} message Warning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Warning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Warning to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Warning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Warning
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Warning.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.FullAutoTuning.Warning.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} VEL_NOISE_TEST_SKIPPED=1 VEL_NOISE_TEST_SKIPPED value
                     * @property {number} VEL_NOISE_TEST_LOW_DATA_QUALITY=2 VEL_NOISE_TEST_LOW_DATA_QUALITY value
                     */
                    Warning.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "VEL_NOISE_TEST_SKIPPED"] = 1;
                        values[valuesById[2] = "VEL_NOISE_TEST_LOW_DATA_QUALITY"] = 2;
                        return values;
                    })();

                    return Warning;
                })();

                return FullAutoTuning;
            })();

            Status.CirculoEncoderConfiguration = (function() {

                /**
                 * Properties of a CirculoEncoderConfiguration.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ICirculoEncoderConfiguration
                 * @property {number|null} [deviceAddress] CirculoEncoderConfiguration deviceAddress
                 * @property {number|null} [encoderOrdinal] CirculoEncoderConfiguration encoderOrdinal
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess|null} [success] CirculoEncoderConfiguration success
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError|null} [error] CirculoEncoderConfiguration error
                 * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress|null} [progress] CirculoEncoderConfiguration progress
                 */

                /**
                 * Constructs a new CirculoEncoderConfiguration.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a CirculoEncoderConfiguration.
                 * @implements ICirculoEncoderConfiguration
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration=} [properties] Properties to set
                 */
                function CirculoEncoderConfiguration(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CirculoEncoderConfiguration deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                CirculoEncoderConfiguration.prototype.deviceAddress = 0;

                /**
                 * CirculoEncoderConfiguration encoderOrdinal.
                 * @member {number} encoderOrdinal
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                CirculoEncoderConfiguration.prototype.encoderOrdinal = 0;

                /**
                 * CirculoEncoderConfiguration success.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                CirculoEncoderConfiguration.prototype.success = null;

                /**
                 * CirculoEncoderConfiguration error.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                CirculoEncoderConfiguration.prototype.error = null;

                /**
                 * CirculoEncoderConfiguration progress.
                 * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                CirculoEncoderConfiguration.prototype.progress = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * CirculoEncoderConfiguration status.
                 * @member {"success"|"error"|"progress"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 */
                Object.defineProperty(CirculoEncoderConfiguration.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CirculoEncoderConfiguration instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration} CirculoEncoderConfiguration instance
                 */
                CirculoEncoderConfiguration.create = function create(properties) {
                    return new CirculoEncoderConfiguration(properties);
                };

                /**
                 * Encodes the specified CirculoEncoderConfiguration message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration} message CirculoEncoderConfiguration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderConfiguration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.encoderOrdinal != null && Object.hasOwnProperty.call(message, "encoderOrdinal"))
                        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.encoderOrdinal);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.encode(message.progress, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CirculoEncoderConfiguration message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ICirculoEncoderConfiguration} message CirculoEncoderConfiguration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CirculoEncoderConfiguration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CirculoEncoderConfiguration message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration} CirculoEncoderConfiguration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderConfiguration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.encoderOrdinal = reader.uint32();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CirculoEncoderConfiguration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration} CirculoEncoderConfiguration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CirculoEncoderConfiguration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CirculoEncoderConfiguration message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CirculoEncoderConfiguration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        if (!$util.isInteger(message.encoderOrdinal))
                            return "encoderOrdinal: integer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CirculoEncoderConfiguration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration} CirculoEncoderConfiguration
                 */
                CirculoEncoderConfiguration.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.encoderOrdinal != null)
                        message.encoderOrdinal = object.encoderOrdinal >>> 0;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.fromObject(object.progress);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CirculoEncoderConfiguration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration} message CirculoEncoderConfiguration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CirculoEncoderConfiguration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        object.encoderOrdinal = 0;
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.encoderOrdinal != null && message.hasOwnProperty("encoderOrdinal"))
                        object.encoderOrdinal = message.encoderOrdinal;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    return object;
                };

                /**
                 * Converts this CirculoEncoderConfiguration to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CirculoEncoderConfiguration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CirculoEncoderConfiguration
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CirculoEncoderConfiguration.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration";
                };

                CirculoEncoderConfiguration.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                CirculoEncoderConfiguration.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "ALREADY_RUNNING":
                        case 1:
                            message.code = 1;
                            break;
                        case "FAILED":
                        case 2:
                            message.code = 2;
                            break;
                        case "NOT_SUPPORTED":
                        case 3:
                            message.code = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} ALREADY_RUNNING=1 ALREADY_RUNNING value
                     * @property {number} FAILED=2 FAILED value
                     * @property {number} NOT_SUPPORTED=3 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "ALREADY_RUNNING"] = 1;
                        values[valuesById[2] = "FAILED"] = 2;
                        values[valuesById[3] = "NOT_SUPPORTED"] = 3;
                        return values;
                    })();

                    return Error;
                })();

                CirculoEncoderConfiguration.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @interface IProgress
                     * @property {number|null} [percentage] Progress percentage
                     * @property {string|null} [message] Progress message
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Progress message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @instance
                     */
                    Progress.prototype.message = "";

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.percentage);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress();
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.percentage = 0;
                            object.message = "";
                        }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.CirculoEncoderConfiguration.Progress";
                    };

                    return Progress;
                })();

                return CirculoEncoderConfiguration;
            })();

            Status.OsCommand = (function() {

                /**
                 * Properties of an OsCommand.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IOsCommand
                 * @property {number|null} [deviceAddress] OsCommand deviceAddress
                 * @property {Uint8Array|null} [response] OsCommand response
                 * @property {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess|null} [success] OsCommand success
                 * @property {motionmaster.MotionMasterMessage.Status.OsCommand.IError|null} [error] OsCommand error
                 * @property {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress|null} [progress] OsCommand progress
                 */

                /**
                 * Constructs a new OsCommand.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents an OsCommand.
                 * @implements IOsCommand
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IOsCommand=} [properties] Properties to set
                 */
                function OsCommand(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OsCommand deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                OsCommand.prototype.deviceAddress = 0;

                /**
                 * OsCommand response.
                 * @member {Uint8Array} response
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                OsCommand.prototype.response = $util.newBuffer([]);

                /**
                 * OsCommand success.
                 * @member {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                OsCommand.prototype.success = null;

                /**
                 * OsCommand error.
                 * @member {motionmaster.MotionMasterMessage.Status.OsCommand.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                OsCommand.prototype.error = null;

                /**
                 * OsCommand progress.
                 * @member {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress|null|undefined} progress
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                OsCommand.prototype.progress = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * OsCommand status.
                 * @member {"success"|"error"|"progress"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 */
                Object.defineProperty(OsCommand.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error", "progress"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new OsCommand instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOsCommand=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.OsCommand} OsCommand instance
                 */
                OsCommand.create = function create(properties) {
                    return new OsCommand(properties);
                };

                /**
                 * Encodes the specified OsCommand message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOsCommand} message OsCommand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OsCommand.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.response != null && Object.hasOwnProperty.call(message, "response"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.response);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.encode(message.success, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                        $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress.encode(message.progress, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified OsCommand message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IOsCommand} message OsCommand message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OsCommand.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OsCommand message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.OsCommand} OsCommand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OsCommand.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.response = reader.bytes();
                                break;
                            }
                        case 3: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 4: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.progress = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OsCommand message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.OsCommand} OsCommand
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OsCommand.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OsCommand message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OsCommand.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.response != null && message.hasOwnProperty("response"))
                        if (!(message.response && typeof message.response.length === "number" || $util.isString(message.response)))
                            return "response: buffer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress.verify(message.progress);
                            if (error)
                                return "progress." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OsCommand message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.OsCommand} OsCommand
                 */
                OsCommand.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OsCommand)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.response != null)
                        if (typeof object.response === "string")
                            $util.base64.decode(object.response, message.response = $util.newBuffer($util.base64.length(object.response)), 0);
                        else if (object.response.length >= 0)
                            message.response = object.response;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OsCommand.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OsCommand.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.fromObject(object.error);
                    }
                    if (object.progress != null) {
                        if (typeof object.progress !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.OsCommand.progress: object expected");
                        message.progress = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress.fromObject(object.progress);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OsCommand message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.OsCommand} message OsCommand
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OsCommand.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.deviceAddress = 0;
                        if (options.bytes === String)
                            object.response = "";
                        else {
                            object.response = [];
                            if (options.bytes !== Array)
                                object.response = $util.newBuffer(object.response);
                        }
                    }
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.response != null && message.hasOwnProperty("response"))
                        object.response = options.bytes === String ? $util.base64.encode(message.response, 0, message.response.length) : options.bytes === Array ? Array.prototype.slice.call(message.response) : message.response;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    if (message.progress != null && message.hasOwnProperty("progress")) {
                        object.progress = $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress.toObject(message.progress, options);
                        if (options.oneofs)
                            object.status = "progress";
                    }
                    return object;
                };

                /**
                 * Converts this OsCommand to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OsCommand.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for OsCommand
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                OsCommand.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OsCommand";
                };

                OsCommand.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.OsCommand.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.OsCommand.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "STARTED":
                        case 1:
                            message.code = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OsCommand.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OsCommand.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OsCommand.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} STARTED=1 STARTED value
                     * @property {number} DONE=2 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STARTED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();

                    return Success;
                })();

                OsCommand.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.OsCommand.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.OsCommand.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "NOT_ALLOWED":
                        case 1:
                            message.code = 1;
                            break;
                        case "ABORTED":
                        case 2:
                            message.code = 2;
                            break;
                        case "TIMEOUT":
                        case 3:
                            message.code = 3;
                            break;
                        case "UNSUPPORTED_OS_COMMAND":
                        case 4:
                            message.code = 4;
                            break;
                        case "ALREADY_RUNNING":
                        case 5:
                            message.code = 5;
                            break;
                        case "FAILED":
                        case 6:
                            message.code = 6;
                            break;
                        case "NOT_SUPPORTED":
                        case 7:
                            message.code = 7;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.OsCommand.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OsCommand.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.OsCommand.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} NOT_ALLOWED=1 NOT_ALLOWED value
                     * @property {number} ABORTED=2 ABORTED value
                     * @property {number} TIMEOUT=3 TIMEOUT value
                     * @property {number} UNSUPPORTED_OS_COMMAND=4 UNSUPPORTED_OS_COMMAND value
                     * @property {number} ALREADY_RUNNING=5 ALREADY_RUNNING value
                     * @property {number} FAILED=6 FAILED value
                     * @property {number} NOT_SUPPORTED=7 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_ALLOWED"] = 1;
                        values[valuesById[2] = "ABORTED"] = 2;
                        values[valuesById[3] = "TIMEOUT"] = 3;
                        values[valuesById[4] = "UNSUPPORTED_OS_COMMAND"] = 4;
                        values[valuesById[5] = "ALREADY_RUNNING"] = 5;
                        values[valuesById[6] = "FAILED"] = 6;
                        values[valuesById[7] = "NOT_SUPPORTED"] = 7;
                        return values;
                    })();

                    return Error;
                })();

                OsCommand.Progress = (function() {

                    /**
                     * Properties of a Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @interface IProgress
                     * @property {number|null} [percentage] Progress percentage
                     * @property {string|null} [message] Progress message
                     */

                    /**
                     * Constructs a new Progress.
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand
                     * @classdesc Represents a Progress.
                     * @implements IProgress
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress=} [properties] Properties to set
                     */
                    function Progress(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Progress percentage.
                     * @member {number} percentage
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @instance
                     */
                    Progress.prototype.percentage = 0;

                    /**
                     * Progress message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @instance
                     */
                    Progress.prototype.message = "";

                    /**
                     * Creates a new Progress instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Progress} Progress instance
                     */
                    Progress.create = function create(properties) {
                        return new Progress(properties);
                    };

                    /**
                     * Encodes the specified Progress message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Progress.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.percentage != null && Object.hasOwnProperty.call(message, "percentage"))
                            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.percentage);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Progress message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.OsCommand.Progress.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.IProgress} message Progress message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Progress.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.percentage = reader.uint32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Progress message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Progress} Progress
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Progress.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Progress message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Progress.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            if (!$util.isInteger(message.percentage))
                                return "percentage: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Progress message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.OsCommand.Progress} Progress
                     */
                    Progress.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.OsCommand.Progress();
                        if (object.percentage != null)
                            message.percentage = object.percentage >>> 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Progress message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.OsCommand.Progress} message Progress
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Progress.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.percentage = 0;
                            object.message = "";
                        }
                        if (message.percentage != null && message.hasOwnProperty("percentage"))
                            object.percentage = message.percentage;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Progress to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Progress.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Progress
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.OsCommand.Progress
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Progress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.OsCommand.Progress";
                    };

                    return Progress;
                })();

                return OsCommand;
            })();

            Status.ForwardCall = (function() {

                /**
                 * Properties of a ForwardCall.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IForwardCall
                 * @property {Uint8Array|null} [response] ForwardCall response
                 * @property {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess|null} [success] ForwardCall success
                 * @property {motionmaster.MotionMasterMessage.Status.ForwardCall.IError|null} [error] ForwardCall error
                 */

                /**
                 * Constructs a new ForwardCall.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a ForwardCall.
                 * @implements IForwardCall
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IForwardCall=} [properties] Properties to set
                 */
                function ForwardCall(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ForwardCall response.
                 * @member {Uint8Array} response
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @instance
                 */
                ForwardCall.prototype.response = $util.newBuffer([]);

                /**
                 * ForwardCall success.
                 * @member {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @instance
                 */
                ForwardCall.prototype.success = null;

                /**
                 * ForwardCall error.
                 * @member {motionmaster.MotionMasterMessage.Status.ForwardCall.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @instance
                 */
                ForwardCall.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * ForwardCall status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @instance
                 */
                Object.defineProperty(ForwardCall.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new ForwardCall instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IForwardCall=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall} ForwardCall instance
                 */
                ForwardCall.create = function create(properties) {
                    return new ForwardCall(properties);
                };

                /**
                 * Encodes the specified ForwardCall message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IForwardCall} message ForwardCall message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForwardCall.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.response != null && Object.hasOwnProperty.call(message, "response"))
                        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.response);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ForwardCall message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IForwardCall} message ForwardCall message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ForwardCall.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ForwardCall message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall} ForwardCall
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForwardCall.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.response = reader.bytes();
                                break;
                            }
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ForwardCall message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall} ForwardCall
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ForwardCall.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ForwardCall message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ForwardCall.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.response != null && message.hasOwnProperty("response"))
                        if (!(message.response && typeof message.response.length === "number" || $util.isString(message.response)))
                            return "response: buffer expected";
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ForwardCall message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall} ForwardCall
                 */
                ForwardCall.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.ForwardCall)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall();
                    if (object.response != null)
                        if (typeof object.response === "string")
                            $util.base64.decode(object.response, message.response = $util.newBuffer($util.base64.length(object.response)), 0);
                        else if (object.response.length >= 0)
                            message.response = object.response;
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.ForwardCall.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.ForwardCall.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ForwardCall message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ForwardCall} message ForwardCall
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ForwardCall.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        if (options.bytes === String)
                            object.response = "";
                        else {
                            object.response = [];
                            if (options.bytes !== Array)
                                object.response = $util.newBuffer(object.response);
                        }
                    if (message.response != null && message.hasOwnProperty("response"))
                        object.response = options.bytes === String ? $util.base64.encode(message.response, 0, message.response.length) : options.bytes === Array ? Array.prototype.slice.call(message.response) : message.response;
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this ForwardCall to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ForwardCall.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ForwardCall
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ForwardCall.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.ForwardCall";
                };

                ForwardCall.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.ForwardCall.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.ForwardCall.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "DONE":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.ForwardCall.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.ForwardCall.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} DONE=1 DONE value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DONE"] = 1;
                        return values;
                    })();

                    return Success;
                })();

                ForwardCall.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.ForwardCall.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.ForwardCall.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.ForwardCall.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.ForwardCall.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.ForwardCall.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.ForwardCall.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.ForwardCall.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.ForwardCall.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.ForwardCall.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} FAILED=1 FAILED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        return values;
                    })();

                    return Error;
                })();

                return ForwardCall;
            })();

            Status.SystemInformation = (function() {

                /**
                 * Properties of a SystemInformation.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface ISystemInformation
                 * @property {string|null} [version] SystemInformation version
                 * @property {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions|null} [startOptions] SystemInformation startOptions
                 */

                /**
                 * Constructs a new SystemInformation.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a SystemInformation.
                 * @implements ISystemInformation
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemInformation=} [properties] Properties to set
                 */
                function SystemInformation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemInformation version.
                 * @member {string} version
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @instance
                 */
                SystemInformation.prototype.version = "";

                /**
                 * SystemInformation startOptions.
                 * @member {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions|null|undefined} startOptions
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @instance
                 */
                SystemInformation.prototype.startOptions = null;

                /**
                 * Creates a new SystemInformation instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemInformation=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation} SystemInformation instance
                 */
                SystemInformation.create = function create(properties) {
                    return new SystemInformation(properties);
                };

                /**
                 * Encodes the specified SystemInformation message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemInformation.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemInformation} message SystemInformation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemInformation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
                    if (message.startOptions != null && Object.hasOwnProperty.call(message, "startOptions"))
                        $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.encode(message.startOptions, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemInformation message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemInformation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.ISystemInformation} message SystemInformation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemInformation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemInformation message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation} SystemInformation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemInformation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemInformation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.version = reader.string();
                                break;
                            }
                        case 2: {
                                message.startOptions = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemInformation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation} SystemInformation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemInformation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemInformation message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemInformation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.version != null && message.hasOwnProperty("version"))
                        if (!$util.isString(message.version))
                            return "version: string expected";
                    if (message.startOptions != null && message.hasOwnProperty("startOptions")) {
                        let error = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.verify(message.startOptions);
                        if (error)
                            return "startOptions." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemInformation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation} SystemInformation
                 */
                SystemInformation.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemInformation)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.SystemInformation();
                    if (object.version != null)
                        message.version = String(object.version);
                    if (object.startOptions != null) {
                        if (typeof object.startOptions !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemInformation.startOptions: object expected");
                        message.startOptions = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.fromObject(object.startOptions);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemInformation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.SystemInformation} message SystemInformation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemInformation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.version = "";
                        object.startOptions = null;
                    }
                    if (message.version != null && message.hasOwnProperty("version"))
                        object.version = message.version;
                    if (message.startOptions != null && message.hasOwnProperty("startOptions"))
                        object.startOptions = $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.toObject(message.startOptions, options);
                    return object;
                };

                /**
                 * Converts this SystemInformation to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemInformation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemInformation
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemInformation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemInformation";
                };

                SystemInformation.StartOptions = (function() {

                    /**
                     * Properties of a StartOptions.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                     * @interface IStartOptions
                     * @property {string|null} [driver] StartOptions driver
                     * @property {string|null} [mac] StartOptions mac
                     * @property {number|null} [reqResPort] StartOptions reqResPort
                     * @property {number|null} [pubSubPort] StartOptions pubSubPort
                     * @property {Array.<string>|null} [ips] StartOptions ips
                     * @property {string|null} [pdoMode] StartOptions pdoMode
                     */

                    /**
                     * Constructs a new StartOptions.
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation
                     * @classdesc Represents a StartOptions.
                     * @implements IStartOptions
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions=} [properties] Properties to set
                     */
                    function StartOptions(properties) {
                        this.ips = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * StartOptions driver.
                     * @member {string} driver
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.driver = "";

                    /**
                     * StartOptions mac.
                     * @member {string} mac
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.mac = "";

                    /**
                     * StartOptions reqResPort.
                     * @member {number} reqResPort
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.reqResPort = 0;

                    /**
                     * StartOptions pubSubPort.
                     * @member {number} pubSubPort
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.pubSubPort = 0;

                    /**
                     * StartOptions ips.
                     * @member {Array.<string>} ips
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.ips = $util.emptyArray;

                    /**
                     * StartOptions pdoMode.
                     * @member {string} pdoMode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     */
                    StartOptions.prototype.pdoMode = "";

                    /**
                     * Creates a new StartOptions instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions} StartOptions instance
                     */
                    StartOptions.create = function create(properties) {
                        return new StartOptions(properties);
                    };

                    /**
                     * Encodes the specified StartOptions message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions} message StartOptions message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StartOptions.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.driver != null && Object.hasOwnProperty.call(message, "driver"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.driver);
                        if (message.mac != null && Object.hasOwnProperty.call(message, "mac"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.mac);
                        if (message.reqResPort != null && Object.hasOwnProperty.call(message, "reqResPort"))
                            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.reqResPort);
                        if (message.pubSubPort != null && Object.hasOwnProperty.call(message, "pubSubPort"))
                            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.pubSubPort);
                        if (message.ips != null && message.ips.length)
                            for (let i = 0; i < message.ips.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.ips[i]);
                        if (message.pdoMode != null && Object.hasOwnProperty.call(message, "pdoMode"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pdoMode);
                        return writer;
                    };

                    /**
                     * Encodes the specified StartOptions message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemInformation.IStartOptions} message StartOptions message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StartOptions.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a StartOptions message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions} StartOptions
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StartOptions.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.driver = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.mac = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.reqResPort = reader.uint32();
                                    break;
                                }
                            case 4: {
                                    message.pubSubPort = reader.uint32();
                                    break;
                                }
                            case 5: {
                                    if (!(message.ips && message.ips.length))
                                        message.ips = [];
                                    message.ips.push(reader.string());
                                    break;
                                }
                            case 6: {
                                    message.pdoMode = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a StartOptions message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions} StartOptions
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StartOptions.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a StartOptions message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StartOptions.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.driver != null && message.hasOwnProperty("driver"))
                            if (!$util.isString(message.driver))
                                return "driver: string expected";
                        if (message.mac != null && message.hasOwnProperty("mac"))
                            if (!$util.isString(message.mac))
                                return "mac: string expected";
                        if (message.reqResPort != null && message.hasOwnProperty("reqResPort"))
                            if (!$util.isInteger(message.reqResPort))
                                return "reqResPort: integer expected";
                        if (message.pubSubPort != null && message.hasOwnProperty("pubSubPort"))
                            if (!$util.isInteger(message.pubSubPort))
                                return "pubSubPort: integer expected";
                        if (message.ips != null && message.hasOwnProperty("ips")) {
                            if (!Array.isArray(message.ips))
                                return "ips: array expected";
                            for (let i = 0; i < message.ips.length; ++i)
                                if (!$util.isString(message.ips[i]))
                                    return "ips: string[] expected";
                        }
                        if (message.pdoMode != null && message.hasOwnProperty("pdoMode"))
                            if (!$util.isString(message.pdoMode))
                                return "pdoMode: string expected";
                        return null;
                    };

                    /**
                     * Creates a StartOptions message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions} StartOptions
                     */
                    StartOptions.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions();
                        if (object.driver != null)
                            message.driver = String(object.driver);
                        if (object.mac != null)
                            message.mac = String(object.mac);
                        if (object.reqResPort != null)
                            message.reqResPort = object.reqResPort >>> 0;
                        if (object.pubSubPort != null)
                            message.pubSubPort = object.pubSubPort >>> 0;
                        if (object.ips) {
                            if (!Array.isArray(object.ips))
                                throw TypeError(".motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions.ips: array expected");
                            message.ips = [];
                            for (let i = 0; i < object.ips.length; ++i)
                                message.ips[i] = String(object.ips[i]);
                        }
                        if (object.pdoMode != null)
                            message.pdoMode = String(object.pdoMode);
                        return message;
                    };

                    /**
                     * Creates a plain object from a StartOptions message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions} message StartOptions
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StartOptions.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.ips = [];
                        if (options.defaults) {
                            object.driver = "";
                            object.mac = "";
                            object.reqResPort = 0;
                            object.pubSubPort = 0;
                            object.pdoMode = "";
                        }
                        if (message.driver != null && message.hasOwnProperty("driver"))
                            object.driver = message.driver;
                        if (message.mac != null && message.hasOwnProperty("mac"))
                            object.mac = message.mac;
                        if (message.reqResPort != null && message.hasOwnProperty("reqResPort"))
                            object.reqResPort = message.reqResPort;
                        if (message.pubSubPort != null && message.hasOwnProperty("pubSubPort"))
                            object.pubSubPort = message.pubSubPort;
                        if (message.ips && message.ips.length) {
                            object.ips = [];
                            for (let j = 0; j < message.ips.length; ++j)
                                object.ips[j] = message.ips[j];
                        }
                        if (message.pdoMode != null && message.hasOwnProperty("pdoMode"))
                            object.pdoMode = message.pdoMode;
                        return object;
                    };

                    /**
                     * Converts this StartOptions to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StartOptions.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for StartOptions
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    StartOptions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.SystemInformation.StartOptions";
                    };

                    return StartOptions;
                })();

                return SystemInformation;
            })();

            Status.PdoMode = (function() {

                /**
                 * Properties of a PdoMode.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IPdoMode
                 * @property {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess|null} [success] PdoMode success
                 * @property {motionmaster.MotionMasterMessage.Status.PdoMode.IError|null} [error] PdoMode error
                 */

                /**
                 * Constructs a new PdoMode.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a PdoMode.
                 * @implements IPdoMode
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IPdoMode=} [properties] Properties to set
                 */
                function PdoMode(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PdoMode success.
                 * @member {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess|null|undefined} success
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @instance
                 */
                PdoMode.prototype.success = null;

                /**
                 * PdoMode error.
                 * @member {motionmaster.MotionMasterMessage.Status.PdoMode.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @instance
                 */
                PdoMode.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PdoMode status.
                 * @member {"success"|"error"|undefined} status
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @instance
                 */
                Object.defineProperty(PdoMode.prototype, "status", {
                    get: $util.oneOfGetter($oneOfFields = ["success", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PdoMode instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPdoMode=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.PdoMode} PdoMode instance
                 */
                PdoMode.create = function create(properties) {
                    return new PdoMode(properties);
                };

                /**
                 * Encodes the specified PdoMode message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPdoMode} message PdoMode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PdoMode.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.encode(message.success, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PdoMode message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IPdoMode} message PdoMode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PdoMode.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PdoMode message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.PdoMode} PdoMode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PdoMode.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2: {
                                message.success = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PdoMode message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.PdoMode} PdoMode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PdoMode.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PdoMode message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PdoMode.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.success != null && message.hasOwnProperty("success")) {
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.verify(message.success);
                            if (error)
                                return "success." + error;
                        }
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.status === 1)
                            return "status: multiple values";
                        properties.status = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PdoMode message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.PdoMode} PdoMode
                 */
                PdoMode.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PdoMode)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode();
                    if (object.success != null) {
                        if (typeof object.success !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.PdoMode.success: object expected");
                        message.success = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.fromObject(object.success);
                    }
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.PdoMode.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PdoMode message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.PdoMode} message PdoMode
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PdoMode.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.success != null && message.hasOwnProperty("success")) {
                        object.success = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.toObject(message.success, options);
                        if (options.oneofs)
                            object.status = "success";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.status = "error";
                    }
                    return object;
                };

                /**
                 * Converts this PdoMode to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PdoMode.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PdoMode
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PdoMode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PdoMode";
                };

                PdoMode.Success = (function() {

                    /**
                     * Properties of a Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                     * @interface ISuccess
                     * @property {motionmaster.MotionMasterMessage.Status.PdoMode.Success.Code|null} [code] Success code
                     * @property {string|null} [message] Success message
                     */

                    /**
                     * Constructs a new Success.
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                     * @classdesc Represents a Success.
                     * @implements ISuccess
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess=} [properties] Properties to set
                     */
                    function Success(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Success code.
                     * @member {motionmaster.MotionMasterMessage.Status.PdoMode.Success.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @instance
                     */
                    Success.prototype.code = 0;

                    /**
                     * Success message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @instance
                     */
                    Success.prototype.message = "";

                    /**
                     * Creates a new Success instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Success} Success instance
                     */
                    Success.create = function create(properties) {
                        return new Success(properties);
                    };

                    /**
                     * Encodes the specified Success message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.Success.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Success message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.Success.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.ISuccess} message Success message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Success.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Success message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Success} Success
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Success.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Success message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Success.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a Success message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Success} Success
                     */
                    Success.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Success message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.Success} message Success
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Success.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.PdoMode.Success.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Success to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Success.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Success
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Success
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Success.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PdoMode.Success";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.PdoMode.Success.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     */
                    Success.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        return values;
                    })();

                    return Success;
                })();

                PdoMode.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.PdoMode.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.PdoMode.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.PdoMode.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.PdoMode.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.PdoMode.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.PdoMode.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.PdoMode.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.PdoMode.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.PdoMode.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        return values;
                    })();

                    return Error;
                })();

                return PdoMode;
            })();

            Status.DeviceSii = (function() {

                /**
                 * Properties of a DeviceSii.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @interface IDeviceSii
                 * @property {number|null} [deviceAddress] DeviceSii deviceAddress
                 * @property {Uint8Array|null} [content] DeviceSii content
                 * @property {motionmaster.MotionMasterMessage.Status.DeviceSii.IError|null} [error] DeviceSii error
                 */

                /**
                 * Constructs a new DeviceSii.
                 * @memberof motionmaster.MotionMasterMessage.Status
                 * @classdesc Represents a DeviceSii.
                 * @implements IDeviceSii
                 * @constructor
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSii=} [properties] Properties to set
                 */
                function DeviceSii(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DeviceSii deviceAddress.
                 * @member {number} deviceAddress
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @instance
                 */
                DeviceSii.prototype.deviceAddress = 0;

                /**
                 * DeviceSii content.
                 * @member {Uint8Array|null|undefined} content
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @instance
                 */
                DeviceSii.prototype.content = null;

                /**
                 * DeviceSii error.
                 * @member {motionmaster.MotionMasterMessage.Status.DeviceSii.IError|null|undefined} error
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @instance
                 */
                DeviceSii.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * DeviceSii data.
                 * @member {"content"|"error"|undefined} data
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @instance
                 */
                Object.defineProperty(DeviceSii.prototype, "data", {
                    get: $util.oneOfGetter($oneOfFields = ["content", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new DeviceSii instance using the specified properties.
                 * @function create
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSii=} [properties] Properties to set
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii} DeviceSii instance
                 */
                DeviceSii.create = function create(properties) {
                    return new DeviceSii(properties);
                };

                /**
                 * Encodes the specified DeviceSii message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSii.verify|verify} messages.
                 * @function encode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSii} message DeviceSii message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceSii.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deviceAddress != null && Object.hasOwnProperty.call(message, "deviceAddress"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.deviceAddress);
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DeviceSii message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSii.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.IDeviceSii} message DeviceSii message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DeviceSii.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DeviceSii message from the specified reader or buffer.
                 * @function decode
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii} DeviceSii
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceSii.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSii();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.deviceAddress = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.content = reader.bytes();
                                break;
                            }
                        case 3: {
                                message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DeviceSii message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii} DeviceSii
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DeviceSii.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DeviceSii message.
                 * @function verify
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DeviceSii.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        if (!$util.isInteger(message.deviceAddress))
                            return "deviceAddress: integer expected";
                    if (message.content != null && message.hasOwnProperty("content")) {
                        properties.data = 1;
                        if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                            return "content: buffer expected";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        if (properties.data === 1)
                            return "data: multiple values";
                        properties.data = 1;
                        {
                            let error = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.verify(message.error);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DeviceSii message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii} DeviceSii
                 */
                DeviceSii.fromObject = function fromObject(object) {
                    if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceSii)
                        return object;
                    let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSii();
                    if (object.deviceAddress != null)
                        message.deviceAddress = object.deviceAddress >>> 0;
                    if (object.content != null)
                        if (typeof object.content === "string")
                            $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                        else if (object.content.length >= 0)
                            message.content = object.content;
                    if (object.error != null) {
                        if (typeof object.error !== "object")
                            throw TypeError(".motionmaster.MotionMasterMessage.Status.DeviceSii.error: object expected");
                        message.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.fromObject(object.error);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DeviceSii message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {motionmaster.MotionMasterMessage.Status.DeviceSii} message DeviceSii
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DeviceSii.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.deviceAddress = 0;
                    if (message.deviceAddress != null && message.hasOwnProperty("deviceAddress"))
                        object.deviceAddress = message.deviceAddress;
                    if (message.content != null && message.hasOwnProperty("content")) {
                        object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                        if (options.oneofs)
                            object.data = "content";
                    }
                    if (message.error != null && message.hasOwnProperty("error")) {
                        object.error = $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.toObject(message.error, options);
                        if (options.oneofs)
                            object.data = "error";
                    }
                    return object;
                };

                /**
                 * Converts this DeviceSii to JSON.
                 * @function toJSON
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DeviceSii.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DeviceSii
                 * @function getTypeUrl
                 * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DeviceSii.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceSii";
                };

                DeviceSii.Error = (function() {

                    /**
                     * Properties of an Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                     * @interface IError
                     * @property {motionmaster.MotionMasterMessage.Status.DeviceSii.Error.Code|null} [code] Error code
                     * @property {string|null} [message] Error message
                     */

                    /**
                     * Constructs a new Error.
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii
                     * @classdesc Represents an Error.
                     * @implements IError
                     * @constructor
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSii.IError=} [properties] Properties to set
                     */
                    function Error(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Error code.
                     * @member {motionmaster.MotionMasterMessage.Status.DeviceSii.Error.Code} code
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @instance
                     */
                    Error.prototype.code = 0;

                    /**
                     * Error message.
                     * @member {string} message
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @instance
                     */
                    Error.prototype.message = "";

                    /**
                     * Creates a new Error instance using the specified properties.
                     * @function create
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSii.IError=} [properties] Properties to set
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii.Error} Error instance
                     */
                    Error.create = function create(properties) {
                        return new Error(properties);
                    };

                    /**
                     * Encodes the specified Error message. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSii.Error.verify|verify} messages.
                     * @function encode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSii.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified Error message, length delimited. Does not implicitly {@link motionmaster.MotionMasterMessage.Status.DeviceSii.Error.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSii.IError} message Error message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Error.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer.
                     * @function decode
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Error message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii.Error} Error
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Error.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Error message.
                     * @function verify
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Error.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            switch (message.code) {
                            default:
                                return "code: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates an Error message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {motionmaster.MotionMasterMessage.Status.DeviceSii.Error} Error
                     */
                    Error.fromObject = function fromObject(object) {
                        if (object instanceof $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error)
                            return object;
                        let message = new $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error();
                        switch (object.code) {
                        default:
                            if (typeof object.code === "number") {
                                message.code = object.code;
                                break;
                            }
                            break;
                        case "UNSPECIFIED":
                        case 0:
                            message.code = 0;
                            break;
                        case "FAILED":
                        case 1:
                            message.code = 1;
                            break;
                        case "NOT_SUPPORTED":
                        case 2:
                            message.code = 2;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Error message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {motionmaster.MotionMasterMessage.Status.DeviceSii.Error} message Error
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Error.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = options.enums === String ? "UNSPECIFIED" : 0;
                            object.message = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = options.enums === String ? $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.Code[message.code] === undefined ? message.code : $root.motionmaster.MotionMasterMessage.Status.DeviceSii.Error.Code[message.code] : message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this Error to JSON.
                     * @function toJSON
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Error.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for Error
                     * @function getTypeUrl
                     * @memberof motionmaster.MotionMasterMessage.Status.DeviceSii.Error
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Error.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/motionmaster.MotionMasterMessage.Status.DeviceSii.Error";
                    };

                    /**
                     * Code enum.
                     * @name motionmaster.MotionMasterMessage.Status.DeviceSii.Error.Code
                     * @enum {number}
                     * @property {number} UNSPECIFIED=0 UNSPECIFIED value
                     * @property {number} FAILED=1 FAILED value
                     * @property {number} NOT_SUPPORTED=2 NOT_SUPPORTED value
                     */
                    Error.Code = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FAILED"] = 1;
                        values[valuesById[2] = "NOT_SUPPORTED"] = 2;
                        return values;
                    })();

                    return Error;
                })();

                return DeviceSii;
            })();

            return Status;
        })();

        return MotionMasterMessage;
    })();

    return motionmaster;
})();

module.exports = $root;
